import type { Lang } from './i18n';

export type LiteralLang = Exclude<Lang, 'zh'>;

export const literalTranslations: Record<LiteralLang, Record<string, string>> = {
  "zhTW": {
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— 查看組織內的 Agent 和成員，建立新 Agent 或邀請新成員。",
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— 查看 Agent 正在執行的後台任務，包括進度、狀態和結果。",
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— 點擊即可切換到不同的組織，Agent 和知識庫會隨之改變。",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "— 賦予 Agent 辨識度，方便在多 Agent 場景下區分。",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— 定義 Agent 的性格、專長和行為方式。例如你可以創建一個「程式碼審查員」Agent，讓它專注於程式碼品質；再創建一個「產品經理」Agent，讓它擅長需求分析。",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— 告訴 Agent 它是誰，擅長什麼領域。",
    "— 个人偏好、组织管理、账号安全。": "— 個人偏好、組織管理、帳號安全。",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— 管理該 Agent 已安裝的技能，或從市場安裝新技能。",
    "— 管理共享文档，上传和浏览 .md 文件。": "— 管理共用文檔，上傳和瀏覽 .md 文件。",
    "— 回答时应该遵循什么格式、风格、步骤。": "— 回答時應該遵循什麼格式、風格、步驟。",
    "— 接入 Zoom 会议或聊天。": "— 接入 Zoom 會議或聊天。",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— 可使用 Agent、參與對話、存取知識庫，不能進行管理操作。",
    "— 浏览和安装技能，管理已发布的技能。": "— 瀏覽和安裝技能，管理已發布的技能。",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— 可以管理 Agent、知識庫和成員，不能修改組織設定。",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— 讓 Agent 具備創建和管理定時任務的能力。",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— 讓 Agent 能夠設定定時或週期性任務，例如每天早上產生報告。",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— 讓 Agent 能夠呼叫其他 Agent，實現跨 Agent 協作。",
    "— 让 Agent 能够自动生成和发布新技能。": "— 讓 Agent 能夠自動產生和發布新技能。",
    "— 什么该做，什么不该做。": "— 什麼該做，什麼不該做。",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— 讓 Agent 自行創造新技能並發佈到市場，供其他 Agent 安裝使用。",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— 擁有者擁有全部權限，管理員可管理 Agent 和成員，普通成員可以使用 Agent 和知識庫。",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "— 透過 BotFather 建立 Bot，填入 Bot Token 即可連接。",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— 透過 iLink 接入，實現在微信中與 Agent 交互。",
    "— 通过 Telegram Bot 接入。": "— 透過 Telegram Bot 存取。",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— 透過安裝不同的技能來擴展 Agent 的能力邊界。",
    "— 通过企业微信或 iLink 接入。": "— 透過企業微信或 iLink 接取。",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— 透過飛書機器人直接在飛書中與 Agent 對話。",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "— 擁有全部權限，管理組織設定、成員、Agent。每個組織只有一個所有者。",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— 與 Agent 的聊天記錄，支援即時串流輸出。",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— 與 Agent 交流的主介面，左側是 Agent 列表，右側是聊天視窗。",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— 允許 Agent 調用工作區內的其他 Agent，以實現跨 Agent 的自動化管線。例如 Agent A 完成分析後自動將結果轉交給 Agent B 產生報表。",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— 在「團隊」頁面透過郵件信箱邀請成員加入目前組織。",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— 在對話式介面的「技能」標籤中，為目前 Agent 安裝或解除安裝技能。不同 Agent 可以安裝不同的技能組合。",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— 在導覽列的「Skill 市集」中瀏覽所有可用技能，查看詳情和安裝說明。",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "— 在飛書開放平台建立應用，取得 App ID 和 App Secret 後接入。團隊成員可在飛行中直接與 Agent 對話。",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— Agent 可以在指定的檔案系統目錄中讀寫文件，執行程式碼。不同 Agent 可以操作不同的專案目錄。",
    "— 最多可创建 2 个组织。": "— 最多可建立 2 個組織。",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": "，不以營利為目的，不會向用戶收取任何費用，也不會以任何形式進行商業推廣或銷售。",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品",
    "、": "、",
    ".pen 文件": ".pen 文件",
    "· 点击启用": "· 點選啟用",
    "· 点击召唤": "· 點擊召喚",
    "· 用于 Agent 理解": "· 用於 Agent 理解",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品",
    "，同时可以被邀请加入他人的组织。": "，同時可以被邀請加入他人的組織。",
    "（一次性延时任务）": "（一次性延時任務）",
    "@提及": "@提及",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@分析師 基於上面的數據，做一份競爭格局分析",
    "@写手 把以上分析整理成一份 PDF 报告": "@寫手 把以上分析整理成 PDF 報告",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@研究員 搜尋 2024 年新能源汽車出海市場數據",
    "/ 月": "/ 月",
    "← 返回": "← 返回",
    "← 返回列表": "← 回傳列表",
    "← 返回详情": "← 返回詳情",
    "+ 记录": "+ 記錄",
    "+ 添加": "+ 新增",
    "✓ 反馈已提交，感谢您的意见！": "✓ 回饋已提交，感謝您的意見！",
    "✓ 已连接": "✓ 已連接",
    "+ 创建新组织": "+ 建立新組織",
    "163 邮箱": "163 信箱",
    "（由 Soul 指令定义）": "（由 Soul 指令定義）",
    "@提及机制": "@提及機制",
    "1. 产品性质": "1. 產品性質",
    "1. 產品性質": "1. 產品性質",
    "2 个组织": "2 個組織",
    "2. 数据与隐私": "2. 資料與隱私",
    "2. 資料與隱私": "2. 資料與隱私",
    "3. 第三方服务": "3. 第三方服務",
    "4. 服务可用性": "4. 服務可用性",
    "3. 第三方服務": "3. 第三方服務",
    "5. 免责声明": "5. 免責聲明",
    "4. 服務可用性": "4. 服務可用性",
    "30 分钟后提醒我开会": "30 分鐘後提醒我開會",
    "6. 联系方式": "6. 聯絡方式",
    "5. 免責聲明": "5. 免責聲明",
    "安装方式": "安裝方式",
    "安装给以下 Agent：": "安裝給以下 Agent：",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "把 Agent 接入團隊正在使用的即時通訊平台，在群組聊天或私聊中直接對話。",
    "把世界级设计标准": "把世界級設計標準",
    "把指标接回真实数据": "把指標接回真實數據",
    "保存对象": "儲存對象",
    "保存失败": "保存失敗",
    "保存修改": "儲存修改",
    "保存中...": "儲存中...",
    "保存中…": "保存…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "報會定期匯總整個組織在 NovaX 中的使用情況，也會根據組織已經連接的資料庫、BI、Git、郵箱等底層數據，發現值得關注的業務感知。",
    "被移出了组织": "被移出了組織",
    "6. 聯絡方式": "6. 聯絡方式",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "本產品不適用於醫療建議、法律諮詢、財務決策等專業場景。",
    "安装不同的": "安裝不同的",
    "本次分析提示": "本次分析提示",
    "本期 SKILL": "本期 SKILL",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "本體不是另一套知識庫。它把業務裡的對象、指標、數據和負責人連接成一張可推理的地圖，讓 Agent 不只“查到資料”，還知道一個數字怎麼來、為什麼變、會影響什麼。",
    "本体加载失败": "本體加載失敗",
    "本体视图": "本體視圖",
    "本体完整度": "本體完整度",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "本體只保存結構與口徑，資料庫憑證由連接器或環境變數管理，不進入業務圖譜。",
    "本月": "本月",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "比較指標觀測值，再沿計算與資料血緣找到變化發生在哪一層。",
    "必填": "必填",
    "避免把相关性误判为因果": "避免把相關性誤判為因果",
    "编辑": "編輯",
    "编辑定义": "編輯定義",
    "编辑对象": "編輯對象",
    "编辑了 Agent": "編輯了 Agent",
    "编辑业务对象": "編輯業務對象",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會依照該服務的隱私權政策來處理。建議避免在對話中輸入敏感個人資訊。",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會依照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。",
    "标识（可选）": "標識（可選）",
    "标题": "標題",
    "表、视图、ETL 模型": "表、視圖、ETL 模型",
    "补充口径、边界或业务背景": "補充口徑、邊界或業務背景",
    "补充驱动关系": "補充驅動關係",
    "补充影响关系": "補充影響關係",
    "不保证": "不保證",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "本產品不適用於醫療建議、法律諮詢、財務決策等專業場景。",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "寫 Soul —— 這是最關鍵的一步。 Soul 決定了 Agent 如何理解任務並回答問題。寫得越具體，Agent 的表現越好。",
    "不会主动收集": "不會主動收集",
    "不保證": "不保證",
    "不會用於商業化營運": "不會用於商業化運營",
    "不会用于商业化运营": "不會用於商業化營運",
    "参会者": "與會者",
    "参与聚合、关联和过滤的列": "參與聚合、關聯和過濾的列",
    "仓库地址": "倉庫地址",
    "仓库协作": "倉庫協作",
    "草稿": "草稿",
    "策": "策",
    "查看": "查看",
    "不會主動收集": "不會主動收集",
    "查看全部模型 →": "看全部模型 →",
    "查看它负责哪些指标、目标或业务流程。": "查看它負責哪些指標、目標或業務流程。",
    "查看完整影响路径": "查看完整影響路徑",
    "查找文件": "尋找文件",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "不同的 Agent 可以有完全不同的 Soul。例如一個團隊可以同時擁有「研究員」、「寫手」、「程式碼審查員」等多個角色各異的 Agent。",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "有別於普通的 AI 對話工具，NovaX 的 Agent 具備持久記憶、可安裝技能、支援多人協作，並且可以連接飛書、Telegram、微信等即時通訊平台，讓 AI 融入你的日常工作流程。",
    "产品 PRD、技术架构文档": "產品 PRD、技術架構文檔",
    "查看每个技能的功能说明、安装量和评分。": "查看每個技能的功能說明、安裝量和評分。",
    "产品文档和技术架构": "產品文件和技術架構",
    "成员 / Agent": "成員 / Agent",
    "常见问题和标准回答": "常見問題和標準回答",
    "成员与权限": "成員與權限",
    "持久记忆": "持久記憶",
    "常见问题和解答模板": "常見問題和答案模板",
    "抽出一位大师的思维，": "抽出一位大師的思維，",
    "处理事件": "處理事件",
    "触发次数": "觸發次數",
    "创建": "創建",
    "创建 Agent": "創建 Agent",
    "创建 Webhook": "建立 Webhook",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "建立 Webhook 後，外部系統（GitHub、Stripe、Sentry 等）可以透過 HTTP POST 自動觸發",
    "创建第一个指标": "創建第一個指標",
    "创建核心指标": "創建核心指標",
    "成员（Member）": "成員（Member）",
    "创建会议": "創建會議",
    "创建了 Agent": "創建了 Agent",
    "创建类型": "建立類型",
    "创建你的第一个 Agent": "創建你的第一個 Agent",
    "创建企业自建应用，获取凭证": "創建企業自建應用，取得憑證",
    "创建失败": "創建失敗",
    "创建时间": "創建時間",
    "创建中...": "創建中...",
    "创建中…": "創建中…",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "除了 Web 介面，NovaX 的 Agent 還可以連接到即時通訊平台：",
    "创建组织": "創建組織",
    "创刊导读": "創刊導讀",
    "创作与协作": "創作與協作",
    "此文件类型暂不支持预览": "此文件類型暫不支援預覽",
    "次": "次",
    "从 160+ 专业角色模板中选择": "從 160+ 專業角色範本中選擇",
    "从数据到行动的业务地图": "從數據到行動的業務地圖",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "從業務對象和指標定義確定同一個字在公司裡的準確語意。",
    "从业务世界的第一个对象开始": "從業務世界的第一個物件開始",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "從營收、訂單量、轉換率或你最關心的業務結果開始。",
    "从预设创建": "從預設創建",
    "大": "大",
    "代码读取": "程式碼讀取",
    "待开始": "待開始",
    "待认领": "待認領",
    "待验证": "待驗證",
    "单次任务": "單次任務",
    "单次执行": "單次執行",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "當你詢問指標、血緣、歸因或影響時，NovaX Agent 會先讀取相關本體上下文。知識庫提供“原文與背景”，本體提供“確定的業務結構”，兩者可以透過證據關聯起來。",
    "当前": "目前",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "建立後系統產生唯一 URL 和金鑰，外部系統向該 URL 發送 POST 請求即可觸發。",
    "当前仅支持 .md 格式": "目前僅支援 .md 格式",
    "当前值": "目前值",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "創建最多 2 個組織，分別用於不同的專案或團隊。",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "登記資料庫、資料表和關鍵字段，再用「資料血緣」或「計算依賴」連接到指標。以後 Agent 被問到口徑時，就能沿著連結找到真實來源，而不是根據文件猜測。",
    "登记数据来源": "登記資料來源",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "登記資料來源、表格和字段，再用「資料血緣」或「計算依賴」關係連接到指標。",
    "登记数据资产": "登記資料資產",
    "登录账号": "登入帳號",
    "登录状态已失效，请重新登录": "登入狀態已失效，請重新登入",
    "等待 Agent 连接...": "等待 Agent 連線...",
    "等待连接成功": "等待連線成功",
    "等待确认": "等待確認",
    "等待扫码...": "等待掃碼...",
    "等待中": "等待中",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "第 1 期 · 由你的 Agent 團隊編撰 · 本期",
    "待上线": "待上線",
    "的 AI 协作者。": "的 AI 協作者。",
    "第二步：认识你的界面": "第二步：認識你的介面",
    "第三步：创建你的第一个 Agent": "第三步：創造你的第一個 Agent",
    "第一期正在准备中": "第一期正在準備中",
    "第五步：丰富 Agent 的知识": "第五步：豐富 Agent 的知識",
    "第一步：注册和登录": "第一步：註冊和登入",
    "第四步：开始对话": "第四步：開始對話",
    "点": "點",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "點選「產生二維碼」，系統會啟動微信網頁登入流程。",
    "点击「生成二维码」获取微信登录码": "點選「產生二維碼」取得微信登入碼",
    "点击连接，系统自动完成配置": "點選連接，系統自動完成配置",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "點擊下方按鈕，跳到飛書開放平台，系統將自動為你建立企業自建應用程式。",
    "钉钉": "釘釘",
    "定时任务": "定時任務",
    "定位变化": "定位變化",
    "定义第一个核心指标": "定義第一個核心指標",
    "定义核心指标": "定義核心指標",
    "定义业务类型": "定義業務類型",
    "定义这个 Agent 的性格、指令和能力...": "定義這個 Agent 的性格、指示和能力...",
    "定义证据": "定義證據",
    "定义指标口径": "定義指標口徑",
    "调整对话消息流中的文字大小": "調整對話訊息流中的文字大小",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "讀取 Figma 檔案結構、元件和評論，讓 Agent 能夠理解介面設計、設計規格與協作回饋。",
    "读取内容": "讀取內容",
    "读取网页": "讀取網頁",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "讀完後可以直接進入它的對話，繼續追問原因、影響和下一步。",
    "端口": "連接埠",
    "断开连接": "斷開連接",
    "断开失败": "斷開失敗",
    "对话": "對話",
    "独立身份、独立记忆、独立技能": "獨立身分、獨立記憶、獨立技能",
    "对话系统": "對話系統",
    "定时任务（MetaSchedule）": "定時任務（MetaSchedule）",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "對話是 NovaX 的核心互動方式。每個 Agent 維護獨立的對話歷史。在對話式介面中，頂部有三個標籤頁：",
    "对象": "物件",
    "对象存储": "物件儲存",
    "对象类型 *": "物件類型 *",
    "对象列表": "物件列表",
    "对象已连接": "物件已連接",
    "对象已删除": "物件已刪除",
    "对应 Agent 暂不可用": "對應 Agent 暫不可用",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "多個檔案以逗號分隔；留空時沿用 Token 自身可見範圍",
    "多媒体": "多媒體",
    "多人": "多人",
    "多维表格": "多維表格",
    "多 Agent 接力": "多 Agent 接力",
    "多平台连接": "多平台連接",
    "额度信息加载失败": "額度資訊載入失敗",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "額度由組織成員共享，所有消費統一從當前組織扣除。",
    "二": "二",
    "二维码已过期，请重新生成": "二維碼已過期，請重新生成",
    "发起会议": "發起會議",
    "发送人": "送出人",
    "发送时间": "發送時間",
    "翻开 →": "翻開 →",
    "反馈": "回饋",
    "反馈中心": "回饋中心",
    "返回": "返回",
    "方向": "方向",
    "方向未知": "方向未知",
    "访问 Token": "參觀 Token",
    "飞书 / Lark": "飛書 / Lark",
    "飞书开放平台": "飛書開放平台",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "飛書應用程式已創建，將 Bot 新增至飛書群組即可開始使用。",
    "费曼思维": "費曼思維",
    "分析对象": "分析對象",
    "分析思路": "分析思路",
    "额度与账单": "額度與帳單",
    "分钟": "分分鐘",
    "否": "否",
    "额外额度": "額外額度",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "伺服器會先驗證 Pencil CLI Key。設計產生固定使用 Codex 5.6 sol · high，並只操作目前 Agent 工作區內的 .pen 檔案。",
    "服务器已连接，等待 Bot 上线...": "伺服器已連接，等待 Bot 上線...",
    "分析完成后：": "分析完成後：",
    "负向": "負向",
    "负责人": "負責人",
    "复制": "複製",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "複製以下命令到終端機運行，Agent 會自動連接到 NovaX 伺服器。",
    "富文本卡片": "富文本卡片",
    "覆盖确认": "覆蓋確認",
    "刚刚": "剛剛",
    "个": "個",
    "个对象": "個對象",
    "个可用技能": "個可用技能",
    "个人存储": "個人儲存",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。",
    "个人文档数": "個人文檔數",
    "个人知识库日志": "個人知識庫日誌",
    "个属性": "個屬性",
    "个已有来源": "個已有來源",
    "个字段": "個字段",
    "给任务取个名字...": "給任務取個名字...",
    "更新计划": "更新計劃",
    "工作目录": "工作目錄",
    "格式文档，上传后立即生效。": "格式文檔，上傳後立即生效。",
    "工作区标识（可选）": "工作區識別（可選）",
    "工作区名称（可选）": "工作區名稱（可選）",
    "工作日": "工作日",
    "工作通知": "工作通知",
    "工作原理": "工作原理",
    "公开仓库（无需凭据）": "公開倉庫（無需憑證）",
    "公式、单位、粒度与负责人": "公式、單位、粒度與負責人",
    "供 Pencil 内的 Codex Agent 使用": "供 Pencil 內的 Codex Agent 使用",
    "共同规则": "共同規則",
    "共同记忆": "共同記憶",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "共享知識庫暫時沒有可關聯文檔，保存後也可以再補證據。",
    "关闭": "關閉",
    "关闭简报": "關閉簡報",
    "关闭上传选择": "關閉上傳選擇",
    "关闭使用引导": "關閉使用引導",
    "关闭消息导航": "關閉訊息導航",
    "关键字段": "關鍵字段",
    "关系名称": "關係名稱",
    "关系说明": "關係說明",
    "关系有证据": "關係有證據",
    "关系证据": "關係證據",
    "观测日期": "觀測日期",
    "观测值已删除": "觀測值已刪除",
    "观远 BI": "觀遠 BI",
    "观远 BI 地址": "觀遠 BI 地址",
    "观远 BI 密码": "觀遠 BI 密碼",
    "管理": "管理",
    "功能详解": "功能詳解",
    "個人練手的技術展示專案（Demo）": "個人練手的技術展示項目（Demo）",
    "规划中": "規劃中",
    "国内平台": "國內平台",
    "还没有积累私有记忆": "還沒有累積私有記憶",
    "还没有上游驱动": "還沒有上游驅動",
    "还没有数据血缘": "還沒有數據血緣",
    "还没有下游影响": "還沒有下游影響",
    "还没有血缘关系。": "還沒有血緣關係。",
    "还没有执行对象": "還沒有執行對象",
    "还没有指标": "還沒有指標",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "還需要在 Notion 中把目標頁面分享給這個 Integration",
    "海外平台": "海外平台",
    "个人练手的技术演示项目（Demo）": "個人練手的技術演示項目（Demo）",
    "核心概念": "核心概念",
    "规定行为": "規定行為",
    "管理员（Admin）": "管理員（Admin）",
    "核心内置技能": "核心內建技能",
    "核心指标": "核心指標",
    "环比变化": "環比變化",
    "恢复": "恢復",
    "会话文件": "會話文件",
    "会议 ·": "會議 ·",
    "会议集成": "會議集成",
    "会议纪要": "會議紀要",
    "会议链接或 ID": "會議連結或 ID",
    "会议密码:": "會議密碼:",
    "会议时长（分钟）": "會議時長（分鐘）",
    "会议主题": "會議主題",
    "活跃": "活躍",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "基於觀遠官方 GuanCLI 驗證連線。連線後可讀取頁面、卡片、資料集、ETL、指標與 ChatBI，預設不開放建立、修改和刪除。",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "基於微信 iLink 協議，掃碼後 Agent 可直接收發私聊訊息。建議使用專用微訊號作為 Agent 載體。",
    "即将推出": "即將推出",
    "计算 / 映射表达式": "計算 / 映射表達式",
    "计算、影响与责任关系": "計算、影響與責任關係",
    "计算公式": "計算公式",
    "计算口径": "計算口徑",
    "记录定义、口径或事实所在位置": "記錄定義、口徑或事實所在位置",
    "记录两个以上周期": "記錄兩個以上週期",
    "记录两个周期的数据后即可比较变化。": "記錄兩個週期的資料後即可比較變化。",
    "记录数值": "記錄數值",
    "记录中…": "記錄中…",
    "纪要": "紀要",
    "技能": "技能",
    "还没有产生额度消费": "還沒有產生額度消費",
    "记住与你的所有历史对话（": "記住與你的所有歷史對話（",
    "技能（Skill）— 能力扩展": "技能（Skill）— 能力擴展",
    "技能。安装后直接在对话中用自然语言描述即可：": "技能。安裝後直接在對話中用自然語言描述即可：",
    "技能创作（MetaSkill）": "技能創作（MetaSkill）",
    "技能市场": "技能市場",
    "技能分为系统内置技能和社区发布的技能。": "技能分為系統內建技能和社群發布的技能。",
    "技能模块": "技能模組",
    "技能市场分为两个维度：": "技能市場分為兩個向度：",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "技能是可以安裝到 Agent 上的功能模組。每個技能賦予 Agent 特定能力。 NovaX 內建了一些核心技能，同時提供技能市場讓你發現並安裝更多功能：",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "技能是給 Agent 擴充能力的模組。不同 Agent 可以安裝不同的技能組合，就像是給員工不同的工具。",
    "技能系统": "技能係統",
    "加入 Zoom 会议": "加入 Zoom 會議",
    "加入会议": "加入會議",
    "加入了组织": "加入了組織",
    "加载中...": "載入中...",
    "加载中…": "載入中…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "相容於 AWS S3、MinIO 及大多數 S3 協定物件存儲",
    "简": "簡",
    "简报": "簡報",
    "简报加载失败": "簡報載入失敗",
    "简报生成失败": "簡報生成失敗",
    "建立关系": "建立關係",
    "建立血缘": "建立血緣",
    "建立业务关系": "建立業務關係",
    "建立中…": "建立中…",
    "建议从一个核心指标开始": "建議從一個核心指標開始",
    "建议使用数据库侧的只读账号": "建議使用資料庫側的唯讀帳號",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "建議先登記一個資料來源、一個核心指標和一個業務目標，然後把它們連起來。",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "建議只授予 current_user:read、file_content:read、file_comments:read",
    "将": "將",
    "将 App ID 和 App Secret 填入下方": "將 App ID 和 App Secret 填入下方",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "將此 Agent 部署為 Discord Bot，在伺服器頻道中互動。",
    "角色权限": "角色權限",
    "接入飞书": "接入飛書",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "接取觀遠 BI 的頁面、資料集、ETL 與指標體系，讓此 Agent 直接理解並分析企業經營資料。",
    "接入微信": "接取微信",
    "揭开第一期": "揭開第一期",
    "结构搭好后，Agent 会自动使用": "結構搭好後，Agent 會自動使用",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "結構關係給予候選路徑；真實歸因仍要結合觀測值、證據和業務條件。",
    "结构信息充足": "結構資訊充足",
    "解释业务": "解釋業務",
    "仅供": "僅供",
    "仅管理员可删除组织知识库文档": "僅管理員可刪除組織知識庫文檔",
    "仅支持 .md 文件": "僅支援 .md 文件",
    "仅所有者可购买": "僅所有者可購買",
    "进 Agent 的肌肉记忆。": "進 Agent 的肌肉記憶。",
    "近 30 天消耗": "近 30 天消耗",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "進入「對話」頁面，在左側清單中點選一個 Agent 進入聊天。在輸入框中傳送訊息，Agent 會即時串流回傳回答。對話支援：",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "進入「團隊」頁面，點選「新建 Agent」按鈕。填寫 Agent 的名稱和描述後創建。創建完成後，點擊 Agent 卡片可以進入詳情頁，在這裡你可以：",
    "进入第一期": "進入第一期",
    "进行中": "進行中",
    "进行中/待开": "進行中/待開",
    "竞": "競",
    "竞对与行业": "競對與產業",
    "聚合方式": "聚合方式",
    "可留空自动生成，例如 contract": "可留空自動生成，例如 contract",
    "可能后果与下游": "可能後果與下游",
    "可能原因与上游": "可能原因與上游",
    "可选": "可選",
    "可选 · 关联共享知识库": "可選 · 關聯共享知識庫",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "可以建立團隊、Agent 或項目，再與指標和業務目標建立責任關係。",
    "可用": "可用",
    "可用 Nova 点": "可用 Nova 點",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "進入「知識庫」頁面，上傳 .md 格式的文件。這些文件會成為所有 Agent 的共用參考資料。例如你可以上傳公司的程式碼規範，之後讓程式碼審查 Agent 依照這個規範來檢查程式碼。",
    "可追溯证据": "可追溯證據",
    "客户联系": "客戶聯繫",
    "口径、公式、粒度和负责人": "口徑、公式、粒度和負責人",
    "口径与依赖": "口徑與依賴",
    "跨层查看正在形成的业务语义。": "跨層查看正在形成的業務語意。",
    "快速上手": "快速上手",
    "来源与流转": "來源與流轉",
    "进入左侧导航栏的「知识库」页面。": "進入左側導覽列的「知識庫」頁面。",
    "类": "類別",
    "类型说明": "類型說明",
    "类型已删除": "類型已刪除",
    "类型与字段": "類型與字段",
    "累计消耗": "累計消耗",
    "来扩展能力": "來擴展能力",
    "理解含义": "理解意義",
    "例：产品评审会、周例会...": "例：產品評審會、週例會...",
    "例如 研究助手": "例如 研究助手",
    "例如 demo": "例如 demo",
    "例如 NovaX 产品团队": "例如 NovaX 產品團隊",
    "例如 product-design": "例如 product-design",
    "例如 researcher": "例如 researcher",
    "例如：2026-W30 / 2026-07": "例如：2026-W30 / 2026-07",
    "例如：合同": "例如：合約",
    "例如：经营看板 / SQL 查询": "例如：經營看板 / SQL 查詢",
    "例如：库存充足时": "例如：庫存充足時",
    "例如：渠道=自然流量，地区=华东": "例如：渠道=自然流量，地區=華東",
    "例如：同日 / 7 天后": "例如：同日 / 7 天后",
    "例如：支付转化率": "例如：支付轉換率",
    "例如：SUM(pay_amount)": "例如：SUM(pay_amount)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "例如：SUM(pay_amount) 或 orders.pay_amount → revenue",
    "连接": "連接",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "連接 AWS S3、MinIO 或相容物件存儲，讓 Agent 瀏覽目錄並讀取授權前綴內的檔案。",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "連接 GitHub、GitLab 或 Gitee 倉庫，讓此 Agent 在授權範圍內讀取程式碼、分析變更並參與開發協作。",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "連接 PostgreSQL、MySQL、SQL Server 等資料庫，透過唯讀權限查詢真實業務資料。",
    "连接成功": "連線成功",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "連線成功後，Agent 會自動接上你的微信，在指定聊天中回應訊息。",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "來指定哪個 Agent 回覆。不帶 @ 的訊息不會觸發任何 Agent。",
    "连接飞书": "連結飛書",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "連結飛書後，團隊成員可以直接在飛書群組聊天中與 Agent 對話。支援富文本卡片、文件收發、日曆連動等飛書原生能力。",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "連線後可讀取檔案節點和評論，不開放修改設計、發表評論或管理團隊。",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "連線後可列出物件並讀取限定前綴內不超過 2MB 的文件，不開放上傳、覆蓋或刪除。",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "連接後可搜尋並讀取已授權頁面和內容區塊，不開放建立、修改或刪除頁面。",
    "连接计算来源和业务目标": "連結計算來源和業務目標",
    "连接类型": "連接類型",
    "连接目标或流程": "連結目標或流程",
    "连接你的 AI 引擎": "連接你的 AI 引擎",
    "连接上下游": "連接上下游",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "連接設計、文件、郵箱、程式碼與業務數據，讓 Agent 在明確授權範圍內參與真實工作。",
    "连接失败": "連線失敗",
    "连接数据或指标": "連結數據或指標",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "連線完成後，將 Agent 新增至飛書群組即可開始對話。",
    "连接微信": "連結微信",
    "连接验证成功": "連線驗證成功",
    "连接中...": "連接中...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "連續記錄兩個週期後，NovaX 會計算變化並在影響分析中沿上游尋找可能驅動。",
    "联网搜索": "網路搜尋",
    "链接": "連結",
    "列表视图": "清單視圖",
    "临时凭据才需要": "臨時憑證才需要",
    "另有": "另有",
    "留空会继续使用已加密保存的凭据": "留空會繼續使用已加密儲存的憑證",
    "六": "六",
    "六个视图，其实是同一张图": "六個視圖，其實是同一張圖",
    "路径样式（MinIO 常用）": "路徑樣式（MinIO 常用）",
    "马斯克思维": "馬斯克思維",
    "芒格思维": "芒格思維",
    "没有发现新增内容": "沒有發現新增內容",
    "没有匹配的角色": "沒有匹配的角色",
    "没有匹配的消息": "沒有符合的訊息",
    "没有匹配的指标": "沒有匹配的指標",
    "没有上游路径": "沒有上游路徑",
    "没有下游路径": "沒有下游路徑",
    "没有新增内容": "沒有新增內容",
    "没有找到匹配的技能": "沒有找到匹配的技能",
    "没有找到匹配的文件": "沒有找到匹配的文件",
    "每": "每",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "沒有 @ 任何 Agent 的訊息會傳送到群組但不會觸發 Agent 回复，方便團隊成員之間交流。",
    "每篇内容都来自": "每篇內容都來自",
    "每天": "每天",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "每個 Agent 都能看到群組聊天中的上下文，所以後續 Agent 可以直接引用前面 Agent 的輸出。",
    "连接到飞书、Telegram、微信等": "連結到飛書、Telegram、微信等",
    "每小时": "每小時",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "每一層回答一個不同問題，連起來才是 Agent 能推理的本體。",
    "每月": "每月",
    "每周": "每週",
    "密码": "密碼",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "密碼、Token 和私鑰只在服務端加密存儲，不會寫入 Agent 檔案或對話。",
    "每天早上 9 点给我发一份行业新闻摘要": "每天早上 9 點給我發一份行業新聞摘要",
    "每周五下午 5 点生成本周工作总结": "每週五下午 5 點產生本週工作總結",
    "每个用户最多可以创建": "每個用戶最多可以創建",
    "免费赠送": "免費贈送",
    "描述": "描述",
    "名称": "名稱",
    "名称 *": "名稱 *",
    "名称不能为空": "名稱不能為空",
    "名称和头像": "名稱和頭像",
    "明确角色": "明確角色",
    "模板消息": "範本訊息",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "免費額度為組織一次性額度，所有成員共同使用。目前以 $1 = 750 Nova 點折算。",
    "模型": "模型",
    "模型定义": "模型定義",
    "模型和": "模型和",
    "默认邮箱目录": "預設郵箱目錄",
    "目录": "目錄",
    "内部群聊": "內部群聊",
    "内容读取": "內容讀取",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "內建類型構成 NovaX 的共同語義，自訂類型描述你的獨特業務。",
    "你": "你",
    "模板中用": "模板中用",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "你可以把 Agent 理解為團隊中的一個虛擬成員。它可以：",
    "你可以随时在设置中注销账号，删除所有关联数据。": "你可以隨時在設定中註銷帳號，刪除所有關聯資料。",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "你可以隨時在設定中登出賬號，刪除所有關聯資料。",
    "女娲 · Skill 造人术": "女媧 · Skill 造人術",
    "篇": "篇",
    "频道对话": "頻道對話",
    "平台": "平台",
    "平台公告": "平台公告",
    "评估后果": "評估後果",
    "评论读取": "評論讀取",
    "凭据已加密保存，": "憑證已加密儲存，",
    "期望方向": "期望方向",
    "企业微信": "企業微信",
    "企业邮箱 / 自定义 IMAP": "企業信箱 / 自訂 IMAP",
    "启用（兼容自签名证书）": "啟用（相容自簽名憑證）",
    "启用（推荐）": "啟用（建議）",
    "启用并验证证书": "啟用並驗證憑證",
    "起点 *": "起點 *",
    "前": "前",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "你在使用過程中輸入的對話內容僅用於與 AI 引擎交互，不會被額外儲存或用於訓練模型。",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。",
    "前往": "前往",
    "前往飞书开放平台 →": "前往飛書開放平台 →",
    "前缀隔离": "前綴隔離",
    "乔布斯思维": "賈伯斯思維",
    "切换": "切換",
    "前提：Agent 需要安装": "前提：Agent 需要安裝",
    "切换组织": "切換組織",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "切換或建立組織，每個組織有獨立的 Agent 和成員。",
    "切换中...": "切換中...",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "請結合簡報結論，進一步說明原因、可能影響，以及我們接下來最值得採取的行動。",
    "请输入您的反馈、建议或遇到的问题...": "請輸入您的回饋、建議或遇到的問題...",
    "请填写 App ID 和 App Secret": "請填寫 App ID 和 App Secret",
    "请勿填写网页登录密码": "請勿填寫網頁登入密碼",
    "请选择一个角色": "請選擇一個角色",
    "区域": "區域",
    "驱动行动": "驅動行動",
    "取消": "取消",
    "全部": "全部",
    "全部对象": "全部對象",
    "全部执行对象": "全部執行對象",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "全程以 IMAP 唯讀模式開啟郵箱；可搜尋及讀取郵件內文、檢視附件名稱，不會傳送、刪除、移動或標記郵件。",
    "全员群": "全員群",
    "权限隔离": "權限隔離",
    "确保 Codex CLI 已安装": "確保 Codex CLI 已安裝",
    "确定": "確定",
    "确定断开？已保存凭据会被删除。": "確定斷開？已儲存憑證會被刪除。",
    "确定删除这个会议？": "確定刪除這個會議？",
    "确定删除这条指标观测吗？": "確定刪除這條指標觀測嗎？",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "切換組織後，你看到的 Agent、知識庫、團隊成員都會跟著改變。",
    "全局市场": "全域市場",
    "确认断开": "確認斷開",
    "清除后所有聊天记录将被删除，无法恢复。": "清除後所有聊天記錄將被刪除，無法恢復。",
    "确认清除": "確認清除",
    "确认已安装。": "確認已安裝。",
    "群聊": "群聊",
    "群聊@唤醒": "群組聊天@喚醒",
    "群聊对话": "群聊對話",
    "确认注销": "確認註銷",
    "确定要注销账号吗？": "確定要註銷帳號嗎？",
    "确定清除所有会话？": "確定清除所有會話？",
    "让组织的重要变化": "讓組織的重要變化",
    "人": "人",
    "人格蒸馏 · 女娲造人": "人格蒸餾 · 女媧造人",
    "群聊与多 Agent 协作": "群聊與多 Agent 協作",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "群組聊天是 NovaX 的核心協作場景。在 Agent 清單頂部點選「全員群」即可進入。群組聊天中所有 Agent 和團隊成員共處一個對話空間。",
    "认证方式": "認證方式",
    "任务": "任務",
    "任务名称": "任務名稱",
    "仍建议用实际数据验证候选原因。": "仍建議用實際數據驗證候選原因。",
    "日": "日",
    "日历联动": "日曆聯動",
    "日期": "日期",
    "如何创建": "如何創建",
    "人设和行为规则": "人設和行為規則",
    "群聊中需要通过": "群聊中需要透過",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "如有任何問題或疑慮，請透過產品內的回饋管道聯繫開發者。",
    "三": "三",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "掃碼登入微信後，Agent 可作為你的微信助手，自動回覆訊息、管理群聊、處理日常事務。",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "掃碼連接微信後，此 Agent 會自動接取微信訊息，可在私人聊天或群組聊天中回應。",
    "扫码区域": "掃碼區域",
    "删除": "刪除",
    "删除观测": "刪除觀測",
    "删除后无法恢复，确定要删除这个文档吗？": "刪除後無法恢復，確定要刪除這個文件嗎？",
    "删除会议": "刪除會議",
    "删除了 Agent": "刪除了 Agent",
    "删除失败": "刪除失敗",
    "删除失败或无权操作": "刪除失敗或無權操作",
    "删除文档": "刪除文檔",
    "商业专业": "商業專業",
    "上传": "上傳",
    "上传到哪里？": "上傳到哪裡？",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "上傳後仍可在「組織知識庫 / 我的知識庫」中分別查看。",
    "上传了": "上傳了",
    "上传录音": "上傳錄音",
    "上传失败": "上傳失敗",
    "三级权限体系": "三級權限體系",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。",
    "上次：": "上次：",
    "上次触发": "上次觸發",
    "上次执行": "上次執行",
    "上下游网络": "上下游網絡",
    "上一步": "上一步",
    "上游候选": "上游候選",
    "尚未补充业务定义": "尚未補充業務定義",
    "尚未连接指标或业务目标。": "尚未連接指標或業務目標。",
    "设定边界": "設定邊界",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "設定定時任務，例如\"每天早上9點給我發日報\"",
    "设计创作": "設計創作",
    "设计生成": "設計生成",
    "设计师包 · DESIGN": "設計師包 · DESIGN",
    "设置": "設定",
    "谁来行动": "誰來行動",
    "上传文件作为附件。": "上傳文件作為附件。",
    "设置头像，从预设中选择或上传自定义图片。": "設定頭像，從預設中選擇或上傳自訂圖片。",
    "什么属于这个类型，什么不属于？": "什麼屬於這個類型，什麼不屬於？",
    "生成二维码": "產生二維碼",
    "生成二维码失败": "產生二維碼失敗",
    "生成纪要": "生成紀要",
    "生成纪要中": "生成紀要中",
    "生成失败": "生成失敗",
    "生成中...": "生成中...",
    "失败": "失敗",
    "时间": "時間",
    "实体与关系来源": "實體與關係來源",
    "使用": "使用",
    "使用工具": "使用工具",
    "使用时只记住两个动作": "使用時只記住兩個動作",
    "使用引导": "使用引導",
    "使用方式": "使用方式",
    "什么是 Agent": "什麼是 Agent",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "使用郵箱註冊帳號。系統會發送驗證碼到你的信箱，驗證後設定密碼即可完成註冊。首次登入會自動建立一個預設組織。",
    "视条件而定": "視條件而定",
    "是": "是",
    "是 / 否": "是 / 否",
    "示例：": "範例：",
    "使用者的個人資訊用於任何商業用途。": "使用者的個人資訊用於任何商業用途。",
    "适用条件": "適用條件",
    "收到 Webhook 事件: {{payload}}": "收到 Webhook 事件: {{payload}}",
    "收起": "收起",
    "手动创建": "手動建立",
    "手动记录": "手動記錄",
    "输入清晰、唯一的业务名称": "輸入清晰、唯一的業務名稱",
    "输入消息，@agent 名字来提问": "輸入訊息，@agent 名字來提問",
    "属性": "屬性",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "屬性用於統一業務意義，也會成為 Agent 的結構化脈絡。",
    "属性字段": "屬性字段",
    "数": "數",
    "数据层：数从哪里来": "資料層：數從哪裡來",
    "数据从哪里来，经过什么，最终形成哪个指标": "數據從哪裡來，經過什麼，最後形成哪個指標",
    "数据分析": "數據分析",
    "数据观察": "數據觀察",
    "数据集": "數據集",
    "数据库、表和关键字段": "資料庫、表格和關鍵字段",
    "数据库地址": "資料庫位址",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "資料庫存取能自動補充血緣和觀測；它可以發現相關性，但不會自動把相關性升級成因果。",
    "数据库类型": "資料庫類型",
    "数据库密码": "資料庫密碼",
    "数据库名": "資料庫名",
    "数据血缘": "數據血緣",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "資料血緣回答「數從哪裡來」；影響關係回答「可能為什麼」；只有已驗證因果才能回答「確定是什麼導致」。",
    "数据血缘图": "數據血緣圖",
    "数据与办公": "數據與辦公室",
    "数据源": "資料來源",
    "数据源、表与字段": "資料來源、表格與字段",
    "数据资产": "數據資產",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "資料欄位 → 核心指標 → 業務目標 → 負責人",
    "数值来源": "數值來源",
    "数字": "數位",
    "双人": "雙人",
    "说明": "說明",
    "说明它在业务里代表什么，以及不包含什么": "說明它在業務裡代表什麼，以及不包含什麼",
    "私聊": "私聊",
    "私聊回复": "私聊回覆",
    "私钥口令（可选）": "私鑰口令（可選）",
    "思考中...": "思考中...",
    "思维框架": "思維框架",
    "四": "四",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "四層不是四個獨立目錄，而是一條從事實到行動的連結。你不需要一次填滿，先搭出一條最重要的連結即可。",
    "松开以上传 .md 文件": "放開以上傳 .md 文件",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "搜尋並讀取授權給 Integration 的 Notion 頁面與內容區塊，讓 Agent 使用團隊文件和專案資料。",
    "搜索会话内的文件": "搜尋會話內的文件",
    "搜索技能名称、描述或标签...": "搜尋技能名稱、描述或標籤...",
    "搜索内容": "搜尋內容",
    "搜索项目、团队或 Agent": "搜尋專案、團隊或 Agent",
    "搜索消息...": "搜尋訊息...",
    "搜索预设角色...": "搜尋預設角色...",
    "搜索知识库...": "搜尋知識庫...",
    "搜索指标或口径": "搜尋指標或口徑",
    "所属层 *": "所屬層 *",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "它也會持續關注競對的緊急或重要情報，以及產業和政策方向的大新聞，把真正需要組織關注的變化集中推到這裡。",
    "适合放入的内容": "適合放入的內容",
    "所有者（Owner）": "所有者（Owner）",
    "提出原因": "提出原因",
    "提交反馈": "提交回饋",
    "提交分析": "提交分析",
    "添加关系": "添加關係",
    "添加字段": "新增字段",
    "条关系": "條關係",
    "条件性": "條件性",
    "条因果关系": "條因果關係",
    "跳": "跳",
    "跳过引导": "跳過引導",
    "通过": "透過",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "透過 Pencil Headless CLI 創建、修改和匯出 .pen 設計稿，生成過程固定使用 Codex。",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "透過 Telegram Bot 與 Agent 交互，支援全球範圍內的即時通訊和檔案處理。",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "透過 Telegram Bot 與此 Agent 交互，支援全球即時通訊。",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "透過 WhatsApp Business API 接取此 Agent，覆蓋全球用戶。",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "透過企業微信應用程式存取此 Agent，支援內部溝通與客戶服務場景。",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "套餐與額度已經可以查看，支付管道確定後即可開放購買。",
    "通信对话 (": "通信對話 (",
    "通用工具 (": "通用工具 (",
    "同名文档": "同名文檔",
    "套餐之间仅额度不同，所有产品能力保持一致。": "套餐之間僅額度不同，所有產品能力一致。",
    "同一组织 · 同一份简报 · 持续沉淀": "同一組織 · 同一份簡報 · 持續沉澱",
    "统计": "統計",
    "统计粒度": "統計粒徑",
    "统计周期": "統計週期",
    "图标": "圖示",
    "图标视图": "圖示視圖",
    "图片 / PDF 导出": "圖片 / PDF 匯出",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "透過郵箱邀請成員加入，設定不同的角色（擁有者 / 管理員 / 成員）。",
    "团队的": "團隊的",
    "团队": "團隊",
    "团队日志": "團隊日誌",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "同一個 Agent 可以同時在 Web 和 IM 平台上工作，對話記憶和技能在所有平台間共享。",
    "团队规范和工作流程": "團隊規格和工作流程",
    "推荐建模顺序": "推薦建模順序",
    "推荐": "推薦",
    "团队协作（NovaX Bus）": "團隊協作（NovaX Bus）",
    "退出登录": "登出登入",
    "拖入 .md 文件，或点击上传": "拖入 .md 文件，或點選上傳",
    "团队规范、工作流程、审批标准": "團隊規範、工作流程、審核標準",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "推理強度，並在 workspace-write 沙箱內執行任務。",
    "外部平台": "外部平台",
    "外部系统 POST 到此 URL 即可触发": "外部系統 POST 到此 URL 即可觸發",
    "外观": "外觀",
    "完成": "完成",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "完整指標包含業務定義、計算口徑、粒度、維度、來源、負責人和歷史觀測。",
    "网络错误": "網路錯誤",
    "微信": "微信",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "微信連線基於網頁版協議，需要保持一個微訊號在線作為 Agent 載體。建議使用專用微訊號。",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "微信已連接，Agent 將自動回應訊息。服務重啟後即可使用。",
    "唯一标识": "唯一識別",
    "维度切片": "維度切片",
    "未补充映射表达式": "未補充映射表達式",
    "未连接": "未連接",
    "未设置": "未設定",
    "未设置编码": "未設定編碼",
    "未设置更新频率": "未設定更新頻率",
    "未设置公式": "未設定公式",
    "未设置统计粒度": "未設定統計粒度",
    "未知": "未知",
    "未知文档": "未知文檔",
    "文本": "文字",
    "文档读取失败": "文檔讀取失敗",
    "文档读取失败或无权访问": "文檔讀取失敗或無權訪問",
    "文档已覆盖": "文檔已覆蓋",
    "文档已删除": "文件已刪除",
    "文档已上传": "文件已上傳",
    "文件处理": "文件處理",
    "文件传输": "文件傳輸",
    "文件读取": "文件讀取",
    "文件分享": "文件分享",
    "文件过大，最大支持 2MB": "檔案過大，最大支援 2MB",
    "文件结构": "文件結構",
    "文件收发": "文件收發",
    "我": "我",
    "我的知识库": "我的知識庫",
    "我们": "我們",
    "我想继续讨论这篇组织简报：": "我想繼續討論這篇組織簡報：",
    "无单位": "無單位",
    "无公式": "無公式",
    "无可用 Agent": "無可用 Agent",
    "无描述": "無描述",
    "五": "五",
    "系统": "系統",
    "系统工具": "系統工具",
    "系统内置": "系統內建",
    "下次：": "下次：",
    "下次执行": "下次執行",
    "下一步": "下一步",
    "下游影响": "下游影響",
    "下载": "下載",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "先“新建物件”，再“建立關係”。物件可以是欄位、指標、目標或 Agent；關係需要明確選擇計算、血緣、影響、因果或歸屬，並盡量補充公式、條件、置信度和證據。",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "先創建「銷售額、訂單量、轉換率」這類真正用於決策的指標，補齊業務定義、公式、統計粒度和負責人；再記錄至少兩個週期的數值，NovaX 才能判斷它發生了什麼變化。",
    "先看懂四层业务地图": "先看懂四層業務地圖",
    "先验证，再保存": "先驗證，再保存",
    "现在搭建第一条业务链路": "現在搭建第一條業務鏈路",
    "现在可以通过受限工具安全使用这个连接。": "現在可以透過受限工具安全地使用這個連線。",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "現在先為你的組織產生第一期。後續隨著資訊和連結不斷補充，NovaX 會繼續在這裡為你推送值得關注的內容。",
    "限定前缀（可选）": "限定前綴（可選）",
    "限定文件 Key（可选）": "限定檔案 Key（可選）",
    "相对上一期": "相對上一期",
    "详细记忆文件": "詳細記憶文件",
    "项操作": "項操作",
    "系统任务": "系統任務",
    "消耗": "消耗",
    "消息导航": "訊息導航",
    "消息卡片": "訊息卡片",
    "消息": "訊息",
    "我們": "我們",
    "小": "小",
    "小时": "小時",
    "协作 Agent": "協作 Agent",
    "斜杠命令": "斜槓命令",
    "新建对象": "新建對象",
    "新建业务概念": "新建業務概念",
    "新建执行对象": "新執行對象",
    "新建指标": "新指標",
    "形成指标": "形成指標",
    "修改文件": "修改文件",
    "虚拟主机样式（AWS 默认）": "虛擬主機樣式（AWS 預設）",
    "需要两个周期": "需要兩個週期",
    "选择 .md 文件 →": "選擇 .md 檔案 →",
    "选择要安装到的 Agent": "選擇要安裝的 Agent",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "選擇一個預設角色快速開始，或手動建立自訂 Agent。",
    "选择一个执行对象": "選擇一個執行對象",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "選擇一個指標後，影響分析會向上尋找計算來源與候選驅動，向下尋找會受影響的目標、流程與負責人。影響關係只是線索；只有有驗證證據的因果關係，Agent 才會作為確定原因表達。",
    "选择一个指标开始": "選擇一個指標開始",
    "选择指标或业务对象": "選擇指標或業務對象",
    "血缘与计算映射": "血緣與計算映射",
    "寻址方式": "尋址方式",
    "沿关系找原因，也看后果": "沿關係找原因，也看後果",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "沿著下游關係識別會受影響的目標、流程、專案和負責人。",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "沿影響與因果關係產生候選驅動，並根據置信度、條件和證據降級表達。",
    "沿用 Figma Token 可见范围": "沿用 Figma Token 可見範圍",
    "颜色": "顏色",
    "演示文稿制作": "簡報製作",
    "验证并保存": "驗證並保存",
    "验证并连接": "驗證並連接",
    "验证结果": "驗證結果",
    "邀请成员": "邀請成員",
    "消息字体大小": "訊息字體大小",
    "要点速读": "要點速讀",
    "也是 Agent 们的": "也是 Agent 們的",
    "业务本体": "業務本體",
    "业务层：数字说明什么": "業務層：數字說明什麼",
    "业务地图": "業務地圖",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "業務地圖看全貌，指標網絡看口徑與上下游，資料血緣看來源，影響分析看原因與後果，組織執行看負責人，模型定義管理對象類型。切換視圖不會產生重複資料。",
    "业务定义": "業務定義",
    "业务对象": "業務對象",
    "写 Soul 的要点": "寫 Soul 的要點",
    "业务连接": "業務連接",
    "业务声明": "業務聲明",
    "业务指标": "業務指標",
    "页面分析": "頁面分析",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "頁面設計、簡報、AI 圖像生成 — 讓你的 Agent 擁有專業設計師水準。",
    "页面搜索": "頁面搜尋",
    "一": "一",
    "一只 Agent。": "一隻 Agent。",
    "移除了": "移除了",
    "已保存，留空不修改": "已保存，留空不修改",
    "已触发": "已觸發",
    "已存在，是否覆盖？": "已存在，是否覆蓋？",
    "已复制": "已複製",
    "已归档": "已歸檔",
    "已过期": "已過期",
    "已结束": "已結束",
    "已连接": "已連接",
    "已连接 ·": "已連接 ·",
    "已取消": "已取消",
    "已扫码，请在手机上确认...": "已掃碼，請在手機上確認...",
    "已生成纪要": "已生成紀要",
    "已完成": "已完成",
    "已验证": "已驗證",
    "已验证因果": "已驗證因果",
    "已暂停": "已暫停",
    "因果可信度阶梯": "因果可信度階梯",
    "业务规则、行业术语、标准话术": "業務規則、行業術語、標準話術",
    "研究员输出数据后：": "研究員輸出資料後：",
    "引导进度": "引導進度",
    "应用消息": "應用程式訊息",
    "应用专用密码 / 授权码": "應用專用密碼 / 授權碼",
    "影响分析": "影響分析",
    "影响分析失败": "影響分析失敗",
    "影响时滞": "影響時滯",
    "影响语义": "影響語意",
    "业务规则和约束条件": "業務規則和約束條件",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "因使用本產品所產生的任何直接或間接損失，開發者不承擔責任。",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。",
    "用 1 分钟看懂业务本体": "用 1 分鐘看懂業務本體",
    "用法示例": "用法範例",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "擁有 MetaSkill 技能的 Agent 可以根據你的需求自動創造新技能並發布。",
    "拥有专属的": "擁有專屬的",
    "用户名": "使用者名稱",
    "用链接或 ID 进入": "用連結或 ID 進入",
    "永久删除你的账号和所有数据，此操作不可撤销。": "永久刪除你的帳號和所有數據，此操作不可撤銷。",
    "用手机微信扫描二维码，确认登录。": "用手機微信掃描二維碼，確認登入。",
    "用手机微信扫描二维码并确认登录": "用手機微信掃描二維碼並確​​認登入",
    "用于比较变化": "用於比較變化",
    "用于区分这个 Agent 的 Pencil 设计文件": "用來區分這個 Agent 的 Pencil 設計文件",
    "邮件搜索": "郵件搜尋",
    "邮箱": "信箱",
    "邮箱类型": "信箱類型",
    "邮箱账号": "信箱帳號",
    "有纪要": "有紀要",
    "语义关系": "語意關係",
    "语义属性": "語義屬性",
    "用量明细加载失败": "用量明細加載失敗",
    "预定时间（可选，留空则立即开始）": "預定時間（可選，留空則立即開始）",
    "原始转写": "原始轉寫",
    "原因与后果": "原因與後果",
    "用户的个人信息用于任何商业用途。": "用戶的個人資訊用於任何商業用途。",
    "月度套餐": "月度套餐",
    "运行连接命令": "運行連線命令",
    "运行引擎": "運轉引擎",
    "运行中": "執行中",
    "再查一次": "再查一次",
    "再查一次，没有新增内容": "再查一次，沒有新增內容",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "在 Microsoft Teams 中與此 Agent 合作，融入企業辦公室流程。",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "在 Slack 頻道中直接與 Agent 協作，適合海外團隊的日常工作流程。",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "在 Slack 頻道中直接與此 Agent 協作，支援 Thread 回覆。",
    "语音输入（需浏览器支持 Web Speech API）。": "語音輸入（需瀏覽器支援 Web Speech API）。",
    "月度额度不足时，可由组织所有者补充。": "月度額度不足時，可由組織所有者補充。",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "在「設定 → 帳號管理」中建立新組織或切換組織。",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "在「任務」標籤頁的「Webhook」子標籤中創建，填寫名稱和提示詞範本。",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "在「團隊」頁面管理組織成員。點擊「邀請成員」輸入郵箱即可發送邀請。",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "在釘釘群組中連接此 Agent，支援訊息卡、工作通知等釘子原生能力。",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "在「團隊」頁面中點選「新建 Agent」即可創建，創建後點選 Agent 卡片進入詳情頁進行設定。",
    "在不同组织之间切换，数据完全隔离。": "在不同組織之間切換，資料完全隔離。",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "在對話式介面頂部切換到「技能」標籤頁，瀏覽可用清單並點擊安裝。",
    "在对话中让": "在對話中讓",
    "在对话中让 agent \"记住\"重要信息": "在對話中讓 agent \"記住\"重要訊息",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "在飛書後台確認授權，應用程式會自動取得必要的權限（訊息收發、群組管理等）。",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "在飛書群聊中直接與此 Agent 對話，支援富文本卡、文件收發等飛書原生能力。",
    "在服务器上读写文件、执行代码": "在伺服器上讀寫檔案、執行程式碼",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "在你的電腦上執行 NovaX Agent，將本機 Codex 工作區安全地連接到 NovaX。",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "在對話頁面的 Agent 清單中，你會看到一個「全員群」入口。在群組聊天中，你可以用 @AgentName 的方式指定某個 Agent 來回答問題。這使得多個 Agent 可以在同一個對話中協作，例如先讓「研究員」Agent 搜尋資料，再讓「寫手」Agent 根據資料撰寫文章。",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "在對話式介面頂部切換到「連線」標籤頁進行設定。目前支援：",
    "暂不关联": "暫不關聯",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "暫時需要手動在飛書後台建立應用程式並填入憑證。自動化建立流程正在開發中 — 屆時只需一鍵授權即可完成連線。",
    "暂停": "暫停",
    "暂无 Webhook": "暫無 Webhook",
    "暂无定时任务": "暫無計時任務",
    "暂无观测": "暫無觀測",
    "暂无观测值": "暫無觀測值",
    "暂无记录": "暫無紀錄",
    "暂无记忆": "暫無記憶",
    "暂无纪要 — 会议结束后自动转写": "暫無紀要 — 會議結束後自動轉寫",
    "暂无类型说明": "暫無類型說明",
    "暂无日志": "暫無日誌",
    "暂无属性字段": "暫無屬性字段",
    "暂无数据": "暫無數據",
    "暂无说明": "暫無說明",
    "暂无文件": "暫無文件",
    "暂无业务定义": "暫無業務定義",
    "粘贴 Figma 访问 Token": "貼上 Figma 訪問 Token",
    "粘贴 Zoom 链接或输入会议 ID": "貼上 Zoom 連結或輸入會議 ID",
    "展开查看": "展開檢視",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "在左側導覽列的「Skill 市集」頁面，可以瀏覽所有可用技能。",
    "账号": "帳號",
    "这份证据如何支持该关系？": "這份證據如何支持這段關係？",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "這裡保留原來的團隊、Agent、專案、任務、文件和 Skill，並把它們連接到業務指標。",
    "蒸馏": "蒸餾",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "蒸餾決策架構、第一原理與表達 DNA — 煉製一位可隨時召喚的思維顧問。",
    "整体结构": "整體結構",
    "正文与附件信息": "正文與附件資訊",
    "正向": "正向",
    "正在编撰组织简报": "正在編撰組織簡報",
    "正在创建微信连接...": "正在創建微信連接...",
    "正在读取组织最近的使用情况": "正在讀取組織最近的使用情況",
    "正在计算影响路径…": "正在計算影響路徑…",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "這是 NovaX 最強大的協作模式。你可以讓多個 Agent 在同一個對話中接力完成複雜任務：",
    "正在建立业务语义地图…": "正在建立業務語意地圖…",
    "正在生成二维码...": "正在產生二維碼...",
    "正在验证连接…": "正在驗證連線…",
    "正在由 Agent 团队编撰第一期": "正在由 Agent 團隊編撰第一期",
    "正在整理组织数据与知识": "正在整理組織資料與知識",
    "证据等级": "證據等級",
    "证据摘要": "證據摘要",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "支援 GitHub、GitLab、Gitee 和企業內部 Git 服務",
    "暂时无法读取额度信息": "暫時無法讀取額度資訊",
    "占位，表示外部传入的数据。例如：": "佔位，表示外部傳入的資料。例如：",
    "知识库": "知識庫",
    "知识库 &middot; Knowledge Base": "知識庫 · Knowledge Base",
    "支付功能正在准备中": "支付功能正在準備中",
    "知识库（Memory）— 共享大脑": "知識庫（Memory）— 共享大腦",
    "正在加载组织额度…": "正在加載組織額度…",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "知識庫是組織層級的共享文件庫。你上傳的每一篇 Markdown 文檔，都會成為該組織下所有 Agent 的共同知識。適合放入：",
    "知识库为空": "知識庫為空",
    "知识库文档": "知識庫文檔",
    "知识库暂无共享文档。": "知識庫暫無共享文件。",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "知識庫中上傳的文件儲存在伺服器本機，僅供你所在組織的 Agent 讀取。",
    "执行层：谁根据它采取行动": "執行層：誰根據它採取行動",
    "执行命令": "執行命令",
    "执行频率": "執行頻率",
    "执行任务": "執行任務",
    "执行时间": "執行時間",
    "执行时间：": "執行時間：",
    "执行异常": "執行例外",
    "执行指令": "執行指令",
    "执行中": "執行中",
    "只读查询": "只讀查詢",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "只讀連接 Gmail、QQ、163 或支援授權碼的企業 IMAP 信箱，讓 Agent 搜尋並整理真實郵件。",
    "只读收件箱": "只讀收件匣",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "知識庫是組織層級的共享文件庫。上傳的文件會被所有 Agent 在回答時自動參考，相當於給所有 Agent 統一配備了背景知識。",
    "指": "指",
    "指标": "指標",
    "指标 / 维度": "指標 / 維度",
    "指标不是一个数字": "指標不是一個數字",
    "指标层：数字怎么计算": "指標層：數字怎麼計算",
    "指标查询": "指標查詢",
    "指标观测": "指標觀測",
    "指标口径": "指標口徑",
    "指标目录": "指標目錄",
    "指标网络": "指標網絡",
    "指标已映射": "指標已映射",
    "指标异动与影响分析": "指標異動與影響分析",
    "指标值 *": "指標值 *",
    "至少需要两个周期": "至少需要兩個週期",
    "置信度": "置信度",
    "置信度 ·": "置信度 ·",
    "中": "中",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "知識庫中上傳的檔案儲存在伺服器本地，僅供你所在組織的 Agent 讀取。",
    "终点 *": "終點 *",
    "终端运行": "終端運作",
    "种类型": "種類型",
    "重复任务": "重複任務",
    "重新尝试": "重新嘗試",
    "重新加载": "重新載入",
    "重要规则": "重要規則",
    "周末": "週末",
    "主持人:": "主持人:",
    "主持人：": "主持人：",
    "主动来到你面前": "主動來到你面前",
    "只有组织所有者可以购买套餐或充值额度。": "只有組織所有者可以購買套餐或預付額度。",
    "注入": "注入",
    "注销账号": "註銷帳號",
    "转发": "轉發",
    "转发到": "轉發到",
    "转写已完成，可生成纪要": "轉寫已完成，可生成紀要",
    "转写中": "轉寫中",
    "状态": "狀態",
    "字段": "欄位",
    "字段名称": "欄位名稱",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "註冊所需的信箱僅用於帳號驗證和登錄，不會用於行銷或轉讓給第三方。",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "註銷後你的帳號、聊天記錄和所有資料將永久刪除，無法恢復。",
    "自定义类型": "自訂類型",
    "自定义名称、描述和人格": "自訂名稱、描述和人格",
    "自定义周期": "自訂週期",
    "自动响应指定聊天中的消息": "自動回應指定聊天中的消息",
    "自动应答": "自動應答",
    "自动转写生成纪要": "自動轉寫生成紀要",
    "自适应卡片": "自適應卡片",
    "组": "群組",
    "组件理解": "組件理解",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "註冊所需的郵箱僅用於帳號驗證和登錄，不會用於行銷或轉讓給第三方。",
    "组织": "組織",
    "注销中...": "註銷中...",
    "组织编辑人数": "組織編輯人數",
    "组织变动": "組織變動",
    "组织存储": "組織儲存",
    "组织洞察": "組織洞察",
    "组织成员和自动任务的消费都会记录在这里。": "組織成員和自動任務的消費都會記錄在這裡。",
    "组织里的某一位 Agent": "組織裡的某一位 Agent",
    "组织名称": "組織名稱",
    "组织共享额度": "組織共享額度",
    "组织内所有成员共享使用": "組織內所有成員共享使用",
    "组织文档数": "組織文件數",
    "组织信号": "組織訊號",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "組織是一個獨立的協作空間，類似 Slack 的 Workspace 或飛書的團隊。一個組織內的所有成員共享同一組 Agent 和知識庫。你可以：",
    "自定义界面显示偏好": "自訂介面顯示偏好",
    "组织（Workspace）— 协作空间": "組織（Workspace）— 協作空間",
    "组织与执行": "組織與執行",
    "组织知识库": "組織知識庫",
    "组织知识库日志": "組織知識庫日誌",
    "组织执行": "組織執行",
    "最多展开 3 跳": "最多展開 3 跳",
    "最多追溯 3 跳": "最多追溯 3 跳",
    "组织与多租户": "組織與多租戶",
    "组织与团队管理": "組織與團隊管理",
    "最近更新": "最近更新",
    "最近观测": "最近觀測",
    "最后更新：2026 年 5 月": "最後更新：2026 年 5 月",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "最小可用連結只需要四個物件。先從你每天都會關注的那個核心指標開始，後面再逐步補全，不需要一開始設計整個公司。",
    "最新观测": "最新觀測",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "左側是可能驅動或計算來源，右側是該指標會影響的物件。",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "作為 PEN_AGENT_API_KEY 僅傳給本次本地 Pencil 進程",
    "组织所有者": "組織所有者",
    "最後更新：2026 年 5 月": "最後更新：2026 年 5 月",
    "最近用量": "最近用量",
    "作为个人练手 Demo 项目，我们": "作為個人練手 Demo 項目，我們",
    "作為個人練手 Demo 專案，我們": "作為個人練手 Demo 項目，我們",
    "Agent 会怎样使用": "Agent 會如何使用",
    "Agent — 你的 AI 团队成员": "Agent — 你的 AI 團隊成員",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "Agent 會自動建立 cron 任務。執行結果以訊息形式出現在對話中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "Agent 不僅可以在 NovaX 網頁端使用，還可以連接到外部即時通訊平台。連結後 Agent 在所有平台共享同一套記憶、技能和知識庫。",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "Agent 啟動後會自動連接，下方狀態變綠即可開始使用。",
    "Agent 级别": "Agent 級別",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "Agent 是 NovaX 的核心單元。每個 Agent 是獨立的 AI 助手，擁有自己的：",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "Agent 可以建立定時執行的後台任務，無需你手動觸發。在對話式介面頂部切換到「任務」標籤頁檢視和管理。",
    "Agent 在对话中输出的文件会显示在这里": "Agent 在對話中輸出的檔案會顯示在這裡",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agent 是 NovaX 的核心概念。不同於傳統的聊天機器人，每個 Agent 是一個擁有",
    "Agent 周报": "Agent 週報",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Agent 在回答問題時會自動參考這些文檔，確保答案符合團隊的規格和上下文。",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "Agent 收到請求後會自動執行，並將結果傳送到對話中。",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "AI 產生的內容可能包含錯誤或不準確信息，請自行判斷和驗證。",
    "AI 图像生成": "AI 影像生成",
    "DOWNSTREAM · 下游": "DOWNSTREAM · 下游",
    "ETL 血缘": "ETL 血緣",
    "Git 仓库": "Git 倉庫",
    "Git 用户名；GitHub App 可填 x-access-token": "Git 使用者名稱；GitHub App 可填 x-access-token",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail、QQ、163 通常需要先開啟 IMAP 並建立應用專用密碼或授權碼",
    "IMAP 地址": "IMAP 地址",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Markdown 格式渲染，包括程式碼高亮、表格、清單等。",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "AI 產生的內容可能包含錯誤或不準確訊息，請自行判斷和驗證。",
    "Notion 工作区": "Notion 工作區",
    "Codex 智能体底座": "Codex 智能體底座",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX 採用組織（Workspace）為單位的多租戶架構。每個組織都是完全獨立的協作空間，Agent、知識庫、技能、成員、對話資料全部隔離。",
    "Nova 点": "Nova 點",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "NovaX 的介面由左側導覽列和右側主內容區組成。導覽列提供五個主要入口：",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX 會向上追溯資料與業務驅動，向下識別目標、流程和執行影響。",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "NovaX 的所有 Agent 統一運行在 OpenAI Codex 上，預設使用",
    "NovaX 是什么": "NovaX 是什麼",
    "NovaX 是一个": "NovaX 是一個",
    "NovaX Agent 工作区": "NovaX Agent 工作區",
    "PG 思维": "PG 思維",
    "Prompt 模板": "Prompt 模板",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Prompt 模板，以 {{payload}} 表示收到的數據",
    "QQ 邮箱": "QQ 信箱",
    "S3 兼容地址（AWS S3 可留空）": "S3 相容位址（AWS S3 可留空）",
    "Schema 浏览": "Schema 瀏覽",
    "secret_... 或 ntn_...": "secret_... 或 ntn_...",
    "Session Token（可选）": "Session Token（可選）",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX 是一個多 Agent AI 協作平台。你可以把它想像成一個 AI 團隊工作台：在這裡創建多個 AI Agent，每個 Agent 都有自己的名字、人設、專業和工作空間。它們能讀寫檔案、執行程式碼、搜尋網路、管理任務，像真正的團隊成員一樣協同工作。",
    "Skill 市场": "Skill 市場",
    "NovaX 是一個": "NovaX 是一個",
    "Shift+Enter 换行，Enter 发送。": "Shift+Enter 換行，Enter 發送。",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX 支援多組織架構。在「設定 → 通用」中可以管理組織：",
    "Soul 人设指令": "Soul 人設指令",
    "SQL 数据库": "SQL 資料庫",
    "SSH 私钥": "SSH 私鑰",
    "Thread 回复": "Thread 回覆",
    "TLS 加密": "TLS 加密",
    "Token 用量榜": "Token 用量榜",
    "UPSTREAM · 上游": "UPSTREAM · 上游",
    "Web 设计工程师": "Web 設計工程師",
    "Webhook 名称，如 GitHub Push...": "Webhook 名稱，如 GitHub Push...",
    "Soul（人设指令）": "Soul（人設指令）",
    "Webhook 事件触发": "Webhook 事件觸發",
    "Webhook URL（含 Secret）": "Webhook URL（含 Secret）",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "Soul 是 Agent 最重要的配置項，它決定了 Agent 的角色定位、專長領域和行為方式。寫好 Soul 是讓 Agent 真正好用的關鍵。",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook 讓外部系統透過 HTTP 請求觸發 Agent 執行任務，適合與 CI/CD、監控警告、表單提交等系統對接。"
  },
  "en": {
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— Switch to a different organization with a click, and the Agent and knowledge base will change accordingly.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— View Agents and members in your organization, create new Agents, or invite new members.",
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— View the background tasks being performed by the Agent, including progress, status, and results.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "—Give Agent recognition to facilitate differentiation in multi-Agent scenarios.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— Define the Agent’s personality, expertise, and behavior. For example, you can create a \"Code Reviewer\" Agent to focus on code quality, and then create a \"Product Manager\" Agent to make it good at requirements analysis.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— Tell the Agent who it is and what it specializes in.",
    "— 个人偏好、组织管理、账号安全。": "—Personal preferences, organizational management, and account security.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— Manage the Agent's installed skills, or install new skills from the market.",
    "— 管理共享文档，上传和浏览 .md 文件。": "— Manage shared documents, upload and browse .md files.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— What format, style, and steps should be followed when answering.",
    "— 接入 Zoom 会议或聊天。": "— Join a Zoom meeting or chat.",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— Can manage Agents, knowledge bases, and members, but cannot modify organization settings.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— You can use Agent, participate in conversations, and access the knowledge base, but cannot perform management operations.",
    "— 浏览和安装技能，管理已发布的技能。": "— Browse and install skills, and manage published skills.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— Give Agent the ability to create and manage scheduled tasks.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— Allow Agent to set scheduled or periodic tasks, such as generating reports every morning.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— Allow Agents to call other Agents to achieve cross-Agent collaboration.",
    "— 让 Agent 能够自动生成和发布新技能。": "— Enable Agents to automatically generate and publish new skills.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— Let Agents create new skills themselves and publish them to the market for other Agent installations to use.",
    "— 什么该做，什么不该做。": "— What to do and what not to do.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— The owner has full permissions, administrators can manage Agents and members, and ordinary members can use Agents and knowledge bases.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— Access through iLink to interact with Agent in WeChat.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "—Create a Bot through BotFather and fill in the Bot Token to connect.",
    "— 通过 Telegram Bot 接入。": "— Access via Telegram Bot.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— Expand the agent’s capability boundaries by installing different skills.",
    "— 通过企业微信或 iLink 接入。": "— Access via Business WeChat or iLink.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Talk to the Agent directly in Feishu through the Feishu robot.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "— Has full permissions to manage organization settings, members, and agents. Each organization has only one owner.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— Chat records with Agent support real-time streaming output.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— The main interface for communicating with Agents, with the Agent list on the left and the chat window on the right.",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— Allow Agents to call other Agents in the workspace to implement cross-Agent automated pipelines. For example, after Agent A completes the analysis, it automatically transfers the results to Agent B to generate a report.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— Invite members to join the current organization via email on the \"Team\" page.",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— Browse all available skills in the \"Skill Market\" in the navigation bar and view details and installation instructions.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— In the \"Skills\" tab of the dialogue interface, install or uninstall skills for the current Agent. Different Agents can have different skill sets installed.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Create an application on the Feishu open platform, obtain the App ID and App Secret, and then access it. Team members can chat directly with the Agent on Feishu.",
    "— 最多可创建 2 个组织。": "— Can create up to 2 organizations.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— The Agent can read and write files and execute code in the specified file system directory. Different Agents can operate different project directories.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": ", is not for profit, will not charge any fees to users, and will not conduct commercial promotion or sales in any form.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": ", not for profit, will not charge any fees to users, and will not conduct commercial promotion or sales in any form.",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": ", is only used to demonstrate the technical feasibility of the multi-Agent AI collaboration platform. This product",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": ", is only used to demonstrate the technical feasibility of the multi-Agent AI collaboration platform. This product",
    "，同时可以被邀请加入他人的组织。": ", and can be invited to join other people's organizations.",
    "、": ",",
    ".pen 文件": ".pen file",
    "· 点击启用": "· Click to enable",
    "· 点击召唤": "· Click to Summon",
    "· 用于 Agent 理解": "· Used for Agent understanding",
    "（一次性延时任务）": "(One-time delayed task)",
    "（由 Soul 指令定义）": "(defined by Soul directive)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst Based on the above data, make a competitive landscape analysis",
    "@提及": "@mentions",
    "@提及机制": "@mention mechanism",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer Organize the above analysis into a PDF report",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher Search the overseas market data of new energy vehicles in 2024",
    "/ 月": "/ moon",
    "← 返回": "← Return",
    "← 返回列表": "← Return to list",
    "← 返回详情": "← Return to details",
    "+ 记录": "+ record",
    "+ 添加": "+ add",
    "✓ 反馈已提交，感谢您的意见！": "✓ Feedback has been submitted, thank you for your opinion!",
    "✓ 已连接": "✓ Connected",
    "+ 创建新组织": "+ Create new organization",
    "1. 产品性质": "1. Product nature",
    "163 邮箱": "163 Email",
    "1. 產品性質": "1. Product nature",
    "2 个组织": "2 organizations",
    "2. 数据与隐私": "2. Data and Privacy",
    "2. 資料與隱私": "2. Data and Privacy",
    "3. 第三方服务": "3. Third-party services",
    "3. 第三方服務": "3. Third-party services",
    "30 分钟后提醒我开会": "Remind me of a meeting in 30 minutes",
    "4. 服务可用性": "4. Service availability",
    "4. 服務可用性": "4. Service availability",
    "5. 免责声明": "5. Disclaimer",
    "5. 免責聲明": "5. Disclaimer",
    "6. 聯絡方式": "6. Contact information",
    "6. 联系方式": "6. Contact information",
    "安装不同的": "Install different",
    "安装方式": "Installation method",
    "安装给以下 Agent：": "Installed to the following Agents:",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "Connect Agent to the instant messaging platform your team is using and have direct conversations in group chats or private chats.",
    "把世界级设计标准": "Bringing world-class design standards",
    "把指标接回真实数据": "Connect indicators back to real data",
    "保存对象": "save object",
    "保存失败": "Save failed",
    "保存修改": "Save changes",
    "保存中...": "Saving...",
    "保存中…": "Saving…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "The report regularly summarizes the entire organization's usage of NovaX, and also discovers business insights worthy of attention based on underlying data such as databases, BI, Git, and mailboxes that the organization has connected to.",
    "被移出了组织": "Removed from organization",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "This product is not suitable for professional scenarios such as medical advice, legal consultation, and financial decision-making.",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "This product calls the OpenAI Codex service to handle conversation requests. The content of your conversations will be processed in accordance with that service's privacy policy. It is recommended to avoid entering sensitive personal information in conversations.",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "This product is not suitable for professional scenarios such as medical advice, legal consultation, and financial decision-making.",
    "本次分析提示": "Tips for this analysis",
    "本期 SKILL": "SKILL in this issue",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "Ontology is not another knowledge base. It connects the objects, indicators, data and persons in charge in the business into a reasonable map, allowing the Agent to not only \"find information\", but also know how a number comes from, why it changes, and what impact it will have.",
    "本体加载失败": "Ontology loading failed",
    "本体视图": "ontology view",
    "本体完整度": "Ontological integrity",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "The ontology only saves the structure and caliber, and the database credentials are managed by the connector or environment variables and do not enter the business graph.",
    "本月": "this month",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "Compare the indicator observation values, and then follow the calculation and data lineage to find which layer the change occurred.",
    "必填": "Required",
    "避免把相关性误判为因果": "Avoid mistaking correlation for causation",
    "编辑": "edit",
    "编辑定义": "Edit definition",
    "编辑对象": "Edit object",
    "编辑了 Agent": "Edited Agent",
    "编辑业务对象": "Edit business object",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "Writing Soul – This is the most crucial step. Soul determines how the Agent understands tasks and answers questions. The more specific it is written, the better the Agent will perform.",
    "标识（可选）": "Logo (optional)",
    "标题": "title",
    "表、视图、ETL 模型": "Tables, views, ETL models",
    "补充口径、边界或业务背景": "Supplement caliber, boundary or business context",
    "补充驱动关系": "Supplementary driving relationship",
    "补充影响关系": "Supplementary influence relationship",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "This product calls the OpenAI Codex service to handle the conversation request. The content of your conversations will be processed in accordance with that service's privacy policy. It is recommended to avoid entering sensitive personal information in conversations.",
    "不保證": "No guarantee",
    "不保证": "No guarantee",
    "不会用于商业化运营": "Will not be used for commercial operations",
    "不会主动收集": "Will not actively collect",
    "不會用於商業化營運": "Will not be used for commercial operations",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "Different Agents can have completely different Souls. For example, a team can have multiple agents with different roles such as \"researcher\", \"writer\", and \"code reviewer\" at the same time.",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "Unlike ordinary AI conversation tools, NovaX's Agent has persistent memory, installable skills, supports multi-person collaboration, and can connect to instant messaging platforms such as Feishu, Telegram, and WeChat to integrate AI into your daily workflow.",
    "参会者": "Attendees",
    "参与聚合、关联和过滤的列": "Columns involved in aggregation, association and filtering",
    "仓库地址": "Warehouse address",
    "仓库协作": "warehouse collaboration",
    "草稿": "draft",
    "策": "policy",
    "查看": "Check",
    "不會主動收集": "Will not actively collect",
    "查看全部模型 →": "View all models →",
    "查看它负责哪些指标、目标或业务流程。": "See what metrics, goals, or business processes it is responsible for.",
    "查看完整影响路径": "View full impact path",
    "查找文件": "Find files",
    "查看每个技能的功能说明、安装量和评分。": "View feature descriptions, installs, and ratings for each skill.",
    "产品 PRD、技术架构文档": "Product PRD, technical architecture documents",
    "产品文档和技术架构": "Product documentation and technical architecture",
    "常见问题和标准回答": "Frequently Asked Questions and Standard Answers",
    "常见问题和解答模板": "FAQ template",
    "成员 / Agent": "Member/Agent",
    "成员（Member）": "Member",
    "成员与权限": "Members and Permissions",
    "抽出一位大师的思维，": "Draw out the thoughts of a master,",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "In addition to the web interface, NovaX's Agent can also connect to instant messaging platforms:",
    "处理事件": "handle events",
    "触发次数": "Number of triggers",
    "创建": "create",
    "创建 Agent": "Create Agent",
    "创建 Webhook": "Create webhook",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "After creating a webhook, external systems (GitHub, Stripe, Sentry, etc.) can automatically trigger via HTTP POST",
    "创建第一个指标": "Create your first indicator",
    "创建核心指标": "Create core indicators",
    "创建会议": "Create meeting",
    "创建了 Agent": "Agent created",
    "创建类型": "Create type",
    "创建你的第一个 Agent": "Create your first Agent",
    "创建企业自建应用，获取凭证": "Create a self-built enterprise application and obtain credentials",
    "创建失败": "Creation failed",
    "创建时间": "creation time",
    "创建中...": "Creating...",
    "创建中…": "Creating…",
    "持久记忆": "lasting memory",
    "创建组织": "Create an organization",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "After creation, the system generates a unique URL and key, which can be triggered by an external system sending a POST request to the URL.",
    "创刊导读": "Introduction to the founding of the publication",
    "创作与协作": "Create and collaborate",
    "此文件类型暂不支持预览": "This file type does not currently support preview",
    "次": "Second-rate",
    "从 160+ 专业角色模板中选择": "Choose from 160+ professional role templates",
    "从数据到行动的业务地图": "Business mapping from data to action",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "Determine the exact semantics of the same word within the company from business object and metric definitions.",
    "从业务世界的第一个对象开始": "Start with the first object of the business world",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "Start with revenue, order volume, conversion rates, or the business results you care about most.",
    "从预设创建": "Create from preset",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "Create up to 2 organizations, one for different projects or teams.",
    "代码读取": "code reading",
    "待开始": "To be started",
    "待认领": "To be claimed",
    "大": "big",
    "待验证": "To be verified",
    "单次任务": "single task",
    "单次执行": "single execution",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "When you ask for metrics, lineage, attribution, or impact, NovaX Agent first reads the relevant ontology context. The knowledge base provides \"original text and background\", and the ontology provides \"determined business structure\", and the two can be related through evidence.",
    "待上线": "To be online",
    "当前": "current",
    "当前仅支持 .md 格式": "Currently only .md format is supported",
    "当前值": "current value",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "Register databases, data tables and key fields, and then use \"data lineage\" or \"calculation dependency\" to connect to indicators. In the future, when the Agent is asked about the caliber, it will be able to find the true source along the link instead of guessing based on documents.",
    "登记数据来源": "Register data sources",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "Register data sources, tables, and fields, and then connect to indicators using \"data lineage\" or \"calculation dependency\" relationships.",
    "登记数据资产": "Register data assets",
    "登录账号": "Login account",
    "登录状态已失效，请重新登录": "Login status has expired, please log in again",
    "等待 Agent 连接...": "Waiting for Agent to connect...",
    "等待连接成功": "Wait for successful connection",
    "等待确认": "Waiting for confirmation",
    "等待扫码...": "Waiting for scanning...",
    "等待中": "Waiting",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "Issue 1 · Compiled by Your Agent Team · This Issue",
    "的 AI 协作者。": "of AI collaborators.",
    "第二步：认识你的界面": "Step 2: Know your interface",
    "第三步：创建你的第一个 Agent": "Step 3: Create your first Agent",
    "第四步：开始对话": "Step 4: Start a conversation",
    "第一步：注册和登录": "Step 1: Register and log in",
    "第一期正在准备中": "The first issue is being prepared",
    "第五步：丰富 Agent 的知识": "Step 5: Enrich Agent’s knowledge",
    "点": "point",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "Click \"Generate QR Code\" and the system will start the WeChat web page login process.",
    "点击「生成二维码」获取微信登录码": "Click \"Generate QR Code\" to obtain the WeChat login code",
    "点击连接，系统自动完成配置": "Click Connect and the system automatically completes the configuration.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "Click the button below to jump to the Feishu open platform, and the system will automatically create a self-built application for you.",
    "钉钉": "DingTalk",
    "定时任务": "scheduled tasks",
    "调整对话消息流中的文字大小": "Adjust text size in conversation stream",
    "定时任务（MetaSchedule）": "Scheduled tasks (MetaSchedule)",
    "定位变化": "Positioning changes",
    "定义第一个核心指标": "Define the first core indicator",
    "定义核心指标": "Define core metrics",
    "定义业务类型": "Define business type",
    "定义这个 Agent 的性格、指令和能力...": "Define this Agent's personality, commands, and abilities...",
    "定义证据": "Define evidence",
    "定义指标口径": "Define indicator caliber",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Read Figma file structure, components and comments to let Agent understand interface design, design specifications and collaborative feedback.",
    "读取内容": "Read content",
    "读取网页": "Read web pages",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "After reading it, you can jump right into its dialogue and continue to ask questions about causes, impacts, and next steps.",
    "端口": "port",
    "断开连接": "Disconnect",
    "断开失败": "Disconnect failed",
    "独立身份、独立记忆、独立技能": "Independent identity, independent memory, independent skills",
    "对话": "dialogue",
    "对话系统": "Dialogue system",
    "对象": "object",
    "对象存储": "object storage",
    "对象类型 *": "Object type *",
    "对象列表": "object list",
    "对象已连接": "Object is connected",
    "对象已删除": "Object deleted",
    "对应 Agent 暂不可用": "The corresponding Agent is temporarily unavailable",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "Conversation is the core interaction method of NovaX. Each Agent maintains an independent conversation history. In the conversation interface, there are three tabs at the top:",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "Multiple files are separated by commas; if left blank, the visible range of the Token itself will be used.",
    "多媒体": "multimedia",
    "多 Agent 接力": "Multi-Agent relay",
    "多人": "multiple people",
    "多维表格": "multidimensional table",
    "多平台连接": "Multi-platform connectivity",
    "额度信息加载失败": "Failed to load quota information",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "The quota is shared by organization members, and all consumption is deducted from the current organization.",
    "额度与账单": "Credit limit and bill",
    "二": "two",
    "二维码已过期，请重新生成": "The QR code has expired, please regenerate it",
    "发起会议": "Start a meeting",
    "发送人": "sender",
    "发送时间": "Send time",
    "翻开 →": "Open →",
    "反馈": "feedback",
    "反馈中心": "Feedback Center",
    "返回": "return",
    "方向": "direction",
    "方向未知": "direction unknown",
    "访问 Token": "Access Token",
    "飞书 / Lark": "Feishu / Lark",
    "飞书开放平台": "Feishu open platform",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "The Feishu app has been created. Add the Bot to Feishu Group to start using it.",
    "费曼思维": "Feynman thinking",
    "分析对象": "Analysis object",
    "分析思路": "Analytical ideas",
    "分析完成后：": "After the analysis is complete:",
    "额外额度": "Extra credit",
    "分钟": "minute",
    "否": "no",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "The server will first verify the Pencil CLI Key. Design generation is fixed using Codex 5.6 sol · high, and only operates on .pen files in the current Agent workspace.",
    "服务器已连接，等待 Bot 上线...": "The server is connected, waiting for the Bot to come online...",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "The continued availability, stability or data durability of the Service. The Service may be suspended, changed or terminated at any time without notice. Do not use this product in a production environment or to store important data.",
    "负向": "Negative",
    "负责人": "person in charge",
    "复制": "copy",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "Copy the following command to the terminal and run it. The Agent will automatically connect to the NovaX server.",
    "富文本卡片": "Rich text card",
    "覆盖确认": "Coverage confirmation",
    "刚刚": "just",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "CONTINUED AVAILABILITY, STABILITY OR DATA DURABILITY OF THE SERVICES. The Service may be suspended, changed or terminated at any time without notice. Do not use this product in a production environment or to store important data.",
    "个": "indivual",
    "个对象": "objects",
    "个可用技能": "available skills",
    "个人存储": "personal storage",
    "个人文档数": "Number of personal documents",
    "个人知识库日志": "Personal knowledge base log",
    "个属性": "attributes",
    "个已有来源": "existing sources",
    "个字段": "fields",
    "个人练手的技术演示项目（Demo）": "Technical demonstration project (Demo) for personal practice",
    "格式文档，上传后立即生效。": "Format document, effective immediately after uploading.",
    "给任务取个名字...": "Give the task a name...",
    "更新计划": "Update plan",
    "工作目录": "working directory",
    "工作区标识（可选）": "Workspace ID (optional)",
    "工作区名称（可选）": "Workspace name (optional)",
    "工作日": "working days",
    "工作通知": "job notice",
    "個人練手的技術展示專案（Demo）": "Personal practice technology demonstration project (Demo)",
    "工作原理": "Working principle",
    "公开仓库（无需凭据）": "Public repository (no credentials required)",
    "公式、单位、粒度与负责人": "Formula, unit, granularity and person in charge",
    "供 Pencil 内的 Codex Agent 使用": "For use by Codex Agent within Pencil",
    "共同规则": "common rules",
    "共同记忆": "shared memory",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "There are currently no documents that can be associated in the shared knowledge base. You can add evidence after saving.",
    "关闭": "closure",
    "关闭简报": "Close presentation",
    "关闭上传选择": "Close upload selection",
    "关闭使用引导": "Close usage guide",
    "关闭消息导航": "Turn off message navigation",
    "关键字段": "Key fields",
    "关系名称": "relationship name",
    "关系说明": "Relationship description",
    "关系有证据": "There is evidence of relationship",
    "关系证据": "evidence of relationship",
    "观测日期": "Observation date",
    "观测值已删除": "Observation deleted",
    "观远 BI": "Guanyuan BI",
    "观远 BI 地址": "Guanyuan BI address",
    "观远 BI 密码": "Guanyuan BI password",
    "管理": "manage",
    "功能详解": "Detailed function explanation",
    "管理员（Admin）": "Admin",
    "规划中": "Under planning",
    "国内平台": "Domestic platform",
    "规定行为": "prescribed behavior",
    "还没有积累私有记忆": "No private memory has been accumulated yet",
    "还没有上游驱动": "There is no upstream driver yet",
    "还没有数据血缘": "No data lineage yet",
    "还没有下游影响": "No downstream effects yet",
    "还没有血缘关系。": "There is no blood relationship yet.",
    "还没有执行对象": "No execution object yet",
    "还没有指标": "No indicators yet",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "You also need to share the target page with this Integration in Notion.",
    "海外平台": "Overseas platform",
    "核心概念": "core concepts",
    "还没有产生额度消费": "No consumption quota has been incurred yet",
    "核心指标": "core indicators",
    "环比变化": "Month-on-month change",
    "恢复": "recover",
    "会话文件": "session file",
    "会议 ·": "Meeting ·",
    "会议集成": "Conference integration",
    "会议纪要": "meeting minutes",
    "会议链接或 ID": "Meeting link or ID",
    "会议密码:": "Meeting password:",
    "会议时长（分钟）": "Meeting length (minutes)",
    "会议主题": "Conference theme",
    "活跃": "active",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Verify the connection based on Guanyuan official GuanCLI. After connection, pages, cards, data sets, ETL, indicators and ChatBI can be read. Creation, modification and deletion are not allowed by default.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "Based on the WeChat iLink protocol, the Agent can directly send and receive private messages after scanning the QR code. It is recommended to use a dedicated WeChat account as the Agent carrier.",
    "即将推出": "coming soon",
    "计算 / 映射表达式": "Calculation/mapping expressions",
    "计算、影响与责任关系": "Calculation, Impact and Responsibility",
    "计算公式": "Calculation formula",
    "计算口径": "Calculate caliber",
    "记录定义、口径或事实所在位置": "Record definition, caliber or factual location",
    "记录两个以上周期": "Record more than two cycles",
    "记录两个周期的数据后即可比较变化。": "Changes can be compared after recording data for two periods.",
    "记录数值": "record value",
    "记录中…": "Recording…",
    "记住与你的所有历史对话（": "Remember all historical conversations with you (",
    "纪要": "summary",
    "核心内置技能": "Core built-in skills",
    "技能": "Skill",
    "技能。安装后直接在对话中用自然语言描述即可：": "Skill. After installation, just describe it in natural language in the conversation:",
    "技能（Skill）— 能力扩展": "Skill - ability expansion",
    "技能创作（MetaSkill）": "Skill Creation (MetaSkill)",
    "技能模块": "Skill module",
    "技能分为系统内置技能和社区发布的技能。": "Skills are divided into system built-in skills and community-published skills.",
    "技能市场": "skills market",
    "技能市场分为两个维度：": "The skills market is divided into two dimensions:",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "Skills are modules that extend the capabilities of Agents. Different Agents can be installed with different skill sets, just like employees are equipped with different tools.",
    "技能系统": "Skill system",
    "加入 Zoom 会议": "Join a Zoom meeting",
    "加入会议": "Join a meeting",
    "加入了组织": "Joined the organization",
    "加载中...": "loading...",
    "加载中…": "loading…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "Compatible with AWS S3, MinIO and most S3 protocol object storage",
    "简": "simple",
    "简报": "briefing",
    "简报加载失败": "Briefing failed to load",
    "简报生成失败": "Briefing generation failed",
    "建立关系": "build relationships",
    "建立血缘": "Establish bloodline",
    "建立业务关系": "Establish business relationships",
    "建立中…": "Building…",
    "建议从一个核心指标开始": "It is recommended to start with a core indicator",
    "建议使用数据库侧的只读账号": "It is recommended to use a read-only account on the database side",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "It is recommended to register a data source, a core indicator and a business goal first, and then connect them.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "It is recommended to only grant current_user:read, file_content:read, file_comments:read",
    "将": "Will",
    "将 App ID 和 App Secret 填入下方": "Fill in the App ID and App Secret below",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "Deploy this Agent as a Discord Bot to interact in the server channel.",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "Skills are functional modules that can be installed on Agents. Each skill gives the Agent a specific ability. NovaX has some built-in core skills and also provides a skills market for you to discover and install more features:",
    "角色权限": "Role permissions",
    "接入飞书": "Access Feishu",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Access the pages, data sets, ETL and indicator systems of Guanyuan BI, allowing this Agent to directly understand and analyze enterprise operating data.",
    "接入微信": "Access WeChat",
    "揭开第一期": "Unveil the first issue",
    "结构搭好后，Agent 会自动使用": "After the structure is set up, Agent will automatically use it",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "Structural relationships give candidate paths; true attribution still requires a combination of observations, evidence, and business conditions.",
    "结构信息充足": "Sufficient structural information",
    "解释业务": "explain business",
    "仅供": "only",
    "仅管理员可删除组织知识库文档": "Only administrators can delete organizational knowledge base documents",
    "仅支持 .md 文件": "Only supports .md files",
    "进 Agent 的肌肉记忆。": "Enter the Agent's muscle memory.",
    "近 30 天消耗": "Consumption in the last 30 days",
    "仅所有者可购买": "Only available for purchase by owner",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "Enter the \"Conversation\" page and click an Agent in the list on the left to enter the chat. Send a message in the input box and the Agent will stream back the answer in real time. Conversation support:",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "Enter the \"Team\" page and click the \"New Agent\" button. Fill in the name and description of the Agent and create it. After creation, click on the Agent card to enter the details page, where you can:",
    "进入第一期": "Enter the first period",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "Enter the \"Knowledge Base\" page and upload the document in .md format. These documents become a shared reference for all Agents. For example, you can upload the company's code specifications, and then let the code review agent check the code according to this specification.",
    "进行中": "in progress",
    "进行中/待开": "In progress/to be opened",
    "竞": "compete",
    "竞对与行业": "Competition and Industry",
    "聚合方式": "Aggregation method",
    "可留空自动生成，例如 contract": "Can be left blank to automatically generate, such as contract",
    "可能后果与下游": "Possible consequences and downstream",
    "可能原因与上游": "Possible reasons and upstream",
    "可选": "Optional",
    "可选 · 关联共享知识库": "Optional · Associated shared knowledge base",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "You can create teams, agents, or projects and establish accountability with metrics and business goals.",
    "可用": "Available",
    "进入左侧导航栏的「知识库」页面。": "Enter the \"Knowledge Base\" page in the left navigation bar.",
    "可用 Nova 点": "Available Nova Points",
    "可追溯证据": "traceable evidence",
    "客户联系": "customer contact",
    "口径、公式、粒度和负责人": "Caliber, formula, granularity and person in charge",
    "口径与依赖": "Caliber and dependence",
    "跨层查看正在形成的业务语义。": "See emerging business semantics across layers.",
    "快速上手": "Get started quickly",
    "来源与流转": "Source and circulation",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "to specify which Agent replies. Messages without @ will not trigger any Agent.",
    "类": "kind",
    "类型说明": "Type description",
    "类型已删除": "Type deleted",
    "类型与字段": "Types and fields",
    "累计消耗": "Cumulative consumption",
    "理解含义": "understand the meaning",
    "例：产品评审会、周例会...": "Example: Product review meeting, weekly meeting...",
    "例如 研究助手": "e.g. research assistant",
    "例如 demo": "For example demo",
    "例如 NovaX 产品团队": "For example, the NovaX product team",
    "例如 product-design": "For example product-design",
    "例如 researcher": "For example researcher",
    "例如：2026-W30 / 2026-07": "For example: 2026-W30/2026-07",
    "例如：合同": "For example: contract",
    "例如：经营看板 / SQL 查询": "For example: Business Kanban/SQL Query",
    "例如：库存充足时": "For example: when the stock is sufficient",
    "例如：渠道=自然流量，地区=华东": "For example: channel = natural traffic, region = East China",
    "例如：同日 / 7 天后": "For example: same day / 7 days later",
    "例如：支付转化率": "For example: payment conversion rate",
    "例如：SUM(pay_amount)": "For example: SUM(pay_amount)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "For example: SUM(pay_amount) or orders.pay_amount → revenue",
    "连接": "connect",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "Connect to AWS S3, MinIO, or a compatible object store and let the agent browse the directory and read files within the authorization prefix.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "Connect to a GitHub, GitLab, or Gitee repository and let this Agent read code, analyze changes, and participate in development collaboration within the scope of authorization.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "Connect to PostgreSQL, MySQL, SQL Server and other databases to query real business data with read-only permissions.",
    "连接成功": "Connection successful",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "After the connection is successful, the Agent will automatically access your WeChat and respond to messages in the designated chat.",
    "来扩展能力": "to expand capabilities",
    "连接飞书": "Connect to Feishu",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "After connecting to Feishu, team members can directly talk to the Agent in the Feishu group chat. It supports Feishu’s native capabilities such as rich text cards, file sending and receiving, and calendar linkage.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "After connection, file nodes and comments can be read, but it is not open to modify the design, post comments or manage the team.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "After connection, objects can be listed and files no larger than 2MB within the limited prefix can be read. Uploading, overwriting or deletion is not allowed.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "After connecting, you can search and read authorized pages and content blocks, but you are not allowed to create, modify or delete pages.",
    "连接计算来源和业务目标": "Connect computing sources and business goals",
    "连接类型": "Connection type",
    "连接目标或流程": "Connect target or process",
    "连接你的 AI 引擎": "Connect your AI engine",
    "连接上下游": "Connect upstream and downstream",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "Connect designs, documents, emails, code and business data to allow Agents to participate in real work within clearly authorized scope.",
    "连接失败": "Connection failed",
    "连接数据或指标": "Connect data or metrics",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "After the connection is completed, add the Agent to Feishu Group to start the conversation.",
    "连接微信": "Connect to WeChat",
    "连接验证成功": "Connection verification successful",
    "连接中...": "Connecting...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "After two consecutive recording periods, NovaX calculates the changes and searches for possible drivers upstream in an impact analysis.",
    "联网搜索": "Internet search",
    "链接": "Link",
    "列表视图": "list view",
    "临时凭据才需要": "Temporary credentials are only required",
    "另有": "Also",
    "留空会继续使用已加密保存的凭据": "Leave blank to continue using encrypted saved credentials",
    "六": "six",
    "六个视图，其实是同一张图": "Six views, actually the same picture",
    "路径样式（MinIO 常用）": "Path style (commonly used by MinIO)",
    "马斯克思维": "Musk thinking",
    "芒格思维": "Munger's thinking",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "Messages without @ any Agent will be sent to the group but will not trigger Agent replies, which facilitates communication between team members.",
    "连接到飞书、Telegram、微信等": "Connect to Feishu, Telegram, WeChat, etc.",
    "没有发现新增内容": "No new content found",
    "没有匹配的角色": "No matching role",
    "没有匹配的消息": "No matching messages",
    "没有匹配的指标": "No matching metrics",
    "没有上游路径": "no upstream path",
    "没有下游路径": "no downstream path",
    "没有新增内容": "Nothing new",
    "没有找到匹配的技能": "No matching skills found",
    "没有找到匹配的文件": "No matching file found",
    "每": "Every",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "Each Agent can see the context in the group chat, so subsequent Agents can directly reference the output of the previous Agent.",
    "每篇内容都来自": "Each content comes from",
    "每天": "every day",
    "每个用户最多可以创建": "Each user can create up to",
    "每天早上 9 点给我发一份行业新闻摘要": "Send me a summary of industry news every morning at 9am",
    "每小时": "per hour",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "Each layer answers a different question, and together they form the ontology that the Agent can reason about.",
    "每月": "per month",
    "每周": "weekly",
    "密码": "password",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "Passwords, tokens, and private keys are only encrypted and stored on the server side and will not be written to Agent files or conversations.",
    "每周五下午 5 点生成本周工作总结": "A summary of the week's work is generated every Friday at 5 p.m.",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "The free quota is a one-time quota for the organization and is shared by all members. Currently converted at $1 = 750 Nova Points.",
    "描述": "describe",
    "名称": "name",
    "名称 *": "Name *",
    "名称不能为空": "Name cannot be empty",
    "免费赠送": "free gift",
    "名称和头像": "Name and avatar",
    "模板消息": "template message",
    "明确角色": "clarify roles",
    "模板中用": "Used in templates",
    "模型定义": "Model definition",
    "模型": "Model",
    "模型和": "model and",
    "默认邮箱目录": "Default mailbox directory",
    "内部群聊": "Internal group chat",
    "内容读取": "Content reading",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "Built-in types form NovaX’s common semantics, and custom types describe your unique business.",
    "你": "you",
    "目录": "Table of contents",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "You can think of an Agent as a virtual member of the team. It can:",
    "你可以随时在设置中注销账号，删除所有关联数据。": "You can log out of your account and delete all associated data at any time in settings.",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "You can log out of your account at any time in settings and delete all associated data.",
    "女娲 · Skill 造人术": "Nuwa·Skill Human Creation Technique",
    "篇": "Chapter",
    "频道对话": "Channel conversation",
    "平台": "platform",
    "平台公告": "Platform announcement",
    "评估后果": "Assess the consequences",
    "评论读取": "Comments read",
    "凭据已加密保存，": "Credentials are saved encrypted,",
    "期望方向": "desired direction",
    "企业微信": "Enterprise WeChat",
    "企业邮箱 / 自定义 IMAP": "Business Email/Customized IMAP",
    "启用（兼容自签名证书）": "Enabled (compatible with self-signed certificates)",
    "启用（推荐）": "Enable (recommended)",
    "启用并验证证书": "Enable and verify certificate",
    "起点 *": "Starting point *",
    "前": "forward",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "The conversation content you enter during use is only used to interact with the AI ​​engine and will not be additionally stored or used to train the model.",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "The conversation content you enter during use is only used to interact with the AI ​​engine and will not be additionally stored or used to train the model.",
    "前往": "Go to",
    "前往飞书开放平台 →": "Go to Feishu Open Platform →",
    "前缀隔离": "prefix isolation",
    "乔布斯思维": "Jobs thinking",
    "前提：Agent 需要安装": "Prerequisite: Agent needs to be installed",
    "切换": "switch",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "Switch or create organizations, each organization has independent Agents and members.",
    "切换中...": "Switching...",
    "切换组织": "Switch organization",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "After switching organizations, the Agents, knowledge base, and team members you see will change accordingly.",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "Please use the conclusion of the briefing to further explain the reasons, possible impacts, and the most worthy actions we should take next.",
    "请输入您的反馈、建议或遇到的问题...": "Please enter your feedback, suggestions or issues...",
    "请填写 App ID 和 App Secret": "Please fill in App ID and App Secret",
    "请勿填写网页登录密码": "Please do not fill in the web page login password",
    "请选择一个角色": "Please select a role",
    "区域": "area",
    "驱动行动": "drive action",
    "取消": "Cancel",
    "全部": "all",
    "全部对象": "All objects",
    "全部执行对象": "All execution objects",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "The mailbox is opened in IMAP read-only mode throughout; the email body can be searched and read, and attachment names can be viewed. The email will not be sent, deleted, moved, or marked.",
    "清除后所有聊天记录将被删除，无法恢复。": "After clearing, all chat history will be deleted and cannot be recovered.",
    "全员群": "All members",
    "权限隔离": "Permission isolation",
    "确保 Codex CLI 已安装": "Make sure Codex CLI is installed",
    "确定": "Sure",
    "确定断开？已保存凭据会被删除。": "Are you sure to disconnect? Saved credentials will be deleted.",
    "全局市场": "global market",
    "确定删除这个会议？": "Are you sure you want to delete this meeting?",
    "确定删除这条指标观测吗？": "Are you sure you want to delete this indicator observation?",
    "确定要注销账号吗？": "Are you sure you want to cancel your account?",
    "确定清除所有会话？": "Are you sure you want to clear all sessions?",
    "确认断开": "Confirm disconnection",
    "确认清除": "Confirm clear",
    "确认已安装。": "Confirm it is installed.",
    "群聊": "group chat",
    "群聊@唤醒": "Group chat@wake",
    "群聊对话": "Group chat conversation",
    "确认注销": "Confirm logout",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "Group chat is the core collaboration scenario of NovaX. Click \"All Members\" at the top of the Agent list to enter. In a group chat, all Agents and team members share the same conversation space.",
    "群聊与多 Agent 协作": "Group chat and multi-Agent collaboration",
    "让组织的重要变化": "Make important changes in your organization",
    "人": "people",
    "人格蒸馏 · 女娲造人": "Personality Distillation·Nuwa creates human beings",
    "群聊中需要通过": "In group chat, you need to pass",
    "认证方式": "Authentication method",
    "任务": "Task",
    "人设和行为规则": "Personality and behavioral rules",
    "任务名称": "Task name",
    "仍建议用实际数据验证候选原因。": "It is still recommended to verify candidate causes with actual data.",
    "日": "day",
    "日历联动": "Calendar linkage",
    "日期": "date",
    "如何创建": "How to create",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "If you have any questions or concerns, please contact the developer through the in-product feedback channel.",
    "三": "three",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "If you have any questions or concerns, please contact the developer through the feedback channel within the product.",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "After scanning the QR code to log in to WeChat, Agent can serve as your WeChat assistant, automatically replying to messages, managing group chats, and handling daily affairs.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "After scanning the QR code to connect to WeChat, this Agent automatically accesses WeChat messages and can respond in private chats or group chats.",
    "扫码区域": "Scan code area",
    "删除": "delete",
    "删除观测": "Delete observation",
    "删除后无法恢复，确定要删除这个文档吗？": "Deletion cannot be restored. Are you sure you want to delete this document?",
    "删除会议": "Delete meeting",
    "删除了 Agent": "Agent deleted",
    "删除失败": "Delete failed",
    "删除失败或无权操作": "Deletion failed or no permission to operate",
    "删除文档": "Delete document",
    "商业专业": "Business major",
    "上传": "upload",
    "上传到哪里？": "Where to upload?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "After uploading, it can still be viewed separately in \"Organization Knowledge Base/My Knowledge Base\".",
    "上传了": "Uploaded",
    "上传录音": "Upload recording",
    "上传失败": "Upload failed",
    "三级权限体系": "Three-level authority system",
    "上传文件作为附件。": "Upload the file as an attachment.",
    "上次：": "Last time:",
    "上次触发": "last triggered",
    "上次执行": "last executed",
    "上下游网络": "Upstream and downstream networks",
    "上一步": "Previous step",
    "上游候选": "upstream candidate",
    "尚未补充业务定义": "No business definition has been added yet",
    "尚未连接指标或业务目标。": "No metrics or business goals have been connected yet.",
    "设定边界": "set boundaries",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "Set a scheduled task, such as \"Send me a daily report at 9 a.m. every day\"",
    "设计创作": "design creation",
    "设计生成": "design generation",
    "设计师包 · DESIGN": "Designer bag · DESIGN",
    "设置": "set up",
    "谁来行动": "who will act",
    "设置头像，从预设中选择或上传自定义图片。": "Set an avatar, choose from presets or upload a custom image.",
    "什么属于这个类型，什么不属于？": "What belongs to this genre and what does not?",
    "生成二维码": "Generate QR code",
    "生成二维码失败": "Failed to generate QR code",
    "生成纪要": "Generate minutes",
    "生成纪要中": "Generating minutes",
    "生成失败": "Build failed",
    "生成中...": "Generating...",
    "失败": "fail",
    "什么是 Agent": "What is Agent",
    "时间": "time",
    "实体与关系来源": "Entity and relationship sources",
    "使用": "use",
    "使用工具": "Use tools",
    "使用时只记住两个动作": "Just remember two actions when using it",
    "使用引导": "Use the guide",
    "使用方式": "Usage",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "Use your email address to register an account. The system will send a verification code to your email. After verification, set a password to complete the registration. Logging in for the first time automatically creates a default organization.",
    "示例：": "Example:",
    "视条件而定": "Subject to conditions",
    "是": "yes",
    "是 / 否": "whether",
    "使用者的個人資訊用於任何商業用途。": "User's personal information is used for any commercial purpose.",
    "适用条件": "Applicable conditions",
    "收到 Webhook 事件: {{payload}}": "Webhook event received: {{payload}}",
    "收起": "close",
    "手动创建": "Create manually",
    "手动记录": "Manual recording",
    "输入清晰、唯一的业务名称": "Enter a clear, unique business name",
    "输入消息，@agent 名字来提问": "Enter a message, @agent name to ask a question",
    "属性": "property",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "Attributes are used to unify business meaning and also become the structured context of the Agent.",
    "属性字段": "attribute field",
    "数": "number",
    "数据层：数从哪里来": "Data layer: where do the numbers come from?",
    "数据从哪里来，经过什么，最终形成哪个指标": "Where does the data come from, what does it go through, and which indicator is ultimately formed?",
    "数据分析": "data analysis",
    "数据观察": "Data observation",
    "数据集": "Dataset",
    "数据库、表和关键字段": "Database, tables and key fields",
    "数据库地址": "Database address",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "Database access can automatically supplement kinship and observation; it can discover correlations, but it will not automatically upgrade correlations to causation.",
    "数据库类型": "Database type",
    "数据库密码": "Database password",
    "数据库名": "Database name",
    "数据血缘": "Data lineage",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "Data lineage answers \"where do numbers come from?\"; influence relationship answers \"possibly why\"; only proven cause and effect can answer \"determine what causes it.\"",
    "数据血缘图": "Data lineage diagram",
    "数据与办公": "Data and Office",
    "数据源": "data source",
    "数据源、表与字段": "Data sources, tables and fields",
    "数据资产": "data assets",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "Data fields → Core indicators → Business goals → Person in charge",
    "数值来源": "Value source",
    "数字": "number",
    "双人": "Double",
    "说明": "illustrate",
    "说明它在业务里代表什么，以及不包含什么": "Explain what it represents in the business and what it does not include",
    "私聊": "private chat",
    "私聊回复": "Private chat reply",
    "私钥口令（可选）": "Private key password (optional)",
    "思考中...": "Thinking...",
    "思维框架": "thinking framework",
    "四": "Four",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "The fourth layer is not four separate directories, but a link from facts to action. You don’t need to fill it all at once, just build the most important link first.",
    "松开以上传 .md 文件": "Release to upload the .md file",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "Search and read Notion pages and content blocks authorized to Integration, allowing Agent to use team documents and project materials.",
    "搜索会话内的文件": "Search files within a session",
    "搜索技能名称、描述或标签...": "Search for a skill name, description, or tag...",
    "搜索内容": "Search content",
    "搜索项目、团队或 Agent": "Search for projects, teams or agents",
    "搜索消息...": "Search messages...",
    "搜索预设角色...": "Search for preset roles...",
    "搜索知识库...": "Search the knowledge base...",
    "搜索指标或口径": "Search metrics or caliber",
    "所属层 *": "Belonging layer *",
    "适合放入的内容": "What to put in",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "It will also continue to pay attention to urgent or important intelligence on competition, as well as big news on industry and policy directions, and push the changes that really require the organization's attention here.",
    "所有者（Owner）": "Owner",
    "提出原因": "Give reasons",
    "提交反馈": "Submit feedback",
    "提交分析": "Submit analysis",
    "添加关系": "Add relationship",
    "添加字段": "Add field",
    "条关系": "relationship",
    "条件性": "conditionality",
    "条因果关系": "causal relationship",
    "跳": "Jump",
    "跳过引导": "Skip boot",
    "套餐之间仅额度不同，所有产品能力保持一致。": "Only the amount differs between packages, and all product capabilities remain the same.",
    "通过": "pass",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "Packages and quotas can already be viewed, and purchases can be made once the payment channel is confirmed.",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Create, modify and export .pen design drafts through Pencil Headless CLI, and the generation process always uses Codex.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Interact with Agent through Telegram Bot, supporting instant messaging and file processing on a global scale.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Interact with this Agent through Telegram Bot to support global instant messaging.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "Access this Agent through WhatsApp Business API to reach users around the world.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "Access this Agent through the enterprise WeChat application to support internal communication and customer service scenarios.",
    "通信对话 (": "communication conversation (",
    "通用工具 (": "General Tools (",
    "同名文档": "Document with the same name",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "Invite members to join via email and set different roles (owner/administrator/member).",
    "同一组织 · 同一份简报 · 持续沉淀": "The same organization · the same brief · continuous accumulation",
    "统计": "statistics",
    "统计粒度": "statistical granularity",
    "统计周期": "statistical period",
    "图标": "icon",
    "图标视图": "icon view",
    "图片 / PDF 导出": "Image/PDF export",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "The same Agent can work on both Web and IM platforms, and conversational memories and skills are shared across all platforms.",
    "团队的": "team",
    "团队": "team",
    "团队规范、工作流程、审批标准": "Team specifications, work processes, and approval standards",
    "团队日志": "Team Log",
    "团队规范和工作流程": "Team norms and work processes",
    "推荐": "recommend",
    "团队协作（NovaX Bus）": "Team collaboration (NovaX Bus)",
    "推荐建模顺序": "Recommended modeling order",
    "退出登录": "Log out",
    "拖入 .md 文件，或点击上传": "Drag in the .md file, or click Upload",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "Reason strength and execute tasks within the workspace-write sandbox.",
    "外部系统 POST 到此 URL 即可触发": "External system POST to this URL can be triggered",
    "外部平台": "external platform",
    "外观": "Appearance",
    "完成": "Finish",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "Complete indicators include business definition, calculation caliber, granularity, dimension, source, person in charge and historical observations.",
    "网络错误": "network error",
    "微信": "WeChat",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "WeChat connection is based on the web version protocol, and a WeChat account needs to be kept online as an Agent carrier. It is recommended to use a dedicated WeChat account.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat is connected and the Agent will automatically respond to the message. It can be used after the service is restarted.",
    "唯一标识": "unique identifier",
    "维度切片": "dimension slice",
    "未补充映射表达式": "Mapping expression not supplemented",
    "未连接": "Not connected",
    "未设置": "not set",
    "未设置编码": "No encoding set",
    "未设置更新频率": "Update frequency not set",
    "未设置公式": "No formula set",
    "未设置统计粒度": "Statistics granularity is not set",
    "未知": "unknown",
    "未知文档": "Unknown document",
    "文本": "text",
    "文档读取失败": "Document reading failed",
    "文档读取失败或无权访问": "Document reading failed or no access permission",
    "文档已覆盖": "Document covered",
    "文档已删除": "Document deleted",
    "文档已上传": "Document uploaded",
    "文件处理": "File processing",
    "文件传输": "file transfer",
    "文件读取": "file reading",
    "文件分享": "file sharing",
    "文件过大，最大支持 2MB": "The file is too large, the maximum supported is 2MB",
    "文件结构": "File structure",
    "文件收发": "File sending and receiving",
    "我": "I",
    "我的知识库": "My knowledge base",
    "我们": "us",
    "我想继续讨论这篇组织简报：": "I'd like to continue discussing this organizational brief:",
    "无单位": "Unitless",
    "无公式": "No formula",
    "无可用 Agent": "No Agent available",
    "无描述": "No description",
    "五": "five",
    "系统": "system",
    "系统工具": "system tools",
    "系统内置": "System built-in",
    "我們": "we",
    "下次：": "next time:",
    "下次执行": "Execute next time",
    "下一步": "Next step",
    "下游影响": "downstream effects",
    "下载": "download",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "First \"create a new object\" and then \"establish a relationship\". The object can be a field, indicator, target or agent; the relationship needs to explicitly select calculation, lineage, impact, causation or attribution, and try to supplement formulas, conditions, confidence and evidence.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "First create indicators such as \"sales, order volume, and conversion rate\" that are truly used for decision-making, and complete the business definition, formula, statistical granularity, and person in charge; then record the values ​​for at least two periods so that NovaX can determine what changes have occurred.",
    "先看懂四层业务地图": "First understand the four-layer business map",
    "先验证，再保存": "Verify first, then save",
    "现在搭建第一条业务链路": "Now build the first business link",
    "现在可以通过受限工具安全使用这个连接。": "This connection is now safe to use with restricted tools.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "Now start by generating the first issue for your organization. As information and connections continue to be added, NovaX will continue to push content worth paying attention to here.",
    "限定前缀（可选）": "Qualifying prefix (optional)",
    "限定文件 Key（可选）": "Qualified file Key (optional)",
    "相对上一期": "Compared to the previous issue",
    "详细记忆文件": "detailed memory file",
    "项操作": "operations",
    "系统任务": "System tasks",
    "消耗": "consume",
    "消息导航": "Message navigation",
    "消息卡片": "message card",
    "消息": "information",
    "小": "Small",
    "小时": "Hour",
    "协作 Agent": "Collaboration Agent",
    "斜杠命令": "slash command",
    "消息字体大小": "Message font size",
    "新建对象": "New object",
    "新建业务概念": "New business concept",
    "新建执行对象": "Create a new execution object",
    "新建指标": "New indicator",
    "形成指标": "form indicators",
    "修改文件": "Modify files",
    "虚拟主机样式（AWS 默认）": "Virtual host style (AWS default)",
    "需要两个周期": "It takes two cycles",
    "选择 .md 文件 →": "Select .md file →",
    "选择要安装到的 Agent": "Select the Agent to install to",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "Choose a preset role to get started quickly, or create a custom Agent manually.",
    "选择一个执行对象": "Select an execution object",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "After selecting a metric, impact analysis looks upwards to the source of calculation and candidate drivers, and downwards to the goals, processes, and people responsible for the impact. The influence relationship is just a clue; only the causal relationship with verification evidence will be expressed by the Agent as a definite cause.",
    "选择一个指标开始": "Choose an indicator to get started",
    "选择指标或业务对象": "Select a metric or business object",
    "血缘与计算映射": "Bloodline and computational mapping",
    "寻址方式": "Addressing mode",
    "沿关系找原因，也看后果": "Follow the relationship to find the cause, and also look at the consequences.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "Identify affected goals, processes, projects, and owners along downstream relationships.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "Generate candidate drivers along impact and causal relationships, and downgrade expressions based on confidence, conditions, and evidence.",
    "沿用 Figma Token 可见范围": "Inherit the visible range of Figma Token",
    "写 Soul 的要点": "Key Points to Writing Soul",
    "研究员输出数据后：": "After the researcher outputs the data:",
    "颜色": "color",
    "演示文稿制作": "Presentation production",
    "验证并保存": "Verify and save",
    "验证并连接": "Verify and connect",
    "验证结果": "Verification results",
    "邀请成员": "Invite members",
    "要点速读": "Points to read quickly",
    "也是 Agent 们的": "Also for Agents",
    "业务本体": "Business ontology",
    "业务层：数字说明什么": "Business Layer: What the Numbers Say",
    "业务地图": "business map",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "The business map looks at the overall picture, the indicator network looks at the caliber and upstream and downstream, the data lineage looks at the source, the impact analysis looks at the causes and consequences, the organization execution looks at the person in charge, and the model defines the management object type. Switching views does not create duplicate data.",
    "业务定义": "business definition",
    "业务对象": "business object",
    "业务规则、行业术语、标准话术": "Business rules, industry terminology, standard vocabulary",
    "业务连接": "business connection",
    "业务声明": "Business Statement",
    "业务指标": "business metrics",
    "页面分析": "Page analysis",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "Page design, presentations, AI image generation—make your Agent look like a professional designer.",
    "页面搜索": "Page search",
    "一": "one",
    "一只 Agent。": "An Agent.",
    "移除了": "Removed",
    "已保存，留空不修改": "Saved, leave blank without modification",
    "已触发": "Triggered",
    "已存在，是否覆盖？": "Already exists? Overwrite?",
    "已复制": "Copied",
    "已归档": "Archived",
    "已过期": "Expired",
    "已结束": "ended",
    "已连接": "Connected",
    "已连接 ·": "Connected ·",
    "已取消": "Canceled",
    "已扫码，请在手机上确认...": "The code has been scanned, please confirm on your mobile phone...",
    "已生成纪要": "Minute generated",
    "已完成": "Completed",
    "已验证": "Verified",
    "已验证因果": "Cause and effect verified",
    "已暂停": "Suspended",
    "因果可信度阶梯": "causal credibility ladder",
    "业务规则和约束条件": "Business rules and constraints",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "The developer is not responsible for any direct or indirect losses arising from the use of this product.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "The developer is not responsible for any direct or indirect losses arising from the use of this product.",
    "引导进度": "boot progress",
    "应用消息": "Application messages",
    "应用专用密码 / 授权码": "Application-specific password/authorization code",
    "影响分析": "impact analysis",
    "影响分析失败": "Impact analysis failed",
    "影响时滞": "Affect time lag",
    "影响语义": "Affect semantics",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "Agents with MetaSkill skills can automatically create and publish new skills based on your needs.",
    "用 1 分钟看懂业务本体": "Take 1 minute to understand the business ontology",
    "用法示例": "Usage examples",
    "拥有专属的": "Have exclusive",
    "用户名": "username",
    "用链接或 ID 进入": "Enter with link or ID",
    "用户的个人信息用于任何商业用途。": "User's personal information is used for any commercial purpose.",
    "用手机微信扫描二维码，确认登录。": "Use WeChat on your mobile phone to scan the QR code to confirm login.",
    "用手机微信扫描二维码并确认登录": "Use WeChat on your mobile phone to scan the QR code and confirm login",
    "用于比较变化": "used to compare changes",
    "用于区分这个 Agent 的 Pencil 设计文件": "Pencil design file used to distinguish this Agent",
    "邮件搜索": "Mail search",
    "邮箱": "Mail",
    "邮箱类型": "Email type",
    "邮箱账号": "Email account",
    "有纪要": "With minutes",
    "语义关系": "Semantic relations",
    "语义属性": "Semantic properties",
    "用量明细加载失败": "Failed to load usage details",
    "预定时间（可选，留空则立即开始）": "Scheduled time (optional, leave blank to start immediately)",
    "原始转写": "original transcription",
    "原因与后果": "causes and consequences",
    "永久删除你的账号和所有数据，此操作不可撤销。": "Permanently delete your account and all data. This action is irreversible.",
    "语音输入（需浏览器支持 Web Speech API）。": "Voice input (requires browser to support Web Speech API).",
    "月度额度不足时，可由组织所有者补充。": "If the monthly quota is insufficient, it can be replenished by the organization owner.",
    "月度套餐": "monthly package",
    "运行连接命令": "Run connection command",
    "运行引擎": "run engine",
    "运行中": "Running",
    "再查一次": "Check again",
    "再查一次，没有新增内容": "Checked again, no new content",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Collaborate with this Agent in Microsoft Teams and integrate into enterprise workflows.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "Collaborate directly with Agents in Slack channels, suitable for the daily workflow of overseas teams.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Work directly with this Agent in a Slack channel, supporting Thread replies.",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "Create it in the \"Webhook\" subtab of the \"Task\" tab and fill in the name and prompt word template.",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "Create a new organization or switch organizations in \"Settings → Account Management\".",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "Manage organization members on the \"Team\" page. Click \"Invite Members\" and enter your email address to send invitations.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "Click \"New Agent\" on the \"Team\" page to create it. After creation, click the Agent card to enter the details page for configuration.",
    "在不同组织之间切换，数据完全隔离。": "Switch between different organizations with complete data isolation.",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "Connect this Agent to a DingTalk group to support DingTalk's native capabilities such as message cards and work notifications.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "Switch to the \"Skills\" tab at the top of the conversation interface, browse the available list and click Install.",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "Switch to the \"Connection\" tab at the top of the dialog interface to configure. Currently supports:",
    "在对话中让": "let in conversation",
    "在对话中让 agent \"记住\"重要信息": "Let the agent \"remember\" important information during the conversation",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Confirm the authorization in the Feishu backend, and the application will automatically obtain the necessary permissions (message sending and receiving, group management, etc.).",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Communicate directly with this Agent in Feishu group chat, supporting Feishu's native capabilities such as rich text cards, file sending and receiving, etc.",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "In the Agent list on the conversation page, you will see an \"All Members Group\" entry. In a group chat, you can use @AgentName to specify an Agent to answer questions.这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "Run NovaX Agent on your computer to securely connect your local Codex workspace to NovaX.",
    "在服务器上读写文件、执行代码": "Read and write files and execute code on the server",
    "暂不关联": "Not relevant yet",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "For the time being, you need to manually create an application in the Feishu backend and fill in the credentials. An automated creation process is in development - one-click authorization will be all it takes to complete the connection.",
    "暂停": "pause",
    "暂无 Webhook": "No Webhooks yet",
    "暂无定时任务": "No scheduled tasks yet",
    "暂无观测": "No observations yet",
    "暂无观测值": "No observations yet",
    "暂无记录": "No record yet",
    "暂无记忆": "No memory yet",
    "暂无纪要 — 会议结束后自动转写": "No minutes yet - automatically transcribed after the meeting ends",
    "暂无类型说明": "No type description yet",
    "暂无日志": "No logs yet",
    "暂无属性字段": "No attribute fields yet",
    "暂无数据": "No data yet",
    "暂无说明": "No description yet",
    "暂无文件": "No files yet",
    "暂无业务定义": "No business definition yet",
    "粘贴 Figma 访问 Token": "Paste Figma access token",
    "粘贴 Zoom 链接或输入会议 ID": "Paste the Zoom link or enter the meeting ID",
    "展开查看": "Expand to view",
    "暂时无法读取额度信息": "Temporarily unable to read the credit information",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "On the \"Skill Market\" page in the left navigation bar, you can browse all available skills.",
    "账号": "account",
    "这份证据如何支持该关系？": "How does this evidence support the relationship?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "Here you keep your original teams, agents, projects, tasks, documents and skills and connect them to business metrics.",
    "占位，表示外部传入的数据。例如：": "Placeholder, representing externally incoming data. For example:",
    "蒸馏": "distillation",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "Distill decision-making frameworks, first principles, and expressive DNA—refining a mental advisor you can call upon at any time.",
    "整体结构": "overall structure",
    "正文与附件信息": "Text and attachment information",
    "正向": "forward",
    "正在编撰组织简报": "Compiling organizational briefing",
    "正在创建微信连接...": "Creating WeChat connection...",
    "正在读取组织最近的使用情况": "Reading the organization's recent usage",
    "正在计算影响路径…": "Calculating impact path…",
    "正在加载组织额度…": "Loading organization quota...",
    "正在建立业务语义地图…": "Building business semantic map...",
    "正在生成二维码...": "Generating QR code...",
    "正在验证连接…": "Verifying connection...",
    "正在由 Agent 团队编撰第一期": "The first issue is being compiled by the Agent team",
    "正在整理组织数据与知识": "Organizing organizational data and knowledge",
    "证据等级": "Level of evidence",
    "证据摘要": "summary of evidence",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "Supports GitHub, GitLab, Gitee and in-house Git services",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "This is NovaX’s most powerful collaboration mode. You can have multiple Agents take over to complete complex tasks in the same conversation:",
    "知识库": "knowledge base",
    "知识库 &middot; Knowledge Base": "Knowledge Base · Knowledge Base",
    "支付功能正在准备中": "Payment function is being prepared",
    "知识库（Memory）— 共享大脑": "Knowledge Base (Memory) - Shared Brain",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "A knowledge base is an organization-level shared document repository. Every Markdown document you upload will become the common knowledge of all Agents in the organization. Suitable for:",
    "知识库为空": "Knowledge base is empty",
    "知识库文档": "Knowledge base documentation",
    "知识库暂无共享文档。": "There are currently no shared documents in the knowledge base.",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "A knowledge base is an organization-level shared document repository. The uploaded documents will be automatically referenced by all Agents when answering, which is equivalent to equipping all Agents with background knowledge.",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "Documents uploaded in the knowledge base are stored locally on the server and can only be read by agents in your organization.",
    "执行层：谁根据它采取行动": "Executive layer: who takes action based on it",
    "执行命令": "execute command",
    "执行频率": "Execution frequency",
    "执行任务": "perform tasks",
    "执行时间": "Execution time",
    "执行时间：": "Execution time:",
    "执行异常": "Execution exception",
    "执行指令": "Execute instructions",
    "执行中": "Executing",
    "只读查询": "read-only query",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "Read-only connection to Gmail, QQ, 163 or enterprise IMAP mailbox that supports authorization code allows Agent to search and sort real emails.",
    "只读收件箱": "read-only inbox",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "Documents uploaded in the knowledge base are stored locally on the server and can only be read by agents in your organization.",
    "只有组织所有者可以购买套餐或充值额度。": "Only the organization owner can purchase plans or credits.",
    "指": "refer to",
    "指标": "index",
    "指标 / 维度": "Metrics/Dimensions",
    "指标不是一个数字": "An indicator is not a number",
    "指标层：数字怎么计算": "Indicator layer: how to calculate numbers",
    "指标查询": "Indicator query",
    "指标观测": "indicator observation",
    "指标口径": "Index caliber",
    "指标目录": "Indicator catalog",
    "指标网络": "indicator network",
    "指标已映射": "Metrics mapped",
    "指标异动与影响分析": "Indicator changes and impact analysis",
    "指标值 *": "Indicator value *",
    "至少需要两个周期": "At least two cycles are required",
    "置信度": "Confidence",
    "置信度 ·": "Confidence ·",
    "终点 *": "End point *",
    "终端运行": "Terminal run",
    "种类型": "type",
    "重复任务": "Repeat tasks",
    "重新尝试": "Try again",
    "重新加载": "reload",
    "重要规则": "Important rules",
    "周末": "weekend",
    "主持人:": "host:",
    "主持人：": "host:",
    "主动来到你面前": "Take the initiative to come to you",
    "中": "middle",
    "注入": "injection",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "After logging out, your account, chat history and all data will be permanently deleted and cannot be recovered.",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "The email address required for registration is only used for account verification and login, and will not be used for marketing or transferred to third parties.",
    "注销账号": "Cancel account",
    "注销中...": "Logging out...",
    "转发": "Forward",
    "转发到": "forward to",
    "转写已完成，可生成纪要": "Transcription has been completed and minutes can be generated",
    "转写中": "Transcribing",
    "状态": "state",
    "字段": "Field",
    "字段名称": "Field name",
    "自定义界面显示偏好": "Customize interface display preferences",
    "自定义类型": "Custom type",
    "自定义名称、描述和人格": "Customize name, description and personality",
    "自定义周期": "Custom cycle",
    "自动响应指定聊天中的消息": "Automatically respond to messages in a specified chat",
    "自动应答": "Auto answer",
    "自动转写生成纪要": "Automatically transcribe and generate minutes",
    "自适应卡片": "adaptive card",
    "组": "Group",
    "组件理解": "Component understanding",
    "组织": "organize",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "The email address required for registration is only used for account verification and login, and will not be used for marketing or transferred to third parties.",
    "组织编辑人数": "Number of editors in the organization",
    "组织变动": "organizational changes",
    "组织（Workspace）— 协作空间": "Organization (Workspace) — Collaboration space",
    "组织存储": "Organize storage",
    "组织洞察": "organizational insights",
    "组织成员和自动任务的消费都会记录在这里。": "The consumption of organization members and automatic tasks will be recorded here.",
    "组织里的某一位 Agent": "An Agent in the organization",
    "组织共享额度": "Organization sharing quota",
    "组织名称": "Organization name",
    "组织内所有成员共享使用": "Shared by all members of the organization",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "An organization is an independent collaboration space, similar to Slack's Workspace or Feishu's Team. All members of an organization share the same set of Agents and knowledge base. you can:",
    "组织文档数": "Number of organization documents",
    "组织信号": "organizational signals",
    "组织所有者": "Organization owner",
    "组织与执行": "Organization and Execution",
    "组织知识库": "organizational knowledge base",
    "组织知识库日志": "Organization knowledge base log",
    "组织执行": "Organizational execution",
    "最多展开 3 跳": "Expand up to 3 jumps",
    "最多追溯 3 跳": "Trace back up to 3 hops",
    "组织与多租户": "Organization and multi-tenancy",
    "组织与团队管理": "Organization and team management",
    "最后更新：2026 年 5 月": "Last updated: May 2026",
    "最近更新": "Latest updates",
    "最近观测": "recent observations",
    "最後更新：2026 年 5 月": "Last updated: May 2026",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "The minimum usable link requires only four objects. Start with the core indicator you pay attention to every day, and then gradually complete it later. There is no need to design the entire company at the beginning.",
    "最新观测": "Latest observations",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "On the left are possible drivers or calculation sources, and on the right are what the indicator affects.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "As PEN_AGENT_API_KEY, it is only passed to this local Pencil process.",
    "最近用量": "recent usage",
    "作為個人練手 Demo 專案，我們": "As a personal practice demo project, we",
    "作为个人练手 Demo 项目，我们": "As a personal training demo project, we",
    "Agent — 你的 AI 团队成员": "Agent — your AI team member",
    "Agent 会怎样使用": "How Agent will be used",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "Agent automatically creates cron tasks. The execution results appear in the conversation as messages. You can pause, resume, or delete created tasks in the Tasks tab.",
    "Agent 级别": "Agent level",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "After the Agent is started, it will automatically connect. The status below will turn green and you can start using it.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "Agent is the core unit of NovaX. Each Agent is an independent AI assistant with its own:",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "Agent can create background tasks that are executed regularly without you having to trigger them manually. Switch to the \"Tasks\" tab at the top of the conversation interface to view and manage.",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "Agent can not only be used on the NovaX web page, but can also be connected to external instant messaging platforms. Once connected, Agents share the same set of memories, skills, and knowledge base across all platforms.",
    "Agent 在对话中输出的文件会显示在这里": "The files output by the Agent in the conversation will be displayed here",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "The Agent automatically executes the request after receiving it and sends the result to the conversation.",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agent is the core concept of NovaX. Unlike traditional chatbots, each Agent is an agent with",
    "Agent 周报": "Agent Weekly",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Agents automatically reference these documents when answering questions, ensuring answers fit within the team's norms and context.",
    "AI 图像生成": "AI image generation",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "The content generated by AI may contain errors or inaccurate information, please make your own judgment and verification.",
    "DOWNSTREAM · 下游": "DOWNSTREAM · Downstream",
    "ETL 血缘": "ETL lineage",
    "Git 仓库": "Git repository",
    "Git 用户名；GitHub App 可填 x-access-token": "Git username; GitHub App can fill in x-access-token",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ, and 163 usually need to enable IMAP first and create an application-specific password or authorization code.",
    "IMAP 地址": "IMAP address",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "AI-generated content may contain errors or inaccurate information, please make your own judgment and verification.",
    "Codex 智能体底座": "Codex smart body base",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Markdown format rendering, including code highlighting, tables, lists, etc.",
    "Notion 工作区": "Notion workspace",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX adopts a multi-tenant architecture based on organizations (Workspaces). Each organization is a completely independent collaboration space, and agents, knowledge bases, skills, members, and conversation data are all isolated.",
    "Nova 点": "Nova point",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "The interface of NovaX consists of a navigation bar on the left and a main content area on the right. The navigation bar provides five main entrances:",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "All Agents of NovaX run uniformly on OpenAI Codex and use",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX traces data and business drivers upwards, and identifies goals, processes, and execution impacts downwards.",
    "NovaX 是什么": "What is NovaX",
    "NovaX 是一个": "NovaX is a",
    "NovaX 是一個": "NovaX is a",
    "NovaX Agent 工作区": "NovaX Agent workspace",
    "PG 思维": "PG thinking",
    "Prompt 模板": "Prompt template",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Prompt template, using {{payload}} to represent the received data",
    "QQ 邮箱": "QQ mailbox",
    "S3 兼容地址（AWS S3 可留空）": "S3 compatible address (AWS S3 can be left blank)",
    "Schema 浏览": "Schema Browse",
    "secret_... 或 ntn_...": "secret_... or ntn_...",
    "Session Token（可选）": "Session Token (optional)",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX is a multi-agent AI collaboration platform. You can think of it like an AI team workbench: multiple AI Agents are created here, each with their own name, persona, expertise, and workspace. They can read and write files, execute code, search the web, manage tasks, and work together like real team members.",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX supports multi-organizational structures. Organizations can be managed in \"Settings → General\":",
    "Skill 市场": "Skill Market",
    "Soul 人设指令": "Soul character command",
    "Shift+Enter 换行，Enter 发送。": "Shift+Enter to wrap line, Enter to send.",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "Soul is the most important configuration item of the Agent. It determines the Agent's role positioning, areas of expertise and behavior. Writing Soul well is the key to making Agent truly useful.",
    "SQL 数据库": "SQL database",
    "SSH 私钥": "SSH private key",
    "Thread 回复": "Thread Reply",
    "TLS 加密": "TLS encryption",
    "Token 用量榜": "Token usage list",
    "UPSTREAM · 上游": "UPSTREAM · upstream",
    "Web 设计工程师": "Web design engineer",
    "Webhook 名称，如 GitHub Push...": "Webhook name, such as GitHub Push...",
    "Soul（人设指令）": "Soul (personality command)",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook allows external systems to trigger Agent execution tasks through HTTP requests, and is suitable for interfacing with CI/CD, monitoring alarms, form submission and other systems.",
    "Webhook URL（含 Secret）": "Webhook URL (including Secret)",
    "Webhook 事件触发": "Webhook event trigger"
  },
  "ja": {
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— 進行状況、ステータス、結果など、エージェントによって実行されているバックグラウンド タスクを表示します。",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— 組織内のエージェントとメンバーを表示したり、新しいエージェントを作成したり、新しいメンバーを招待したりできます。",
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— クリックして別の組織に切り替えると、エージェントとナレッジ ベースがそれに応じて変更されます。",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— エージェントの性格、専門知識、および行動を定義します。たとえば、コードの品質に重点を置く「コード レビューアー」エージェントを作成し、要件分析を得意とする「プロダクト マネージャー」エージェントを作成できます。",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "- 複数エージェントのシナリオでの差別化を促進するために、エージェントを認識します。",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— エージェントに、それが誰であるか、そして何を専門としているかを伝えます。",
    "— 个人偏好、组织管理、账号安全。": "-個人の好み、組織管理、アカウントのセキュリティ。",
    "— 管理共享文档，上传和浏览 .md 文件。": "— 共有ドキュメントを管理し、.md ファイルをアップロードおよび参照します。",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— エージェントにインストールされているスキルを管理するか、マーケットから新しいスキルをインストールします。",
    "— 回答时应该遵循什么格式、风格、步骤。": "— 回答する際にはどのような形式、スタイル、手順に従う必要がありますか。",
    "— 接入 Zoom 会议或聊天。": "— Zoom ミーティングまたはチャットに参加します。",
    "— 浏览和安装技能，管理已发布的技能。": "— スキルを参照してインストールし、公開されたスキルを管理します。",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— エージェント、ナレッジベース、およびメンバーを管理できますが、組織の設定を変更することはできません。",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— エージェントを使用したり、会話に参加したり、ナレッジ ベースにアクセスしたりすることはできますが、管理操作を実行することはできません。",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— エージェントにスケジュールされたタスクを作成および管理できるようにします。",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— エージェントが他のエージェントに電話して、エージェント間のコラボレーションを実現できるようにします。",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— エージェントが毎朝のレポートの生成など、スケジュールされたタスクまたは定期的なタスクを設定できるようにします。",
    "— 让 Agent 能够自动生成和发布新技能。": "— エージェントが新しいスキルを自動的に生成して公開できるようにします。",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— エージェントが新しいスキルを自分で作成し、他のエージェント インストールで使用できるようにマーケットに公開します。",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— 所有者は完全な権限を持ち、管理者はエージェントとメンバーを管理でき、一般のメンバーはエージェントとナレッジベースを使用できます。",
    "— 什么该做，什么不该做。": "— 何をすべきか、何をしてはいけないのか。",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— iLink 経由でアクセスして、WeChat でエージェントと対話します。",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "- BotFather を通じてボットを作成し、ボット トークンを入力して接続します。",
    "— 通过企业微信或 iLink 接入。": "— ビジネス WeChat または iLink 経由でアクセスします。",
    "— 通过 Telegram Bot 接入。": "— Telegram Bot経由でアクセスします。",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— フェイシュロボットを通じてフェイシュのエージェントと直接話します。",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— さまざまなスキルをインストールすることで、エージェントの能力の限界を拡張します。",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— エージェントと通信するためのメイン インターフェイス。左側にエージェント リスト、右側にチャット ウィンドウが表示されます。",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— エージェントがワークスペース内の他のエージェントを呼び出して、エージェント間の自動パイプラインを実装できるようにします。たとえば、エージェント A が分析を完了すると、その結果が自動的にエージェント B に転送され、レポートが生成されます。",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— エージェントとのチャット記録は、リアルタイムのストリーミング出力をサポートします。",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "- 組織の設定、メンバー、エージェントを管理するための完全な権限を持ちます。各組織には所有者が 1 人だけいます。",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— [チーム] ページで電子メールを介してメンバーを現在の組織に招待します。",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— ナビゲーション バーの「スキル マーケット」で利用可能なすべてのスキルを参照し、詳細とインストール手順を表示します。",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— ダイアログ インターフェイスの [スキル] タブで、現在のエージェントのスキルをインストールまたはアンインストールします。エージェントごとに異なるスキル セットをインストールできます。",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Feishuオープンプラットフォーム上でアプリケーションを作成し、App IDとApp Secretを取得してアクセスします。チームメンバーは、Feishu 上のエージェントと直接チャットできます。",
    "— 最多可创建 2 个组织。": "— 組織は 2 つまで作成できます。",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": "は営利目的ではなく、ユーザーに料金を請求することはなく、いかなる形でも商業的なプロモーションや販売を行うことはありません。",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— エージェントは、指定されたファイル システム ディレクトリでファイルの読み取りと書き込み、およびコードの実行ができます。異なるエージェントは異なるプロジェクト ディレクトリを操作できます。",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": "は営利目的ではなく、ユーザーに料金を請求することはなく、いかなる形でも商業的なプロモーションや販売を行うことはありません。",
    "、": "、",
    ".pen 文件": ".penファイル",
    "· 点击启用": "· クリックして有効にします",
    "· 点击召唤": "· クリックして召喚",
    "· 用于 Agent 理解": "· エージェントの理解に使用されます",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": "、マルチエージェント AI コラボレーション プラットフォームの技術的な実現可能性を実証するためにのみ使用されます。この商品",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": "、マルチエージェント AI コラボレーション プラットフォームの技術的な実現可能性を実証するためにのみ使用されます。この商品",
    "（一次性延时任务）": "(1回だけ遅延したタスク)",
    "@提及": "@メンション",
    "，同时可以被邀请加入他人的组织。": "、他の人の組織に招待されることもあります。",
    "（由 Soul 指令定义）": "(Soul ディレクティブで定義)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst 上記のデータに基づいて、競合状況の分析を行います。",
    "← 返回": "← 戻る",
    "← 返回列表": "← 一覧に戻る",
    "← 返回详情": "← 詳細へ戻る",
    "/ 月": "/ 月",
    "+ 记录": "+記録",
    "+ 添加": "+追加",
    "✓ 反馈已提交，感谢您的意见！": "✓ フィードバックが送信されました。ご意見ありがとうございます。",
    "✓ 已连接": "✓ 接続済み",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer 上記の分析を PDF レポートに整理します",
    "@提及机制": "@メンションメカニズム",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher 2024年の新エネルギー車の海外市場データを調査",
    "163 邮箱": "163 メール",
    "+ 创建新组织": "+ 新しい組織を作成する",
    "1. 产品性质": "1. 製品の性質",
    "1. 產品性質": "1. 製品の性質",
    "2 个组织": "2団体",
    "3. 第三方服務": "3. サードパーティのサービス",
    "2. 数据与隐私": "2. データとプライバシー",
    "2. 資料與隱私": "2. データとプライバシー",
    "3. 第三方服务": "3. サードパーティのサービス",
    "4. 服務可用性": "4. サービスの利用可能性",
    "4. 服务可用性": "4. サービスの利用可能性",
    "5. 免责声明": "5. 免責事項",
    "30 分钟后提醒我开会": "30 分後の会議を思い出させて",
    "5. 免責聲明": "5. 免責事項",
    "安装方式": "設置方法",
    "安装给以下 Agent：": "次のエージェントにインストールされます:",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "チームが使用しているインスタント メッセージング プラットフォームにエージェントを接続し、グループ チャットまたはプライベート チャットで直接会話できます。",
    "把世界级设计标准": "世界クラスの設計基準をもたらす",
    "把指标接回真实数据": "インジケーターを実際のデータに接続します",
    "保存对象": "オブジェクトの保存",
    "保存失败": "保存に失敗しました",
    "保存修改": "変更を保存する",
    "保存中...": "保存中...",
    "保存中…": "保存中…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "このレポートでは、組織全体の NovaX の使用状況が定期的に要約され、組織が接続しているデータベース、BI、Git、メールボックスなどの基礎となるデータに基づいて、注目に値するビジネスの洞察も発見されます。",
    "被移出了组织": "組織から削除されました",
    "6. 联系方式": "6. 連絡先情報",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "この製品は、医学的アドバイス、法律相談、財務上の意思決定などの専門的なシナリオには適していません。",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "この製品は、OpenAI Codex サービスを呼び出して会話リクエストを処理します。会話の内容は、そのサービスのプライバシー ポリシーに従って処理されます。会話の中で機密の個人情報を入力しないことをお勧めします。",
    "6. 聯絡方式": "6. 連絡先情報",
    "安装不同的": "別のものをインストールする",
    "本次分析提示": "この分析のヒント",
    "本期 SKILL": "この号のスキル",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "オントロジーは別の知識ベースではありません。ビジネスのオブジェクト、指標、データ、担当者を合理的なマップに結びつけることで、エージェントは「情報を見つける」だけでなく、数値がどのようにして得られるのか、なぜ変化するのか、どのような影響を与えるのかを知ることができます。",
    "本体加载失败": "オントロジーのロードに失敗しました",
    "本体视图": "オントロジービュー",
    "本体完整度": "存在論的整合性",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "オントロジーは構造と口径のみを保存し、データベースの資格情報はコネクタまたは環境変数によって管理され、ビジネス グラフには入力されません。",
    "本月": "今月",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "インジケーターの観測値を比較し、計算とデータリネージに従って、どのレイヤーで変化が発生したかを確認します。",
    "必填": "必須",
    "避免把相关性误判为因果": "相関関係を因果関係と取り違えないようにする",
    "编辑": "編集",
    "编辑定义": "定義の編集",
    "编辑对象": "オブジェクトの編集",
    "编辑了 Agent": "編集されたエージェント",
    "编辑业务对象": "ビジネスオブジェクトの編集",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "この製品は、医学的アドバイス、法律相談、財務上の意思決定などの専門的なシナリオには適していません。",
    "标识（可选）": "ロゴ (オプション)",
    "标题": "タイトル",
    "表、视图、ETL 模型": "テーブル、ビュー、ETL モデル",
    "补充口径、边界或业务背景": "補足の口径、境界、またはビジネスコンテキスト",
    "补充驱动关系": "補助運転関係",
    "补充影响关系": "補足的な影響関係",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "魂を書く – これは最も重要なステップです。ソウルは、エージェントがタスクをどのように理解し、質問に答えるかを決定します。より具体的に記述されるほど、エージェントのパフォーマンスが向上します。",
    "不保证": "保証なし",
    "不保證": "保証なし",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "この製品は、OpenAI Codex サービスを呼び出して会話リクエストを処理します。会話の内容は、そのサービスのプライバシー ポリシーに従って処理されます。会話の中で機密の個人情報を入力しないことをお勧めします。",
    "不会用于商业化运营": "商業活動には使用されません",
    "不會用於商業化營運": "商業活動には使用されません",
    "参会者": "出席者",
    "参与聚合、关联和过滤的列": "集計、関連付け、フィルタリングに関与する列",
    "仓库地址": "倉庫の住所",
    "仓库协作": "倉庫コラボレーション",
    "草稿": "下書き",
    "策": "ポリシー",
    "查看": "チェック",
    "不会主动收集": "積極的には集めない",
    "不會主動收集": "積極的には集めない",
    "查看全部模型 →": "すべてのモデルを見る→",
    "查看它负责哪些指标、目标或业务流程。": "どのような指標、目標、またはビジネス プロセスを担当しているかを確認します。",
    "查看完整影响路径": "完全な影響経路を表示する",
    "查找文件": "ファイルの検索",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "異なるエージェントは完全に異なる魂を持つことができます。たとえば、チームには、「研究者」、「ライター」、「コードレビュー担当者」などの異なる役割を持つ複数のエージェントを同時に配置できます。",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "通常の AI 会話ツールとは異なり、NovaX のエージェントは永続的なメモリ、インストール可能なスキルを備え、複数人のコラボレーションをサポートし、Feishu、Telegram、WeChat などのインスタント メッセージング プラットフォームに接続して AI を日常のワークフローに統合できます。",
    "产品 PRD、技术架构文档": "製品PRD、技術アーキテクチャ文書",
    "产品文档和技术架构": "製品ドキュメントと技術アーキテクチャ",
    "查看每个技能的功能说明、安装量和评分。": "各スキルの機能の説明、インストール、評価を表示します。",
    "成员与权限": "メンバーと権限",
    "常见问题和解答模板": "FAQテンプレート",
    "成员 / Agent": "メンバー/エージェント",
    "常见问题和标准回答": "よくある質問と標準的な回答",
    "成员（Member）": "メンバー",
    "抽出一位大师的思维，": "匠の想いを引き出し、",
    "处理事件": "イベントを処理する",
    "触发次数": "トリガーの数",
    "创建": "作成する",
    "创建 Agent": "エージェントの作成",
    "创建 Webhook": "Webhook の作成",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "Webhook を作成した後、外部システム (GitHub、Stripe、Sentry など) は HTTP POST 経由で自動的にトリガーできます。",
    "创建第一个指标": "最初のインジケーターを作成する",
    "创建核心指标": "コアインジケーターの作成",
    "创建会议": "会議を作成する",
    "创建了 Agent": "エージェントが作成されました",
    "创建类型": "作成タイプ",
    "创建你的第一个 Agent": "最初のエージェントを作成する",
    "创建企业自建应用，获取凭证": "自社構築のエンタープライズ アプリケーションを作成し、資格情報を取得する",
    "创建失败": "作成に失敗しました",
    "创建时间": "作成時間",
    "创建中...": "作成...",
    "创建中…": "作成…",
    "创刊导读": "出版物の設立についての紹介",
    "创作与协作": "作成してコラボレーションする",
    "此文件类型暂不支持预览": "このファイル タイプは現在プレビューをサポートしていません",
    "次": "二流",
    "从 160+ 专业角色模板中选择": "160 を超える専門職の役割テンプレートから選択",
    "从数据到行动的业务地图": "データからアクションへのビジネスマッピング",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "ビジネス オブジェクトとメトリックの定義から、社内の同じ単語の正確な意味を判断します。",
    "从业务世界的第一个对象开始": "ビジネス世界の最初の目的から始める",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "収益、注文量、コンバージョン率、または最も関心のある業績から始めましょう。",
    "从预设创建": "プリセットから作成",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "Web インターフェイスに加えて、NovaX のエージェントはインスタント メッセージング プラットフォームにも接続できます。",
    "持久记忆": "永続的な記憶",
    "创建组织": "組織を作成する",
    "代码读取": "コードの読み取り",
    "待开始": "開始予定",
    "待认领": "請求されるべき",
    "大": "大きい",
    "待验证": "検証対象",
    "单次任务": "シングルタスク",
    "单次执行": "単一実行",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "メトリック、系統、属性、または影響を要求すると、NovaX エージェントはまず関連するオントロジー コンテキストを読み取ります。知識ベースは「オリジナルのテキストと背景」を提供し、オントロジーは「決定されたビジネス構造」を提供し、この 2 つは証拠を通じて関連付けることができます。",
    "当前": "現在",
    "当前仅支持 .md 格式": "現在、.md 形式のみがサポートされています",
    "当前值": "現在値",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "データベース、データテーブル、キーフィールドを登録し、「データリネージュ」や「計算依存関係」を利用してインジケーターに接続します。将来的には、エージェントが口径について尋ねられたとき、文書に基づいて推測するのではなく、リンクに沿って本当の情報源を見つけることができるようになります。",
    "登记数据来源": "データソースの登録",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "データソース、テーブル、フィールドを登録し、「データリネージ」または「計算の依存関係」関係を使用してインジケーターに接続します。",
    "登记数据资产": "データ資産の登録",
    "登录账号": "ログインアカウント",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "作成後、システムは一意の URL とキーを生成します。これは、外部システムが URL に POST リクエストを送信することによってトリガーされます。",
    "登录状态已失效，请重新登录": "ログインステータスの有効期限が切れています。再度ログインしてください",
    "等待 Agent 连接...": "エージェントが接続するのを待っています...",
    "等待连接成功": "接続が成功するまで待ちます",
    "等待确认": "確認待ち",
    "等待扫码...": "スキャンを待っています...",
    "等待中": "待っている",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "問題 1 · エージェント チームによって編集 · この問題",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "異なるプロジェクトまたはチーム用に 1 つずつ、最大 2 つの組織を作成します。",
    "的 AI 协作者。": "AI 協力者の数。",
    "待上线": "オンラインになるには",
    "第二步：认识你的界面": "ステップ 2: インターフェースを理解する",
    "第三步：创建你的第一个 Agent": "ステップ 3: 最初のエージェントを作成する",
    "第一期正在准备中": "第1号は準備中です",
    "点": "ポイント",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "「QR コードを生成」をクリックすると、システムは WeChat Web ページのログインプロセスを開始します。",
    "点击「生成二维码」获取微信登录码": "「QR コードを生成」をクリックして WeChat ログイン コードを取得します。",
    "点击连接，系统自动完成配置": "「接続」をクリックすると、システムは自動的に構成を完了します。",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "下のボタンをクリックして Feishu オープン プラットフォームにジャンプすると、システムが自動的に自己構築アプリケーションを作成します。",
    "钉钉": "ディントーク",
    "定时任务": "スケジュールされたタスク",
    "第四步：开始对话": "ステップ 4: 会話を開始する",
    "第一步：注册和登录": "ステップ 1: 登録してログインする",
    "定位变化": "ポジショニングの変更",
    "定义第一个核心指标": "最初のコアインジケーターを定義する",
    "定义核心指标": "コア指標を定義する",
    "定义业务类型": "ビジネスタイプを定義する",
    "定义这个 Agent 的性格、指令和能力...": "このエージェントの性格、コマンド、能力を定義します...",
    "定义证据": "証拠を定義する",
    "定义指标口径": "インジケーターの口径を定義する",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Figma のファイル構造、コンポーネント、コメントを読んで、エージェントがインターフェイスの設計、設計仕様、共同フィードバックを理解できるようにします。",
    "读取内容": "コンテンツを読む",
    "读取网页": "ウェブページを読む",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "読んだ後は、すぐに対話に飛び込み、原因、影響、次のステップについて質問を続けることができます。",
    "端口": "ポート",
    "断开连接": "切断する",
    "断开失败": "切断に失敗しました",
    "对话": "対話",
    "调整对话消息流中的文字大小": "会話ストリームのテキスト サイズを調整する",
    "定时任务（MetaSchedule）": "スケジュールされたタスク (MetaSchedule)",
    "第五步：丰富 Agent 的知识": "ステップ 5: エージェントの知識を強化する",
    "对象": "物体",
    "对象存储": "オブジェクトストレージ",
    "对象类型 *": "オブジェクトの種類 *",
    "对象列表": "オブジェクトリスト",
    "对象已连接": "オブジェクトが接続されています",
    "对象已删除": "オブジェクトが削除されました",
    "对应 Agent 暂不可用": "対応するエージェントは一時的に利用できません",
    "对话系统": "対話システム",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "複数のファイルはカンマで区切られます。空白のままにすると、トークン自体の表示範囲が使用されます。",
    "多媒体": "マルチメディア",
    "独立身份、独立记忆、独立技能": "独立したアイデンティティ、独立した記憶、独立したスキル",
    "多人": "複数人",
    "多维表格": "多次元テーブル",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "会話は NovaX の中核となる対話方法です。各エージェントは独立した会話履歴を保持します。会話インターフェイスの上部には 3 つのタブがあります。",
    "多平台连接": "マルチプラットフォーム接続",
    "多 Agent 接力": "マルチエージェントリレー",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "クォータは組織メンバーによって共有され、すべての消費量は現在の組織から差し引かれます。",
    "二": "二",
    "二维码已过期，请重新生成": "QRコードの有効期限が切れていますので再生成してください",
    "发起会议": "会議を開始する",
    "发送人": "差出人",
    "发送时间": "送信時間",
    "翻开 →": "開く→",
    "反馈": "フィードバック",
    "反馈中心": "フィードバックセンター",
    "返回": "戻る",
    "方向": "方向",
    "方向未知": "方向不明",
    "访问 Token": "アクセストークン",
    "飞书 / Lark": "フェイシュ/ヒバリ",
    "飞书开放平台": "フェイシュオープンプラットフォーム",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "フェイシュアプリが作成されました。 Bot を Feishu グループに追加して使用を開始します。",
    "费曼思维": "ファインマンの思考",
    "分析对象": "分析対象",
    "分析思路": "分析のアイデア",
    "分钟": "分",
    "否": "いいえ",
    "额外额度": "追加クレジット",
    "分析完成后：": "分析が完了したら:",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "サーバーは最初に Pencil CLI キーを検証します。デザインの生成は Codex 5.6 sol · high を使用して修正されており、現在のエージェント ワークスペース内の .pen ファイルでのみ動作します。",
    "服务器已连接，等待 Bot 上线...": "サーバーは接続されており、ボットがオンラインになるのを待っています...",
    "额度信息加载失败": "クォータ情報のロードに失敗しました",
    "额度与账单": "利用限度額と請求額",
    "负向": "ネガティブ",
    "负责人": "担当者",
    "复制": "コピー",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "次のコマンドをターミナルにコピーして実行します。エージェントは自動的に NovaX サーバーに接続します。",
    "富文本卡片": "リッチテキストカード",
    "覆盖确认": "補償範囲の確認",
    "刚刚": "ただ",
    "个": "個人の",
    "个对象": "オブジェクト",
    "个可用技能": "利用可能なスキル",
    "个人存储": "個人保管",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "サービスのデータの継続的な可用性、安定性、または耐久性。本サービスは、予告なくいつでも停止、変更、終了する場合があります。この製品を実稼働環境で使用したり、重要なデータを保存したりしないでください。",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "サービスの継続的な可用性、安定性、またはデータの耐久性。本サービスは、予告なくいつでも停止、変更、終了する場合があります。この製品を実稼働環境で使用したり、重要なデータを保存したりしないでください。",
    "个人文档数": "個人文書の数",
    "个人知识库日志": "個人的なナレッジベースのログ",
    "个属性": "属性",
    "个已有来源": "既存のソース",
    "个字段": "フィールド",
    "给任务取个名字...": "タスクに名前を付けます...",
    "更新计划": "計画を更新する",
    "工作区标识（可选）": "ワークスペースID (オプション)",
    "工作区名称（可选）": "ワークスペース名 (オプション)",
    "工作日": "営業日",
    "工作通知": "仕事の通知",
    "格式文档，上传后立即生效。": "ドキュメントのフォーマット。アップロード後すぐに有効になります。",
    "公开仓库（无需凭据）": "パブリックリポジトリ (認証情報は必要ありません)",
    "公式、单位、粒度与负责人": "計算式、単位、粒度、担当者",
    "个人练手的技术演示项目（Demo）": "個人練習向け技術実証プロジェクト（Demo）",
    "工作原理": "動作原理",
    "工作目录": "作業ディレクトリ",
    "供 Pencil 内的 Codex Agent 使用": "Pencil 内の Codex Agent によって使用される",
    "共同规则": "共通ルール",
    "共同记忆": "共有メモリ",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "現在、共有ナレッジ ベースに関連付けられるドキュメントはありません。保存後に証拠を追加できます。",
    "关闭": "閉鎖",
    "关闭简报": "プレゼンテーションを閉じる",
    "关闭上传选择": "アップロード選択を閉じる",
    "关闭使用引导": "ご利用ガイドを閉じる",
    "关闭消息导航": "メッセージナビゲーションをオフにする",
    "关键字段": "主要なフィールド",
    "关系名称": "関係名",
    "关系说明": "関係の説明",
    "关系有证据": "関係の証拠はある",
    "关系证据": "関係の証拠",
    "观测日期": "観測日",
    "观测值已删除": "観察が削除されました",
    "观远 BI": "BI グアンユアン",
    "观远 BI 地址": "関源BIアドレス",
    "观远 BI 密码": "Guanyuan BI パスワード",
    "管理": "管理",
    "個人練手的技術展示專案（Demo）": "個人練習技術実証事業（デモ）",
    "规划中": "計画中",
    "国内平台": "国内プラットフォーム",
    "管理员（Admin）": "管理者",
    "还没有积累私有记忆": "プライベートな記憶はまだ蓄積されていない",
    "还没有上游驱动": "上流のドライバーはまだありません",
    "还没有数据血缘": "まだデータリネージがありません",
    "还没有下游影响": "下流効果はまだありません",
    "还没有血缘关系。": "まだ血のつながりはありません。",
    "还没有执行对象": "まだ実行オブジェクトがありません",
    "还没有指标": "まだ指標はありません",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "また、ターゲット ページを Notion のこの統合と共有する必要があります。",
    "海外平台": "海外プラットフォーム",
    "功能详解": "詳しい機能説明",
    "核心指标": "コア指標",
    "环比变化": "前月比変化率",
    "恢复": "回復する",
    "会话文件": "セッションファイル",
    "会议 ·": "ミーティング ・",
    "会议集成": "会議の統合",
    "会议纪要": "会議議事録",
    "会议链接或 ID": "ミーティングリンクまたはID",
    "会议密码:": "ミーティングパスワード:",
    "会议时长（分钟）": "会議の長さ (分)",
    "会议主题": "会議のテーマ",
    "活跃": "アクティブ",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Guanyuan 公式 GuanCLI に基づいて接続を確認します。接続後、ページ、カード、データセット、ETL、インジケーター、ChatBI を読み取ることができます。デフォルトでは、作成、変更、削除は許可されていません。",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "WeChat iLink プロトコルに基づいて、エージェントは QR コードをスキャンした後、プライベート メッセージを直接送受信できます。専用の WeChat アカウントをエージェント キャリアとして使用することをお勧めします。",
    "即将推出": "近日公開",
    "计算 / 映射表达式": "計算式/マッピング式",
    "计算、影响与责任关系": "計算、影響、そして責任",
    "计算公式": "計算式",
    "计算口径": "口径の計算",
    "记录定义、口径或事实所在位置": "記録の定義、基準または事実上の場所",
    "记录两个以上周期": "2 サイクル以上を記録する",
    "记录两个周期的数据后即可比较变化。": "2 つの期間のデータを記録した後、変化を比較できます。",
    "记录数值": "記録的な価値",
    "记录中…": "録音中…",
    "规定行为": "規定された行動",
    "核心概念": "コアコンセプト",
    "纪要": "まとめ",
    "技能": "スキル",
    "核心内置技能": "コア組み込みスキル",
    "还没有产生额度消费": "消費クォータはまだ発生していません",
    "技能。安装后直接在对话中用自然语言描述即可：": "スキル。インストール後、会話の中で自然言語で説明するだけです。",
    "记住与你的所有历史对话（": "あなたとの過去の会話をすべて覚えておいてください (",
    "技能创作（MetaSkill）": "スキル作成（メタスキル）",
    "技能（Skill）— 能力扩展": "スキル - 能力拡張",
    "技能分为系统内置技能和社区发布的技能。": "スキルは、システム組み込みスキルとコミュニティ公開スキルに分かれています。",
    "技能市场": "スキルマーケット",
    "技能模块": "スキルモジュール",
    "技能市场分为两个维度：": "スキル市場は 2 つの側面に分かれています。",
    "加入 Zoom 会议": "Zoomミーティングに参加する",
    "加入会议": "会議に参加する",
    "加入了组织": "組織に参加しました",
    "加载中...": "読み込み中...",
    "加载中…": "読み込み中…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "AWS S3、MinIO、およびほとんどの S3 プロトコル オブジェクト ストレージと互換性があります",
    "简": "単純",
    "简报": "説明会",
    "简报加载失败": "ブリーフィングを読み込めませんでした",
    "简报生成失败": "ブリーフィングの生成に失敗しました",
    "建立关系": "関係を築く",
    "建立血缘": "血統を確立する",
    "建立业务关系": "ビジネス関係を確立する",
    "建立中…": "建物…",
    "建议从一个核心指标开始": "コアインジケーターから始めることをお勧めします",
    "建议使用数据库侧的只读账号": "データベース側では読み取り専用アカウントを使用することをお勧めします。",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "最初にデータソース、コア指標、ビジネス目標を登録してから、それらを接続することをお勧めします。",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "current_user:read、file_content:read、file_comments:read のみを付与することをお勧めします。",
    "将": "意思",
    "将 App ID 和 App Secret 填入下方": "以下にアプリ ID とアプリ シークレットを入力します。",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "このエージェントを Discord ボットとしてデプロイして、サーバー チャネルで対話します。",
    "接入飞书": "フェイシュへのアクセス",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Guanyuan BI のページ、データ セット、ETL、インジケーター システムにアクセスすると、このエージェントが企業の運用データを直接理解して分析できるようになります。",
    "接入微信": "WeChatにアクセスする",
    "揭开第一期": "最初の問題を公開する",
    "结构搭好后，Agent 会自动使用": "構造がセットアップされると、エージェントはそれを自動的に使用します。",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "構造的関係により候補パスが得られます。真の帰属を特定するには、やはり観察、証拠、ビジネス条件の組み合わせが必要です。",
    "结构信息充足": "十分な構造情報",
    "解释业务": "ビジネスを説明する",
    "仅供": "のみ",
    "仅管理员可删除组织知识库文档": "組織のナレッジベースドキュメントを削除できるのは管理者だけです",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "スキルは、エージェントの機能を拡張するモジュールです。従業員が異なるツールを装備しているのと同じように、異なるスキル セットを備えた異なるエージェントをインストールできます。",
    "仅支持 .md 文件": ".md ファイルのみをサポートします",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "スキルは、エージェントにインストールできる機能モジュールです。各スキルはエージェントに特定の能力を与えます。 NovaX にはいくつかのコア スキルが組み込まれており、さらに多くの機能を見つけてインストールするためのスキル マーケットも提供します。",
    "进 Agent 的肌肉记忆。": "エージェントのマッスルメモリーを入力します。",
    "技能系统": "スキルシステム",
    "角色权限": "役割の権限",
    "仅所有者可购买": "所有者のみ購入可能",
    "近 30 天消耗": "過去 30 日間の消費量",
    "进入第一期": "最初のピリオドを入力してください",
    "进行中": "進行中",
    "进行中/待开": "進行中/オープン予定",
    "竞": "競争する",
    "竞对与行业": "競争と業界",
    "聚合方式": "集計方法",
    "可留空自动生成，例如 contract": "契約書など自動生成する場合は空白のままでも可",
    "可能后果与下游": "起こり得る影響と下流",
    "可能原因与上游": "考えられる理由と上流",
    "可选": "オプション",
    "可选 · 关联共享知识库": "オプション · 関連する共有ナレッジ ベース",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "チーム、エージェント、またはプロジェクトを作成し、指標とビジネス目標に対する説明責任を確立できます。",
    "可用": "利用可能",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "エージェントの名前と説明を入力し、エージェントを作成します。作成が完了すると、ポイント エージェント パッケージに次の情報を入力できます。",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "「会話」ページに入り、左側のリストでエージェントをクリックしてチャットに参加します。入力ボックスにメッセージを送信すると、エージェントがリアルタイムで回答を返します。会話サポート:",
    "可追溯证据": "追跡可能な証拠",
    "客户联系": "顧客連絡先",
    "口径、公式、粒度和负责人": "口径、配合、粒度、担当者",
    "口径与依赖": "素質と依存性",
    "跨层查看正在形成的业务语义。": "レイヤ全体にわたる新たなビジネス セマンティクスを確認します。",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "「ナレッジベース」ページに入り、ドキュメントを .md 形式でアップロードします。これらの文書は、すべてのエージェントの共有参照になります。たとえば、会社のコード仕様をアップロードし、コード レビュー エージェントにこの仕様に従ってコードをチェックさせることができます。",
    "快速上手": "すぐに始めましょう",
    "来源与流转": "供給源と循環",
    "进入左侧导航栏的「知识库」页面。": "左側のナビゲーション バーにある「ナレッジ ベース」ページに入ります。",
    "可用 Nova 点": "利用可能なNovaポイント",
    "类": "親切",
    "类型说明": "タイプの説明",
    "类型已删除": "タイプが削除されました",
    "类型与字段": "タイプとフィールド",
    "理解含义": "意味を理解する",
    "例：产品评审会、周例会...": "例: 製品レビュー会議、週次会議...",
    "例如 研究助手": "例えば研究助手",
    "例如 demo": "たとえばデモ",
    "例如 NovaX 产品团队": "たとえば、NovaX 製品チーム",
    "例如 product-design": "例えばプロダクトデザイン",
    "例如 researcher": "たとえば研究者",
    "例如：2026-W30 / 2026-07": "例: 2026-W30/2026-07",
    "例如：合同": "例: 契約書",
    "例如：经营看板 / SQL 查询": "例: ビジネス カンバン/SQL クエリ",
    "例如：库存充足时": "例：在庫が十分にある場合",
    "例如：渠道=自然流量，地区=华东": "例: チャネル = 自然交通量、地域 = 中国東部",
    "例如：同日 / 7 天后": "例：同日 / 7日後",
    "例如：支付转化率": "例: 支払い換算率",
    "例如：SUM(pay_amount)": "例: SUM(pay_amount)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "例: SUM(pay_amount) またはorders.pay_amount → 収益",
    "连接": "接続する",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "AWS S3、MinIO、または互換性のあるオブジェクト ストアに接続し、エージェントがディレクトリを参照して、認証プレフィックス内のファイルを読み取れるようにします。",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "GitHub、GitLab、または Gitee リポジトリに接続し、このエージェントにコードを読み取り、変更を分析させ、承認の範囲内で開発コラボレーションに参加させます。",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "PostgreSQL、MySQL、SQL Server、その他のデータベースに接続し、読み取り専用権限で実際のビジネス データをクエリします。",
    "连接成功": "接続成功",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "接続が成功すると、エージェントは自動的に WeChat にアクセスし、指定されたチャットのメッセージに応答します。",
    "连接到飞书、Telegram、微信等": "Feishu、Telegram、WeChat などに接続します。",
    "连接飞书": "フェイシュに接続する",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Feishu に接続した後、チームメンバーは Feishu グループ チャットでエージェントと直接話すことができます。リッチテキストカード、ファイル送受信、カレンダー連携など、Feishuのネイティブ機能をサポートしています。",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "接続後、ファイル ノードとコメントを読み取ることができますが、デザインを変更したり、コメントを投稿したり、チームを管理したりすることはできません。",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "接続後、オブジェクトを一覧表示し、制限されたプレフィックス内の 2MB 以下のファイルを読み取ることができます。アップロード、上書き、削除はできません。",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "接続後は、許可されたページとコンテンツ ブロックを検索して読み取ることができますが、ページを作成、変更、削除することはできません。",
    "连接计算来源和业务目标": "コンピューティング ソースとビジネス目標を結び付ける",
    "连接类型": "接続タイプ",
    "连接目标或流程": "ターゲットまたはプロセスを接続する",
    "连接你的 AI 引擎": "AI エンジンを接続する",
    "连接上下游": "上流と下流を接続する",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "デザイン、ドキュメント、電子メール、コード、ビジネス データを接続して、エージェントが明確に許可された範囲内で実際の作業に参加できるようにします。",
    "连接失败": "接続に失敗しました",
    "连接数据或指标": "データまたはメトリクスを接続する",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "接続が完了したら、Feishu グループにエージェントを追加して会話を開始します。",
    "连接微信": "WeChatに接続する",
    "连接验证成功": "接続検証に成功しました",
    "连接中...": "接続中...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "2 つの連続した記録期間の後、NovaX は変更を計算し、影響分析で上流の潜在的な要因を検索します。",
    "联网搜索": "インターネット検索",
    "链接": "リンク",
    "列表视图": "リストビュー",
    "临时凭据才需要": "一時的な認証情報のみが必要です",
    "另有": "また",
    "留空会继续使用已加密保存的凭据": "暗号化して保存された認証情報を引き続き使用するには、空白のままにします",
    "六": "六",
    "六个视图，其实是同一张图": "6 つのビュー、実際には同じ写真",
    "路径样式（MinIO 常用）": "パス スタイル (MinIO で一般的に使用される)",
    "马斯克思维": "ムスクの思考",
    "芒格思维": "マンガーの考え方",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "どのエージェントが応答するかを指定します。 @ のないメッセージはエージェントをトリガーしません。",
    "没有发现新增内容": "新しいコンテンツは見つかりませんでした",
    "没有匹配的角色": "一致する役割がありません",
    "没有匹配的消息": "一致するメッセージはありません",
    "没有匹配的指标": "一致する指標がありません",
    "没有上游路径": "上流パスがありません",
    "没有下游路径": "下流パスがありません",
    "没有新增内容": "新しいことは何もありません",
    "没有找到匹配的技能": "一致するスキルが見つかりませんでした",
    "没有找到匹配的文件": "一致するファイルが見つかりませんでした",
    "每": "毎",
    "累计消耗": "累積消費量",
    "来扩展能力": "能力を拡張する",
    "每篇内容都来自": "それぞれのコンテンツの由来は、",
    "每天": "毎日",
    "每小时": "1時間あたり",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "各層は異なる質問に答え、エージェントが推論できるオントロジーを一緒に形成します。",
    "每月": "月あたり",
    "每周": "毎週",
    "密码": "パスワード",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "パスワード、トークン、秘密キーは暗号化されてサーバー側に保存されるだけで、エージェントのファイルや会話には書き込まれません。",
    "每个用户最多可以创建": "各ユーザーが作成できるのは次のとおりです",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "各エージェントはグループ チャットのコンテキストを確認できるため、後続のエージェントは前のエージェントの出力を直接参照できます。",
    "每天早上 9 点给我发一份行业新闻摘要": "毎朝午前9時に業界ニュースの概要を送ってください",
    "描述": "説明する",
    "名称": "名前",
    "名称 *": "名前 *",
    "名称不能为空": "名前を空にすることはできません",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "@ any Agent のないメッセージはグループに送信されますが、エージェントの返信はトリガーされないため、チーム メンバー間のコミュニケーションが容易になります。",
    "每周五下午 5 点生成本周工作总结": "週の作業の概要は毎週金曜日の午後 5 時に生成されます。",
    "模板消息": "テンプレートメッセージ",
    "免费赠送": "無料ギフト",
    "名称和头像": "名前とアバター",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "無料割り当ては組織に対する 1 回限りの割り当てであり、すべてのメンバーによって共有されます。現在、1 ドル = 750 Nova ポイントで変換されます。",
    "模型": "モデル",
    "模型定义": "モデルの定義",
    "默认邮箱目录": "デフォルトのメールボックスディレクトリ",
    "目录": "目次",
    "内部群聊": "社内グループチャット",
    "内容读取": "コンテンツの読み取り",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "組み込みタイプは NovaX の共通セマンティクスを形成し、カスタム タイプは独自のビジネスを記述します。",
    "你": "あなた",
    "模板中用": "テンプレートで使用される",
    "明确角色": "役割を明確にする",
    "模型和": "モデルと",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "エージェントはチームの仮想メンバーと考えることができます。できる：",
    "女娲 · Skill 造人术": "ヌワ・スキル 人間創造術",
    "篇": "章",
    "频道对话": "チャンネルでの会話",
    "平台": "プラットフォーム",
    "平台公告": "プラットフォームの発表",
    "评估后果": "結果を評価する",
    "评论读取": "読まれたコメント",
    "凭据已加密保存，": "認証情報は暗号化されて保存されます。",
    "期望方向": "希望の方向",
    "企业微信": "エンタープライズ WeChat",
    "企业邮箱 / 自定义 IMAP": "ビジネスメール/カスタマイズされたIMAP",
    "启用（兼容自签名证书）": "有効 (自己署名証明書と互換性があります)",
    "启用（推荐）": "有効にする (推奨)",
    "启用并验证证书": "証明書を有効にして検証する",
    "起点 *": "出発点 *",
    "前": "フォワード",
    "你可以随时在设置中注销账号，删除所有关联数据。": "設定でいつでもアカウントからログアウトし、関連するすべてのデータを削除できます。",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "設定でいつでもアカウントからログアウトし、関連するすべてのデータを削除できます。",
    "前往": "に行く",
    "前往飞书开放平台 →": "Feishuオープンプラットフォームへ→",
    "前缀隔离": "プレフィックス分離",
    "乔布斯思维": "ジョブズ思考",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "使用中に入力した会話内容は、AI エンジンとの対話にのみ使用され、追加で保存されたり、モデルのトレーニングに使用されたりすることはありません。",
    "切换": "スイッチ",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "使用中に入力した会話内容は、AI エンジンとの対話にのみ使用され、追加で保存されたり、モデルのトレーニングに使用されたりすることはありません。",
    "前提：Agent 需要安装": "前提条件: エージェントがインストールされている必要があります",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "説明会の結論を使用して、その理由、考えられる影響、次に取るべき最も価値のある行動についてさらに説明してください。",
    "请输入您的反馈、建议或遇到的问题...": "フィードバック、提案、問題点を入力してください...",
    "请填写 App ID 和 App Secret": "アプリIDとアプリシークレットを入力してください",
    "请勿填写网页登录密码": "Webページのログインパスワードは入力しないでください",
    "请选择一个角色": "役割を選択してください",
    "区域": "エリア",
    "驱动行动": "ドライブアクション",
    "取消": "キャンセル",
    "全部": "全て",
    "全部对象": "すべてのオブジェクト",
    "全部执行对象": "すべての実行オブジェクト",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "メールボックスは全体的に IMAP 読み取り専用モードで開かれます。電子メールの本文を検索して読むことができ、添付ファイルの名前を表示することができます。電子メールは送信、削除、移動、またはマークされません。",
    "切换中...": "切り替え中...",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "組織を切り替えると、表示されるエージェント、ナレッジベース、チームメンバーもそれに応じて変わります。",
    "切换组织": "組織を切り替える",
    "全员群": "メンバー全員",
    "权限隔离": "権限の分離",
    "确保 Codex CLI 已安装": "Codex CLI がインストールされていることを確認してください",
    "确定": "もちろん",
    "确定断开？已保存凭据会被删除。": "本当に切断しますか?保存された認証情報は削除されます。",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "組織を切り替えるか作成します。各組織には独立したエージェントとメンバーがいます。",
    "清除后所有聊天记录将被删除，无法恢复。": "クリア後​​はトーク履歴がすべて削除され復元できなくなります。",
    "确定删除这个会议？": "この会議を削除してもよろしいですか?",
    "确定删除这条指标观测吗？": "この指標観測を削除してもよろしいですか?",
    "确认断开": "切断の確認",
    "确定要注销账号吗？": "アカウントをキャンセルしてもよろしいですか?",
    "确定清除所有会话？": "すべてのセッションをクリアしてもよろしいですか?",
    "确认已安装。": "インストールされていることを確認します。",
    "全局市场": "世界市場",
    "群聊": "グループチャット",
    "群聊@唤醒": "グループチャット@wake",
    "群聊对话": "グループチャットでの会話",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "グループ チャットは、NovaX の中核となるコラボレーション シナリオです。エージェントリストの上部にある「すべてのメンバー」をクリックして入力します。グループ チャット内のすべてのエージェントとチーム メンバーは、同じ会話スペースを共有します。",
    "确认注销": "ログアウトの確認",
    "确认清除": "クリアを確認する",
    "让组织的重要变化": "組織に重要な変化を起こす",
    "人": "人々",
    "人格蒸馏 · 女娲造人": "個性蒸留・女媧が人間を創る",
    "认证方式": "認証方式",
    "任务": "タスク",
    "任务名称": "タスク名",
    "仍建议用实际数据验证候选原因。": "候補となる原因を実際のデータで検証することをお勧めします。",
    "日": "日",
    "日历联动": "カレンダー連携",
    "日期": "日付",
    "群聊与多 Agent 协作": "グループチャットと複数エージェントのコラボレーション",
    "群聊中需要通过": "グループチャットではパスする必要があります",
    "如何创建": "作成方法",
    "三": "三つ",
    "人设和行为规则": "性格と行動ルール",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "QR コードをスキャンして WeChat にログインすると、エージェントは WeChat アシスタントとして機能し、メッセージに自動的に返信したり、グループ チャットを管理したり、日常業務を処理したりできます。",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "QR コードをスキャンして WeChat に接続すると、このエージェントは自動的に WeChat メッセージにアクセスし、プライベート チャットまたはグループ チャットで応答できます。",
    "扫码区域": "スキャンコード領域",
    "删除": "消去",
    "删除观测": "観察の削除",
    "删除后无法恢复，确定要删除这个文档吗？": "削除を元に戻すことはできません。この文書を削除してもよろしいですか?",
    "删除会议": "会議を削除する",
    "删除了 Agent": "エージェントが削除されました",
    "删除失败": "削除に失敗しました",
    "删除失败或无权操作": "削除に失敗したか、操作権限がありません",
    "删除文档": "文書の削除",
    "商业专业": "ビジネス専攻",
    "上传": "アップロード",
    "上传到哪里？": "どこにアップロードするか?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "アップロード後も、「組織ナレッジベース/マイナレッジベース」で個別に表示できます。",
    "上传了": "アップロードされました",
    "上传录音": "録音をアップロードする",
    "上传失败": "アップロードに失敗しました",
    "上次：": "前回：",
    "上次触发": "最後にトリガーされた",
    "上次执行": "最後に実行された",
    "上下游网络": "上流および下流のネットワーク",
    "上一步": "前のステップ",
    "上游候选": "上流候補",
    "尚未补充业务定义": "ビジネス定義はまだ追加されていません",
    "尚未连接指标或业务目标。": "指標やビジネス目標はまだ関連付けられていません。",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "「毎日午前 9 時に日次レポートを送信する」などのスケジュールされたタスクを設定します。",
    "设计创作": "デザイン作成",
    "设计生成": "デザインの生成",
    "设计师包 · DESIGN": "デザイナーバッグ・デザイン",
    "上传文件作为附件。": "ファイルを添付ファイルとしてアップロードします。",
    "设置": "設定",
    "谁来行动": "誰が行動するのか",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "ご質問やご不明な点がございましたら、製品内のフィードバック チャネルを通じて開発者にお問い合わせください。",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "ご質問やご不明な点がございましたら、製品内のフィードバック チャネルを通じて開発者にお問い合わせください。",
    "三级权限体系": "3段階の権限体系",
    "什么属于这个类型，什么不属于？": "何がこのジャンルに属し、何が属さないのでしょうか?",
    "生成二维码": "QRコードを生成する",
    "生成二维码失败": "QRコードの生成に失敗しました",
    "生成纪要": "議事録を生成する",
    "生成纪要中": "議事録の作成",
    "生成失败": "ビルドに失敗しました",
    "生成中...": "生成中...",
    "失败": "失敗",
    "时间": "時間",
    "实体与关系来源": "エンティティと関係のソース",
    "使用": "使用",
    "使用工具": "ツールを使用する",
    "使用时只记住两个动作": "使用するときは2つのアクションを覚えてください",
    "使用引导": "ガイドを使用する",
    "设定边界": "境界線を設定する",
    "设置头像，从预设中选择或上传自定义图片。": "アバターを設定し、プリセットから選択するか、カスタム画像をアップロードします。",
    "使用方式": "使用法",
    "什么是 Agent": "エージェントとは",
    "示例：": "例：",
    "视条件而定": "条件あり",
    "是": "はい",
    "是 / 否": "かどうか",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "メールアドレスを使用してアカウントを登録します。システムは確認コードを電子メールに送信します。確認後、パスワードを設定して登録完了です。初めてログインすると、デフォルトの組織が自動的に作成されます。",
    "适用条件": "適用条件",
    "收到 Webhook 事件: {{payload}}": "受信した Webhook イベント: {{ペイロード}}",
    "收起": "近い",
    "手动创建": "手動で作成する",
    "手动记录": "手動録音",
    "输入清晰、唯一的业务名称": "明確で一意のビジネス名を入力してください",
    "输入消息，@agent 名字来提问": "質問するにはメッセージ、@エージェント名を入力してください",
    "属性": "財産",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "属性はビジネス上の意味を統一するために使用され、エージェントの構造化されたコンテキストにもなります。",
    "属性字段": "属性フィールド",
    "数": "番号",
    "数据层：数从哪里来": "データ層: 数値はどこから来たのか?",
    "数据从哪里来，经过什么，最终形成哪个指标": "データはどこから来て、何を経て、最終的にどの指標が形成されるのでしょうか?",
    "数据分析": "データ分析",
    "数据观察": "データ観測",
    "数据集": "データセット",
    "数据库、表和关键字段": "データベース、テーブル、キーフィールド",
    "数据库地址": "データベースアドレス",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "データベースにアクセスすると、親族関係と観察が自動的に補完されます。相関関係を発見することはできますが、相関関係を因果関係に自動的にアップグレードすることはありません。",
    "数据库类型": "データベースの種類",
    "数据库密码": "データベースのパスワード",
    "数据库名": "データベース名",
    "数据血缘": "データ系統",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "データリネージは「数値はどこから来たのか?」という疑問に答えます。影響関係は「おそらくなぜ」と答えます。証明された原因と結果のみが、「何が原因であるかを特定する」ことに答えることができます。",
    "数据血缘图": "データリネージ図",
    "数据与办公": "データとオフィス",
    "数据源": "データソース",
    "数据源、表与字段": "データソース、テーブル、フィールド",
    "数据资产": "データ資産",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "データフィールド → コア指標 → 事業目標 → 担当者",
    "数值来源": "価値の源泉",
    "数字": "番号",
    "双人": "ダブル",
    "说明": "説明する",
    "说明它在业务里代表什么，以及不包含什么": "ビジネスにおいて何を表し、何が含まれないのかを説明する",
    "私聊": "プライベートチャット",
    "私聊回复": "プライベートチャットの返信",
    "私钥口令（可选）": "秘密キーのパスワード (オプション)",
    "思考中...": "考え...",
    "思维框架": "思考の枠組み",
    "四": "4",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "4 番目の層は 4 つの個別のディレクトリではなく、事実から行動へのリンクです。一度にすべてを入力する必要はありません。最初に最も重要なリンクを構築するだけです。",
    "松开以上传 .md 文件": "リリースして .md ファイルをアップロードします",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "統合が許可されている Notion ページとコンテンツ ブロックを検索および読み取り、エージェントがチーム ドキュメントとプロジェクト資料を使用できるようにします。",
    "搜索会话内的文件": "セッション内のファイルを検索する",
    "搜索技能名称、描述或标签...": "スキル名、説明、またはタグを検索します...",
    "搜索内容": "コンテンツの検索",
    "搜索项目、团队或 Agent": "プロジェクト、チーム、エージェントを検索する",
    "搜索消息...": "メッセージを検索...",
    "搜索预设角色...": "プリセットの役割を検索します...",
    "搜索知识库...": "ナレッジベースを検索...",
    "搜索指标或口径": "検索指標または基準",
    "所属层 *": "所属レイヤー※",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "また、業界や政策の方向性に関する大きなニュースだけでなく、競争に関する緊急または重要な情報にも引き続き注意を払い、組織の注目を本当に必要とする変化を推進していきます。",
    "所有者（Owner）": "所有者",
    "适合放入的内容": "何を入れるか",
    "使用者的個人資訊用於任何商業用途。": "ユーザーの個人情報はあらゆる商業目的に使用されます。",
    "提出原因": "理由を述べる",
    "提交反馈": "フィードバックを送信する",
    "提交分析": "分析を送信する",
    "添加关系": "関係を追加",
    "添加字段": "フィールドの追加",
    "条关系": "関係",
    "条件性": "条件付き",
    "条因果关系": "因果関係",
    "跳": "ジャンプ",
    "跳过引导": "スキップブート",
    "通过": "合格",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Pencil Headless CLI を使用して .pen デザイン ドラフトを作成、変更、エクスポートします。生成プロセスでは常に Codex が使用されます。",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Telegram Bot を通じてエージェントと対話し、世界規模でのインスタント メッセージングとファイル処理をサポートします。",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Telegram Bot を通じてこのエージェントと対話し、グローバル インスタント メッセージングをサポートします。",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "WhatsApp Business API を通じてこのエージェントにアクセスし、世界中のユーザーに連絡します。",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "エンタープライズ WeChat アプリケーションを通じてこのエージェントにアクセスし、内部コミュニケーションと顧客サービス シナリオをサポートします。",
    "通信对话 (": "コミュニケーション会話（",
    "通用工具 (": "一般的なツール (",
    "同名文档": "同名の文書",
    "同一组织 · 同一份简报 · 持续沉淀": "同じ組織・同じ概要・継続的な蓄積",
    "统计": "統計",
    "统计粒度": "統計的な粒度",
    "统计周期": "統計期間",
    "图标": "アイコン",
    "图标视图": "アイコンビュー",
    "图片 / PDF 导出": "画像/PDF エクスポート",
    "套餐之间仅额度不同，所有产品能力保持一致。": "パッケージ間で金額が異なるだけで、すべての製品の機能は同じです。",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "パッケージと割り当てはすでに表示されており、支払いチャネルが決定された後に購入を行うことができます。",
    "团队的": "チーム",
    "团队": "チーム",
    "团队日志": "チームログ",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "同じエージェントが Web プラットフォームと IM プラットフォームの両方で作業でき、会話の記憶とスキルがすべてのプラットフォームで共有されます。",
    "团队规范、工作流程、审批标准": "チームの仕様、作業プロセス、承認基準",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "電子メールでメンバーを参加に招待し、さまざまな役割 (所有者/管理者/メンバー) を設定します。",
    "推荐": "推薦する",
    "推荐建模顺序": "推奨されるモデリング順序",
    "退出登录": "ログアウト",
    "拖入 .md 文件，或点击上传": ".md ファイルをドラッグするか、「アップロード」をクリックします",
    "外部系统 POST 到此 URL 即可触发": "この URL への外部システム POST をトリガーできます",
    "外观": "外観",
    "完成": "仕上げる",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "完全な指標には、ビジネス定義、計算能力、粒度、次元、ソース、担当者、履歴観察が含まれます。",
    "网络错误": "ネットワークエラー",
    "微信": "微信",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "WeChat 接続は Web バージョンのプロトコルに基づいており、WeChat アカウントはエージェント キャリアとしてオンラインに維持する必要があります。専用の WeChat アカウントを使用することをお勧めします。",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat が接続され、エージェントが自動的にメッセージに応答します。サービスを再起動すると使用できるようになります。",
    "唯一标识": "一意の識別子",
    "维度切片": "次元スライス",
    "未补充映射表达式": "マッピング式は補足されていません",
    "未连接": "接続されていません",
    "未设置": "設定されていません",
    "未设置编码": "エンコーディングが設定されていません",
    "未设置更新频率": "更新頻度が設定されていません",
    "未设置公式": "数式が設定されていません",
    "未设置统计粒度": "統計の粒度が設定されていません",
    "未知": "未知",
    "未知文档": "不明な文書",
    "文本": "文章",
    "文档读取失败": "文書の読み取りに失敗しました",
    "文档读取失败或无权访问": "文書の読み取りに失敗したか、アクセス権限がありません",
    "文档已覆盖": "対象となる文書",
    "文档已删除": "文書が削除されました",
    "文档已上传": "ドキュメントがアップロードされました",
    "文件处理": "ファイル処理",
    "文件传输": "ファイル転送",
    "文件读取": "ファイルの読み取り",
    "文件分享": "ファイル共有",
    "文件过大，最大支持 2MB": "ファイルが大きすぎます。サポートされる最大値は 2MB です",
    "文件结构": "ファイル構造",
    "文件收发": "ファイルの送受信",
    "我": "私",
    "我的知识库": "私の知識ベース",
    "团队规范和工作流程": "チームの規範と作業プロセス",
    "我们": "私たち",
    "我想继续讨论这篇组织简报：": "この組織概要について引き続き議論したいと思います。",
    "无单位": "ユニットなし",
    "无公式": "公式なし",
    "无可用 Agent": "対応可能なエージェントがいません",
    "无描述": "説明なし",
    "五": "五",
    "系统": "システム",
    "系统工具": "システムツール",
    "系统内置": "システム内蔵",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "強度を判断し、ワークスペース書き込みサンドボックス内でタスクを実行します。",
    "我們": "私たちは",
    "下次：": "次回：",
    "下次执行": "次回実行",
    "下一步": "次のステップ",
    "下游影响": "下流効果",
    "下载": "ダウンロード",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "まず「新しいオブジェクトを作成」し、次に「関係を確立」します。オブジェクトは、フィールド、インジケーター、ターゲット、またはエージェントです。関係では、計算、系統、影響、因果関係、または帰属を明示的に選択し、公式、条件、信頼性、証拠を補足するように努める必要があります。",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "「売上、受注量、コンバージョン率」など本当に意思決定に使える指標をまず作成し、事業定義、計算式、統計粒度、担当者を完成させます。次に、NovaX がどのような変更が発生したかを判断できるように、少なくとも 2 つの期間の値を記録します。",
    "先看懂四层业务地图": "まずは4層のビジネスマップを理解する",
    "先验证，再保存": "最初に確認してから保存します",
    "现在搭建第一条业务链路": "最初のビジネス リンクを構築します",
    "现在可以通过受限工具安全使用这个连接。": "この接続は、制限されたツールでも安全に使用できるようになりました。",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "次に、組織の最初の問題を生成することから始めます。情報と接続が追加され続けるにつれて、NovaX は注目に値するコンテンツをここにプッシュし続けます。",
    "限定前缀（可选）": "修飾プレフィックス (オプション)",
    "限定文件 Key（可选）": "修飾されたファイルキー (オプション)",
    "相对上一期": "前号との比較",
    "详细记忆文件": "詳細メモリファイル",
    "项操作": "オペレーション",
    "外部平台": "外部プラットフォーム",
    "团队协作（NovaX Bus）": "チームコラボレーション (NovaX Bus)",
    "消耗": "消費する",
    "消息导航": "メッセージナビゲーション",
    "消息卡片": "メッセージカード",
    "消息": "情報",
    "小时": "時間",
    "协作 Agent": "コラボレーションエージェント",
    "斜杠命令": "スラッシュコマンド",
    "小": "小さい",
    "新建对象": "新しいオブジェクト",
    "新建业务概念": "新しい事業コンセプト",
    "新建执行对象": "新しい実行オブジェクトを作成する",
    "新建指标": "新しいインジケーター",
    "形成指标": "フォームインジケーター",
    "修改文件": "ファイルを変更する",
    "虚拟主机样式（AWS 默认）": "仮想ホスト スタイル (AWS デフォルト)",
    "需要两个周期": "2サイクルかかります",
    "选择 .md 文件 →": ".mdファイルを選択→",
    "选择要安装到的 Agent": "インストール先のエージェントを選択してください",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "事前に設定された役割を選択してすぐに開始するか、カスタム エージェントを手動で作成します。",
    "选择一个执行对象": "実行オブジェクトを選択してください",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "指標を選択した後、影響分析では、計算のソースと推進要因の候補を上向きに調べ、下向きに目標、プロセス、影響の責任者を調べます。影響関係は単なる手がかりにすぎません。検証証拠との因果関係のみがエージェントによって明確な原因として表現されます。",
    "选择一个指标开始": "開始するにはインジケーターを選択してください",
    "选择指标或业务对象": "メトリックまたはビジネス オブジェクトを選択します",
    "血缘与计算映射": "血統と計算によるマッピング",
    "寻址方式": "アドレッシングモード",
    "沿关系找原因，也看后果": "関係をたどって原因を見つけ、その結果も見てみましょう。",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "下流関係に沿って、影響を受ける目標、プロセス、プロジェクト、所有者を特定します。",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "影響と因果関係に沿ってドライバーの候補を生成し、信頼性、条件、証拠に基づいて表現を格下げします。",
    "沿用 Figma Token 可见范围": "Figma Tokenの可視範囲を継承",
    "消息字体大小": "メッセージのフォントサイズ",
    "系统任务": "システムタスク",
    "颜色": "色",
    "演示文稿制作": "プレゼンテーション制作",
    "验证并保存": "確認して保存する",
    "验证并连接": "確認して接続する",
    "验证结果": "検証結果",
    "写 Soul 的要点": "ソウルを書くための重要なポイント",
    "邀请成员": "メンバーを招待する",
    "要点速读": "すぐに読むためのポイント",
    "也是 Agent 们的": "エージェント向けにも",
    "业务本体": "ビジネスオントロジー",
    "业务层：数字说明什么": "ビジネス層: 数字が語るもの",
    "业务地图": "ビジネスマップ",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "ビジネスマップは全体像を観察し、指標ネットワークは口径と上流と下流を観察し、データリネージはソースを観察し、影響分析は原因と結果を観察し、組織の実行は担当者を観察し、モデルは管理オブジェクトのタイプを定義します。ビューを切り替えても重複データは作成されません。",
    "业务定义": "ビジネスの定義",
    "业务对象": "ビジネスオブジェクト",
    "研究员输出数据后：": "研究者がデータを出力した後:",
    "业务连接": "ビジネス上のつながり",
    "业务声明": "ビジネスステートメント",
    "业务指标": "ビジネス指標",
    "页面分析": "ページ分析",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "ページ デザイン、プレゼンテーション、AI 画像生成 - エージェントをプロのデザイナーのように見せます。",
    "页面搜索": "ページ検索",
    "一": "1つ",
    "一只 Agent。": "エージェント。",
    "移除了": "削除されました",
    "已保存，留空不修改": "保存しました。変更せずに空白のままにしておきます",
    "已触发": "トリガーされた",
    "已存在，是否覆盖？": "すでに存在しますか?上書きしますか?",
    "已复制": "コピーされました",
    "已归档": "アーカイブ済み",
    "已过期": "期限切れ",
    "已结束": "終わった",
    "已连接": "接続済み",
    "已连接 ·": "接続済み ·",
    "已取消": "キャンセル",
    "已扫码，请在手机上确认...": "コードはスキャンされました。携帯電話で確認してください...",
    "已生成纪要": "生成された分",
    "已完成": "完了しました",
    "已验证": "確認済み",
    "已验证因果": "因果関係が検証された",
    "已暂停": "一時停止中",
    "因果可信度阶梯": "因果関係の信頼性のはしご",
    "业务规则和约束条件": "ビジネスルールと制約",
    "引导进度": "ブートの進行状況",
    "应用消息": "アプリケーションメッセージ",
    "应用专用密码 / 授权码": "アプリケーション固有のパスワード/認証コード",
    "影响分析": "影響分析",
    "影响分析失败": "影響分析が失敗しました",
    "影响时滞": "タイムラグに影響する",
    "影响语义": "セマンティクスに影響を与える",
    "业务规则、行业术语、标准话术": "ビジネスルール、業界用語、標準用語",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "開発者は、本製品の使用により生じる直接的または間接的な損失については責任を負いません。",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "開発者は、本製品の使用により生じる直接的または間接的な損失については責任を負いません。",
    "用 1 分钟看懂业务本体": "1 分でビジネス オントロジーを理解できます",
    "用法示例": "使用例",
    "用户名": "ユーザー名",
    "用链接或 ID 进入": "リンクまたはIDで入力してください",
    "用户的个人信息用于任何商业用途。": "ユーザーの個人情報はあらゆる商業目的に使用されます。",
    "用手机微信扫描二维码，确认登录。": "携帯電話の WeChat を使用して QR コードをスキャンし、ログインを確認します。",
    "用手机微信扫描二维码并确认登录": "携帯電話で WeChat を使用して QR コードをスキャンし、ログインを確認します",
    "用于比较变化": "変更を比較するために使用されます",
    "用于区分这个 Agent 的 Pencil 设计文件": "このエージェントを区別するために使用される鉛筆デザイン ファイル",
    "邮件搜索": "メール検索",
    "邮箱": "郵便",
    "邮箱类型": "電子メールの種類",
    "邮箱账号": "メールアカウント",
    "有纪要": "議事録あり",
    "语义关系": "意味関係",
    "语义属性": "セマンティックプロパティ",
    "拥有专属的": "独占的なものを持つ",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "MetaSkill スキルを持つエージェントは、ニーズに基づいて新しいスキルを自動的に作成し、公開できます。",
    "预定时间（可选，留空则立即开始）": "スケジュールされた時間 (オプション、すぐに開始するには空白のままにします)",
    "原始转写": "オリジナルの転写",
    "原因与后果": "原因と結果",
    "语音输入（需浏览器支持 Web Speech API）。": "音声入力 (ブラウザが Web Speech API をサポートする必要があります)。",
    "用量明细加载失败": "使用量の詳細をロードできませんでした",
    "永久删除你的账号和所有数据，此操作不可撤销。": "アカウントとすべてのデータを完全に削除します。この操作は元に戻せません。",
    "运行连接命令": "接続コマンドを実行する",
    "运行引擎": "エンジンを動かす",
    "运行中": "実行中",
    "再查一次": "もう一度確認してください",
    "再查一次，没有新增内容": "再度確認しましたが、新しい内容はありませんでした",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Microsoft Teams でこのエージェントと共同作業し、エンタープライズ ワークフローに統合します。",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "海外チームの日常のワークフローに適した Slack チャネルでエージェントと直接コラボレーションできます。",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Slack チャネルでこのエージェントと直接連携し、スレッド返信をサポートします。",
    "月度额度不足时，可由组织所有者补充。": "毎月の割り当てが不足している場合は、組織の所有者が補充できます。",
    "月度套餐": "月額パッケージ",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "「設定→アカウント管理」で新しい組織を作成するか、組織を切り替えます。",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "「タスク」タブの「Webhook」サブタブで作成し、名前とプロンプトの単語テンプレートを入力します。",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "このエージェントを DingTalk グループに接続して、メッセージ カードや仕事通知などの DingTalk のネイティブ機能をサポートします。",
    "在不同组织之间切换，数据完全隔离。": "完全なデータ分離により、異なる組織間を切り替えます。",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "「チーム」ページの「新規エージェント」をクリックして作成します。作成後、エージェント カードをクリックして、構成の詳細ページに入ります。",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "「チーム」ページで組織のメンバーを管理します。 「メンバーを招待」をクリックし、メールアドレスを入力して招待状を送信します。",
    "在对话中让": "会話をさせてください",
    "在对话中让 agent \"记住\"重要信息": "エージェントが会話中に重要な情報を「記憶」できるようにする",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Feishu バックエンドで承認を確認すると、アプリケーションは必要な権限 (メッセージの送受信、グループ管理など) を自動的に取得します。",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Feishu グループ チャットでこのエージェントと直接通信し、リッチ テキスト カード、ファイルの送受信などの Feishu のネイティブ機能をサポートします。",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "会話インターフェイスの上部にある [スキル] タブに切り替え、利用可能なリストを参照して、[インストール] をクリックします。",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "コンピュータ上で NovaX Agent を実行して、ローカル Codex ワークスペースを NovaX に安全に接続します。",
    "暂不关联": "まだ関連性がありません",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "ダイアログインターフェースの上部にある「接続」タブに切り替えて設定します。現在サポートしているもの:",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "会話ページのエージェント リストに、「すべてのメンバー グループ」エントリが表示されます。グループ チャットでは、@AgentName を使用して、質問に回答するエージェントを指定できます。これにより、たとえば、「調査」エージェントの検索で、エージェントの同意書に基づいて、複数のエージェントが同じ会話で行動できます。",
    "在服务器上读写文件、执行代码": "ファイルの読み取りと書き込み、サーバー上でのコードの実行",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "当面は、Feishu バックエンドでアプリケーションを手動で作成し、資格情報を入力する必要があります。自動作成プロセスが開発中です。ワンクリックの認証だけで接続を完了できます。",
    "暂停": "一時停止",
    "暂无 Webhook": "Webhook はまだありません",
    "暂无定时任务": "スケジュールされたタスクはまだありません",
    "暂无观测": "まだ観測はありません",
    "暂无观测值": "まだ観測はありません",
    "暂无记录": "まだ記録がありません",
    "暂无记忆": "まだ記憶がない",
    "暂无纪要 — 会议结束后自动转写": "議事録はまだありません - 会議終了後に自動的に書き起こされます",
    "暂无类型说明": "タイプの説明はまだありません",
    "暂无日志": "まだログがありません",
    "暂无属性字段": "属性フィールドはまだありません",
    "暂无数据": "まだデータがありません",
    "暂无说明": "まだ説明がありません",
    "暂无文件": "まだファイルがありません",
    "暂无业务定义": "ビジネス定義はまだありません",
    "粘贴 Figma 访问 Token": "Figma アクセス トークンを貼り付けます",
    "粘贴 Zoom 链接或输入会议 ID": "Zoom リンクを貼り付けるか、ミーティング ID を入力してください",
    "展开查看": "展開して表示",
    "账号": "アカウント",
    "这份证据如何支持该关系？": "この証拠は関係をどのように裏付けますか?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "ここでは、元のチーム、エージェント、プロジェクト、タスク、ドキュメント、スキルを保持し、それらをビジネス指標に関連付けます。",
    "蒸馏": "蒸留",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "意思決定の枠組み、第一原則、表現力豊かな DNA を抽出し、いつでも相談できるメンタルアドバイザーを磨きます。",
    "整体结构": "全体構造",
    "正文与附件信息": "テキストと添付ファイルの情報",
    "正向": "フォワード",
    "正在编撰组织简报": "組織概要の作成",
    "正在创建微信连接...": "WeChat 接続を作成しています...",
    "正在读取组织最近的使用情况": "組織の最近の使用状況を読む",
    "正在计算影响路径…": "衝撃経路を計算中…",
    "暂时无法读取额度信息": "一時的に信用情報が読み取れなくなる",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "左側のナビゲーション バーの「スキル マーケット」ページでは、利用可能なすべてのスキルを参照できます。",
    "正在建立业务语义地图…": "ビジネス セマンティック マップの構築...",
    "正在生成二维码...": "QRコードを生成中...",
    "正在验证连接…": "接続を確認しています...",
    "正在由 Agent 团队编撰第一期": "最初の問題はエージェント チームによって編集中です",
    "正在整理组织数据与知识": "組織のデータと知識の整理",
    "证据等级": "証拠のレベル",
    "证据摘要": "証拠の要約",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "GitHub、GitLab、Gitee、および社内 Git サービスをサポート",
    "知识库": "知識ベース",
    "知识库 &middot; Knowledge Base": "ナレッジベース · ナレッジベース",
    "占位，表示外部传入的数据。例如：": "外部から受信するデータを表すプレースホルダー。例えば：",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "これは、NovaX の最も強力なコラボレーション モードです。複数のエージェントに引き継いでもらい、同じ会話で複雑なタスクを完了させることができます。",
    "支付功能正在准备中": "決済機能は準備中です",
    "正在加载组织额度…": "組織の割り当てを読み込んでいます...",
    "知识库为空": "ナレッジベースが空です",
    "知识库文档": "ナレッジベースのドキュメント",
    "知识库暂无共享文档。": "現在、ナレッジ ベースには共有ドキュメントはありません。",
    "知识库（Memory）— 共享大脑": "知識ベース (メモリ) - 共有頭脳",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "ナレッジ ベースは、組織レベルの共有ドキュメント リポジトリです。アップロードしたすべての Markdown ドキュメントは、組織内のすべてのエージェントの共通知識になります。以下に適しています:",
    "执行层：谁根据它采取行动": "エグゼクティブ層：それに基づいてアクションを起こす人",
    "执行命令": "コマンドを実行する",
    "执行频率": "実行頻度",
    "执行任务": "タスクを実行する",
    "执行时间": "実行時間",
    "执行时间：": "実行時間:",
    "执行异常": "実行例外",
    "执行指令": "命令の実行",
    "执行中": "実行中",
    "只读查询": "読み取り専用クエリ",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "認証コードをサポートする Gmail、QQ、163、またはエンタープライズ IMAP メールボックスへの読み取り専用接続により、エージェントは実際の電子メールを検索および並べ替えることができます。",
    "只读收件箱": "読み取り専用の受信箱",
    "指": "参照",
    "指标": "索引",
    "指标 / 维度": "指標/ディメンション",
    "指标不是一个数字": "インジケーターは数値ではありません",
    "指标层：数字怎么计算": "インジケーターレイヤー: 数値の計算方法",
    "指标查询": "インジケータクエリ",
    "指标观测": "指標の観察",
    "指标口径": "インデックスキャリバー",
    "指标目录": "インジケーターカタログ",
    "指标网络": "インジケーターネットワーク",
    "指标已映射": "マッピングされたメトリクス",
    "指标异动与影响分析": "指標の変更と影響分析",
    "指标值 *": "インジケータ値 *",
    "至少需要两个周期": "少なくとも 2 サイクルが必要です",
    "置信度": "自信",
    "置信度 ·": "自信 ・",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "ナレッジ ベースにアップロードされたドキュメントはサーバー上にローカルに保存され、組織内のエージェントのみが読み取ることができます。",
    "终点 *": "終点 *",
    "终端运行": "ターミナルの実行",
    "种类型": "タイプ",
    "重复任务": "タスクを繰り返す",
    "重新尝试": "もう一度やり直してください",
    "重新加载": "リロード",
    "重要规则": "重要なルール",
    "周末": "週末",
    "主持人:": "ホスト：",
    "主持人：": "ホスト：",
    "主动来到你面前": "率先してあなたのところに来てください",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "ナレッジ ベースは、組織レベルの共有ドキュメント リポジトリです。アップロードされたドキュメントは、回答するときにすべてのエージェントによって自動的に参照されます。これは、すべてのエージェントに背景知識を与えることと同じです。",
    "中": "真ん中",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "ナレッジ ベースにアップロードされたドキュメントはサーバー上にローカルに保存され、組織内のエージェントのみが読み取ることができます。",
    "注入": "注射",
    "注销账号": "アカウントをキャンセルする",
    "只有组织所有者可以购买套餐或充值额度。": "組織の所有者のみがプランまたはクレジットを購入できます。",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "ログアウトすると、アカウント、チャット履歴、およびすべてのデータが完全に削除され、復元できなくなります。",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "登録に必要なメールアドレスはアカウント認証とログインのみに使用され、マーケティングに使用されたり、第三者に譲渡されることはありません。",
    "转发": "フォワード",
    "转发到": "に進む",
    "转写已完成，可生成纪要": "文字起こしが完了し、議事録を作成できるようになりました",
    "转写中": "文字起こし",
    "状态": "州",
    "字段": "分野",
    "字段名称": "フィールド名",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "登録に必要なメールアドレスはアカウント認証とログインのみに使用され、マーケティングに使用されたり、第三者に譲渡されることはありません。",
    "自定义类型": "カスタムタイプ",
    "自定义名称、描述和人格": "名前、説明、性格をカスタマイズする",
    "自定义周期": "カスタムサイクル",
    "自动响应指定聊天中的消息": "指定したチャットのメッセージに自動的に応答する",
    "自动应答": "自動応答",
    "自动转写生成纪要": "自動的に文字起こしして議事録を生成",
    "自适应卡片": "アダプティブカード",
    "组": "グループ",
    "组件理解": "コンポーネントの理解",
    "注销中...": "ログアウト中...",
    "组织": "整理する",
    "组织编辑人数": "組織内の編集者の数",
    "组织变动": "組織変更",
    "组织存储": "収納を整理する",
    "组织洞察": "組織の洞察",
    "自定义界面显示偏好": "インターフェースの表示設定をカスタマイズする",
    "组织里的某一位 Agent": "組織内のエージェント",
    "组织（Workspace）— 协作空间": "組織 (ワークスペース) — コラボレーション スペース",
    "组织名称": "組織名",
    "组织成员和自动任务的消费都会记录在这里。": "組織メンバーと自動タスクの消費量がここに記録されます。",
    "组织共享额度": "組織共有クォータ",
    "组织内所有成员共享使用": "組織のメンバー全員が共有",
    "组织文档数": "組織文書の数",
    "组织信号": "組織的なシグナル",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "組織は、Slack のワークスペースや Feishu のチームに似た、独立したコラボレーション スペースです。組織のすべてのメンバーは、同じエージェントとナレッジ ベースのセットを共有します。あなたはできる：",
    "组织所有者": "組織の所有者",
    "组织与执行": "組織と実行",
    "组织知识库": "組織の知識ベース",
    "组织知识库日志": "組織ナレッジベースログ",
    "组织执行": "組織的な実行",
    "最多展开 3 跳": "最大3つのジャンプまで拡張",
    "最多追溯 3 跳": "最大 3 ホップまでのトレースバック",
    "组织与团队管理": "組織とチームの管理",
    "组织与多租户": "組織とマルチテナンシー",
    "最近更新": "最新のアップデート",
    "最近观测": "最近の観察",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "使用可能なリンクに必要な最小のオブジェクトは 4 つだけです。毎日注目しているコア指標から始めて、後で徐々に完成させてください。最初から会社全体をデザインする必要はありません。",
    "最新观测": "最新の観測結果",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "左側には考えられるドライバーまたは計算ソースが表示され、右側にはインジケーターが影響する内容が表示されます。",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "PEN_AGENT_API_KEY として、このローカル Pencil プロセスにのみ渡されます。",
    "最后更新：2026 年 5 月": "最終更新日: 2026 年 5 月",
    "最後更新：2026 年 5 月": "最終更新日: 2026 年 5 月",
    "最近用量": "最近の使用法",
    "作為個人練手 Demo 專案，我們": "個人練習デモプロジェクトとして、",
    "Agent 会怎样使用": "エージェントの使用方法",
    "作为个人练手 Demo 项目，我们": "パーソナルトレーニングのデモプロジェクトとして、",
    "Agent — 你的 AI 团队成员": "エージェント — AI チームのメンバー",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "エージェントが起動すると、自動的に接続されます。以下のステータスが緑色に変わり、使用を開始できるようになります。",
    "Agent 级别": "エージェントレベル",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "エージェントは NovaX の中核ユニットです。各エージェントは、独自の以下を備えた独立した AI アシスタントです。",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "エージェントは NovaX の中核概念です。従来のチャットボットとは異なり、各エージェントは次の機能を備えたエージェントです。",
    "Agent 在对话中输出的文件会显示在这里": "会話中にエージェントが出力したファイルがここに表示されます",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "エージェントは自動的に cron タスクを作成します。実行結果は会話にメッセージとして表示されます。 [タスク] タブで、作成したタスクを一時停止、再開、または削除できます。",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "エージェントは、手動でトリガーしなくても定期的に実行されるバックグラウンド タスクを作成できます。会話インターフェースの上部にある「タスク」タブに切り替えて、表示および管理します。",
    "Agent 周报": "エージェントウィークリー",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "エージェントは NovaX Web ページ上で使用できるだけでなく、外部のインスタント メッセージング プラットフォームにも接続できます。接続すると、エージェントはすべてのプラットフォームで同じ記憶、スキル、知識ベースを共有します。",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "エージェントはリクエストを受信した後、自動的にリクエストを実行し、結果を会話に送信します。",
    "AI 图像生成": "AI画像生成",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "エージェントは質問に回答するときにこれらの文書を自動的に参照し、回答がチームの規範とコンテキスト内に収まるようにします。",
    "DOWNSTREAM · 下游": "下流・下流",
    "ETL 血缘": "ETLの系統",
    "Git 仓库": "Gitリポジトリ",
    "Git 用户名；GitHub App 可填 x-access-token": "Git ユーザー名; GitHub アプリは x-access-token を入力できます",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail、QQ、および 163 では通常、まず IMAP を有効にして、アプリケーション固有のパスワードまたは認証コードを作成する必要があります。",
    "IMAP 地址": "IMAPアドレス",
    "Notion 工作区": "概念ワークスペース",
    "Codex 智能体底座": "コーデックススマートボディベース",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "AIが生成したコンテンツには誤りや不正確な情報が含まれる可能性がありますので、ご自身で判断・検証してください。",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "AIにより生成されたコンテンツには誤りや不正確な情報が含まれる可能性がありますので、ご自身の判断・検証でお願いいたします。",
    "Nova 点": "ノバポイント",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "コードの強調表示、テーブル、リストなどを含むマークダウン形式のレンダリング。",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX は、データとビジネス推進力を上向きに追跡し、目標、プロセス、および実行による下向きの影響を特定します。",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX は、組織 (ワークスペース) に基づいたマルチテナント アーキテクチャを採用しています。各組織は完全に独立したコラボレーション スペースであり、エージェント、ナレッジ ベース、スキル、メンバー、会話データはすべて分離されています。",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "NovaX のインターフェイスは、左側のナビゲーション バーと右側のメイン コンテンツ領域で構成されます。ナビゲーション バーには、次の 5 つの主要な入り口があります。",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "NovaX のすべてのエージェントは OpenAI Codex 上で均一に実行され、",
    "NovaX 是什么": "NovaXとは",
    "NovaX Agent 工作区": "NovaX エージェント ワークスペース",
    "PG 思维": "PG思考",
    "Prompt 模板": "プロンプトテンプレート",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "{{payload}} を使用して受信したデータを表すプロンプト テンプレート",
    "QQ 邮箱": "QQメールボックス",
    "S3 兼容地址（AWS S3 可留空）": "S3 互換アドレス (AWS S3 は空白のままでも可)",
    "Schema 浏览": "スキーマの参照",
    "secret_... 或 ntn_...": "Secret_... または ntn_...",
    "Session Token（可选）": "セッショントークン (オプション)",
    "NovaX 是一个": "NovaX は、",
    "NovaX 是一個": "NovaX は、",
    "Skill 市场": "スキルマーケット",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX は、マルチエージェント AI コラボレーション プラットフォームです。これは AI チームのワークベンチのように考えることができます。ここでは複数の AI エージェントが作成され、それぞれが独自の名前、ペルソナ、専門知識、およびワークスペースを持ちます。ファイルの読み取りと書き込み、コードの実行、Web の検索、タスクの管理を行うことができ、実際のチーム メンバーのように共同作業することができます。",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX は複数の組織構造をサポートします。組織は「設定 → 一般」で管理できます。",
    "Shift+Enter 换行，Enter 发送。": "Shift+Enter で行を折り返し、Enter で送信します。",
    "SQL 数据库": "SQLデータベース",
    "SSH 私钥": "SSH秘密鍵",
    "Thread 回复": "スレッドの返信",
    "TLS 加密": "TLS暗号化",
    "Token 用量榜": "トークン使用量一覧",
    "UPSTREAM · 上游": "上流 · 上流",
    "Web 设计工程师": "Webデザインエンジニア",
    "Webhook 名称，如 GitHub Push...": "Webhook 名 (GitHub Push など)",
    "Soul 人设指令": "ソウルキャラクターコマンド",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "ソウルはエージェントの最も重要な構成アイテムです。これにより、エージェントの役割の位置付け、専門分野、および行動が決まります。 Soul を適切に記述することが、エージェントを真に役立つものにする鍵となります。",
    "Soul（人设指令）": "ソウル（性格コマンド）",
    "Webhook URL（含 Secret）": "Webhook URL (シークレットを含む)",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook を使用すると、外部システムが HTTP リクエストを通じてエージェント実行タスクをトリガーできるようになり、CI/CD とのインターフェース、アラームの監視、フォーム送信、その他のシステムに適しています。",
    "Webhook 事件触发": "Webhookイベントトリガー"
  },
  "ko": {
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— 클릭 한 번으로 다른 조직으로 전환하면 에이전트와 지식 기반이 그에 따라 변경됩니다.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— 조직 내의 에이전트 및 구성원을 보고, 새 에이전트를 생성하거나, 새 구성원을 초대합니다.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "—여러 에이전트 시나리오에서 차별화를 촉진하기 위해 에이전트 인식 기능을 제공합니다.",
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— 진행률, 상태, 결과 등 에이전트가 수행 중인 백그라운드 작업을 봅니다.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— 상담원의 성격, 전문성, 행동을 정의합니다. 예를 들어, \"코드 검토자\" 에이전트를 생성하여 코드 품질에 초점을 맞춘 다음 \"제품 관리자\" 에이전트를 생성하여 요구 사항 분석을 효과적으로 수행할 수 있습니다.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— 에이전트에게 그것이 누구인지, 무엇을 전문으로 하는지 알려주세요.",
    "— 个人偏好、组织管理、账号安全。": "—개인 취향, 조직 관리, 계정 보안.",
    "— 管理共享文档，上传和浏览 .md 文件。": "— 공유 문서를 관리하고, .md 파일을 업로드하고 찾아보세요.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— 에이전트에 설치된 스킬을 관리하거나 시장에서 새로운 스킬을 설치합니다.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— 응답할 때 따라야 할 형식, 스타일 및 단계는 무엇입니까?",
    "— 接入 Zoom 会议或聊天。": "— Zoom 회의에 참여하거나 채팅하세요.",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— 상담원, 지식 베이스 및 구성원을 관리할 수 있지만 조직 설정을 수정할 수는 없습니다.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— 에이전트를 사용하고, 대화에 참여하고, 지식 베이스에 액세스할 수 있지만 관리 작업을 수행할 수는 없습니다.",
    "— 浏览和安装技能，管理已发布的技能。": "— 스킬을 검색 및 설치하고 게시된 스킬을 관리합니다.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— 에이전트에게 예약된 작업을 생성하고 관리할 수 있는 기능을 제공합니다.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— 에이전트가 매일 아침 보고서 생성과 같은 예약된 작업이나 주기적인 작업을 설정할 수 있도록 허용합니다.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— 에이전트가 다른 에이전트에 전화하여 에이전트 간 협업을 달성할 수 있도록 허용합니다.",
    "— 让 Agent 能够自动生成和发布新技能。": "— 상담원이 자동으로 새로운 기술을 생성하고 게시할 수 있도록 합니다.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— 에이전트가 스스로 새로운 기술을 만들고 이를 다른 에이전트 설치에서 사용할 수 있도록 시장에 게시할 수 있습니다.",
    "— 什么该做，什么不该做。": "— 해야 할 일과 하지 말아야 할 일.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— 소유자는 모든 권한을 갖고, 관리자는 에이전트와 구성원을 관리할 수 있으며, 일반 구성원은 에이전트와 지식 베이스를 사용할 수 있습니다.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "—BotFather를 통해 Bot을 생성하고 Bot Token을 입력하여 연결합니다.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— 다양한 스킬을 설치하여 상담원의 기능 경계를 확장합니다.",
    "— 通过 Telegram Bot 接入。": "— Telegram Bot을 통해 액세스합니다.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Feishu 로봇을 통해 Feishu에서 에이전트와 직접 대화하세요.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— iLink를 통해 액세스하여 WeChat의 에이전트와 상호 작용합니다.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "— 조직 설정, 구성원 및 상담원을 관리할 수 있는 전체 권한이 있습니다. 각 조직에는 소유자가 한 명뿐입니다.",
    "— 通过企业微信或 iLink 接入。": "— Business WeChat 또는 iLink를 통해 액세스합니다.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— 에이전트와의 채팅 기록은 실시간 스트리밍 출력을 지원합니다.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— 에이전트와 통신하기 위한 기본 인터페이스로 왼쪽에는 에이전트 목록, 오른쪽에는 채팅 창이 있습니다.",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— 에이전트가 작업 공간에서 다른 에이전트를 호출하여 에이전트 간 자동화된 파이프라인을 구현할 수 있도록 허용합니다. 예를 들어 에이전트 A가 분석을 완료한 후 자동으로 결과를 에이전트 B에 전송하여 보고서를 생성합니다.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— \"팀\" 페이지에서 이메일을 통해 구성원을 현재 조직에 초대합니다.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— 대화 인터페이스의 \"스킬\" 탭에서 현재 에이전트의 스킬을 설치하거나 제거합니다. 에이전트마다 서로 다른 스킬 세트를 설치할 수 있습니다.",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— 탐색 모음의 \"스킬 마켓\"에서 사용 가능한 모든 기술을 찾아보고 세부 정보 및 설치 지침을 확인하세요.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Feishu 오픈 플랫폼에서 애플리케이션을 만들고 앱 ID와 앱 비밀을 얻은 다음 액세스합니다. 팀원은 Feishu에서 에이전트와 직접 채팅할 수 있습니다.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": ", 영리 목적이 아니며 사용자에게 수수료를 청구하지 않으며 어떤 형태로든 상업적인 판촉이나 판매를 수행하지 않습니다.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— 에이전트는 지정된 파일 시스템 디렉터리에서 파일을 읽고 쓸 수 있으며 코드를 실행할 수 있습니다. 다양한 에이전트는 다양한 프로젝트 디렉터리를 운영할 수 있습니다.",
    "— 最多可创建 2 个组织。": "— 최대 2개의 조직을 생성할 수 있습니다.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": "은(는) 영리 목적이 아닌 이용자에게 어떠한 수수료도 청구하지 않으며, 어떠한 형태의 상업적 판촉이나 판매도 하지 않습니다.",
    "、": ",",
    ".pen 文件": ".펜 파일",
    "· 点击启用": "· 활성화하려면 클릭하세요.",
    "· 点击召唤": "· 소환하려면 클릭하세요.",
    "· 用于 Agent 理解": "· Agent 이해를 위해 사용",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": "는 다중 에이전트 AI 협업 플랫폼의 기술적 타당성을 입증하는 데에만 사용됩니다. 이 제품",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": "는 다중 에이전트 AI 협업 플랫폼의 기술적 타당성을 입증하는 데에만 사용됩니다. 이 제품",
    "，同时可以被邀请加入他人的组织。": ", 다른 사람의 조직에 가입하도록 초대받을 수 있습니다.",
    "（一次性延时任务）": "(일회성 지연 작업)",
    "@提及": "@멘션",
    "（由 Soul 指令定义）": "(Soul 지시어로 정의됨)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst 위 데이터를 바탕으로 경쟁 구도 분석",
    "@提及机制": "@멘션 메커니즘",
    "← 返回": "← 복귀",
    "← 返回列表": "← 목록으로 돌아가기",
    "← 返回详情": "← 세부정보로 돌아가기",
    "+ 记录": "+ 기록",
    "+ 添加": "+ 추가",
    "✓ 反馈已提交，感谢您的意见！": "✓ 피드백이 제출되었습니다. 의견을 보내주셔서 감사합니다!",
    "✓ 已连接": "✓ 연결됨",
    "/ 月": "/ 달",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer 위 분석을 PDF 보고서로 구성",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher 2024년 신에너지차 해외시장데이터를 검색해 보세요",
    "163 邮箱": "163 이메일",
    "1. 产品性质": "1. 제품 특성",
    "+ 创建新组织": "+ 새 조직 만들기",
    "1. 產品性質": "1. 제품 특성",
    "2 个组织": "2개 기관",
    "2. 数据与隐私": "2. 데이터 및 개인정보 보호",
    "3. 第三方服务": "3. 제3자 서비스",
    "2. 資料與隱私": "2. 데이터 및 개인정보 보호",
    "3. 第三方服務": "3. 제3자 서비스",
    "30 分钟后提醒我开会": "30분 후에 회의 알림",
    "4. 服務可用性": "4. 서비스 가용성",
    "5. 免责声明": "5. 면책조항",
    "4. 服务可用性": "4. 서비스 가용성",
    "5. 免責聲明": "5. 면책조항",
    "6. 联系方式": "6. 연락처 정보",
    "6. 聯絡方式": "6. 연락처 정보",
    "安装方式": "설치방법",
    "安装给以下 Agent：": "다음 에이전트에 설치됩니다.",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "팀이 사용하는 인스턴트 메시징 플랫폼에 에이전트를 연결하고 그룹 채팅이나 비공개 채팅에서 직접 대화를 나누세요.",
    "把世界级设计标准": "세계적 수준의 디자인 표준 제공",
    "把指标接回真实数据": "지표를 실제 데이터에 다시 연결",
    "保存对象": "객체 저장",
    "保存失败": "저장 실패",
    "保存修改": "변경사항 저장",
    "保存中...": "절약...",
    "保存中…": "절약…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "보고서는 정기적으로 조직 전체의 NovaX 사용 현황을 요약하고, 조직이 연결한 데이터베이스, BI, Git, 메일박스 등 기본 데이터를 기반으로 주목할 만한 비즈니스 통찰력을 발견합니다.",
    "被移出了组织": "조직에서 삭제됨",
    "安装不同的": "다른 설치",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "이 제품은 의학적 조언, 법률 상담, 재정적 의사결정 등 전문적인 시나리오에 적합하지 않습니다.",
    "本次分析提示": "이 분석을 위한 팁",
    "本期 SKILL": "이번 호에 대한 기술",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "온톨로지는 또 다른 지식 기반이 아닙니다. 객체, 지표, 데이터, 업무 담당자를 합리적인 지도로 연결하여 에이전트가 \"정보를 찾을\" 뿐만 아니라 숫자가 어떻게 나오는지, 왜 변경되는지, 어떤 영향을 미칠지 알 수 있습니다.",
    "本体加载失败": "온톨로지 로딩 실패",
    "本体视图": "온톨로지 뷰",
    "本体完整度": "존재론적 무결성",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "온톨로지는 구조와 정도만 저장하며, 데이터베이스 크리덴셜은 커넥터나 환경변수로 관리되며 비즈니스 그래프에는 들어가지 않는다.",
    "本月": "이번 달",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "지표 관찰값을 비교한 후 계산 및 데이터 계보를 따라 어떤 레이어에 변화가 발생했는지 알아보세요.",
    "必填": "필수의",
    "避免把相关性误判为因果": "상관관계를 인과관계로 착각하지 마세요",
    "编辑": "편집하다",
    "编辑定义": "정의 편집",
    "编辑对象": "개체 편집",
    "编辑了 Agent": "편집된 에이전트",
    "编辑业务对象": "비즈니스 객체 편집",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "이 제품은 의학적 조언, 법률 상담, 재정적 의사결정 등 전문적인 시나리오에 적합하지 않습니다.",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "본 제품은 OpenAI Codex 서비스를 호출하여 대화 요청을 처리합니다. 귀하의 대화 내용은 해당 서비스의 개인정보 보호정책에 따라 처리됩니다. 대화 중에는 민감한 개인정보를 입력하지 않는 것이 좋습니다.",
    "标识（可选）": "로고(선택사항)",
    "标题": "제목",
    "表、视图、ETL 模型": "테이블, 뷰, ETL 모델",
    "补充口径、边界或业务背景": "보완 역량, 경계 또는 비즈니스 맥락",
    "补充驱动关系": "보조운전관계",
    "补充影响关系": "보충 영향 관계",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "본 제품은 OpenAI Codex 서비스를 호출하여 대화 요청을 처리합니다. 귀하의 대화 내용은 해당 서비스의 개인정보 보호정책에 따라 처리됩니다. 대화 중에는 민감한 개인정보를 입력하지 않는 것이 좋습니다.",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "영혼 쓰기 - 이것이 가장 중요한 단계입니다. Soul은 에이전트가 작업을 이해하고 질문에 답변하는 방법을 결정합니다. 구체적으로 작성할수록 에이전트의 성능이 향상됩니다.",
    "不会用于商业化运营": "상업적인 운영에는 사용되지 않습니다",
    "不保证": "보증 없음",
    "不保證": "보증 없음",
    "不會用於商業化營運": "상업적인 운영에는 사용되지 않습니다",
    "不会主动收集": "적극적으로 수집하지 않음",
    "不會主動收集": "적극적으로 수집하지 않음",
    "参会者": "참석자",
    "参与聚合、关联和过滤的列": "집계, 연관 및 필터링과 관련된 열",
    "仓库地址": "창고 주소",
    "仓库协作": "창고 협업",
    "草稿": "초안",
    "策": "정책",
    "查看": "확인하다",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "에이전트마다 완전히 다른 영혼을 가질 수 있습니다. 예를 들어 팀에는 \"연구원\", \"작성자\", \"코드 검토자\" 등 서로 다른 역할을 가진 여러 에이전트가 동시에 있을 수 있습니다.",
    "查看全部模型 →": "모든 모델 보기 →",
    "查看它负责哪些指标、目标或业务流程。": "담당하는 측정항목, 목표 또는 비즈니스 프로세스를 확인하세요.",
    "查看完整影响路径": "전체 영향 경로 보기",
    "查找文件": "파일 찾기",
    "查看每个技能的功能说明、安装量和评分。": "각 스킬에 대한 기능 설명, 설치 및 등급을 봅니다.",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "일반 AI 대화 도구와 달리 NovaX의 Agent는 지속적인 메모리, 설치 가능한 기술을 갖추고 있으며 여러 사람의 협업을 지원하고 Feishu, Telegram 및 WeChat과 같은 인스턴트 메시징 플랫폼에 연결하여 AI를 일상 작업 흐름에 통합할 수 있습니다.",
    "产品文档和技术架构": "제품 문서 및 기술 아키텍처",
    "产品 PRD、技术架构文档": "제품 PRD, 기술 아키텍처 문서",
    "常见问题和解答模板": "FAQ 템플릿",
    "成员（Member）": "회원",
    "成员 / Agent": "회원/대리인",
    "抽出一位大师的思维，": "스승의 생각을 그려내고,",
    "常见问题和标准回答": "자주 묻는 질문과 표준 답변",
    "处理事件": "이벤트 처리",
    "触发次数": "트리거 수",
    "创建": "만들다",
    "创建 Agent": "에이전트 생성",
    "创建 Webhook": "웹훅 생성",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "웹훅을 생성한 후 외부 시스템(GitHub, Stripe, Sentry 등)이 HTTP POST를 통해 자동으로 트리거될 수 있습니다.",
    "创建第一个指标": "첫 번째 지표 만들기",
    "创建核心指标": "핵심 지표 생성",
    "持久记忆": "지속적인 기억",
    "成员与权限": "회원 및 권한",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "웹 인터페이스 외에도 NovaX 에이전트는 인스턴트 메시징 플랫폼에도 연결할 수 있습니다.",
    "创建会议": "회의 만들기",
    "创建了 Agent": "에이전트가 생성되었습니다.",
    "创建类型": "유형 생성",
    "创建你的第一个 Agent": "첫 번째 에이전트 만들기",
    "创建企业自建应用，获取凭证": "자체 구축된 엔터프라이즈 애플리케이션을 만들고 자격 증명을 얻습니다.",
    "创建失败": "생성 실패",
    "创建时间": "생성 시간",
    "创建中...": "만드는 중...",
    "创建中…": "만드는 중…",
    "创刊导读": "출판물의 창립 소개",
    "创作与协作": "창작 및 공동작업",
    "此文件类型暂不支持预览": "이 파일 형식은 현재 미리보기를 지원하지 않습니다.",
    "次": "이류",
    "从 160+ 专业角色模板中选择": "160개 이상의 전문 역할 템플릿 중에서 선택",
    "从数据到行动的业务地图": "데이터에서 행동으로의 비즈니스 매핑",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "비즈니스 개체 및 지표 정의를 통해 회사 내 동일한 단어의 정확한 의미를 결정합니다.",
    "从业务世界的第一个对象开始": "비즈니스 세계의 첫 번째 대상부터 시작하세요.",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "가장 관심 있는 수익, 주문량, 전환율 또는 비즈니스 결과부터 시작하세요.",
    "从预设创建": "사전 설정에서 만들기",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "생성 후 시스템은 고유한 URL과 키를 생성하며, 이는 URL에 POST 요청을 보내는 외부 시스템에 의해 트리거될 수 있습니다.",
    "代码读取": "코드 판독",
    "待开始": "시작 예정",
    "待认领": "청구 예정",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "서로 다른 프로젝트 또는 팀에 대해 하나씩 최대 2개의 조직을 만듭니다.",
    "大": "큰",
    "待验证": "확인 예정",
    "单次任务": "단일 작업",
    "单次执行": "단일 실행",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "메트릭, 계보, 속성 또는 영향을 요청하면 NovaX Agent는 먼저 관련 온톨로지 컨텍스트를 읽습니다. 지식 베이스는 '원본 텍스트와 배경'을 제공하고, 온톨로지는 '결정된 비즈니스 구조'를 제공하며, 둘은 증거를 통해 연관될 수 있습니다.",
    "待上线": "온라인 상태가 되려면",
    "创建组织": "조직 만들기",
    "当前仅支持 .md 格式": "현재는 .md 형식만 지원됩니다.",
    "当前值": "현재 가치",
    "当前": "현재의",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "데이터베이스, 데이터 테이블 및 키 필드를 등록한 다음 \"데이터 계보\" 또는 \"계산 종속성\"을 사용하여 지표에 연결합니다. 앞으로는 에이전트가 구경에 대해 질문을 받을 때 문서를 기반으로 추측하는 대신 링크를 따라 실제 출처를 찾을 수 있을 것입니다.",
    "登记数据来源": "데이터 소스 등록",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "데이터 소스, 테이블 및 필드를 등록한 다음 \"데이터 계보\" 또는 \"계산 종속성\" 관계를 사용하여 표시기에 연결합니다.",
    "登记数据资产": "데이터 자산 등록",
    "登录账号": "로그인 계정",
    "等待 Agent 连接...": "에이전트 연결을 기다리는 중...",
    "等待连接成功": "성공적인 연결을 기다립니다",
    "等待确认": "확인을 기다리는 중",
    "等待扫码...": "스캔을 기다리는 중...",
    "等待中": "대기 중",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "문제 1 · 귀하의 대리인 팀에서 편집 · 이번 문제",
    "登录状态已失效，请重新登录": "로그인 상태가 만료되었습니다. 다시 로그인해 주세요.",
    "的 AI 协作者。": "AI 협력자들.",
    "第二步：认识你的界面": "2단계: 인터페이스 파악",
    "第四步：开始对话": "4단계: 대화 시작",
    "第三步：创建你的第一个 Agent": "3단계: 첫 번째 에이전트 만들기",
    "第一期正在准备中": "첫 번째 호를 준비 중입니다.",
    "点": "가리키다",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "\"QR 코드 생성\"을 클릭하면 시스템이 WeChat 웹 페이지 로그인 프로세스를 시작합니다.",
    "点击「生成二维码」获取微信登录码": "WeChat 로그인 코드를 얻으려면 \"QR 코드 생성\"을 클릭하세요.",
    "点击连接，系统自动完成配置": "연결을 클릭하면 시스템이 자동으로 구성을 완료합니다.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "아래 버튼을 클릭하여 Feishu 개방형 플랫폼으로 이동하면 시스템이 자동으로 자체 구축 애플리케이션을 생성합니다.",
    "第五步：丰富 Agent 的知识": "5단계: 상담원의 지식 강화",
    "第一步：注册和登录": "1단계: 등록 및 로그인",
    "钉钉": "딩톡",
    "定时任务": "예약된 작업",
    "定位变化": "포지셔닝 변경",
    "定义第一个核心指标": "첫 번째 핵심 지표 정의",
    "定义核心指标": "핵심 지표 정의",
    "定义业务类型": "비즈니스 유형 정의",
    "定义这个 Agent 的性格、指令和能力...": "이 요원의 성격, 명령, 능력을 정의하세요...",
    "定义证据": "증거 정의",
    "定义指标口径": "표시기 구경 정의",
    "调整对话消息流中的文字大小": "대화 스트림의 텍스트 크기 조정",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "에이전트가 인터페이스 디자인, 디자인 사양 및 협업 피드백을 이해할 수 있도록 Figma 파일 구조, 구성 요소 및 설명을 읽어보세요.",
    "读取内容": "콘텐츠 읽기",
    "读取网页": "웹페이지 읽기",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "읽은 후에는 바로 대화로 들어가 원인, 영향 및 다음 단계에 대해 계속해서 질문할 수 있습니다.",
    "端口": "포트",
    "断开连接": "연결 끊기",
    "断开失败": "연결 해제 실패",
    "对话": "대화",
    "对象": "물체",
    "对象存储": "객체 스토리지",
    "对象类型 *": "객체 유형 *",
    "对象列表": "개체 목록",
    "对象已连接": "개체가 연결되었습니다.",
    "对象已删除": "개체가 삭제되었습니다.",
    "对应 Agent 暂不可用": "해당 에이전트를 일시적으로 사용할 수 없습니다.",
    "对话系统": "대화 시스템",
    "独立身份、独立记忆、独立技能": "독립적인 정체성, 독립적인 기억, 독립적인 기술",
    "定时任务（MetaSchedule）": "예약된 작업(MetaSchedule)",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "여러 파일은 쉼표로 구분됩니다. 공백으로 두면 토큰 자체의 가시 범위가 사용됩니다.",
    "多媒体": "멀티미디어",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "대화는 NovaX의 핵심 상호작용 방식입니다. 각 에이전트는 독립적인 대화 기록을 유지합니다. 대화 인터페이스 상단에는 세 개의 탭이 있습니다.",
    "多人": "여러 사람",
    "多维表格": "다차원 테이블",
    "多 Agent 接力": "다중 에이전트 릴레이",
    "额度信息加载失败": "할당량 정보를 로드하지 못했습니다.",
    "多平台连接": "다중 플랫폼 연결",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "할당량은 조직 구성원이 공유하며 모든 소비는 현재 조직에서 차감됩니다.",
    "二": "둘",
    "二维码已过期，请重新生成": "QR코드가 만료되었습니다. 다시 생성해주세요.",
    "发起会议": "회의 시작",
    "发送人": "보내는 사람",
    "发送时间": "보내는 시간",
    "翻开 →": "열기 →",
    "反馈": "피드백",
    "反馈中心": "피드백 센터",
    "返回": "반품",
    "方向": "방향",
    "方向未知": "방향을 알 수 없음",
    "访问 Token": "액세스 토큰",
    "飞书 / Lark": "페이슈 / 종달새",
    "飞书开放平台": "Feishu 오픈 플랫폼",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "Feishu 앱이 만들어졌습니다. 사용을 시작하려면 Feishu 그룹에 봇을 추가하세요.",
    "费曼思维": "파인만의 생각",
    "分析对象": "분석대상",
    "分析思路": "분석적 아이디어",
    "分钟": "분",
    "否": "아니요",
    "额外额度": "추가 크레딧",
    "额度与账单": "신용 한도 및 청구서",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "서버는 먼저 Pencil CLI 키를 확인합니다. 디자인 생성은 Codex 5.6 sol·high를 사용하여 수정되었으며 현재 에이전트 작업 영역의 .pen 파일에서만 작동합니다.",
    "服务器已连接，等待 Bot 上线...": "서버가 연결되어 있고 봇이 온라인 상태가 될 때까지 기다리고 있습니다...",
    "负向": "부정적인",
    "负责人": "담당자",
    "复制": "복사",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "다음 명령을 터미널에 복사하고 실행합니다. 에이전트는 NovaX 서버에 자동으로 연결됩니다.",
    "富文本卡片": "서식 있는 텍스트 카드",
    "覆盖确认": "보장범위 확인",
    "刚刚": "단지",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "서비스의 지속적인 가용성, 안정성 또는 데이터 내구성. 서비스는 언제든지 통지 없이 중단, 변경 또는 종료될 수 있습니다. 본 제품을 생산 환경에서 사용하거나 중요한 데이터를 저장하지 마십시오.",
    "个": "개인",
    "个对象": "사물",
    "个可用技能": "사용 가능한 스킬",
    "个人存储": "개인 저장공간",
    "分析完成后：": "분석이 완료된 후:",
    "个人文档数": "개인 문서 수",
    "个人知识库日志": "개인 지식 베이스 로그",
    "个属性": "속성",
    "个已有来源": "기존 소스",
    "个字段": "전지",
    "给任务取个名字...": "작업 이름을 지정하세요...",
    "更新计划": "계획 업데이트",
    "格式文档，上传后立即生效。": "문서 형식은 업로드 후 즉시 적용됩니다.",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "서비스의 지속적인 가용성, 안정성 또는 데이터 내구성. 서비스는 언제든지 통지 없이 중단, 변경 또는 종료될 수 있습니다. 본 제품을 생산 환경에서 사용하거나 중요한 데이터를 저장하지 마십시오.",
    "工作目录": "작업 디렉토리",
    "工作区标识（可选）": "작업공간 ID(선택사항)",
    "工作区名称（可选）": "작업공간 이름(선택사항)",
    "工作日": "근무일",
    "工作通知": "채용 공고",
    "个人练手的技术演示项目（Demo）": "개인 실습을 위한 기술 시연 프로젝트(Demo)",
    "公开仓库（无需凭据）": "공개 저장소(자격 증명이 필요하지 않음)",
    "公式、单位、粒度与负责人": "공식, 단위, 입도 및 담당자",
    "工作原理": "작동 원리",
    "供 Pencil 内的 Codex Agent 使用": "Pencil 내의 Codex Agent에서 사용",
    "共同规则": "공통 규칙",
    "共同记忆": "공유 메모리",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "현재 공유 기술 자료에 연결할 수 있는 문서가 없습니다. 저장 후 증거를 추가할 수 있습니다.",
    "关闭": "폐쇄",
    "关闭简报": "프레젠테이션 닫기",
    "关闭上传选择": "업로드 선택 닫기",
    "关闭使用引导": "이용안내 닫기",
    "关闭消息导航": "메시지 탐색 끄기",
    "关键字段": "주요 분야",
    "关系名称": "관계 이름",
    "关系说明": "관계 설명",
    "关系有证据": "관계의 증거가 있습니다",
    "关系证据": "관계의 증거",
    "观测日期": "관찰 날짜",
    "观测值已删除": "관찰이 삭제되었습니다.",
    "观远 BI": "관위안 BI",
    "观远 BI 地址": "Guanyuan BI 주소",
    "观远 BI 密码": "관원 BI 비밀번호",
    "管理": "관리하다",
    "個人練手的技術展示專案（Demo）": "개인실습기술 실증사업(Demo)",
    "管理员（Admin）": "관리자",
    "规划中": "계획중",
    "国内平台": "국내 플랫폼",
    "功能详解": "자세한 기능 설명",
    "还没有积累私有记忆": "아직 개인 메모리가 축적되지 않았습니다.",
    "还没有上游驱动": "아직 업스트림 드라이버가 없습니다.",
    "还没有数据血缘": "아직 데이터 계보가 없습니다.",
    "还没有下游影响": "아직 다운스트림 효과 없음",
    "还没有血缘关系。": "아직 혈연관계는 없습니다.",
    "还没有执行对象": "아직 실행 개체가 없습니다.",
    "还没有指标": "아직 지표가 없습니다.",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "또한 Notion의 이 통합과 대상 페이지를 공유해야 합니다.",
    "海外平台": "해외 플랫폼",
    "规定行为": "규정된 행동",
    "核心概念": "핵심 개념",
    "核心指标": "핵심지표",
    "环比变化": "월별 변화",
    "恢复": "다시 덮다",
    "会话文件": "세션 파일",
    "会议 ·": "회의 ·",
    "会议集成": "회의 통합",
    "会议纪要": "회의록",
    "会议链接或 ID": "회의 링크 또는 ID",
    "会议密码:": "회의 비밀번호:",
    "会议时长（分钟）": "회의 시간(분)",
    "会议主题": "컨퍼런스 주제",
    "活跃": "활동적인",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Guanyuan 공식 GuanCLI를 기반으로 연결을 확인합니다. 연결 후 페이지, 카드, 데이터 세트, ETL, 표시기 및 ChatBI를 읽을 수 있습니다. 기본적으로 생성, 수정, 삭제가 허용되지 않습니다.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "WeChat iLink 프로토콜을 기반으로 에이전트는 QR 코드를 스캔한 후 직접 비공개 메시지를 보내고 받을 수 있습니다. 에이전트 캐리어로 전용 WeChat 계정을 사용하는 것이 좋습니다.",
    "即将推出": "곧 온다",
    "计算 / 映射表达式": "계산/매핑 표현식",
    "计算、影响与责任关系": "계산, 영향 및 책임",
    "计算公式": "계산식",
    "计算口径": "구경 계산",
    "记录定义、口径或事实所在位置": "기록 정의, 구경 또는 실제 위치",
    "记录两个以上周期": "2사이클 이상 기록",
    "记录两个周期的数据后即可比较变化。": "두 기간 동안 데이터를 기록한 후 변경 사항을 비교할 수 있습니다.",
    "记录数值": "기록적인 가치",
    "记录中…": "녹음…",
    "还没有产生额度消费": "아직 소비 할당량이 발생하지 않았습니다.",
    "纪要": "요약",
    "记住与你的所有历史对话（": "당신과의 모든 역사적 대화를 기억하십시오 (",
    "技能": "기능",
    "核心内置技能": "핵심 내장 스킬",
    "技能创作（MetaSkill）": "스킬 생성(MetaSkill)",
    "技能。安装后直接在对话中用自然语言描述即可：": "기능. 설치 후 대화에서 자연어로 설명하면 됩니다.",
    "技能（Skill）— 能力扩展": "스킬 - 능력 확장",
    "技能分为系统内置技能和社区发布的技能。": "스킬은 시스템 내장 스킬과 커뮤니티 공개 스킬로 구분됩니다.",
    "技能市场": "기술 시장",
    "技能模块": "스킬 모듈",
    "技能市场分为两个维度：": "기술 시장은 두 가지 차원으로 나누어집니다.",
    "加入 Zoom 会议": "Zoom 회의에 참여하세요",
    "加入会议": "회의에 참여",
    "加入了组织": "조직에 가입했습니다",
    "加载中...": "로드 중...",
    "加载中…": "로드 중…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "AWS S3, MinIO 및 대부분의 S3 프로토콜 객체 스토리지와 호환 가능",
    "简": "단순한",
    "简报": "요약 보고",
    "简报加载失败": "브리핑을 로드하지 못했습니다.",
    "简报生成失败": "브리핑 생성 실패",
    "建立关系": "관계 구축",
    "建立血缘": "혈통을 확립하다",
    "建立业务关系": "비즈니스 관계 구축",
    "建立中…": "건물…",
    "建议从一个核心指标开始": "핵심 지표로 시작하는 것이 좋습니다",
    "建议使用数据库侧的只读账号": "데이터베이스 측에서는 읽기 전용 계정을 사용하는 것이 좋습니다.",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "데이터소스, 핵심지표, 비즈니스 목표를 먼저 등록한 후 연결하는 것이 좋습니다.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "current_user:read, file_content:read, file_comments:read만 부여하는 것이 좋습니다.",
    "将": "할 것이다",
    "将 App ID 和 App Secret 填入下方": "아래에 앱 ID와 앱 비밀번호를 입력하세요.",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "서버 채널에서 상호 작용하려면 이 에이전트를 Discord Bot으로 배포하세요.",
    "接入飞书": "페이슈에 접속하다",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Guanyuan BI의 페이지, 데이터 세트, ETL 및 지표 시스템에 액세스하여 이 에이전트가 기업 운영 데이터를 직접 이해하고 분석할 수 있도록 합니다.",
    "接入微信": "위챗에 접속하세요",
    "揭开第一期": "첫 번째 이슈 공개",
    "结构搭好后，Agent 会自动使用": "구조가 설정되면 에이전트가 자동으로 이를 사용합니다.",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "구조적 관계는 후보 경로를 제공합니다. 진정한 귀속을 위해서는 여전히 관찰, 증거 및 비즈니스 조건의 조합이 필요합니다.",
    "结构信息充足": "충분한 구조 정보",
    "解释业务": "사업을 설명하다",
    "仅供": "오직",
    "仅管理员可删除组织知识库文档": "관리자만 조직의 기술 자료 문서를 삭제할 수 있습니다.",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "스킬은 에이전트의 기능을 확장하는 모듈입니다. 직원이 다양한 도구를 사용하는 것처럼 다양한 에이전트를 다양한 기술 세트로 설치할 수 있습니다.",
    "仅支持 .md 文件": ".md 파일만 지원",
    "角色权限": "역할 권한",
    "技能系统": "스킬 시스템",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "스킬은 에이전트에 설치할 수 있는 기능 모듈입니다. 각 기술은 에이전트에게 특정 능력을 부여합니다. NovaX에는 몇 가지 핵심 기술이 내장되어 있으며 더 많은 기능을 검색하고 설치할 수 있는 기술 시장도 제공합니다.",
    "进 Agent 的肌肉记忆。": "에이전트의 근육 기억을 입력하세요.",
    "近 30 天消耗": "지난 30일 동안 소비",
    "进入第一期": "첫 번째 기간을 입력하세요.",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "\"대화\" 페이지에 들어가서 왼쪽 목록에서 에이전트를 클릭하면 채팅에 입장할 수 있습니다. 입력 상자에 메시지를 보내면 에이전트가 실시간으로 답변을 스트리밍합니다. 대화 지원:",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "\"팀\" 페이지에 들어가서 \"새 에이전트\" 버튼을 클릭하세요. Agent의 이름과 설명을 입력하고 생성합니다. 생성 후 에이전트 카드를 클릭하여 세부정보 페이지로 이동하여 다음을 수행할 수 있습니다.",
    "仅所有者可购买": "소유자 본인만 구매 가능",
    "进行中": "진행 중",
    "进行中/待开": "진행 중/개봉 예정",
    "竞": "경쟁하다",
    "竞对与行业": "경쟁과 산업",
    "聚合方式": "집계 방법",
    "可留空自动生成，例如 contract": "계약서 등 자동 생성을 위해 비워둘 수 있습니다.",
    "可能后果与下游": "가능한 결과 및 다운스트림",
    "可能原因与上游": "가능한 이유 및 업스트림",
    "可选": "선택 과목",
    "可选 · 关联共享知识库": "선택사항 · 관련 공유 지식 베이스",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "팀, 에이전트 또는 프로젝트를 생성하고 측정항목 및 비즈니스 목표에 대한 책임을 설정할 수 있습니다.",
    "可用": "사용 가능",
    "进入左侧导航栏的「知识库」页面。": "왼쪽 탐색 표시줄에 \"기술 자료\" 페이지를 입력합니다.",
    "可追溯证据": "추적 가능한 증거",
    "客户联系": "고객 연락처",
    "口径、公式、粒度和负责人": "구경, 공식, 세분성 및 담당자",
    "口径与依赖": "구경과 의존성",
    "跨层查看正在形成的业务语义。": "여러 계층에 걸쳐 새로운 비즈니스 의미를 확인하세요.",
    "可用 Nova 点": "사용 가능한 Nova 포인트",
    "来源与流转": "소스 및 유통",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "\"기술 자료\" 페이지에 들어가서 .md 형식으로 문서를 업로드하세요. 이 문서는 모든 상담원이 공유하는 참조 자료가 됩니다. 예를 들어 회사의 코드 사양을 업로드한 다음 코드 검토 담당자가 이 사양에 따라 코드를 확인하도록 할 수 있습니다.",
    "类": "친절한",
    "类型说明": "유형 설명",
    "类型已删除": "유형이 삭제되었습니다.",
    "类型与字段": "유형 및 필드",
    "快速上手": "빨리 시작하세요",
    "来扩展能力": "역량을 확장하기 위해",
    "理解含义": "의미를 이해하다",
    "例：产品评审会、周例会...": "예: 제품 리뷰 회의, 주간 회의...",
    "例如 研究助手": "예를 들어 연구 조교",
    "例如 demo": "예를 들어 데모",
    "例如 NovaX 产品团队": "예를 들어 NovaX 제품 팀은",
    "例如 product-design": "예를 들어 제품 디자인",
    "例如 researcher": "예를 들어 연구원",
    "例如：2026-W30 / 2026-07": "예: 2026-W30/2026-07",
    "例如：合同": "예: 계약",
    "例如：经营看板 / SQL 查询": "예: 비즈니스 Kanban/SQL 쿼리",
    "例如：库存充足时": "예: 재고가 충분한 경우",
    "例如：渠道=自然流量，地区=华东": "예: 채널 = 자연 교통, 지역 = 중국 동부",
    "例如：同日 / 7 天后": "예: 당일/7일 후",
    "例如：支付转化率": "예: 결제 전환율",
    "例如：SUM(pay_amount)": "예: SUM(지불_금액)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "예: SUM(pay_amount) 또는orders.pay_amount → 수익",
    "连接": "연결하다",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "AWS S3, MinIO 또는 호환 가능한 객체 저장소에 연결하면 에이전트가 디렉터리를 찾아보고 인증 접두사 내의 파일을 읽을 수 있습니다.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "GitHub, GitLab 또는 Gitee 저장소에 연결하여 이 에이전트가 코드를 읽고, 변경 사항을 분석하고, 인증 범위 내에서 개발 협업에 참여할 수 있도록 하세요.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "PostgreSQL, MySQL, SQL Server 및 기타 데이터베이스에 연결하여 읽기 전용 권한으로 실제 비즈니스 데이터를 쿼리하세요.",
    "连接成功": "연결 성공",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "연결이 성공하면 에이전트가 자동으로 WeChat에 액세스하고 지정된 채팅의 메시지에 응답합니다.",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "어떤 상담원이 응답할지 지정합니다. @가 없는 메시지는 에이전트를 실행하지 않습니다.",
    "连接飞书": "페이슈에 연결",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Feishu에 연결한 후 팀원은 Feishu 그룹 채팅에서 에이전트와 직접 대화할 수 있습니다. 서식 있는 텍스트 카드, 파일 전송 및 수신, 캘린더 연결과 같은 Feishu의 기본 기능을 지원합니다.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "연결 후 파일 노드와 댓글을 읽을 수는 있지만, 디자인 수정, 댓글 게시, 팀 관리 등은 열람할 수 없습니다.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "연결 후에는 개체를 나열할 수 있으며 제한된 접두사 내에서 2MB 이하의 파일을 읽을 수 있습니다. 업로드, 덮어쓰기, 삭제는 허용되지 않습니다.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "접속 후 승인된 페이지 및 콘텐츠 블록을 검색하고 열람할 수 있으나, 페이지 생성, 수정, 삭제는 허용되지 않습니다.",
    "连接计算来源和业务目标": "컴퓨팅 소스와 비즈니스 목표 연결",
    "连接类型": "연결 유형",
    "连接目标或流程": "대상 또는 프로세스 연결",
    "连接你的 AI 引擎": "AI 엔진 연결",
    "连接上下游": "업스트림과 다운스트림 연결",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "디자인, 문서, 이메일, 코드 및 비즈니스 데이터를 연결하여 에이전트가 명확하게 승인된 범위 내에서 실제 작업에 참여할 수 있도록 합니다.",
    "连接失败": "연결 실패",
    "连接数据或指标": "데이터 또는 측정항목 연결",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "연결이 완료된 후 Feishu 그룹에 에이전트를 추가하여 대화를 시작하세요.",
    "连接微信": "위챗에 연결",
    "连接验证成功": "연결 확인 성공",
    "连接中...": "연결 중...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "두 번의 연속 기록 기간이 지나면 NovaX는 변경 사항을 계산하고 영향 분석에서 가능한 동인 업스트림을 검색합니다.",
    "联网搜索": "인터넷 검색",
    "链接": "링크",
    "列表视图": "목록 보기",
    "临时凭据才需要": "임시 자격 증명만 필요합니다.",
    "另有": "또한",
    "留空会继续使用已加密保存的凭据": "암호화된 저장된 자격 증명을 계속 사용하려면 비워 두세요.",
    "六": "육",
    "六个视图，其实是同一张图": "6개의 보기, 실제로는 같은 사진",
    "路径样式（MinIO 常用）": "경로 스타일(MinIO에서 일반적으로 사용됨)",
    "马斯克思维": "사향 생각",
    "芒格思维": "멍거의 생각",
    "没有发现新增内容": "새 콘텐츠를 찾을 수 없습니다.",
    "没有匹配的角色": "일치하는 역할 없음",
    "没有匹配的消息": "일치하는 메시지가 없습니다.",
    "没有匹配的指标": "일치하는 측정항목이 없습니다.",
    "没有上游路径": "업스트림 경로 없음",
    "没有下游路径": "다운스트림 경로 없음",
    "没有新增内容": "새로운 것은 없다",
    "没有找到匹配的技能": "일치하는 기술을 찾을 수 없습니다.",
    "没有找到匹配的文件": "일치하는 파일이 없습니다",
    "每": "모든",
    "累计消耗": "누적 소비",
    "连接到飞书、Telegram、微信等": "Feishu, Telegram, WeChat 등에 연결하세요.",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "@모든 상담원이 없는 메시지는 그룹으로 전송되지만 상담원의 답장은 실행되지 않으므로 팀 구성원 간의 의사소통이 원활해집니다.",
    "每篇内容都来自": "각 콘텐츠의 출처는 다음과 같습니다.",
    "每天": "매일",
    "每小时": "시간당",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "각 계층은 서로 다른 질문에 대답하고 함께 에이전트가 추론할 수 있는 온톨로지를 형성합니다.",
    "每月": "매월",
    "每周": "주간",
    "每天早上 9 点给我发一份行业新闻摘要": "매일 아침 9시에 업계 뉴스 요약을 보내주세요.",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "각 에이전트는 그룹 채팅의 상황을 볼 수 있으므로 후속 에이전트는 이전 에이전트의 출력을 직접 참조할 수 있습니다.",
    "每个用户最多可以创建": "각 사용자는 최대",
    "密码": "비밀번호",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "비밀번호, 토큰 및 개인 키는 암호화되어 서버측에만 저장되며 에이전트 파일이나 대화에는 기록되지 않습니다.",
    "每周五下午 5 点生成本周工作总结": "한 주의 작업 요약은 매주 금요일 오후 5시에 생성됩니다.",
    "描述": "설명하다",
    "名称": "이름",
    "名称 *": "이름 *",
    "名称不能为空": "이름은 비워둘 수 없습니다.",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "무료 할당량은 조직의 일회성 할당량이며 모든 구성원이 공유합니다. 현재 $1 = 750 Nova 포인트로 전환됩니다.",
    "模板消息": "템플릿 메시지",
    "免费赠送": "무료 선물",
    "名称和头像": "이름과 아바타",
    "模型定义": "모델 정의",
    "模型": "모델",
    "默认邮箱目录": "기본 메일함 디렉토리",
    "明确角色": "역할을 명확히 하다",
    "模板中用": "템플릿에 사용됨",
    "内部群聊": "내부 그룹 채팅",
    "内容读取": "콘텐츠 읽기",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "기본 제공 유형은 NovaX의 공통 의미를 형성하고 사용자 정의 유형은 고유한 비즈니스를 설명합니다.",
    "你": "너",
    "目录": "목차",
    "模型和": "모델과",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "에이전트를 팀의 가상 구성원으로 생각할 수 있습니다. 다음을 수행할 수 있습니다.",
    "你可以随时在设置中注销账号，删除所有关联数据。": "언제든지 설정에서 계정에서 로그아웃하고 관련 데이터를 모두 삭제할 수 있습니다.",
    "女娲 · Skill 造人术": "누와·스킬 인간창조기술",
    "篇": "장",
    "频道对话": "채널 대화",
    "平台": "플랫폼",
    "平台公告": "플랫폼 발표",
    "评估后果": "결과 평가",
    "评论读取": "읽은 댓글",
    "凭据已加密保存，": "자격 증명은 암호화되어 저장됩니다.",
    "期望方向": "원하는 방향",
    "企业微信": "엔터프라이즈 위챗",
    "企业邮箱 / 自定义 IMAP": "비즈니스 이메일/맞춤형 IMAP",
    "启用（兼容自签名证书）": "활성화됨(자체 서명된 인증서와 호환 가능)",
    "启用（推荐）": "활성화(권장)",
    "启用并验证证书": "인증서 활성화 및 확인",
    "起点 *": "출발점 *",
    "前": "앞으로",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "설정에서 언제든지 계정에서 로그아웃하고 관련 데이터를 모두 삭제할 수 있습니다.",
    "前往": "이동",
    "前往飞书开放平台 →": "Feishu 오픈 플랫폼 바로가기 →",
    "前缀隔离": "접두사 격리",
    "乔布斯思维": "직업 생각",
    "切换": "스위치",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "이용 중 입력하신 대화 내용은 AI 엔진과의 상호작용에만 사용되며, 추가로 저장되거나 모델 학습에 사용되지 않습니다.",
    "前提：Agent 需要安装": "전제조건: 에이전트를 설치해야 합니다.",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "이용 중 입력하신 대화 내용은 AI 엔진과의 상호작용에만 사용되며, 추가로 저장되거나 모델 학습에 사용되지 않습니다.",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "조직을 전환하거나 생성하면 각 조직에는 독립적인 에이전트와 구성원이 있습니다.",
    "切换中...": "전환 중...",
    "切换组织": "조직 전환",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "조직을 전환하면 표시되는 상담원, 지식창고, 팀 구성원이 그에 따라 변경됩니다.",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "브리핑의 결론을 활용하여 이유, 가능한 영향 및 다음에 취해야 할 가장 가치 있는 조치에 대해 자세히 설명하십시오.",
    "请输入您的反馈、建议或遇到的问题...": "피드백, 제안 또는 문제를 입력해 주세요...",
    "请填写 App ID 和 App Secret": "앱 ID와 앱 비밀번호를 입력해주세요.",
    "请勿填写网页登录密码": "웹페이지 로그인 비밀번호를 입력하지 마세요.",
    "请选择一个角色": "역할을 선택하세요.",
    "区域": "영역",
    "驱动行动": "행동을 유도하다",
    "取消": "취소",
    "全部": "모두",
    "全部对象": "모든 개체",
    "全部执行对象": "모든 실행 객체",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "사서함은 전체적으로 IMAP 읽기 전용 모드로 열립니다. 이메일 본문을 검색하여 읽을 수 있으며 첨부 파일 이름을 볼 수 있습니다. 이메일은 전송, 삭제, 이동 또는 표시되지 않습니다.",
    "全员群": "전원",
    "权限隔离": "권한 격리",
    "确保 Codex CLI 已安装": "Codex CLI가 설치되어 있는지 확인하세요",
    "确定": "확신하는",
    "确定断开？已保存凭据会被删除。": "연결을 끊으시겠어요? 저장된 자격 증명이 삭제됩니다.",
    "确定删除这个会议？": "이 회의를 삭제하시겠습니까?",
    "确定删除这条指标观测吗？": "이 지표 관찰을 삭제하시겠습니까?",
    "确定要注销账号吗？": "계정을 취소하시겠습니까?",
    "确定清除所有会话？": "모든 세션을 지우시겠습니까?",
    "确认断开": "연결 해제 확인",
    "清除后所有聊天记录将被删除，无法恢复。": "삭제 후에는 모든 채팅 기록이 삭제되며 복구할 수 없습니다.",
    "确认已安装。": "설치되었는지 확인하세요.",
    "全局市场": "글로벌 시장",
    "群聊": "그룹 채팅",
    "群聊@唤醒": "그룹채팅@wake",
    "群聊对话": "그룹 채팅 대화",
    "确认注销": "로그아웃 확인",
    "确认清除": "삭제 확인",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "그룹 채팅은 NovaX의 핵심 협업 시나리오입니다. 에이전트 목록 상단의 '모든 구성원'을 클릭하여 입장하세요. 그룹 채팅의 모든 상담원과 팀원은 동일한 대화 공간을 공유합니다.",
    "让组织的重要变化": "조직에 중요한 변화를 가져오세요",
    "人": "사람들",
    "人格蒸馏 · 女娲造人": "성격증류·누와가 인간을 창조한다",
    "认证方式": "인증방법",
    "群聊与多 Agent 协作": "그룹 채팅 및 다중 에이전트 협업",
    "群聊中需要通过": "그룹 채팅에서는 통과해야 합니다.",
    "任务": "일",
    "任务名称": "작업 이름",
    "仍建议用实际数据验证候选原因。": "그래도 실제 데이터를 통해 예상 원인을 검증하는 것이 좋습니다.",
    "日": "낮",
    "日历联动": "캘린더 연동",
    "日期": "날짜",
    "人设和行为规则": "성격과 행동 규칙",
    "三": "삼",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "질문이나 우려 사항이 있는 경우 제품 내 피드백 채널을 통해 개발자에게 문의하시기 바랍니다.",
    "如何创建": "만드는 방법",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "QR 코드를 스캔하여 WeChat에 로그인한 후 에이전트는 WeChat 도우미 역할을 하여 메시지에 자동으로 응답하고, 그룹 채팅을 관리하고, 일상 업무를 처리할 수 있습니다.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "QR 코드를 스캔하여 WeChat에 연결한 후 이 에이전트는 자동으로 WeChat 메시지에 액세스하고 개인 채팅 또는 그룹 채팅에 응답할 수 있습니다.",
    "扫码区域": "스캔 코드 영역",
    "删除": "삭제",
    "删除观测": "관찰 삭제",
    "删除后无法恢复，确定要删除这个文档吗？": "삭제한 내용은 복원할 수 없습니다. 이 문서를 삭제하시겠습니까?",
    "删除会议": "회의 삭제",
    "删除了 Agent": "에이전트가 삭제되었습니다.",
    "删除失败": "삭제 실패",
    "删除失败或无权操作": "삭제에 실패했거나 작업 권한이 없습니다.",
    "删除文档": "문서 삭제",
    "商业专业": "경영전공",
    "上传": "업로드",
    "上传到哪里？": "어디에 업로드하나요?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "업로드한 후에도 \"조직 지식 베이스/내 지식 베이스\"에서 별도로 볼 수 있습니다.",
    "上传了": "업로드됨",
    "上传录音": "녹음 업로드",
    "上传失败": "업로드 실패",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "질문이나 우려 사항이 있는 경우 제품 내 피드백 채널을 통해 개발자에게 문의하시기 바랍니다.",
    "上次：": "지난번:",
    "上次触发": "마지막으로 트리거된",
    "上次执行": "마지막으로 실행된",
    "上下游网络": "업스트림 및 다운스트림 네트워크",
    "上一步": "이전 단계",
    "上游候选": "업스트림 후보",
    "尚未补充业务定义": "아직 추가된 비즈니스 정의가 없습니다.",
    "尚未连接指标或业务目标。": "아직 측정항목이나 비즈니스 목표가 연결되지 않았습니다.",
    "设定边界": "경계를 설정하다",
    "三级权限体系": "3단계 권한 시스템",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "\"매일 오전 9시에 일일 보고서를 보내주세요\"와 같은 예약된 작업을 설정하세요.",
    "设计创作": "디자인 창작",
    "设计生成": "디자인 세대",
    "设计师包 · DESIGN": "디자이너 가방 · DESIGN",
    "设置": "설정",
    "上传文件作为附件。": "파일을 첨부파일로 업로드하세요.",
    "谁来行动": "누가 행동할 것인가",
    "什么属于这个类型，什么不属于？": "이 장르에 속하는 것과 그렇지 않은 것은 무엇입니까?",
    "生成二维码": "QR 코드 생성",
    "生成二维码失败": "QR 코드를 생성하지 못했습니다.",
    "生成纪要": "분 생성",
    "生成纪要中": "분 생성",
    "生成失败": "빌드 실패",
    "生成中...": "생성 중...",
    "失败": "실패하다",
    "设置头像，从预设中选择或上传自定义图片。": "아바타를 설정하고 사전 설정에서 선택하거나 사용자 정의 이미지를 업로드하세요.",
    "实体与关系来源": "엔터티 및 관계 소스",
    "使用": "사용",
    "时间": "시간",
    "使用工具": "도구 사용",
    "使用时只记住两个动作": "사용할 때 두 가지 동작만 기억하세요.",
    "使用引导": "가이드 사용",
    "什么是 Agent": "에이전트란?",
    "使用方式": "용법",
    "视条件而定": "조건에 따라 달라질 수 있음",
    "是": "예",
    "是 / 否": "~이든",
    "示例：": "예:",
    "适用条件": "적용 조건",
    "收到 Webhook 事件: {{payload}}": "수신된 웹훅 이벤트: {{payload}}",
    "收起": "닫다",
    "手动创建": "수동으로 생성",
    "手动记录": "수동녹화",
    "输入清晰、唯一的业务名称": "명확하고 고유한 업체 이름을 입력하세요.",
    "输入消息，@agent 名字来提问": "질문하려면 메시지, @상담원 이름을 입력하세요.",
    "属性": "재산",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "속성은 비즈니스 의미를 통합하는 데 사용되며 에이전트의 구조화된 컨텍스트가 됩니다.",
    "属性字段": "속성 필드",
    "数": "숫자",
    "数据层：数从哪里来": "데이터 계층: 숫자는 어디에서 오는가?",
    "数据从哪里来，经过什么，最终形成哪个指标": "데이터는 어디서 오고, 어떤 과정을 거치며, 최종적으로 어떤 지표가 형성되나요?",
    "数据分析": "데이터 분석",
    "数据观察": "데이터 관찰",
    "数据集": "데이터세트",
    "数据库、表和关键字段": "데이터베이스, 테이블 및 키 필드",
    "数据库地址": "데이터베이스 주소",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "데이터베이스 접근은 친족관계와 관찰을 자동으로 보완할 수 있습니다. 상관관계를 발견할 수 있지만 상관관계를 인과관계로 자동 업그레이드하지는 않습니다.",
    "数据库类型": "데이터베이스 유형",
    "数据库密码": "데이터베이스 비밀번호",
    "数据库名": "데이터베이스 이름",
    "数据血缘": "데이터 계보",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "데이터 계보는 \"숫자는 어디에서 오는가?\"에 대해 답합니다. 영향 관계는 \"아마도 왜\"라고 대답합니다. 입증된 원인과 결과만이 \"원인이 무엇인지 결정\"할 수 있습니다.",
    "数据血缘图": "데이터 계보 다이어그램",
    "数据与办公": "데이터 및 사무실",
    "数据源": "데이터 소스",
    "数据源、表与字段": "데이터 소스, 테이블 및 필드",
    "数据资产": "데이터 자산",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "데이터 항목 → 핵심지표 → 사업목표 → 담당자",
    "数值来源": "가치 소스",
    "数字": "숫자",
    "双人": "더블",
    "说明": "설명하다",
    "说明它在业务里代表什么，以及不包含什么": "비즈니스에서 그것이 나타내는 것과 포함되지 않는 것을 설명하십시오.",
    "私聊": "비공개 채팅",
    "私聊回复": "비공개 채팅 답장",
    "私钥口令（可选）": "개인 키 비밀번호(선택 사항)",
    "思考中...": "생각...",
    "思维框架": "사고의 틀",
    "四": "4개",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "네 번째 계층은 4개의 개별 디렉토리가 아니라 사실을 행동으로 연결하는 링크입니다. 한 번에 모두 채울 필요는 없으며, 가장 중요한 링크만 먼저 구축하세요.",
    "松开以上传 .md 文件": ".md 파일을 업로드하려면 손을 떼세요.",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "통합이 승인된 Notion 페이지와 콘텐츠 블록을 검색하고 읽어 에이전트가 팀 문서와 프로젝트 자료를 사용할 수 있도록 합니다.",
    "搜索会话内的文件": "세션 내에서 파일 검색",
    "搜索技能名称、描述或标签...": "스킬 이름, 설명 또는 태그를 검색하세요...",
    "搜索内容": "콘텐츠 검색",
    "搜索项目、团队或 Agent": "프로젝트, 팀 또는 에이전트 검색",
    "搜索消息...": "메시지 검색...",
    "搜索预设角色...": "사전 설정된 역할 검색...",
    "搜索知识库...": "지식 베이스 검색...",
    "搜索指标或口径": "측정항목 또는 구경 검색",
    "所属层 *": "소속 레이어 *",
    "使用者的個人資訊用於任何商業用途。": "사용자의 개인정보는 상업적 목적으로 사용됩니다.",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "이메일 주소를 사용하여 계정을 등록하세요. 시스템에서 귀하의 이메일로 인증 코드를 보내드립니다. 확인 후 비밀번호를 설정하시면 등록이 완료됩니다. 처음 로그인하면 자동으로 기본 조직이 생성됩니다.",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "또한 경쟁에 대한 시급하거나 중요한 정보는 물론 업계 및 정책 방향에 대한 빅 뉴스에도 지속적으로 관심을 기울이고 조직의 관심이 필요한 변화를 여기에서 추진할 것입니다.",
    "所有者（Owner）": "소유자",
    "适合放入的内容": "무엇을 넣을까?",
    "提出原因": "이유를 대세요",
    "提交反馈": "피드백 제출",
    "提交分析": "분석 제출",
    "添加关系": "관계 추가",
    "添加字段": "필드 추가",
    "条关系": "관계",
    "条件性": "조건부",
    "条因果关系": "인과관계",
    "跳": "도약",
    "跳过引导": "부팅 건너뛰기",
    "通过": "통과하다",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Pencil Headless CLI를 통해 .pen 디자인 초안을 생성, 수정 및 내보내며 생성 프로세스에는 항상 Codex가 사용됩니다.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "전 세계적으로 인스턴트 메시징 및 파일 처리를 지원하는 Telegram Bot을 통해 에이전트와 상호 작용합니다.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Telegram Bot을 통해 이 에이전트와 상호 작용하여 글로벌 인스턴트 메시징을 지원합니다.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "WhatsApp Business API를 통해 이 에이전트에 액세스하여 전 세계 사용자에게 다가가세요.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "내부 커뮤니케이션 및 고객 서비스 시나리오를 지원하려면 기업 WeChat 애플리케이션을 통해 이 에이전트에 액세스하세요.",
    "套餐之间仅额度不同，所有产品能力保持一致。": "패키지별로 금액만 다를 뿐, 모든 제품의 기능은 동일합니다.",
    "通信对话 (": "소통대화(",
    "通用工具 (": "일반 도구(",
    "同名文档": "같은 이름의 문서",
    "同一组织 · 同一份简报 · 持续沉淀": "같은 조직 · 같은 간략 · 지속적인 축적",
    "统计": "통계",
    "统计粒度": "통계적 세분성",
    "统计周期": "통계기간",
    "图标": "상",
    "图标视图": "아이콘 보기",
    "图片 / PDF 导出": "이미지/PDF 내보내기",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "패키지 및 할당량을 이미 볼 수 있으며, 결제 채널이 확인되면 구매가 가능합니다.",
    "团队的": "팀",
    "团队": "팀",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "동일한 에이전트가 웹과 IM 플랫폼 모두에서 작업할 수 있으며 대화 추억과 기술은 모든 플랫폼에서 공유됩니다.",
    "团队规范、工作流程、审批标准": "팀 사양, 업무 프로세스 및 승인 기준",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "이메일을 통해 회원을 초대하고 다양한 역할(소유자/관리자/회원)을 설정하세요.",
    "团队日志": "팀 로그",
    "推荐": "추천하다",
    "推荐建模顺序": "권장 모델링 순서",
    "退出登录": "로그아웃",
    "拖入 .md 文件，或点击上传": ".md 파일을 드래그하거나 업로드를 클릭하세요.",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "작업 공간 쓰기 샌드박스 내에서 강점을 추론하고 작업을 실행하세요.",
    "外部系统 POST 到此 URL 即可触发": "이 URL에 대한 외부 시스템 POST가 트리거될 수 있습니다.",
    "团队规范和工作流程": "팀 규범 및 업무 프로세스",
    "团队协作（NovaX Bus）": "팀 협업(NovaX 버스)",
    "完成": "마치다",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "완전한 지표에는 비즈니스 정의, 계산 범위, 세분성, 차원, 소스, 담당자 및 기록 관찰이 포함됩니다.",
    "网络错误": "네트워크 오류",
    "微信": "위챗",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "WeChat 연결은 웹 버전 프로토콜을 기반으로 하며, WeChat 계정은 에이전트 캐리어로 온라인 상태로 유지되어야 합니다. 전용 WeChat 계정을 사용하는 것이 좋습니다.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat이 연결되고 에이전트가 자동으로 메시지에 응답합니다. 서비스를 다시 시작한 후 사용할 수 있습니다.",
    "唯一标识": "고유 식별자",
    "维度切片": "차원 조각",
    "未补充映射表达式": "매핑 표현식이 보완되지 않음",
    "未连接": "연결되지 않음",
    "未设置": "설정되지 않음",
    "未设置编码": "인코딩이 설정되지 않았습니다.",
    "未设置更新频率": "업데이트 빈도가 설정되지 않았습니다.",
    "未设置公式": "설정된 수식 없음",
    "未设置统计粒度": "통계 세분성이 설정되지 않았습니다.",
    "未知": "알려지지 않은",
    "未知文档": "알 수 없는 문서",
    "文本": "텍스트",
    "文档读取失败": "문서 읽기 실패",
    "文档读取失败或无权访问": "문서읽기에 실패했거나 접근권한이 없습니다",
    "文档已覆盖": "문서가 다루어졌습니다",
    "文档已删除": "문서가 삭제되었습니다.",
    "文档已上传": "문서가 업로드됨",
    "文件处理": "파일 처리",
    "文件传输": "파일 전송",
    "文件读取": "파일 읽기",
    "文件分享": "파일 공유",
    "文件过大，最大支持 2MB": "파일이 너무 큽니다. 지원되는 최대 크기는 2MB입니다.",
    "文件结构": "파일 구조",
    "文件收发": "파일 보내기 및 받기",
    "我": "나",
    "我的知识库": "내 지식 기반",
    "外观": "모습",
    "我们": "우리를",
    "我想继续讨论这篇组织简报：": "저는 이 조직 개요에 대해 계속 논의하고 싶습니다.",
    "无单位": "단위 없음",
    "无公式": "수식 없음",
    "无可用 Agent": "사용 가능한 에이전트가 없습니다.",
    "无描述": "설명 없음",
    "五": "다섯",
    "系统": "체계",
    "系统工具": "시스템 도구",
    "系统内置": "시스템 내장",
    "外部平台": "외부 플랫폼",
    "下次：": "다음번:",
    "下次执行": "다음에 실행",
    "下一步": "다음 단계",
    "下游影响": "다운스트림 효과",
    "下载": "다운로드",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "먼저 \"새 개체 만들기\"를 수행한 다음 \"관계 설정\"을 수행합니다. 객체는 필드, 지표, 대상 또는 에이전트일 수 있습니다. 관계는 계산, 계보, 영향, 인과관계 또는 귀속을 명시적으로 선택하고 공식, 조건, 신뢰도 및 증거를 보완해야 합니다.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "먼저 의사결정에 실제로 활용되는 '판매량, 주문량, 전환율' 등의 지표를 작성하고, 사업 정의, 공식, 통계 세분성, 담당자 등을 완성합니다. 그런 다음 NovaX가 어떤 변화가 발생했는지 확인할 수 있도록 최소 두 기간 동안 값을 기록합니다.",
    "先看懂四层业务地图": "먼저 4계층 비즈니스 맵을 이해하세요.",
    "先验证，再保存": "먼저 확인 후 저장하세요",
    "现在搭建第一条业务链路": "이제 첫 번째 비즈니스 링크를 구축하세요",
    "现在可以通过受限工具安全使用这个连接。": "이제 이 연결은 제한된 도구와 함께 사용해도 안전합니다.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "이제 조직의 첫 번째 이슈를 생성하는 것부터 시작하세요. 정보와 연결이 계속 추가됨에 따라 NovaX는 여기에 주목할 만한 콘텐츠를 계속해서 푸시할 것입니다.",
    "限定前缀（可选）": "적격 접두사(선택사항)",
    "限定文件 Key（可选）": "정규화된 파일 키(선택 사항)",
    "相对上一期": "지난 호에 비해",
    "详细记忆文件": "상세 메모리 파일",
    "项操作": "운영",
    "我們": "우리",
    "消耗": "소비하다",
    "消息导航": "메시지 탐색",
    "消息卡片": "메시지 카드",
    "消息": "정보",
    "系统任务": "시스템 작업",
    "小": "작은",
    "小时": "시간",
    "协作 Agent": "협업 에이전트",
    "斜杠命令": "슬래시 명령",
    "新建对象": "새 개체",
    "新建业务概念": "새로운 비즈니스 컨셉",
    "新建执行对象": "새로운 실행 객체 생성",
    "新建指标": "새로운 지표",
    "形成指标": "양식 표시기",
    "修改文件": "파일 수정",
    "虚拟主机样式（AWS 默认）": "가상 호스트 스타일(AWS 기본값)",
    "需要两个周期": "2주기가 걸립니다",
    "选择 .md 文件 →": ".md 파일 선택 →",
    "选择要安装到的 Agent": "설치할 에이전트를 선택하세요.",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "미리 설정된 역할을 선택하여 빠르게 시작하거나 사용자 지정 에이전트를 수동으로 생성하세요.",
    "选择一个执行对象": "실행 객체 선택",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "지표를 선택한 후 영향 분석에서는 계산 소스와 후보 동인을 위쪽으로 찾고, 아래쪽으로는 영향을 담당하는 목표, 프로세스 및 사람을 찾습니다. 영향력 관계는 단지 단서일 뿐입니다. 검증 증거와의 인과 관계만이 에이전트에 의해 명확한 원인으로 표현됩니다.",
    "选择一个指标开始": "시작하려면 지표를 선택하세요",
    "选择指标或业务对象": "측정항목 또는 비즈니스 개체를 선택하세요.",
    "血缘与计算映射": "혈통 및 컴퓨터 매핑",
    "寻址方式": "주소 지정 모드",
    "沿关系找原因，也看后果": "관계를 따라가며 원인을 찾고, 결과도 살펴보세요.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "다운스트림 관계를 따라 영향을 받는 목표, 프로세스, 프로젝트 및 소유자를 식별합니다.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "영향 및 인과 관계에 따라 후보 동인을 생성하고 신뢰도, 조건 및 증거를 기반으로 표현을 하향 조정합니다.",
    "沿用 Figma Token 可见范围": "Figma 토큰의 가시 범위를 상속받습니다.",
    "消息字体大小": "메시지 글꼴 크기",
    "颜色": "색상",
    "演示文稿制作": "프레젠테이션 제작",
    "验证并保存": "확인 및 저장",
    "验证并连接": "확인 및 연결",
    "验证结果": "검증 결과",
    "研究员输出数据后：": "연구원이 데이터를 출력한 후:",
    "要点速读": "빨리 읽어야 할 포인트",
    "也是 Agent 们的": "에이전트에게도",
    "业务本体": "비즈니스 온톨로지",
    "业务层：数字说明什么": "비즈니스 계층: 숫자가 말하는 것",
    "业务地图": "비즈니스 지도",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "비즈니스 맵은 전체 그림을 보고, 지표 네트워크는 역량과 업스트림 및 다운스트림을 보고, 데이터 계보는 소스를 보고, 영향 분석은 원인과 결과를 보고, 조직 실행은 담당자를 보고, 모델은 관리 개체 유형을 정의합니다. 보기를 전환해도 중복 데이터가 생성되지 않습니다.",
    "业务定义": "비즈니스 정의",
    "业务对象": "비즈니스 객체",
    "写 Soul 的要点": "글쓰기 소울의 핵심 포인트",
    "邀请成员": "회원 초대",
    "业务连接": "비즈니스 연결",
    "业务声明": "사업 명세서",
    "业务指标": "비즈니스 지표",
    "页面分析": "페이지 분석",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "페이지 디자인, 프레젠테이션, AI 이미지 생성 등 에이전트를 전문 디자이너처럼 보이게 만드세요.",
    "页面搜索": "페이지 검색",
    "一": "하나",
    "一只 Agent。": "에이전트.",
    "移除了": "제거됨",
    "已保存，留空不修改": "저장되었습니다. 수정하지 않고 비워두세요.",
    "已触发": "트리거됨",
    "已存在，是否覆盖？": "이미 존재합니까? 덮어쓰시겠습니까?",
    "已复制": "복사됨",
    "已归档": "보관됨",
    "已过期": "만료됨",
    "已结束": "끝났다",
    "已连接": "연결됨",
    "已连接 ·": "연결됨 ·",
    "已取消": "취소",
    "已扫码，请在手机上确认...": "코드가 스캔되었습니다. 휴대폰에서 확인해 주세요...",
    "已生成纪要": "생성된 시간(분)",
    "已完成": "완전한",
    "已验证": "확인됨",
    "已验证因果": "원인과 결과가 확인됨",
    "已暂停": "정지된",
    "因果可信度阶梯": "인과적 신뢰성 사다리",
    "业务规则、行业术语、标准话术": "비즈니스 규칙, 업계 용어, 표준 어휘",
    "业务规则和约束条件": "비즈니스 규칙 및 제약",
    "引导进度": "부팅 진행",
    "应用消息": "애플리케이션 메시지",
    "应用专用密码 / 授权码": "애플리케이션별 비밀번호/인증 코드",
    "影响分析": "영향 분석",
    "影响分析失败": "영향 분석 실패",
    "影响时滞": "시간 지연에 영향을 미침",
    "影响语义": "의미론에 영향을 미침",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "개발자는 본 제품의 사용으로 인해 발생하는 직간접적인 손실에 대해 책임을 지지 않습니다.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "개발자는 본 제품의 사용으로 인해 발생하는 직간접적인 손실에 대해 책임을 지지 않습니다.",
    "拥有专属的": "독점적이다",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "MetaSkill 기술을 보유한 상담원은 필요에 따라 자동으로 새로운 기술을 생성하고 게시할 수 있습니다.",
    "用 1 分钟看懂业务本体": "1분만 시간을 내어 비즈니스 온톨로지를 이해하세요.",
    "用法示例": "사용 예",
    "用户的个人信息用于任何商业用途。": "사용자의 개인정보는 상업적 목적으로 사용됩니다.",
    "用户名": "사용자 이름",
    "用链接或 ID 进入": "링크 또는 ID로 입장",
    "永久删除你的账号和所有数据，此操作不可撤销。": "귀하의 계정과 모든 데이터를 영구적으로 삭제하십시오. 이 작업은 되돌릴 수 없습니다.",
    "用手机微信扫描二维码，确认登录。": "휴대폰에서 WeChat을 사용하여 QR 코드를 스캔하여 로그인을 확인하세요.",
    "用手机微信扫描二维码并确认登录": "휴대폰에서 WeChat을 사용하여 QR 코드를 스캔하고 로그인을 확인하세요.",
    "用于比较变化": "변경 사항을 비교하는 데 사용됩니다.",
    "用于区分这个 Agent 的 Pencil 设计文件": "이 에이전트를 구별하기 위해 사용된 연필 디자인 파일",
    "邮件搜索": "메일 검색",
    "邮箱": "우편",
    "邮箱类型": "이메일 유형",
    "邮箱账号": "이메일 계정",
    "有纪要": "회의록 있음",
    "语义关系": "의미론적 관계",
    "语义属性": "의미론적 속성",
    "预定时间（可选，留空则立即开始）": "예약된 시간(선택사항, 즉시 시작하려면 비워두세요)",
    "原始转写": "원본 전사",
    "原因与后果": "원인과 결과",
    "运行连接命令": "연결 명령 실행",
    "运行引擎": "엔진을 작동하다",
    "运行中": "실행 중",
    "再查一次": "다시 확인하세요",
    "再查一次，没有新增内容": "다시 확인해 보니 새 내용이 없습니다.",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Microsoft Teams에서 이 에이전트와 협력하고 엔터프라이즈 워크플로에 통합하세요.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "해외 팀의 일상적인 워크플로에 적합한 Slack 채널에서 에이전트와 직접 협업하세요.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Slack 채널에서 이 에이전트와 직접 작업하여 스레드 응답을 지원합니다.",
    "用量明细加载失败": "사용량 세부정보를 로드하지 못했습니다.",
    "语音输入（需浏览器支持 Web Speech API）。": "음성 입력(Web Speech API를 지원하려면 브라우저가 필요함)",
    "月度套餐": "월간 패키지",
    "月度额度不足时，可由组织所有者补充。": "월별 할당량이 부족한 경우 조직 소유자가 보충할 수 있습니다.",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "\"설정 → 계정 관리\"에서 새로운 조직을 생성하거나 조직을 전환하세요.",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "\"작업\" 탭의 \"웹훅\" 하위 탭에서 생성하고 이름과 프롬프트 단어 템플릿을 입력합니다.",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "메시지 카드, 업무 알림 등 DingTalk의 기본 기능을 지원하려면 이 에이전트를 DingTalk 그룹에 연결하세요.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "팀을 생성하려면 \"팀\" 페이지에서 \"새 에이전트\"를 클릭하세요. 생성 후 에이전트 카드를 클릭하여 구성에 대한 세부정보 페이지로 들어갑니다.",
    "在不同组织之间切换，数据完全隔离。": "완전한 데이터 격리를 통해 여러 조직 간에 전환합니다.",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "\"팀\" 페이지에서 조직 구성원을 관리하세요. \"회원 초대\"를 클릭하고 이메일 주소를 입력하여 초대장을 보내세요.",
    "在对话中让": "대화를 나누다",
    "在对话中让 agent \"记住\"重要信息": "상담원이 대화 중에 중요한 정보를 \"기억\"하도록 하세요.",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Feishu 백엔드에서 승인을 확인하면 애플리케이션이 자동으로 필요한 권한(메시지 전송 및 수신, 그룹 관리 등)을 획득합니다.",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Feishu 그룹 채팅에서 이 에이전트와 직접 통신하여 서식 있는 텍스트 카드, 파일 전송 및 수신 등과 같은 Feishu의 기본 기능을 지원합니다.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "대화 인터페이스 상단의 \"스킬\" 탭으로 전환하여 사용 가능한 목록을 찾아 설치를 클릭하세요.",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "구성하려면 대화 상자 인터페이스 상단의 \"연결\" 탭으로 전환하세요. 현재 다음을 지원합니다.",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "컴퓨터에서 NovaX Agent를 실행하여 로컬 Codex 작업 공간을 NovaX에 안전하게 연결하세요.",
    "暂不关联": "아직 관련 없음",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "대화 페이지의 에이전트 목록에 \"모든 구성원 그룹\" 항목이 표시됩니다. 그룹 채팅에서는 @AgentName을 사용하여 질문에 답변할 에이전트를 지정할 수 있습니다. 이를 통해 여러 에이전트가 동일한 대화에서 협업할 수 있습니다. 예를 들어, 먼저 \"Researcher\" 에이전트가 정보를 검색하도록 하고, 그런 다음 \"Writer\" 에이전트가 해당 정보를 기반으로 기사를 쓰도록 합니다.",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "당분간은 Feishu 백엔드에서 애플리케이션을 수동으로 생성하고 자격 증명을 입력해야 합니다. 자동화된 생성 프로세스가 개발 중입니다. 연결을 완료하는 데는 원클릭 인증만 있으면 됩니다.",
    "暂停": "정지시키다",
    "暂无 Webhook": "아직 웹훅이 없습니다.",
    "暂无定时任务": "아직 예약된 작업이 없습니다.",
    "暂无观测": "아직 관측값이 없습니다.",
    "暂无观测值": "아직 관측값이 없습니다.",
    "暂无记录": "아직 기록이 없습니다",
    "暂无记忆": "아직 기억이 없습니다",
    "暂无纪要 — 会议结束后自动转写": "아직 회의록이 없습니다. 회의 종료 후 자동으로 기록됩니다.",
    "暂无类型说明": "아직 유형 설명이 없습니다.",
    "暂无日志": "아직 로그가 없습니다.",
    "暂无属性字段": "아직 속성 필드가 없습니다.",
    "暂无数据": "아직 데이터가 없습니다",
    "暂无说明": "아직 설명이 없습니다",
    "暂无文件": "아직 파일이 없습니다",
    "暂无业务定义": "아직 비즈니스 정의가 없습니다.",
    "粘贴 Figma 访问 Token": "Figma 액세스 토큰 붙여넣기",
    "粘贴 Zoom 链接或输入会议 ID": "Zoom 링크를 붙여넣거나 회의 ID를 입력하세요.",
    "展开查看": "펼치면 볼 수 있습니다",
    "在服务器上读写文件、执行代码": "파일을 읽고 쓰고 서버에서 코드를 실행합니다.",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "왼쪽 네비게이션 바의 \"스킬 마켓\" 페이지에서 사용 가능한 모든 스킬을 찾아볼 수 있습니다.",
    "暂时无法读取额度信息": "일시적으로 신용정보를 읽을 수 없습니다.",
    "账号": "계정",
    "这份证据如何支持该关系？": "이 증거는 관계를 어떻게 뒷받침합니까?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "여기서는 원래 팀, 에이전트, 프로젝트, 작업, 문서 및 기술을 유지하고 이를 비즈니스 지표에 연결합니다.",
    "蒸馏": "증류",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "의사결정 프레임워크, 첫 번째 원칙, 표현 DNA를 정제하여 언제든지 요청할 수 있는 정신적 조언자를 정제합니다.",
    "整体结构": "전체 구조",
    "正文与附件信息": "텍스트 및 첨부 정보",
    "正向": "앞으로",
    "正在编撰组织简报": "조직 브리핑 작성",
    "正在创建微信连接...": "WeChat 연결을 생성하는 중...",
    "正在读取组织最近的使用情况": "조직의 최근 사용량 읽기",
    "正在计算影响路径…": "영향 경로 계산 중…",
    "正在建立业务语义地图…": "비즈니스 의미 지도 작성 중...",
    "正在生成二维码...": "QR 코드 생성 중...",
    "正在验证连接…": "연결 확인 중...",
    "正在由 Agent 团队编撰第一期": "첫 번째 문제는 Agent 팀에서 편집 중입니다.",
    "正在整理组织数据与知识": "조직의 데이터 및 지식 정리",
    "证据等级": "증거 수준",
    "证据摘要": "증거 요약",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "GitHub, GitLab, Gitee 및 사내 Git 서비스 지원",
    "占位，表示外部传入的数据。例如：": "외부에서 들어오는 데이터를 나타내는 자리 표시자입니다. 예를 들어:",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "이는 NovaX의 가장 강력한 협업 모드입니다. 여러 에이전트가 인계받아 동일한 대화에서 복잡한 작업을 완료하도록 할 수 있습니다.",
    "知识库": "지식 기반",
    "知识库 &middot; Knowledge Base": "기술 자료 · 기술 자료",
    "正在加载组织额度…": "조직 할당량 로드 중...",
    "支付功能正在准备中": "결제 기능 준비 중",
    "知识库为空": "기술 자료가 비어 있습니다.",
    "知识库文档": "기술 자료 문서",
    "知识库暂无共享文档。": "현재 지식창고에는 공유 문서가 없습니다.",
    "知识库（Memory）— 共享大脑": "지식 베이스(메모리) - 공유 두뇌",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "기술 자료는 조직 수준의 공유 문서 저장소입니다. 귀하가 업로드하는 모든 Markdown 문서는 조직 내 모든 에이전트의 공통 지식이 됩니다. 적합 대상:",
    "执行层：谁根据它采取行动": "임원층: 누가 이를 기반으로 조치를 취하는가",
    "执行命令": "명령을 실행하다",
    "执行频率": "실행 빈도",
    "执行任务": "작업을 수행하다",
    "执行时间": "실행 시간",
    "执行时间：": "실행 시간:",
    "执行异常": "실행 예외",
    "执行指令": "지침 실행",
    "执行中": "실행 중",
    "只读查询": "읽기 전용 쿼리",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "인증 코드를 지원하는 Gmail, QQ, 163 또는 기업 IMAP 사서함에 대한 읽기 전용 연결을 통해 에이전트는 실제 이메일을 검색하고 정렬할 수 있습니다.",
    "只读收件箱": "읽기 전용 받은편지함",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "지식창고에 업로드된 문서는 서버에 로컬로 저장되며 조직의 상담원만 읽을 수 있습니다.",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "지식창고에 업로드된 문서는 서버에 로컬로 저장되며 조직의 상담원만 읽을 수 있습니다.",
    "指": "참조하다",
    "指标": "색인",
    "指标 / 维度": "지표/차원",
    "指标不是一个数字": "지표는 숫자가 아니다",
    "指标层：数字怎么计算": "표시 레이어: 숫자 계산 방법",
    "指标查询": "지표 쿼리",
    "指标观测": "지표 관찰",
    "指标口径": "인덱스 구경",
    "指标目录": "지표 카탈로그",
    "指标网络": "지표 네트워크",
    "指标已映射": "매핑된 측정항목",
    "指标异动与影响分析": "지표 변경 및 영향 분석",
    "指标值 *": "지표값 *",
    "至少需要两个周期": "최소 2사이클이 필요합니다.",
    "置信度": "신뢰",
    "置信度 ·": "신뢰 ·",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "기술 자료는 조직 수준의 공유 문서 저장소입니다. 업로드된 문서는 모든 상담원이 답변할 때 자동으로 참조되며, 이는 모든 상담원에게 배경 지식을 갖추는 것과 같습니다.",
    "终点 *": "종료 지점 *",
    "终端运行": "터미널 실행",
    "种类型": "유형",
    "重复任务": "작업 반복",
    "重新尝试": "다시 시도하세요",
    "重新加载": "다시 장전하다",
    "重要规则": "중요한 규칙",
    "周末": "주말",
    "主持人:": "주인:",
    "主持人：": "주인:",
    "主动来到你面前": "솔선해서 당신에게 다가가세요",
    "中": "가운데",
    "注入": "주입",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "로그아웃 후에는 귀하의 계정, 채팅 기록 및 모든 데이터가 영구적으로 삭제되며 복구할 수 없습니다.",
    "注销账号": "계정 취소",
    "只有组织所有者可以购买套餐或充值额度。": "조직 소유자만 플랜이나 크레딧을 구매할 수 있습니다.",
    "注销中...": "로그아웃 중...",
    "转发": "앞으로",
    "转发到": "앞으로",
    "转写已完成，可生成纪要": "전사가 완료되었으며 분을 생성할 수 있습니다.",
    "转写中": "전사하는 중",
    "状态": "상태",
    "字段": "필드",
    "字段名称": "필드 이름",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "등록에 필요한 이메일 주소는 계정 확인 및 로그인에만 사용되며, 마케팅 목적으로 사용되거나 제3자에게 양도되지 않습니다.",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "등록에 필요한 이메일 주소는 계정 확인 및 로그인에만 사용되며, 마케팅 목적으로 사용되거나 제3자에게 양도되지 않습니다.",
    "自定义类型": "맞춤 유형",
    "自定义名称、描述和人格": "이름, 설명, 성격을 맞춤설정하세요.",
    "自定义周期": "맞춤형 사이클",
    "自动响应指定聊天中的消息": "지정된 채팅의 메시지에 자동으로 응답",
    "自动应答": "자동 응답",
    "自动转写生成纪要": "자동으로 기록하고 회의록을 생성합니다.",
    "自适应卡片": "적응형 카드",
    "组": "그룹",
    "组件理解": "구성 요소 이해",
    "组织": "정리하다",
    "组织编辑人数": "조직의 편집자 수",
    "组织变动": "조직 변화",
    "自定义界面显示偏好": "인터페이스 표시 기본 설정 사용자 정의",
    "组织存储": "스토리지 정리",
    "组织洞察": "조직 통찰력",
    "组织里的某一位 Agent": "조직의 에이전트",
    "组织（Workspace）— 协作空间": "조직(작업공간) — 협업 공간",
    "组织成员和自动任务的消费都会记录在这里。": "조직 구성원의 소비량과 자동 작업이 여기에 기록됩니다.",
    "组织名称": "조직 이름",
    "组织共享额度": "조직 공유 할당량",
    "组织文档数": "조직 문서 수",
    "组织信号": "조직 신호",
    "组织内所有成员共享使用": "조직의 모든 구성원이 공유함",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "조직은 Slack의 Workspace 또는 Feishu의 Team과 유사한 독립적인 협업 공간입니다. 조직의 모든 구성원은 동일한 에이전트 및 지식 기반 세트를 공유합니다. 당신은 할 수 있습니다 :",
    "组织与执行": "조직 및 실행",
    "组织知识库": "조직의 지식 기반",
    "组织知识库日志": "조직 지식 기반 로그",
    "组织执行": "조직적 실행",
    "最多展开 3 跳": "최대 3번의 점프 확장",
    "最多追溯 3 跳": "최대 3홉까지 추적",
    "组织所有者": "조직 소유자",
    "组织与多租户": "조직 및 멀티 테넌시",
    "组织与团队管理": "조직 및 팀 관리",
    "最近更新": "최신 업데이트",
    "最近观测": "최근 관찰",
    "最后更新：2026 年 5 月": "최종 업데이트: 2026년 5월",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "사용 가능한 최소 링크에는 4개의 개체만 필요합니다. 매일 주의를 기울이는 핵심 지표부터 시작하여 나중에 점차적으로 완료하세요. 처음부터 회사 전체를 디자인할 필요는 없습니다.",
    "最新观测": "최신 관찰",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "왼쪽에는 가능한 동인 또는 계산 소스가 있고 오른쪽에는 표시기가 영향을 미치는 항목이 있습니다.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "PEN_AGENT_API_KEY로서 이 로컬 Pencil 프로세스에만 전달됩니다.",
    "最近用量": "최근 사용량",
    "最後更新：2026 年 5 月": "최종 업데이트: 2026년 5월",
    "作为个人练手 Demo 项目，我们": "개인 트레이닝 데모 프로젝트로서 우리는",
    "Agent 会怎样使用": "에이전트 사용 방법",
    "作為個人練手 Demo 專案，我們": "개인 연습 데모 프로젝트로 우리는",
    "Agent — 你的 AI 团队成员": "에이전트 - AI 팀원",
    "Agent 级别": "상담원 수준",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "에이전트는 자동으로 크론 작업을 생성합니다. 실행 결과는 대화에 메시지로 나타납니다. 작업 탭에서 생성된 작업을 일시 중지, 재개 또는 삭제할 수 있습니다.",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "에이전트가 시작되면 자동으로 연결됩니다. 아래 상태가 녹색으로 바뀌고 사용이 가능해집니다.",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "에이전트는 수동으로 트리거할 필요 없이 정기적으로 실행되는 백그라운드 작업을 생성할 수 있습니다. 대화 인터페이스 상단의 '작업' 탭으로 전환하여 확인하고 관리하세요.",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "에이전트는 NovaX 웹 페이지에서 사용할 수 있을 뿐만 아니라 외부 인스턴트 메시징 플랫폼에도 연결할 수 있습니다. 일단 연결되면 에이전트는 모든 플랫폼에서 동일한 추억, 기술 및 지식 기반을 공유합니다.",
    "Agent 在对话中输出的文件会显示在这里": "대화에서 에이전트가 출력한 파일이 여기에 표시됩니다.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "Agent는 NovaX의 핵심 유닛입니다. 각 에이전트는 다음과 같은 고유한 기능을 갖춘 독립적인 AI 보조자입니다.",
    "Agent 周报": "에이전트 주간",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agent는 NovaX의 핵심 개념입니다. 기존 챗봇과 달리 각 에이전트는",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "상담원은 질문에 답변할 때 자동으로 이러한 문서를 참조하여 답변이 팀의 규범과 상황에 맞는지 확인합니다.",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "에이전트는 요청을 받은 후 자동으로 실행하고 결과를 대화로 보냅니다.",
    "AI 图像生成": "AI 이미지 생성",
    "DOWNSTREAM · 下游": "다운스트림 · 다운스트림",
    "ETL 血缘": "ETL 계보",
    "Git 仓库": "힘내 저장소",
    "Git 用户名；GitHub App 可填 x-access-token": "힘내 사용자 이름; GitHub 앱은 x-access-token을 채울 수 있습니다.",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ 및 163은 일반적으로 먼저 IMAP을 활성화하고 애플리케이션별 비밀번호 또는 인증 코드를 생성해야 합니다.",
    "IMAP 地址": "IMAP 주소",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "AI가 생성한 콘텐츠에는 오류나 부정확한 정보가 포함될 수 있으니 스스로 판단하고 검증하시기 바랍니다.",
    "Notion 工作区": "노션 작업공간",
    "Codex 智能体底座": "코덱스 스마트 바디 베이스",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "AI가 생성한 콘텐츠에는 오류나 부정확한 정보가 포함될 수 있으므로 스스로 판단하고 확인하시기 바랍니다.",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "코드 강조 표시, 테이블, 목록 등을 포함한 마크다운 형식 렌더링",
    "Nova 点": "노바 포인트",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX는 데이터와 비즈니스 동인을 위쪽으로 추적하고 아래쪽으로 목표, 프로세스 및 실행 영향을 식별합니다.",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "NovaX의 인터페이스는 왼쪽의 탐색 모음과 오른쪽의 기본 콘텐츠 영역으로 구성됩니다. 탐색 표시줄에는 5개의 주요 입구가 있습니다.",
    "NovaX 是什么": "NovaX 란 무엇입니까?",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "NovaX의 모든 에이전트는 OpenAI Codex에서 균일하게 실행되며",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX는 조직(Workspaces) 기반의 멀티 테넌트 아키텍처를 채택합니다. 각 조직은 완전히 독립적인 협업 공간이며 상담원, 지식 기반, 기술, 구성원 및 대화 데이터가 모두 격리되어 있습니다.",
    "NovaX 是一个": "NovaX는",
    "NovaX 是一個": "NovaX는",
    "NovaX Agent 工作区": "NovaX 에이전트 작업 공간",
    "PG 思维": "PG의 생각",
    "Prompt 模板": "프롬프트 템플릿",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "수신된 데이터를 나타내기 위해 {{payload}}를 사용하는 프롬프트 템플릿",
    "QQ 邮箱": "QQ 사서함",
    "S3 兼容地址（AWS S3 可留空）": "S3 호환 주소(AWS S3는 비워둘 수 있음)",
    "Schema 浏览": "스키마 찾아보기",
    "secret_... 或 ntn_...": "secret_... 또는 ntn_...",
    "Session Token（可选）": "세션 토큰(선택 사항)",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX는 다중 에이전트 AI 협업 플랫폼입니다. AI 팀 워크벤치처럼 생각할 수 있습니다. 여기에서는 각각 고유한 이름, 페르소나, 전문 지식 및 작업 공간을 가진 여러 AI 에이전트가 생성됩니다. 파일을 읽고 쓰고, 코드를 실행하고, 웹을 검색하고, 작업을 관리하고, 실제 팀 구성원처럼 함께 작업할 수 있습니다.",
    "Skill 市场": "스킬마켓",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX는 다중 조직 구조를 지원합니다. 조직은 \"설정 → 일반\"에서 관리할 수 있습니다.",
    "Soul 人设指令": "소울 캐릭터 명령",
    "Shift+Enter 换行，Enter 发送。": "줄 바꿈하려면 Shift+Enter를, 보내려면 Enter를 누르세요.",
    "SQL 数据库": "SQL 데이터베이스",
    "SSH 私钥": "SSH 개인 키",
    "Thread 回复": "스레드 답글",
    "TLS 加密": "TLS 암호화",
    "Token 用量榜": "토큰 사용 목록",
    "UPSTREAM · 上游": "업스트림 · 업스트림",
    "Web 设计工程师": "웹 디자인 엔지니어",
    "Webhook 名称，如 GitHub Push...": "GitHub Push와 같은 웹훅 이름...",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "Soul은 Agent의 가장 중요한 구성 항목입니다. 이는 상담원의 역할 위치, 전문 분야 및 행동을 결정합니다. Soul을 잘 작성하는 것이 Agent를 정말 유용하게 만드는 열쇠입니다.",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "웹후크를 사용하면 외부 시스템이 HTTP 요청을 통해 에이전트 실행 작업을 트리거할 수 있으며 CI/CD와의 인터페이스, 경보 모니터링, 양식 제출 및 기타 시스템에 적합합니다.",
    "Soul（人设指令）": "영혼(성격 명령)",
    "Webhook URL（含 Secret）": "웹훅 URL(비밀 포함)",
    "Webhook 事件触发": "웹훅 이벤트 트리거"
  },
  "es": {
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— Ver las tareas en segundo plano que realiza el Agente, incluido el progreso, el estado y los resultados.",
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— Cambie a una organización diferente con un clic y el Agente y la base de conocimientos cambiarán en consecuencia.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— Vea agentes y miembros dentro de su organización, cree nuevos agentes o invite a nuevos miembros.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "—Otorgar reconocimiento al Agente para facilitar la diferenciación en escenarios de múltiples Agentes.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— Definir la personalidad, experiencia y comportamiento del Agente. Por ejemplo, puede crear un Agente \"Revisor de código\" para centrarse en la calidad del código y luego crear un Agente \"Gerente de producto\" para que sea bueno en el análisis de requisitos.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— Informar al Agente quién es y en qué se especializa.",
    "— 个人偏好、组织管理、账号安全。": "—Preferencias personales, gestión organizativa y seguridad de la cuenta.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— Administrar las habilidades instaladas del Agente o instalar nuevas habilidades del mercado.",
    "— 管理共享文档，上传和浏览 .md 文件。": "— Administre documentos compartidos, cargue y explore archivos .md.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— Qué formato, estilo y pasos se deben seguir al responder.",
    "— 接入 Zoom 会议或聊天。": "— Únase a una reunión o chat de Zoom.",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— Puede administrar agentes, bases de conocimiento y miembros, pero no puede modificar la configuración de la organización.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— Puede utilizar el Agente, participar en conversaciones y acceder a la base de conocimientos, pero no puede realizar operaciones de administración.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— Brinde al Agente la capacidad de crear y administrar tareas programadas.",
    "— 浏览和安装技能，管理已发布的技能。": "— Explorar e instalar habilidades y administrar habilidades publicadas.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— Permita que el Agente establezca tareas programadas o periódicas, como generar informes todas las mañanas.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— Permitir que los Agentes llamen a otros Agentes para lograr la colaboración entre Agentes.",
    "— 让 Agent 能够自动生成和发布新技能。": "— Permitir que los agentes generen y publiquen automáticamente nuevas habilidades.",
    "— 什么该做，什么不该做。": "— Qué hacer y qué no hacer.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— Permita que los Agentes creen nuevas habilidades ellos mismos y las publiquen en el mercado para que las utilicen otras instalaciones de Agentes.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— El propietario tiene permisos completos, los administradores pueden administrar Agentes y miembros, y los miembros comunes pueden usar Agentes y bases de conocimiento.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— Acceda a través de iLink para interactuar con el Agente en WeChat.",
    "— 通过 Telegram Bot 接入。": "— Acceso a través de Telegram Bot.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "—Crea un Bot a través de BotFather y completa el Bot Token para conectarte.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— Ampliar los límites de capacidades del agente instalando diferentes habilidades.",
    "— 通过企业微信或 iLink 接入。": "— Acceso a través de Business WeChat o iLink.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Habla con el Agente directamente en Feishu a través del robot Feishu.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "—Tiene permisos completos para administrar la configuración, los miembros y los agentes de la organización. Cada organización tiene un solo propietario.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— Los registros de chat con el Agente admiten salida de transmisión en tiempo real.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— La interfaz principal para comunicarse con los Agentes, con la lista de Agentes a la izquierda y la ventana de chat a la derecha.",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— Permitir que los agentes llamen a otros agentes en el espacio de trabajo para implementar canales automatizados entre agentes. Por ejemplo, una vez que el Agente A completa el análisis, transfiere automáticamente los resultados al Agente B para generar un informe.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— Invitar a miembros a unirse a la organización actual por correo electrónico en la página \"Equipo\".",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— Explore todas las habilidades disponibles en el \"Mercado de habilidades\" en la barra de navegación y vea los detalles y las instrucciones de instalación.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— En la pestaña \"Habilidades\" de la interfaz de diálogo, instale o desinstale habilidades para el Agente actual. Diferentes agentes pueden tener instalados diferentes conjuntos de habilidades.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Cree una aplicación en la plataforma abierta Feishu, obtenga el ID de la aplicación y el secreto de la aplicación, y luego acceda a ella. Los miembros del equipo pueden chatear directamente con el Agente en Feishu.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— El Agente puede leer y escribir archivos y ejecutar código en el directorio del sistema de archivos especificado. Diferentes agentes pueden operar diferentes directorios de proyectos.",
    "— 最多可创建 2 个组织。": "— Puede crear hasta 2 organizaciones.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": ", no tiene fines de lucro, no cobrará ninguna tarifa a los usuarios y no realizará promociones comerciales ni ventas de ninguna forma.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": ", sin fines de lucro, no cobrará ninguna tarifa a los usuarios y no realizará promociones comerciales ni ventas de ninguna forma.",
    "、": ",",
    ".pen 文件": "archivo .pen",
    "· 点击启用": "· Haga clic para habilitar",
    "· 点击召唤": "· Haz clic para invocar",
    "· 用于 Agent 理解": "· Utilizado para la comprensión del agente",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": ", solo se utiliza para demostrar la viabilidad técnica de la plataforma de colaboración de IA de múltiples agentes. este producto",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": ", solo se utiliza para demostrar la viabilidad técnica de la plataforma de colaboración de IA multiagente. este producto",
    "，同时可以被邀请加入他人的组织。": "y se le puede invitar a unirse a organizaciones de otras personas.",
    "（一次性延时任务）": "(Tarea retrasada única)",
    "@提及": "@menciones",
    "（由 Soul 指令定义）": "(definido por la directiva del alma)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst Con base en los datos anteriores, realice un análisis del panorama competitivo.",
    "@提及机制": "@mecanismo de mención",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer Organice el análisis anterior en un informe PDF",
    "← 返回": "← Volver",
    "← 返回列表": "← Volver a la lista",
    "← 返回详情": "← Volver a los detalles",
    "/ 月": "/ luna",
    "+ 记录": "+ registro",
    "+ 添加": "+ agregar",
    "✓ 反馈已提交，感谢您的意见！": "✓ Se han enviado comentarios, ¡gracias por tu opinión!",
    "✓ 已连接": "✓ Conectado",
    "+ 创建新组织": "+ Crear nueva organización",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher Busque datos del mercado extranjero de vehículos de nueva energía en 2024",
    "1. 产品性质": "1. Naturaleza del producto",
    "1. 產品性質": "1. Naturaleza del producto",
    "163 邮箱": "163 correo electrónico",
    "2 个组织": "2 organizaciones",
    "2. 数据与隐私": "2. Datos y Privacidad",
    "2. 資料與隱私": "2. Datos y Privacidad",
    "3. 第三方服务": "3. Servicios de terceros",
    "3. 第三方服務": "3. Servicios de terceros",
    "30 分钟后提醒我开会": "Recuérdame una reunión en 30 minutos.",
    "4. 服务可用性": "4. Disponibilidad del servicio",
    "4. 服務可用性": "4. Disponibilidad del servicio",
    "5. 免责声明": "5. Descargo de responsabilidad",
    "5. 免責聲明": "5. Descargo de responsabilidad",
    "安装给以下 Agent：": "Instalado en los siguientes agentes:",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "Conecte el Agente a la plataforma de mensajería instantánea que utiliza su equipo y tenga conversaciones directas en chats grupales o privados.",
    "把世界级设计标准": "Brindando estándares de diseño de clase mundial",
    "把指标接回真实数据": "Conecte los indicadores a datos reales",
    "保存对象": "guardar objeto",
    "保存失败": "Error al guardar",
    "保存修改": "Guardar cambios",
    "保存中...": "Ahorro...",
    "保存中…": "Ahorro…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "El informe resume periódicamente el uso de NovaX por parte de toda la organización y también descubre información empresarial digna de atención basada en datos subyacentes, como bases de datos, BI, Git y buzones de correo a los que se ha conectado la organización.",
    "被移出了组织": "Eliminado de la organización",
    "6. 聯絡方式": "6. Información de contacto",
    "6. 联系方式": "6. Información de contacto",
    "安装方式": "Método de instalación",
    "安装不同的": "Instalar diferentes",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "Este producto no es adecuado para escenarios profesionales como asesoramiento médico, consulta legal y toma de decisiones financieras.",
    "本次分析提示": "Consejos para este análisis",
    "本期 SKILL": "HABILIDAD en este tema",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "La ontología no es otra base de conocimiento. Conecta los objetos, indicadores, datos y responsables del negocio en un mapa razonable, permitiendo al Agente no sólo \"encontrar información\", sino también saber de dónde viene un número, por qué cambia y qué impacto tendrá.",
    "本体加载失败": "Falló la carga de la ontología",
    "本体视图": "vista de ontología",
    "本体完整度": "Integridad ontológica",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "La ontología solo guarda la estructura y el calibre, y las credenciales de la base de datos son administradas por el conector o las variables de entorno y no ingresan al gráfico comercial.",
    "本月": "este mes",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "Compare los valores de observación del indicador y luego siga el cálculo y el linaje de datos para encontrar en qué capa se produjo el cambio.",
    "必填": "Requerido",
    "避免把相关性误判为因果": "Evite confundir correlación con causalidad",
    "编辑": "editar",
    "编辑定义": "Editar definición",
    "编辑对象": "Editar objeto",
    "编辑了 Agent": "Agente editado",
    "编辑业务对象": "Editar objeto de negocio",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "Este producto no es adecuado para escenarios profesionales como asesoramiento médico, consulta legal y toma de decisiones financieras.",
    "标识（可选）": "Logotipo (opcional)",
    "标题": "título",
    "表、视图、ETL 模型": "Tablas, vistas, modelos ETL.",
    "补充口径、边界或业务背景": "Calibre del suplemento, límite o contexto empresarial.",
    "补充驱动关系": "Relación de conducción suplementaria",
    "补充影响关系": "Relación de influencia suplementaria",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "Este producto llama al servicio OpenAI Codex para manejar solicitudes de conversación. El contenido de sus conversaciones se procesará de acuerdo con la política de privacidad de ese servicio. Se recomienda evitar ingresar información personal sensible en las conversaciones.",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "Escribir alma: este es el paso más crucial. Soul determina cómo el Agente entiende las tareas y responde preguntas. Cuanto más específico esté escrito, mejor se desempeñará el Agente.",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "Este producto llama al servicio OpenAI Codex para manejar la solicitud de conversación. El contenido de sus conversaciones se procesará de acuerdo con la política de privacidad de ese servicio. Se recomienda evitar ingresar información personal sensible en las conversaciones.",
    "不保證": "Sin garantía",
    "不会用于商业化运营": "No será utilizado para operaciones comerciales.",
    "不保证": "Sin garantía",
    "不会主动收集": "No recolectará activamente",
    "不會用於商業化營運": "No será utilizado para operaciones comerciales.",
    "不會主動收集": "No recolectará activamente",
    "参会者": "Asistentes",
    "参与聚合、关联和过滤的列": "Columnas involucradas en agregación, asociación y filtrado.",
    "仓库地址": "Dirección del almacén",
    "仓库协作": "colaboración de almacén",
    "草稿": "borrador",
    "策": "política",
    "查看": "Controlar",
    "查看全部模型 →": "Ver todos los modelos →",
    "查看它负责哪些指标、目标或业务流程。": "Vea de qué métricas, objetivos o procesos de negocio es responsable.",
    "查看完整影响路径": "Ver ruta de impacto completa",
    "查找文件": "encontrar archivos",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "Diferentes Agentes pueden tener Almas completamente diferentes. Por ejemplo, un equipo puede tener varios agentes con diferentes roles, como \"investigador\", \"escritor\" y \"revisor de código\" al mismo tiempo.",
    "查看每个技能的功能说明、安装量和评分。": "Vea descripciones de funciones, instalaciones y calificaciones para cada habilidad.",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "A diferencia de las herramientas de conversación de IA ordinarias, el Agente de NovaX tiene memoria persistente, habilidades instalables, admite la colaboración de varias personas y puede conectarse a plataformas de mensajería instantánea como Feishu, Telegram y WeChat para integrar la IA en su flujo de trabajo diario.",
    "产品文档和技术架构": "Documentación del producto y arquitectura técnica.",
    "产品 PRD、技术架构文档": "Producto PRD, documentos de arquitectura técnica.",
    "常见问题和标准回答": "Preguntas frecuentes y respuestas estándar",
    "常见问题和解答模板": "Plantilla de preguntas frecuentes",
    "成员 / Agent": "Miembro/Agente",
    "抽出一位大师的思维，": "Saca los pensamientos de un maestro,",
    "成员（Member）": "Miembro",
    "成员与权限": "Miembros y permisos",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "Además de la interfaz web, el Agente de NovaX también puede conectarse a plataformas de mensajería instantánea:",
    "处理事件": "manejar eventos",
    "触发次数": "Número de desencadenantes",
    "创建": "crear",
    "创建 Agent": "Crear agente",
    "创建 Webhook": "Crear webhook",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "Después de crear un webhook, los sistemas externos (GitHub, Stripe, Sentry, etc.) pueden activarse automáticamente a través de HTTP POST.",
    "创建第一个指标": "Crea tu primer indicador",
    "创建核心指标": "Crear indicadores básicos",
    "持久记忆": "memoria duradera",
    "创建会议": "Crear reunión",
    "创建了 Agent": "Agente creado",
    "创建类型": "Crear tipo",
    "创建你的第一个 Agent": "Crea tu primer Agente",
    "创建企业自建应用，获取凭证": "Cree una aplicación empresarial de creación propia y obtenga credenciales",
    "创建失败": "La creación falló",
    "创建时间": "tiempo de creación",
    "创建中...": "Creando...",
    "创建中…": "Creando…",
    "创建组织": "Crear una organización",
    "创刊导读": "Introducción a la fundación de la publicación.",
    "创作与协作": "Crear y colaborar",
    "此文件类型暂不支持预览": "Este tipo de archivo no admite actualmente la vista previa",
    "次": "De segunda categoría",
    "从 160+ 专业角色模板中选择": "Elija entre más de 160 plantillas de roles profesionales",
    "从数据到行动的业务地图": "Mapeo empresarial de los datos a la acción",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "Determine la semántica exacta de la misma palabra dentro de la empresa a partir de definiciones de métricas y objetos de negocio.",
    "从业务世界的第一个对象开始": "Empiece por el primer objeto del mundo empresarial.",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "Comience con los ingresos, el volumen de pedidos, las tasas de conversión o los resultados comerciales que más le interesan.",
    "从预设创建": "Crear desde preestablecido",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "Después de la creación, el sistema genera una URL y una clave únicas, que pueden ser activadas por un sistema externo que envía una solicitud POST a la URL.",
    "代码读取": "lectura de código",
    "待开始": "Para empezar",
    "待认领": "Para ser reclamado",
    "大": "grande",
    "待验证": "Por verificar",
    "单次任务": "tarea única",
    "单次执行": "ejecución única",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "Cuando solicita métricas, linaje, atribución o impacto, NovaX Agent primero lee el contexto de la ontología relevante. La base de conocimientos proporciona \"texto original y antecedentes\", y la ontología proporciona \"estructura empresarial determinada\", y los dos pueden relacionarse mediante evidencia.",
    "当前仅支持 .md 格式": "Actualmente solo se admite el formato .md",
    "当前值": "valor actual",
    "当前": "actual",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "Registre bases de datos, tablas de datos y campos clave, y luego utilice \"linaje de datos\" o \"dependencia de cálculo\" para conectarse a los indicadores. En el futuro, cuando se le pregunte al Agente sobre el calibre, podrá encontrar la fuente verdadera a lo largo del enlace en lugar de adivinar basándose en el documento.",
    "登记数据来源": "Registrar fuentes de datos",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "Registre fuentes de datos, tablas y campos, y luego conéctese a indicadores utilizando relaciones de \"linaje de datos\" o \"dependencia de cálculo\".",
    "登记数据资产": "Registrar activos de datos",
    "登录账号": "Iniciar sesión en la cuenta",
    "待上线": "Estar en línea",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "Crea hasta 2 organizaciones, una para diferentes proyectos o equipos.",
    "等待 Agent 连接...": "Esperando que el Agente se conecte...",
    "等待连接成功": "Espere una conexión exitosa",
    "等待确认": "Esperando confirmación",
    "等待扫码...": "Esperando escaneo...",
    "等待中": "Espera",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "Número 1 · Compilado por su equipo de agentes · Este número",
    "登录状态已失效，请重新登录": "El estado de inicio de sesión ha caducado, inicie sesión nuevamente",
    "的 AI 协作者。": "de colaboradores de IA.",
    "第二步：认识你的界面": "Paso 2: conozca su interfaz",
    "第四步：开始对话": "Paso 4: inicia una conversación",
    "第三步：创建你的第一个 Agent": "Paso 3: crea tu primer agente",
    "第一期正在准备中": "Se está preparando el primer número.",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "Haga clic en \"Generar código QR\" y el sistema iniciará el proceso de inicio de sesión en la página web de WeChat.",
    "点击「生成二维码」获取微信登录码": "Haga clic en \"Generar código QR\" para obtener el código de inicio de sesión de WeChat.",
    "点击连接，系统自动完成配置": "Haga clic en Conectar y el sistema completará automáticamente la configuración.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "Haga clic en el botón a continuación para saltar a la plataforma abierta de Feishu y el sistema creará automáticamente una aplicación de creación propia para usted.",
    "点": "punto",
    "第五步：丰富 Agent 的知识": "Paso 5: enriquecer el conocimiento del agente",
    "钉钉": "DingTalk",
    "定时任务": "tareas programadas",
    "第一步：注册和登录": "Paso 1: Regístrate e inicia sesión",
    "定位变化": "Cambios de posicionamiento",
    "定义第一个核心指标": "Definir el primer indicador básico",
    "定义核心指标": "Definir métricas centrales",
    "定义业务类型": "Definir tipo de negocio",
    "定义这个 Agent 的性格、指令和能力...": "Defina la personalidad, los comandos y las habilidades de este Agente...",
    "定义证据": "Definir evidencia",
    "定义指标口径": "Definir calibre indicador",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Lea la estructura de archivos, los componentes y los comentarios de Figma para que el Agente comprenda el diseño de la interfaz, las especificaciones de diseño y los comentarios colaborativos.",
    "读取内容": "Leer contenido",
    "读取网页": "leer paginas web",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "Después de leerlo, puede saltar directamente al diálogo y continuar haciendo preguntas sobre las causas, los impactos y los próximos pasos.",
    "端口": "puerto",
    "断开连接": "Desconectar",
    "断开失败": "Falló la desconexión",
    "对话": "diálogo",
    "调整对话消息流中的文字大小": "Ajustar el tamaño del texto en el flujo de conversación",
    "定时任务（MetaSchedule）": "Tareas programadas (MetaSchedule)",
    "对象": "objeto",
    "对象存储": "almacenamiento de objetos",
    "对象类型 *": "Tipo de objeto *",
    "对象列表": "lista de objetos",
    "对象已连接": "El objeto está conectado.",
    "对象已删除": "Objeto eliminado",
    "对应 Agent 暂不可用": "El Agente correspondiente no está disponible temporalmente",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "La conversación es el método de interacción principal de NovaX. Cada Agente mantiene un historial de conversaciones independiente. En la interfaz de conversación, hay tres pestañas en la parte superior:",
    "独立身份、独立记忆、独立技能": "Identidad independiente, memoria independiente, habilidades independientes.",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "Varios archivos están separados por comas; si se deja en blanco, se utilizará el rango visible del token.",
    "多媒体": "multimedia",
    "对话系统": "Sistema de diálogo",
    "多人": "varias personas",
    "多维表格": "tabla multidimensional",
    "多 Agent 接力": "Retransmisión multiagente",
    "额度信息加载失败": "No se pudo cargar la información de la cuota",
    "多平台连接": "Conectividad multiplataforma",
    "二": "dos",
    "二维码已过期，请重新生成": "El código QR ha caducado, por favor regénelo",
    "发起会议": "iniciar una reunión",
    "发送人": "remitente",
    "发送时间": "enviar hora",
    "翻开 →": "Abrir →",
    "反馈": "comentario",
    "反馈中心": "Centro de comentarios",
    "返回": "devolver",
    "方向": "dirección",
    "方向未知": "dirección desconocida",
    "访问 Token": "Token de acceso",
    "飞书 / Lark": "Feishu / Alondra",
    "飞书开放平台": "Plataforma abierta Feishu",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "Se ha creado la aplicación Feishu. Agregue el Bot al Grupo Feishu para comenzar a usarlo.",
    "费曼思维": "Feynman pensando",
    "分析对象": "Objeto de análisis",
    "分析思路": "Ideas analíticas",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "La cuota la comparten los miembros de la organización y todo el consumo se deduce de la organización actual.",
    "额度与账单": "Límite de crédito y factura",
    "分钟": "minuto",
    "否": "No",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "El servidor primero verificará la clave CLI del Pencil. La generación de diseños se corrige usando Codex 5.6 sol · high y solo funciona en archivos .pen en el espacio de trabajo actual del Agente.",
    "服务器已连接，等待 Bot 上线...": "El servidor está conectado, esperando que el Bot se conecte...",
    "额外额度": "crédito extra",
    "分析完成后：": "Una vez finalizado el análisis:",
    "负向": "Negativo",
    "负责人": "persona responsable",
    "复制": "Copiar",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "Copie el siguiente comando a la terminal y ejecútelo. El Agente se conectará automáticamente al servidor NovaX.",
    "富文本卡片": "Tarjeta de texto enriquecido",
    "覆盖确认": "Confirmación de cobertura",
    "刚刚": "justo",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "La continua disponibilidad, estabilidad o durabilidad de los datos del Servicio. El Servicio puede suspenderse, modificarse o cancelarse en cualquier momento sin previo aviso. No utilice este producto en un entorno de producción ni para almacenar datos importantes.",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "CONTINUACIÓN DISPONIBILIDAD, ESTABILIDAD O DURABILIDAD DE LOS DATOS DE LOS SERVICIOS. El Servicio puede suspenderse, modificarse o cancelarse en cualquier momento sin previo aviso. No utilice este producto en un entorno de producción ni para almacenar datos importantes.",
    "个": "individual",
    "个对象": "objetos",
    "个可用技能": "habilidades disponibles",
    "个人存储": "almacenamiento personal",
    "个人文档数": "Número de documentos personales",
    "个人知识库日志": "Registro de la base de conocimientos personales",
    "个属性": "atributos",
    "个已有来源": "fuentes existentes",
    "个字段": "campos",
    "格式文档，上传后立即生效。": "Dar formato al documento, efectivo inmediatamente después de cargarlo.",
    "个人练手的技术演示项目（Demo）": "Proyecto de demostración técnica (Demo) para práctica personal.",
    "给任务取个名字...": "Dale un nombre a la tarea...",
    "更新计划": "Plan de actualización",
    "工作区标识（可选）": "ID del espacio de trabajo (opcional)",
    "工作区名称（可选）": "Nombre del espacio de trabajo (opcional)",
    "工作日": "dias laborables",
    "工作通知": "aviso de trabajo",
    "工作目录": "directorio de trabajo",
    "公开仓库（无需凭据）": "Repositorio público (no se requieren credenciales)",
    "公式、单位、粒度与负责人": "Fórmula, unidad, granularidad y responsable.",
    "供 Pencil 内的 Codex Agent 使用": "Para uso del Codex Agent dentro de Pencil",
    "共同规则": "reglas comunes",
    "共同记忆": "memoria compartida",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "Actualmente no hay documentos que puedan asociarse en la base de conocimiento compartida. Puede agregar evidencia después de guardar.",
    "关闭": "cierre",
    "关闭简报": "Cerrar presentación",
    "关闭上传选择": "Cerrar selección de carga",
    "关闭使用引导": "Cerrar guía de uso",
    "关闭消息导航": "Desactivar la navegación de mensajes",
    "关键字段": "Campos clave",
    "关系名称": "nombre de la relación",
    "关系说明": "Descripción de la relación",
    "关系有证据": "Hay evidencia de relación",
    "关系证据": "evidencia de relación",
    "观测日期": "Fecha de observación",
    "观测值已删除": "Observación eliminada",
    "观远 BI": "Guanyuan BI",
    "观远 BI 地址": "Dirección de Guanyuan BI",
    "观远 BI 密码": "Contraseña de BI de Guanyuan",
    "管理": "administrar",
    "個人練手的技術展示專案（Demo）": "Proyecto de demostración de tecnología de práctica personal (Demo)",
    "工作原理": "Principio de funcionamiento",
    "管理员（Admin）": "Administración",
    "规划中": "En planificación",
    "国内平台": "plataforma nacional",
    "功能详解": "Explicación detallada de la función",
    "还没有积累私有记忆": "Aún no se ha acumulado ninguna memoria privada.",
    "还没有上游驱动": "Aún no hay ningún controlador ascendente",
    "还没有数据血缘": "Aún no hay linaje de datos",
    "还没有下游影响": "Aún no hay efectos posteriores",
    "还没有血缘关系。": "Aún no existe ningún parentesco consanguíneo.",
    "还没有执行对象": "Aún no hay objeto de ejecución",
    "还没有指标": "Aún no hay indicadores",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "También debes compartir la página de destino con esta integración en Notion.",
    "海外平台": "plataforma en el extranjero",
    "规定行为": "comportamiento prescrito",
    "核心概念": "conceptos centrales",
    "核心指标": "indicadores básicos",
    "环比变化": "Cambio mes a mes",
    "恢复": "recuperar",
    "会话文件": "archivo de sesión",
    "会议 ·": "Reunión ·",
    "会议集成": "Integración de conferencias",
    "会议纪要": "actas de la reunión",
    "会议链接或 ID": "Enlace o ID de la reunión",
    "会议密码:": "Contraseña de la reunión:",
    "会议时长（分钟）": "Duración de la reunión (minutos)",
    "会议主题": "Tema de la conferencia",
    "活跃": "activo",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Verifique la conexión según el GuanCLI oficial de Guanyuan. Después de la conexión, se pueden leer páginas, tarjetas, conjuntos de datos, ETL, indicadores y ChatBI. La creación, modificación y eliminación no están permitidas por defecto.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "Basado en el protocolo WeChat iLink, el Agente puede enviar y recibir mensajes privados directamente después de escanear el código QR. Se recomienda utilizar una cuenta WeChat dedicada como operador de agente.",
    "即将推出": "muy pronto",
    "计算 / 映射表达式": "Expresiones de cálculo/mapeo",
    "计算、影响与责任关系": "Cálculo, Impacto y Responsabilidad",
    "计算公式": "Fórmula de cálculo",
    "计算口径": "calcular calibre",
    "记录定义、口径或事实所在位置": "Definición del registro, calibre o ubicación fáctica",
    "记录两个以上周期": "Graba más de dos ciclos.",
    "记录两个周期的数据后即可比较变化。": "Los cambios se pueden comparar después de registrar datos durante dos períodos.",
    "记录数值": "valor récord",
    "记录中…": "Grabación…",
    "还没有产生额度消费": "Aún no se ha incurrido en ninguna cuota de consumo",
    "纪要": "resumen",
    "技能": "Habilidad",
    "记住与你的所有历史对话（": "Recuerda todas las conversaciones históricas contigo (",
    "核心内置技能": "Habilidades básicas incorporadas",
    "技能（Skill）— 能力扩展": "Habilidad - expansión de habilidad",
    "技能。安装后直接在对话中用自然语言描述即可：": "Habilidad. Después de la instalación, simplemente descríbalo en lenguaje natural en la conversación:",
    "技能创作（MetaSkill）": "Creación de habilidades (MetaSkill)",
    "技能分为系统内置技能和社区发布的技能。": "Las habilidades se dividen en habilidades integradas en el sistema y habilidades publicadas por la comunidad.",
    "技能模块": "Módulo de habilidades",
    "技能市场": "mercado de habilidades",
    "技能市场分为两个维度：": "El mercado de habilidades se divide en dos dimensiones:",
    "加入 Zoom 会议": "Únase a una reunión de Zoom",
    "加入会议": "Unirse a una reunión",
    "加入了组织": "Se unió a la organización",
    "加载中...": "cargando...",
    "加载中…": "cargando…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "Compatible con AWS S3, MinIO y la mayoría de almacenamiento de objetos de protocolo S3",
    "简": "simple",
    "简报": "instrucciones",
    "简报加载失败": "No se pudo cargar el resumen",
    "简报生成失败": "Falló la generación de información",
    "建立关系": "construir relaciones",
    "建立血缘": "Establecer linaje",
    "建立业务关系": "Establecer relaciones comerciales",
    "建立中…": "Edificio…",
    "建议从一个核心指标开始": "Se recomienda comenzar con un indicador básico.",
    "建议使用数据库侧的只读账号": "Se recomienda utilizar una cuenta de solo lectura en el lado de la base de datos.",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "Se recomienda registrar primero una fuente de datos, un indicador central y un objetivo comercial, y luego conectarlos.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "Se recomienda otorgar solo usuario_actual: leer, contenido_archivo: leer, comentarios_archivo: leer",
    "将": "Voluntad",
    "将 App ID 和 App Secret 填入下方": "Complete el ID de la aplicación y el secreto de la aplicación a continuación",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "Implemente este Agente como Discord Bot para interactuar en el canal del servidor.",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "Las habilidades son módulos que amplían las capacidades de los Agentes. Se pueden instalar diferentes agentes con diferentes conjuntos de habilidades, al igual que los empleados están equipados con diferentes herramientas.",
    "接入飞书": "Acceso Feishu",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Acceda a las páginas, conjuntos de datos, ETL y sistemas de indicadores de Guanyuan BI, lo que permite a este Agente comprender y analizar directamente los datos operativos de la empresa.",
    "接入微信": "Acceder a WeChat",
    "揭开第一期": "Revela el primer número",
    "结构搭好后，Agent 会自动使用": "Una vez configurada la estructura, el Agente la usará automáticamente",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "Las relaciones estructurales dan caminos candidatos; La verdadera atribución aún requiere una combinación de observaciones, evidencia y condiciones comerciales.",
    "结构信息充足": "Información estructural suficiente",
    "解释业务": "explicar negocios",
    "仅供": "solo",
    "仅管理员可删除组织知识库文档": "Solo los administradores pueden eliminar documentos de la base de conocimientos de la organización.",
    "技能系统": "Sistema de habilidades",
    "角色权限": "Permisos de rol",
    "仅支持 .md 文件": "Sólo admite archivos .md",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "Las habilidades son módulos funcionales que se pueden instalar en los Agentes. Cada habilidad le da al Agente una habilidad específica. NovaX tiene algunas habilidades básicas integradas y también proporciona un mercado de habilidades para que usted descubra e instale más funciones:",
    "进 Agent 的肌肉记忆。": "Ingrese a la memoria muscular del Agente.",
    "近 30 天消耗": "Consumo en los últimos 30 días",
    "仅所有者可购买": "Solo disponible para compra por parte del propietario.",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "Ingrese a la página \"Conversación\" y haga clic en un Agente en la lista de la izquierda para ingresar al chat. Envíe un mensaje en el cuadro de entrada y el agente transmitirá la respuesta en tiempo real. Soporte de conversación:",
    "进入第一期": "Ingrese el primer período",
    "进行中": "en curso",
    "进行中/待开": "En proceso/por abrir",
    "竞": "competir",
    "竞对与行业": "Competencia e industria",
    "聚合方式": "Método de agregación",
    "可留空自动生成，例如 contract": "Se puede dejar en blanco para generar automáticamente, como contrato",
    "可能后果与下游": "Posibles consecuencias y aguas abajo.",
    "可能原因与上游": "Posibles razones y aguas arriba.",
    "可选": "Opcional",
    "可选 · 关联共享知识库": "Opcional · Base de conocimiento compartida asociada",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "Puede crear equipos, agentes o proyectos y establecer responsabilidad con métricas y objetivos comerciales.",
    "可用": "Disponible",
    "可追溯证据": "evidencia rastreable",
    "客户联系": "contacto con el cliente",
    "口径、公式、粒度和负责人": "Calibre, fórmula, granularidad y responsable.",
    "口径与依赖": "Calibre y dependencia",
    "跨层查看正在形成的业务语义。": "Vea la semántica empresarial emergente en todas las capas.",
    "进入左侧导航栏的「知识库」页面。": "Ingrese a la página \"Base de conocimientos\" en la barra de navegación izquierda.",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "Ingrese a la página \"Equipo\" y haga clic en el botón \"Nuevo agente\". Complete el nombre y la descripción del Agente y créelo. Después de la creación, haga clic en la tarjeta de Agente para ingresar a la página de detalles, donde podrá:",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "Ingrese a la página \"Base de conocimientos\" y cargue el documento en formato .md. Estos documentos se convierten en una referencia compartida para todos los Agentes. Por ejemplo, puede cargar las especificaciones del código de la empresa y luego dejar que el agente de revisión del código verifique el código de acuerdo con esta especificación.",
    "可用 Nova 点": "Puntos Nova disponibles",
    "快速上手": "Comience rápidamente",
    "来源与流转": "Fuente y circulación",
    "类": "amable",
    "类型说明": "Descripción del tipo",
    "类型已删除": "Tipo eliminado",
    "类型与字段": "Tipos y campos",
    "理解含义": "entender el significado",
    "例：产品评审会、周例会...": "Ejemplo: reunión de revisión de producto, reunión semanal...",
    "例如 研究助手": "p.ej. asistente de investigación",
    "例如 demo": "Por ejemplo demostración",
    "例如 NovaX 产品团队": "Por ejemplo, el equipo de producto NovaX",
    "例如 product-design": "Por ejemplo, diseño de producto.",
    "例如 researcher": "Por ejemplo investigador",
    "例如：2026-W30 / 2026-07": "Por ejemplo: 2026-W30/2026-07",
    "例如：合同": "Por ejemplo: contrato",
    "例如：经营看板 / SQL 查询": "Por ejemplo: consulta Kanban/SQL empresarial",
    "例如：库存充足时": "Por ejemplo: cuando el stock es suficiente",
    "例如：渠道=自然流量，地区=华东": "Por ejemplo: canal = tráfico natural, región = este de China",
    "例如：同日 / 7 天后": "Por ejemplo: el mismo día / 7 días después",
    "例如：支付转化率": "Por ejemplo: tasa de conversión de pagos",
    "例如：SUM(pay_amount)": "Por ejemplo: SUMA(monto_pago)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "Por ejemplo: SUM(monto_pago) o pedidos.monto_pago → ingresos",
    "连接": "conectar",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "Conéctese a AWS S3, MinIO o un almacén de objetos compatible y permita que el agente explore el directorio y lea archivos dentro del prefijo de autorización.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "Conéctese a un repositorio de GitHub, GitLab o Gitee y permita que este Agente lea código, analice cambios y participe en la colaboración de desarrollo dentro del alcance de la autorización.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "Conéctese a PostgreSQL, MySQL, SQL Server y otras bases de datos para consultar datos comerciales reales con permisos de solo lectura.",
    "连接成功": "Conexión exitosa",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "Una vez que la conexión sea exitosa, el Agente accederá automáticamente a su WeChat y responderá a los mensajes en el chat designado.",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "para especificar qué agente responde. Los mensajes sin @ no activarán ningún Agente.",
    "连接飞书": "Conéctate a Feishu",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Después de conectarse con Feishu, los miembros del equipo pueden hablar directamente con el Agente en el chat grupal de Feishu. Admite las capacidades nativas de Feishu, como tarjetas de texto enriquecido, envío y recepción de archivos y vinculación de calendarios.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "Después de la conexión, se pueden leer los nodos del archivo y los comentarios, pero no está abierto para modificar el diseño, publicar comentarios o administrar el equipo.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "Después de la conexión, se pueden enumerar objetos y se pueden leer archivos que no superen los 2 MB dentro del prefijo limitado. No se permite cargar, sobrescribir o eliminar.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "Después de conectarse, puede buscar y leer páginas autorizadas y bloques de contenido, pero no puede crear, modificar ni eliminar páginas.",
    "连接计算来源和业务目标": "Conecte fuentes informáticas y objetivos comerciales",
    "连接类型": "Tipo de conexión",
    "连接目标或流程": "Conectar objetivo o proceso",
    "连接你的 AI 引擎": "Conecte su motor de IA",
    "连接上下游": "Conecte aguas arriba y aguas abajo",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "Conecte diseños, documentos, correos electrónicos, códigos y datos comerciales para permitir que los agentes participen en trabajos reales dentro de un alcance claramente autorizado.",
    "连接失败": "La conexión falló",
    "连接数据或指标": "Conectar datos o métricas",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "Una vez completada la conexión, agregue el Agente al Grupo Feishu para iniciar la conversación.",
    "连接微信": "Conéctate a WeChat",
    "连接验证成功": "Verificación de conexión exitosa",
    "连接中...": "Conectando...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "Después de dos períodos de registro consecutivos, NovaX calcula los cambios y busca posibles impulsores en un análisis de impacto.",
    "联网搜索": "búsqueda en internet",
    "链接": "Enlace",
    "列表视图": "vista de lista",
    "临时凭据才需要": "Sólo se requieren credenciales temporales",
    "另有": "También",
    "留空会继续使用已加密保存的凭据": "Déjelo en blanco para continuar usando las credenciales guardadas cifradas",
    "六": "seis",
    "六个视图，其实是同一张图": "Seis vistas, en realidad la misma imagen.",
    "路径样式（MinIO 常用）": "Estilo de ruta (comúnmente utilizado por MinIO)",
    "马斯克思维": "Pensamiento almizclero",
    "芒格思维": "El pensamiento de Munger",
    "没有发现新增内容": "No se encontró contenido nuevo",
    "没有匹配的角色": "No hay rol coincidente",
    "没有匹配的消息": "No hay mensajes coincidentes",
    "没有匹配的指标": "No hay métricas coincidentes",
    "没有上游路径": "sin camino aguas arriba",
    "没有下游路径": "sin camino aguas abajo",
    "没有新增内容": "Nada nuevo",
    "没有找到匹配的技能": "No se encontraron habilidades coincidentes",
    "没有找到匹配的文件": "No se encontró ningún archivo coincidente",
    "每": "Cada",
    "来扩展能力": "para ampliar las capacidades",
    "连接到飞书、Telegram、微信等": "Conéctese a Feishu, Telegram, WeChat, etc.",
    "累计消耗": "Consumo acumulado",
    "每篇内容都来自": "Cada contenido proviene de",
    "每天": "cada día",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "Los mensajes sin @ ningún Agente se enviarán al grupo pero no generarán respuestas del Agente, lo que facilita la comunicación entre los miembros del equipo.",
    "每个用户最多可以创建": "Cada usuario puede crear hasta",
    "每小时": "por hora",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "Cada capa responde a una pregunta diferente y juntas forman la ontología sobre la que el Agente puede razonar.",
    "每月": "por mes",
    "每周": "semanalmente",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "Cada Agente puede ver el contexto en el chat grupal, por lo que los Agentes posteriores pueden hacer referencia directamente a la salida del Agente anterior.",
    "密码": "contraseña",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "Las contraseñas, tokens y claves privadas solo se cifran y almacenan en el lado del servidor y no se escribirán en archivos ni conversaciones del Agente.",
    "每天早上 9 点给我发一份行业新闻摘要": "Envíame un resumen de noticias de la industria todas las mañanas a las 9 a.m.",
    "描述": "describir",
    "名称": "nombre",
    "名称 *": "Nombre *",
    "名称不能为空": "El nombre no puede estar vacío",
    "每周五下午 5 点生成本周工作总结": "Todos los viernes a las 5 p.m. se genera un resumen del trabajo de la semana.",
    "名称和头像": "Nombre y avatar",
    "免费赠送": "regalo gratis",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "La cuota gratuita es una cuota única para la organización y es compartida por todos los miembros. Actualmente convertido a $1 = 750 puntos Nova.",
    "模板消息": "mensaje de plantilla",
    "模型": "Modelo",
    "模型定义": "Definición del modelo",
    "默认邮箱目录": "Directorio de buzón predeterminado",
    "明确角色": "aclarar roles",
    "内部群聊": "Chat grupal interno",
    "内容读取": "Lectura de contenido",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "Los tipos integrados forman la semántica común de NovaX y los tipos personalizados describen su negocio único.",
    "你": "tú",
    "模板中用": "Utilizado en plantillas",
    "目录": "Tabla de contenido",
    "模型和": "modelo y",
    "你可以随时在设置中注销账号，删除所有关联数据。": "Puede cerrar sesión en su cuenta y eliminar todos los datos asociados en cualquier momento en la configuración.",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "Puedes pensar en un Agente como un miembro virtual del equipo. Puede:",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "Puede cerrar sesión en su cuenta en cualquier momento en la configuración y eliminar todos los datos asociados.",
    "女娲 · Skill 造人术": "Técnica de creación humana Nuwa·Skill",
    "篇": "Capítulo",
    "频道对话": "Conversación del canal",
    "平台": "plataforma",
    "平台公告": "Anuncio de plataforma",
    "评估后果": "Evaluar las consecuencias",
    "评论读取": "Comentarios leídos",
    "凭据已加密保存，": "Las credenciales se guardan cifradas,",
    "期望方向": "dirección deseada",
    "企业微信": "WeChat empresarial",
    "企业邮箱 / 自定义 IMAP": "Correo electrónico empresarial/IMAP personalizado",
    "启用（兼容自签名证书）": "Habilitado (compatible con certificados autofirmados)",
    "启用（推荐）": "Habilitar (recomendado)",
    "启用并验证证书": "Habilitar y verificar certificado",
    "起点 *": "Punto de partida *",
    "前": "adelante",
    "前往": "Ir a",
    "前往飞书开放平台 →": "Ir a la plataforma abierta Feishu →",
    "前缀隔离": "aislamiento de prefijo",
    "乔布斯思维": "Trabajos pensando",
    "切换": "cambiar",
    "前提：Agent 需要安装": "Requisito previo: el agente debe estar instalado",
    "切换中...": "Traspuesta...",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "El contenido de la conversación que ingresa durante el uso solo se usa para interactuar con el motor de IA y no se almacenará ni se usará adicionalmente para entrenar el modelo.",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "El contenido de la conversación que ingresa durante el uso solo se usa para interactuar con el motor de IA y no se almacenará ni se usará adicionalmente para entrenar el modelo.",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "Cambie o cree organizaciones, cada organización tiene Agentes y miembros independientes.",
    "切换组织": "Cambiar de organización",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "Utilice la conclusión de la sesión informativa para explicar con más detalle las razones, los posibles impactos y las acciones más valiosas que debemos tomar a continuación.",
    "请输入您的反馈、建议或遇到的问题...": "Por favor ingrese sus comentarios, sugerencias o problemas...",
    "请填写 App ID 和 App Secret": "Complete el ID de la aplicación y el secreto de la aplicación",
    "请勿填写网页登录密码": "Por favor no complete la contraseña de inicio de sesión de la página web",
    "请选择一个角色": "Por favor seleccione un rol",
    "区域": "área",
    "驱动行动": "impulsar la acción",
    "取消": "Cancelar",
    "全部": "todo",
    "全部对象": "Todos los objetos",
    "全部执行对象": "Todos los objetos de ejecución",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "El buzón se abre en modo IMAP de solo lectura en todo momento; se puede buscar y leer el cuerpo del correo electrónico, y se pueden ver los nombres de los archivos adjuntos. El correo electrónico no será enviado, eliminado, movido ni marcado.",
    "全员群": "Todos los miembros",
    "权限隔离": "Aislamiento de permisos",
    "确保 Codex CLI 已安装": "Asegúrese de que Codex CLI esté instalado",
    "确定": "Seguro",
    "确定断开？已保存凭据会被删除。": "¿Estás seguro de desconectarte? Se eliminarán las credenciales guardadas.",
    "清除后所有聊天记录将被删除，无法恢复。": "Después de borrarlo, todo el historial de chat se eliminará y no se podrá recuperar.",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "Después de cambiar de organización, los agentes, la base de conocimientos y los miembros del equipo que verá cambiarán en consecuencia.",
    "确定删除这个会议？": "¿Está seguro de que desea eliminar esta reunión?",
    "确定删除这条指标观测吗？": "¿Está seguro de que desea eliminar esta observación de indicador?",
    "全局市场": "mercado global",
    "确认断开": "Confirmar desconexión",
    "确定清除所有会话？": "¿Está seguro de que desea borrar todas las sesiones?",
    "确认已安装。": "Confirme que esté instalado.",
    "确定要注销账号吗？": "¿Estás seguro de que deseas cancelar tu cuenta?",
    "确认清除": "Confirmar claro",
    "群聊": "chat grupal",
    "群聊@唤醒": "Chat grupal @ despertar",
    "群聊对话": "Conversación de chat grupal",
    "确认注销": "Confirmar cierre de sesión",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "El chat grupal es el escenario de colaboración principal de NovaX. Haga clic en \"Todos los miembros\" en la parte superior de la lista de agentes para ingresar. En un chat grupal, todos los agentes y miembros del equipo comparten el mismo espacio de conversación.",
    "让组织的重要变化": "Realiza cambios importantes en tu organización",
    "人": "gente",
    "人格蒸馏 · 女娲造人": "Destilación de Personalidad·Nuwa crea seres humanos",
    "认证方式": "Método de autenticación",
    "群聊与多 Agent 协作": "Chat grupal y colaboración entre múltiples agentes",
    "任务名称": "Nombre de la tarea",
    "仍建议用实际数据验证候选原因。": "Todavía se recomienda verificar las causas candidatas con datos reales.",
    "日": "día",
    "日历联动": "Enlace de calendario",
    "日期": "fecha",
    "群聊中需要通过": "En el chat grupal, debes pasar",
    "任务": "Tarea",
    "人设和行为规则": "Reglas de personalidad y comportamiento.",
    "如何创建": "como crear",
    "三": "tres",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "Si tiene alguna pregunta o inquietud, comuníquese con el desarrollador a través del canal de comentarios del producto.",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "Después de escanear el código QR para iniciar sesión en WeChat, el Agente puede actuar como su asistente de WeChat, respondiendo automáticamente a mensajes, administrando chats grupales y manejando asuntos diarios.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "Después de escanear el código QR para conectarse a WeChat, este agente accede automáticamente a los mensajes de WeChat y puede responder en chats privados o grupales.",
    "扫码区域": "Área de código de escaneo",
    "删除": "borrar",
    "删除观测": "Eliminar observación",
    "删除后无法恢复，确定要删除这个文档吗？": "La eliminación no se puede restaurar. ¿Está seguro de que desea eliminar este documento?",
    "删除会议": "Eliminar reunión",
    "删除了 Agent": "Agente eliminado",
    "删除失败": "Error al eliminar",
    "删除失败或无权操作": "Eliminación fallida o sin permiso para operar",
    "删除文档": "Eliminar documento",
    "商业专业": "Especialidad en negocios",
    "上传": "subir",
    "上传到哪里？": "¿Dónde subir?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "Después de cargarlo, aún se puede ver por separado en \"Base de conocimientos de la organización/Mi base de conocimientos\".",
    "上传了": "subido",
    "上传录音": "Subir grabación",
    "上传失败": "Error al subir",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "Si tiene alguna pregunta o inquietud, comuníquese con el desarrollador a través del canal de comentarios dentro del producto.",
    "上次：": "Último tiempo:",
    "上次触发": "último activado",
    "上次执行": "último ejecutado",
    "上下游网络": "Redes ascendentes y descendentes",
    "上一步": "Paso anterior",
    "上游候选": "candidato aguas arriba",
    "尚未补充业务定义": "Aún no se ha agregado ninguna definición de negocio",
    "尚未连接指标或业务目标。": "Aún no se han conectado métricas ni objetivos comerciales.",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "Establece una tarea programada, como \"Envíame un informe diario a las 9 a. m. todos los días\".",
    "设计创作": "creación de diseño",
    "设计生成": "generación de diseño",
    "设计师包 · DESIGN": "Bolso de diseño · DISEÑO",
    "上传文件作为附件。": "Sube el archivo como archivo adjunto.",
    "三级权限体系": "Sistema de autoridad de tres niveles",
    "设置": "configuración",
    "谁来行动": "quien actuará",
    "什么属于这个类型，什么不属于？": "¿Qué pertenece a este género y qué no?",
    "生成二维码": "Generar código QR",
    "生成二维码失败": "No se pudo generar el código QR",
    "生成纪要": "Generar minutos",
    "生成纪要中": "Generando minutos",
    "生成失败": "Error de compilación",
    "生成中...": "Generando...",
    "失败": "fallar",
    "设定边界": "establecer límites",
    "实体与关系来源": "Fuentes de entidades y relaciones",
    "使用": "usar",
    "时间": "tiempo",
    "什么是 Agent": "¿Qué es el agente?",
    "使用工具": "utilizar herramientas",
    "使用时只记住两个动作": "Solo recuerda dos acciones al usarlo.",
    "使用引导": "Usa la guía",
    "设置头像，从预设中选择或上传自定义图片。": "Configure un avatar, elija entre ajustes preestablecidos o cargue una imagen personalizada.",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "Utilice su dirección de correo electrónico para registrar una cuenta. El sistema enviará un código de verificación a su correo electrónico. Después de la verificación, establezca una contraseña para completar el registro. Al iniciar sesión por primera vez se crea automáticamente una organización predeterminada.",
    "使用方式": "Uso",
    "视条件而定": "Sujeto a condiciones",
    "是": "Sí",
    "是 / 否": "si",
    "示例：": "Ejemplo:",
    "适用条件": "Condiciones aplicables",
    "收到 Webhook 事件: {{payload}}": "Evento de webhook recibido: {{payload}}",
    "收起": "cerca",
    "手动创建": "Crear manualmente",
    "手动记录": "Grabación manual",
    "输入清晰、唯一的业务名称": "Ingrese un nombre comercial claro y único",
    "输入消息，@agent 名字来提问": "Ingrese un mensaje, @nombre del agente para hacer una pregunta",
    "属性": "propiedad",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "Los atributos se utilizan para unificar el significado comercial y también convertirse en el contexto estructurado del Agente.",
    "属性字段": "campo de atributo",
    "数": "número",
    "数据层：数从哪里来": "Capa de datos: ¿de dónde vienen los números?",
    "数据从哪里来，经过什么，最终形成哪个指标": "¿De dónde proceden los datos, por qué pasan y qué indicador se forma finalmente?",
    "数据分析": "análisis de datos",
    "数据观察": "Observación de datos",
    "数据集": "Conjunto de datos",
    "数据库、表和关键字段": "Base de datos, tablas y campos clave.",
    "数据库地址": "Dirección de la base de datos",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "El acceso a la base de datos puede complementar automáticamente el parentesco y la observación; puede descubrir correlaciones, pero no las actualizará automáticamente a causalidad.",
    "数据库类型": "Tipo de base de datos",
    "数据库密码": "Contraseña de la base de datos",
    "数据库名": "Nombre de la base de datos",
    "数据血缘": "Linaje de datos",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "El linaje de datos responde \"¿de dónde vienen los números?\"; la relación de influencia responde \"posiblemente por qué\"; Sólo causa y efecto probados pueden responder \"determinar qué lo causa\".",
    "数据血缘图": "Diagrama de linaje de datos",
    "数据与办公": "Datos y oficina",
    "数据源": "fuente de datos",
    "数据源、表与字段": "Fuentes de datos, tablas y campos.",
    "数据资产": "activos de datos",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "Campos de datos → Indicadores básicos → Objetivos de negocio → Responsable",
    "数值来源": "fuente de valor",
    "数字": "número",
    "双人": "Doble",
    "说明": "ilustrar",
    "说明它在业务里代表什么，以及不包含什么": "Explique qué representa en el negocio y qué no incluye",
    "私聊": "chat privado",
    "私聊回复": "Respuesta de chat privado",
    "私钥口令（可选）": "Contraseña de clave privada (opcional)",
    "思考中...": "Pensamiento...",
    "思维框架": "marco de pensamiento",
    "四": "cuatro",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "La cuarta capa no son cuatro directorios separados, sino un vínculo entre los hechos y la acción. No es necesario que lo complete todo de una vez, simplemente cree primero el enlace más importante.",
    "松开以上传 .md 文件": "Suelte para cargar el archivo .md",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "Busque y lea páginas de Notion y bloques de contenido autorizados para la integración, lo que permite al Agente utilizar documentos del equipo y materiales del proyecto.",
    "搜索会话内的文件": "Buscar archivos dentro de una sesión",
    "搜索技能名称、描述或标签...": "Busque el nombre, la descripción o la etiqueta de una habilidad...",
    "搜索内容": "Buscar contenido",
    "搜索项目、团队或 Agent": "Buscar proyectos, equipos o agentes",
    "搜索消息...": "Buscar mensajes...",
    "搜索预设角色...": "Buscar roles preestablecidos...",
    "搜索知识库...": "Busque en la base de conocimientos...",
    "搜索指标或口径": "Buscar métricas o calibre",
    "所属层 *": "Capa de pertenencia *",
    "使用者的個人資訊用於任何商業用途。": "La información personal del usuario se utiliza para cualquier fin comercial.",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "También seguirá prestando atención a la inteligencia urgente o importante sobre competencia, así como a las grandes noticias sobre la industria y las direcciones políticas, e impulsará los cambios que realmente requieran la atención de la organización aquí.",
    "所有者（Owner）": "Dueño",
    "提出原因": "dar razones",
    "提交反馈": "Enviar comentarios",
    "提交分析": "Enviar análisis",
    "添加关系": "Agregar relación",
    "添加字段": "Agregar campo",
    "条关系": "relación",
    "条件性": "condicionalidad",
    "条因果关系": "relación causal",
    "跳": "Saltar",
    "跳过引导": "Saltar arranque",
    "适合放入的内容": "que poner",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Cree, modifique y exporte borradores de diseño .pen a través de Pencil Headless CLI, y el proceso de generación siempre utiliza Codex.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Interactúe con el Agente a través de Telegram Bot, admitiendo mensajería instantánea y procesamiento de archivos a escala global.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Interactúe con este Agente a través de Telegram Bot para admitir mensajería instantánea global.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "Acceda a este Agente a través de la API de WhatsApp Business para llegar a usuarios de todo el mundo.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "Acceda a este Agente a través de la aplicación empresarial WeChat para admitir escenarios de comunicación interna y servicio al cliente.",
    "通过": "aprobar",
    "通信对话 (": "conversación de comunicación (",
    "通用工具 (": "Herramientas generales (",
    "同名文档": "Documento con el mismo nombre.",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "Ya se pueden visualizar paquetes y cupos, y realizar compras una vez confirmado el canal de pago.",
    "套餐之间仅额度不同，所有产品能力保持一致。": "Sólo la cantidad difiere entre paquetes y todas las capacidades del producto siguen siendo las mismas.",
    "同一组织 · 同一份简报 · 持续沉淀": "La misma organización · el mismo breve · acumulación continua",
    "统计": "estadística",
    "统计粒度": "granularidad estadística",
    "统计周期": "período estadístico",
    "图标": "icono",
    "图标视图": "vista de icono",
    "图片 / PDF 导出": "Exportación de imagen/PDF",
    "团队的": "equipo",
    "团队": "equipo",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "El mismo agente puede trabajar en plataformas web y de mensajería instantánea, y los recuerdos y habilidades de las conversaciones se comparten en todas las plataformas.",
    "团队规范、工作流程、审批标准": "Especificaciones del equipo, procesos de trabajo y estándares de aprobación.",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "Invite a miembros a unirse por correo electrónico y establezca diferentes roles (propietario/administrador/miembro).",
    "团队日志": "Registro del equipo",
    "推荐": "recomendar",
    "推荐建模顺序": "Orden de modelado recomendado",
    "退出登录": "Finalizar la sesión",
    "拖入 .md 文件，或点击上传": "Arrastre el archivo .md o haga clic en Cargar",
    "团队协作（NovaX Bus）": "Colaboración en equipo (NovaX Bus)",
    "团队规范和工作流程": "Normas de equipo y procesos de trabajo.",
    "外部系统 POST 到此 URL 即可触发": "Se puede activar la publicación del sistema externo a esta URL",
    "完成": "Finalizar",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "Los indicadores completos incluyen definición de negocio, calibre de cálculo, granularidad, dimensión, fuente, responsable y observaciones históricas.",
    "网络错误": "error de red",
    "微信": "WeChat",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "La conexión WeChat se basa en el protocolo de la versión web y es necesario mantener una cuenta WeChat en línea como operador de agente. Se recomienda utilizar una cuenta WeChat dedicada.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat está conectado y el Agente responderá automáticamente al mensaje. Se puede utilizar después de reiniciar el servicio.",
    "唯一标识": "identificador único",
    "维度切片": "rebanada de dimensión",
    "未补充映射表达式": "Expresión de mapeo no complementada",
    "未连接": "No conectado",
    "未设置": "no establecido",
    "未设置编码": "Sin conjunto de codificación",
    "未设置更新频率": "Frecuencia de actualización no establecida",
    "未设置公式": "No hay fórmula establecida",
    "未设置统计粒度": "La granularidad de las estadísticas no está establecida",
    "未知": "desconocido",
    "未知文档": "Documento desconocido",
    "文本": "texto",
    "文档读取失败": "Falló la lectura del documento",
    "文档读取失败或无权访问": "La lectura del documento falló o no hay permiso de acceso",
    "文档已覆盖": "Documento cubierto",
    "文档已删除": "Documento eliminado",
    "文档已上传": "Documento subido",
    "文件处理": "Procesamiento de archivos",
    "文件传输": "transferencia de archivos",
    "文件读取": "lectura de archivos",
    "文件分享": "compartir archivos",
    "文件过大，最大支持 2MB": "El archivo es demasiado grande, el máximo admitido es 2 MB.",
    "文件结构": "Estructura de archivos",
    "文件收发": "Envío y recepción de archivos",
    "我": "I",
    "我的知识库": "Mi base de conocimientos",
    "外观": "Apariencia",
    "我们": "a nosotros",
    "我想继续讨论这篇组织简报：": "Me gustaría continuar discutiendo este resumen organizacional:",
    "无单位": "sin unidades",
    "无公式": "Sin fórmula",
    "无可用 Agent": "No hay agente disponible",
    "无描述": "Sin descripción",
    "五": "cinco",
    "系统": "sistema",
    "系统工具": "herramientas del sistema",
    "系统内置": "Sistema incorporado",
    "我們": "nosotros",
    "下次：": "La próxima vez:",
    "下次执行": "Ejecutar la próxima vez",
    "下一步": "Siguiente paso",
    "下游影响": "efectos posteriores",
    "下载": "descargar",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "Primero \"crea un nuevo objeto\" y luego \"establece una relación\". El objeto puede ser un campo, indicador, objetivo o agente; la relación debe seleccionar explícitamente cálculo, linaje, impacto, causalidad o atribución, y tratar de complementar fórmulas, condiciones, confianza y evidencia.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "Primero cree indicadores como \"ventas, volumen de pedidos y tasa de conversión\" que realmente se utilicen para la toma de decisiones, y complete la definición del negocio, la fórmula, la granularidad estadística y el responsable; luego registre los valores durante al menos dos períodos para que NovaX pueda determinar qué cambios han ocurrido.",
    "先看懂四层业务地图": "Primero comprenda el mapa empresarial de cuatro capas.",
    "先验证，再保存": "Primero verifique y luego guarde",
    "现在搭建第一条业务链路": "Ahora cree el primer vínculo comercial",
    "现在可以通过受限工具安全使用这个连接。": "Esta conexión ahora es segura de usar con herramientas restringidas.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "Ahora comience generando el primer problema para su organización. A medida que se sigan agregando información y conexiones, NovaX continuará publicando contenido al que vale la pena prestar atención aquí.",
    "限定前缀（可选）": "prefijo calificativo (opcional)",
    "限定文件 Key（可选）": "Clave de archivo calificado (opcional)",
    "相对上一期": "Comparado con el número anterior",
    "详细记忆文件": "archivo de memoria detallado",
    "项操作": "operaciones",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "Razonar y ejecutar tareas dentro del entorno limitado de escritura del espacio de trabajo.",
    "消耗": "consumir",
    "消息导航": "Navegación de mensajes",
    "消息卡片": "tarjeta de mensaje",
    "消息": "información",
    "外部平台": "plataforma externa",
    "小": "Pequeño",
    "小时": "Hora",
    "协作 Agent": "Agente de colaboración",
    "斜杠命令": "comando de barra diagonal",
    "新建对象": "Nuevo objeto",
    "新建业务概念": "Nuevo concepto de negocio",
    "新建执行对象": "Crear un nuevo objeto de ejecución",
    "新建指标": "Nuevo indicador",
    "形成指标": "indicadores de forma",
    "修改文件": "Modificar archivos",
    "虚拟主机样式（AWS 默认）": "Estilo de host virtual (predeterminado de AWS)",
    "需要两个周期": "Se necesitan dos ciclos.",
    "选择 .md 文件 →": "Seleccione el archivo .md →",
    "选择要安装到的 Agent": "Seleccione el agente para instalar",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "Elija una función preestablecida para comenzar rápidamente o cree un Agente personalizado manualmente.",
    "选择一个执行对象": "Seleccione un objeto de ejecución",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "Después de seleccionar una métrica, el análisis de impacto mira hacia arriba, hacia la fuente del cálculo y los impulsores candidatos, y hacia abajo, hacia los objetivos, procesos y personas responsables del impacto. La relación de influencia es sólo una pista; sólo la relación de causalidad con la evidencia de verificación será expresada por el Agente como causa definitiva.",
    "选择一个指标开始": "Elija un indicador para comenzar",
    "选择指标或业务对象": "Seleccione una métrica u objeto de negocio",
    "血缘与计算映射": "Línea de sangre y mapeo computacional.",
    "寻址方式": "Modo de direccionamiento",
    "沿关系找原因，也看后果": "Siga la relación para encontrar la causa y también observe las consecuencias.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "Identifique los objetivos, procesos, proyectos y propietarios afectados a lo largo de las relaciones posteriores.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "Genere candidatos candidatos a lo largo del impacto y las relaciones causales, y degrade las expresiones en función de la confianza, las condiciones y la evidencia.",
    "沿用 Figma Token 可见范围": "Heredar el rango visible de Figma Token",
    "系统任务": "Tareas del sistema",
    "颜色": "color",
    "演示文稿制作": "Producción de presentaciones",
    "验证并保存": "Verificar y guardar",
    "验证并连接": "Verificar y conectar",
    "验证结果": "Resultados de la verificación",
    "要点速读": "Puntos para leer rápidamente",
    "也是 Agent 们的": "También para agentes",
    "业务本体": "Ontología empresarial",
    "业务层：数字说明什么": "Capa empresarial: lo que dicen los números",
    "业务地图": "mapa empresarial",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "El mapa empresarial analiza el panorama general, la red de indicadores analiza el calibre y las fases ascendentes y descendentes, el linaje de datos analiza la fuente, el análisis de impacto analiza las causas y consecuencias, la ejecución de la organización analiza a la persona a cargo y el modelo define el tipo de objeto de gestión. Cambiar de vista no crea datos duplicados.",
    "业务定义": "definicion de negocio",
    "业务对象": "objeto de negocio",
    "消息字体大小": "Tamaño de fuente del mensaje",
    "写 Soul 的要点": "Puntos clave para escribir Soul",
    "邀请成员": "Invitar miembros",
    "研究员输出数据后：": "Después de que el investigador genera los datos:",
    "业务连接": "conexión de negocios",
    "业务声明": "Declaración comercial",
    "业务指标": "métricas de negocio",
    "页面分析": "Análisis de página",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "Diseño de páginas, presentaciones, generación de imágenes con IA: haga que su agente parezca un diseñador profesional.",
    "页面搜索": "Búsqueda de página",
    "一": "uno",
    "一只 Agent。": "Un agente.",
    "移除了": "Remoto",
    "已保存，留空不修改": "Guardado, dejar en blanco sin modificaciones.",
    "已触发": "Motivado",
    "已存在，是否覆盖？": "¿Ya existe? ¿Exagerar?",
    "已复制": "Copiado",
    "已归档": "Archivado",
    "已过期": "Venció",
    "已结束": "terminó",
    "已连接": "Conectado",
    "已连接 ·": "Conectado ·",
    "已取消": "Cancelado",
    "已扫码，请在手机上确认...": "El código ha sido escaneado, por favor confírmalo en tu teléfono móvil...",
    "已生成纪要": "Minuto generado",
    "已完成": "Terminado",
    "已验证": "Verificado",
    "已验证因果": "Causa y efecto verificados",
    "已暂停": "Suspendido",
    "因果可信度阶梯": "escalera de credibilidad causal",
    "业务规则、行业术语、标准话术": "Reglas comerciales, terminología industrial, vocabulario estándar.",
    "业务规则和约束条件": "Reglas y restricciones comerciales",
    "引导进度": "progreso de arranque",
    "应用消息": "Mensajes de aplicación",
    "应用专用密码 / 授权码": "Contraseña/código de autorización específico de la aplicación",
    "影响分析": "análisis de impacto",
    "影响分析失败": "El análisis de impacto falló",
    "影响时滞": "Afecta el desfase temporal",
    "影响语义": "Afecta la semántica",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "El desarrollador no es responsable de ninguna pérdida directa o indirecta que surja del uso de este producto.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "El desarrollador no es responsable de ninguna pérdida directa o indirecta que surja del uso de este producto.",
    "用 1 分钟看懂业务本体": "Tómese 1 minuto para comprender la ontología empresarial",
    "用法示例": "Ejemplos de uso",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "Los agentes con habilidades MetaSkill pueden crear y publicar automáticamente nuevas habilidades según sus necesidades.",
    "拥有专属的": "tener exclusiva",
    "用户的个人信息用于任何商业用途。": "La información personal del usuario se utiliza para cualquier fin comercial.",
    "用户名": "nombre de usuario",
    "用链接或 ID 进入": "Ingresa con link o ID",
    "用手机微信扫描二维码，确认登录。": "Utilice WeChat en su teléfono móvil para escanear el código QR y confirmar el inicio de sesión.",
    "用手机微信扫描二维码并确认登录": "Utilice WeChat en su teléfono móvil para escanear el código QR y confirmar el inicio de sesión",
    "用于比较变化": "Se utiliza para comparar cambios.",
    "用于区分这个 Agent 的 Pencil 设计文件": "Archivo de diseño de lápiz utilizado para distinguir este Agente",
    "邮件搜索": "búsqueda de correo",
    "邮箱": "Correo",
    "邮箱类型": "Tipo de correo electrónico",
    "邮箱账号": "cuenta de correo electrónico",
    "有纪要": "Con acta",
    "语义关系": "Relaciones semánticas",
    "语义属性": "Propiedades semánticas",
    "预定时间（可选，留空则立即开始）": "Hora programada (opcional, déjelo en blanco para comenzar de inmediato)",
    "原始转写": "transcripción original",
    "原因与后果": "causas y consecuencias",
    "永久删除你的账号和所有数据，此操作不可撤销。": "Elimina permanentemente tu cuenta y todos tus datos. Esta acción es irreversible.",
    "用量明细加载失败": "No se pudieron cargar los detalles de uso",
    "运行连接命令": "Ejecutar comando de conexión",
    "运行引擎": "hacer funcionar el motor",
    "运行中": "En ejecución",
    "再查一次": "comprobar de nuevo",
    "再查一次，没有新增内容": "Comprobado de nuevo, no hay contenido nuevo.",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Colabore con este Agente en Microsoft Teams e intégrelo en los flujos de trabajo empresariales.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "Colabore directamente con agentes en los canales de Slack, adecuados para el flujo de trabajo diario de equipos en el extranjero.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Trabaje directamente con este Agente en un canal de Slack, admitiendo respuestas de Thread.",
    "语音输入（需浏览器支持 Web Speech API）。": "Entrada de voz (requiere que el navegador sea compatible con Web Speech API).",
    "月度额度不足时，可由组织所有者补充。": "Cuando la cuota mensual es insuficiente, el propietario de la organización puede reponerla.",
    "月度套餐": "paquete mensual",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "Cree una nueva organización o cambie de organización en \"Configuración → Gestión de cuentas\".",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "Créelo en la subpestaña \"Webhook\" de la pestaña \"Tarea\" y complete el nombre y la plantilla de palabras clave.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "Haga clic en \"Nuevo agente\" en la página \"Equipo\" para crearlo. Después de la creación, haga clic en la tarjeta Agente para ingresar a la página de detalles para la configuración.",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "Conecte este agente a un grupo de DingTalk para admitir las capacidades nativas de DingTalk, como tarjetas de mensajes y notificaciones de trabajo.",
    "在不同组织之间切换，数据完全隔离。": "Cambie entre diferentes organizaciones con completo aislamiento de datos.",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "Administre los miembros de la organización en la página \"Equipo\". Haga clic en \"Invitar miembros\" e ingrese su dirección de correo electrónico para enviar invitaciones.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "Cambie a la pestaña \"Habilidades\" en la parte superior de la interfaz de conversación, explore la lista disponible y haga clic en Instalar.",
    "在对话中让": "dejar entrar la conversación",
    "在对话中让 agent \"记住\"重要信息": "Deje que el agente \"recuerde\" información importante durante la conversación",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Confirme la autorización en el backend de Feishu y la aplicación obtendrá automáticamente los permisos necesarios (envío y recepción de mensajes, gestión de grupos, etc.).",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Comuníquese directamente con este agente en el chat grupal de Feishu, lo que admite las capacidades nativas de Feishu, como tarjetas de texto enriquecido, envío y recepción de archivos, etc.",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "Cambie a la pestaña \"Conexión\" en la parte superior de la interfaz de diálogo para configurar. Actualmente soporta:",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "Ejecute NovaX Agent en su computadora para conectar de forma segura su espacio de trabajo local de Codex a NovaX.",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "En la lista de agentes en la página de conversación, verá una entrada \"Grupo de todos los miembros\". En un chat grupal, puede usar @AgentName para especificar un agente para responder preguntas. Esto permite que varios agentes colaboren en la misma conversación. Por ejemplo, primero deje que el agente \"investigador\" busque información y luego deje que el agente \"escritor\" escriba un artículo basado en la información.",
    "暂不关联": "Aún no relevante",
    "在服务器上读写文件、执行代码": "Leer y escribir archivos y ejecutar código en el servidor.",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "Por el momento, debe crear manualmente una aplicación en el backend de Feishu y completar las credenciales. Se está desarrollando un proceso de creación automatizado: la autorización con un solo clic será todo lo que se necesita para completar la conexión.",
    "暂停": "pausa",
    "暂无 Webhook": "Aún no hay webhooks",
    "暂无定时任务": "Aún no hay tareas programadas",
    "暂无观测": "Aún no hay observaciones",
    "暂无观测值": "Aún no hay observaciones",
    "暂无记录": "Aún no hay registro",
    "暂无记忆": "Aún no hay memoria",
    "暂无纪要 — 会议结束后自动转写": "Aún no hay actas: se transcriben automáticamente una vez finalizada la reunión",
    "暂无类型说明": "Aún no hay descripción del tipo",
    "暂无日志": "Aún no hay registros",
    "暂无属性字段": "Aún no hay campos de atributos",
    "暂无数据": "Aún no hay datos",
    "暂无说明": "Aún no hay descripción",
    "暂无文件": "Aún no hay archivos",
    "暂无业务定义": "Aún no hay definición de negocio",
    "粘贴 Figma 访问 Token": "Pegar token de acceso a Figma",
    "粘贴 Zoom 链接或输入会议 ID": "Pegue el enlace de Zoom o ingrese el ID de la reunión",
    "展开查看": "Ampliar para ver",
    "账号": "cuenta",
    "这份证据如何支持该关系？": "¿Cómo apoya esta evidencia la relación?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "Aquí conserva sus equipos, agentes, proyectos, tareas, documentos y habilidades originales y los conecta con métricas comerciales.",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "En la página \"Mercado de habilidades\" en la barra de navegación izquierda, puede explorar todas las habilidades disponibles.",
    "占位，表示外部传入的数据。例如：": "Marcador de posición, que representa datos entrantes externos. Por ejemplo:",
    "暂时无法读取额度信息": "Temporalmente no puedo leer la información crediticia",
    "蒸馏": "destilación",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "Destila marcos de toma de decisiones, primeros principios y ADN expresivo, refinando un asesor mental al que puedes recurrir en cualquier momento.",
    "整体结构": "estructura general",
    "正文与附件信息": "Información de texto y archivos adjuntos",
    "正向": "adelante",
    "正在编撰组织简报": "Recopilación de información organizacional",
    "正在创建微信连接...": "Creando conexión WeChat...",
    "正在读取组织最近的使用情况": "Leer el uso reciente de la organización",
    "正在计算影响路径…": "Calculando la trayectoria del impacto...",
    "正在建立业务语义地图…": "Construyendo mapa semántico empresarial...",
    "正在生成二维码...": "Generando código QR...",
    "正在验证连接…": "Verificando conexión...",
    "正在由 Agent 团队编撰第一期": "El primer número está siendo compilado por el equipo del Agente.",
    "正在整理组织数据与知识": "Organización de datos y conocimientos organizacionales.",
    "证据等级": "Nivel de evidencia",
    "证据摘要": "resumen de evidencia",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "Admite GitHub, GitLab, Gitee y servicios internos de Git",
    "知识库": "base de conocimientos",
    "知识库 &middot; Knowledge Base": "Base de conocimientos · Base de conocimientos",
    "正在加载组织额度…": "Cargando cuota de organización...",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "Este es el modo de colaboración más potente de NovaX. Puede hacer que varios agentes se hagan cargo de completar tareas complejas en la misma conversación:",
    "支付功能正在准备中": "Se está preparando la función de pago.",
    "知识库为空": "La base de conocimientos está vacía.",
    "知识库文档": "Documentación de la base de conocimientos",
    "知识库暂无共享文档。": "Actualmente no hay documentos compartidos en la base de conocimientos.",
    "知识库（Memory）— 共享大脑": "Base de conocimientos (memoria): cerebro compartido",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "Una base de conocimientos es un depósito de documentos compartido a nivel de organización. Cada documento de Markdown que cargue se convertirá en conocimiento común de todos los agentes de la organización. Adecuado para:",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "Una base de conocimientos es un depósito de documentos compartido a nivel de organización. Todos los agentes harán referencia automáticamente a los documentos cargados al responder, lo que equivale a dotar a todos los agentes de conocimientos previos.",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "Los documentos cargados en la base de conocimientos se almacenan localmente en el servidor y solo los agentes de su organización pueden leerlos.",
    "执行层：谁根据它采取行动": "Capa ejecutiva: quién actúa en base a ella",
    "执行命令": "ejecutar comando",
    "执行频率": "Frecuencia de ejecución",
    "执行任务": "realizar tareas",
    "执行时间": "tiempo de ejecución",
    "执行时间：": "Tiempo de ejecución:",
    "执行异常": "excepción de ejecución",
    "执行指令": "Ejecutar instrucciones",
    "执行中": "ejecutando",
    "只读查询": "consulta de solo lectura",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "La conexión de solo lectura a Gmail, QQ, 163 o al buzón IMAP empresarial que admite código de autorización le permite al Agente buscar y ordenar correos electrónicos reales.",
    "只读收件箱": "bandeja de entrada de solo lectura",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "Los documentos cargados en la base de conocimientos se almacenan localmente en el servidor y solo los agentes de su organización pueden leerlos.",
    "指": "referirse a",
    "指标": "índice",
    "指标 / 维度": "Métricas/Dimensiones",
    "指标不是一个数字": "Un indicador no es un número",
    "指标层：数字怎么计算": "Capa indicadora: cómo calcular números",
    "指标查询": "Consulta de indicador",
    "指标观测": "observación del indicador",
    "指标口径": "Calibre índice",
    "指标目录": "Catálogo de indicadores",
    "指标网络": "red de indicadores",
    "指标已映射": "Métricas asignadas",
    "指标异动与影响分析": "Cambios de indicadores y análisis de impacto.",
    "指标值 *": "Valor del indicador *",
    "至少需要两个周期": "Se requieren al menos dos ciclos.",
    "置信度": "Confianza",
    "置信度 ·": "Confianza ·",
    "终点 *": "Punto final *",
    "终端运行": "Ejecución de terminales",
    "种类型": "tipo",
    "重复任务": "repetir tareas",
    "重新尝试": "Intentar otra vez",
    "重新加载": "recargar",
    "重要规则": "Reglas importantes",
    "周末": "fin de semana",
    "主持人:": "anfitrión:",
    "主持人：": "anfitrión:",
    "主动来到你面前": "Toma la iniciativa de venir a ti.",
    "中": "medio",
    "注入": "inyección",
    "只有组织所有者可以购买套餐或充值额度。": "Sólo el propietario de la organización puede comprar planes o créditos.",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "La dirección de correo electrónico requerida para el registro solo se utiliza para la verificación de la cuenta y el inicio de sesión, y no se utilizará para marketing ni se transferirá a terceros.",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "Después de cerrar sesión, su cuenta, historial de chat y todos los datos se eliminarán permanentemente y no podrán recuperarse.",
    "注销账号": "Cancelar cuenta",
    "转发": "Adelante",
    "转发到": "adelante a",
    "转写已完成，可生成纪要": "La transcripción se ha completado y se pueden generar actas.",
    "转写中": "Transcribiendo",
    "状态": "estado",
    "字段": "Campo",
    "字段名称": "Nombre del campo",
    "自定义类型": "Tipo personalizado",
    "自定义名称、描述和人格": "Personaliza el nombre, la descripción y la personalidad.",
    "自定义周期": "Ciclo personalizado",
    "自动响应指定聊天中的消息": "Responder automáticamente a mensajes en un chat específico",
    "自动应答": "Respuesta automática",
    "自动转写生成纪要": "Transcribe y genera actas automáticamente",
    "自适应卡片": "tarjeta adaptativa",
    "组": "Grupo",
    "组件理解": "Comprensión de componentes",
    "注销中...": "Cerrar sesión...",
    "自定义界面显示偏好": "Personalizar las preferencias de visualización de la interfaz",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "La dirección de correo electrónico requerida para el registro solo se utiliza para la verificación de la cuenta y el inicio de sesión, y no se utilizará para marketing ni se transferirá a terceros.",
    "组织编辑人数": "Número de editores en la organización.",
    "组织变动": "cambios organizacionales",
    "组织": "organizar",
    "组织存储": "Organizar el almacenamiento",
    "组织洞察": "conocimientos organizacionales",
    "组织（Workspace）— 协作空间": "Organización (espacio de trabajo): espacio de colaboración",
    "组织里的某一位 Agent": "Un agente en la organización.",
    "组织成员和自动任务的消费都会记录在这里。": "Aquí se registrará el consumo de miembros de la organización y las tareas automáticas.",
    "组织名称": "Nombre de la organización",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "Una organización es un espacio de colaboración independiente, similar al Workspace de Slack o al Team de Feishu. Todos los miembros de una organización comparten el mismo conjunto de agentes y base de conocimientos. puede:",
    "组织文档数": "Número de documentos de la organización.",
    "组织信号": "señales organizacionales",
    "组织共享额度": "Cuota de uso compartido de la organización",
    "组织内所有成员共享使用": "Compartido por todos los miembros de la organización.",
    "组织所有者": "Propietario de la organización",
    "组织与执行": "Organización y Ejecución",
    "组织知识库": "base de conocimiento organizacional",
    "组织知识库日志": "Registro de la base de conocimientos de la organización",
    "组织执行": "Ejecución organizacional",
    "最多展开 3 跳": "Ampliar hasta 3 saltos",
    "最多追溯 3 跳": "Rastree hasta 3 saltos",
    "组织与多租户": "Organización y multitenencia",
    "最后更新：2026 年 5 月": "Última actualización: mayo de 2026",
    "最近更新": "Últimas actualizaciones",
    "最近观测": "observaciones recientes",
    "最後更新：2026 年 5 月": "Última actualización: mayo de 2026",
    "组织与团队管理": "Organización y gestión de equipos.",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "El enlace mínimo utilizable requiere sólo cuatro objetos. Comience con el indicador central al que presta atención todos los días y luego complételo gradualmente. No es necesario diseñar toda la empresa desde el principio.",
    "最新观测": "Últimas observaciones",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "A la izquierda están los posibles impulsores o fuentes de cálculo, y a la derecha, a qué afecta el indicador.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "Como PEN_AGENT_API_KEY, solo se pasa a este proceso Pencil local.",
    "最近用量": "uso reciente",
    "作为个人练手 Demo 项目，我们": "Como proyecto de demostración de entrenamiento personal,",
    "作為個人練手 Demo 專案，我們": "Como proyecto de demostración de práctica personal,",
    "Agent 会怎样使用": "Cómo se utilizará el agente",
    "Agent — 你的 AI 团队成员": "Agente: miembro de su equipo de IA",
    "Agent 级别": "Nivel de agente",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "Una vez iniciado el Agente, se conectará automáticamente. El estado a continuación se volverá verde y podrá comenzar a usarlo.",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "El agente crea automáticamente tareas cron. Los resultados de la ejecución aparecen en la conversación como mensajes. Puede pausar, reanudar o eliminar tareas creadas en la pestaña Tareas.",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "El agente puede crear tareas en segundo plano que se ejecutan periódicamente sin que usted tenga que activarlas manualmente. Cambie a la pestaña \"Tareas\" en la parte superior de la interfaz de conversación para ver y administrar.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "El agente es la unidad central de NovaX. Cada Agente es un asistente de IA independiente con su propio:",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "Agent no sólo se puede utilizar en la página web de NovaX, sino que también se puede conectar a plataformas externas de mensajería instantánea. Una vez conectados, los agentes comparten el mismo conjunto de recuerdos, habilidades y base de conocimientos en todas las plataformas.",
    "Agent 在对话中输出的文件会显示在这里": "Los archivos generados por el Agente en la conversación se mostrarán aquí",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agente es el concepto central de NovaX. A diferencia de los chatbots tradicionales, cada Agente es un agente con",
    "Agent 周报": "Agente semanal",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Los agentes hacen referencia automáticamente a estos documentos al responder preguntas, lo que garantiza que las respuestas se ajusten a las normas y el contexto del equipo.",
    "AI 图像生成": "Generación de imágenes de IA",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "El Agente ejecuta automáticamente la solicitud después de recibirla y envía el resultado a la conversación.",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "El contenido generado por AI puede contener errores o información inexacta, haga su propio juicio y verificación.",
    "DOWNSTREAM · 下游": "ABAJO · Aguas abajo",
    "ETL 血缘": "linaje ETL",
    "Git 仓库": "repositorio git",
    "Git 用户名；GitHub App 可填 x-access-token": "nombre de usuario de Git; La aplicación GitHub puede completar x-access-token",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ y 163 generalmente necesitan habilitar IMAP primero y crear una contraseña o un código de autorización específicos de la aplicación.",
    "IMAP 地址": "dirección IMAP",
    "Notion 工作区": "Espacio de trabajo de nociones",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "El contenido generado por IA puede contener errores o información inexacta; haga su propio juicio y verificación.",
    "Codex 智能体底座": "Base del cuerpo inteligente Codex",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Representación en formato Markdown, incluido resaltado de código, tablas, listas, etc.",
    "Nova 点": "punto nova",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX adopta una arquitectura multiinquilino basada en organizaciones (Workspaces). Cada organización es un espacio de colaboración completamente independiente y los agentes, las bases de conocimientos, las habilidades, los miembros y los datos de las conversaciones están todos aislados.",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX rastrea los datos y los impulsores comerciales hacia arriba e identifica objetivos, procesos e impactos en la ejecución hacia abajo.",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "La interfaz de NovaX consta de una barra de navegación a la izquierda y un área de contenido principal a la derecha. La barra de navegación proporciona cinco entradas principales:",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "Todos los agentes de NovaX se ejecutan uniformemente en OpenAI Codex y utilizan",
    "NovaX 是一个": "NovaX es un",
    "NovaX 是什么": "¿Qué es NovaX?",
    "NovaX 是一個": "NovaX es un",
    "NovaX Agent 工作区": "Espacio de trabajo del agente NovaX",
    "PG 思维": "Pensamiento PG",
    "Prompt 模板": "plantilla de aviso",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Plantilla de aviso, usando {{payload}} para representar los datos recibidos",
    "QQ 邮箱": "buzón QQ",
    "S3 兼容地址（AWS S3 可留空）": "Dirección compatible con S3 (AWS S3 se puede dejar en blanco)",
    "Schema 浏览": "Exploración de esquemas",
    "secret_... 或 ntn_...": "secreto_... o ntn_...",
    "Session Token（可选）": "Token de sesión (opcional)",
    "Skill 市场": "Mercado de habilidades",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX es una plataforma de colaboración de IA de múltiples agentes. Puede considerarlo como un banco de trabajo de un equipo de IA: aquí se crean múltiples agentes de IA, cada uno con su propio nombre, personalidad, experiencia y espacio de trabajo. Pueden leer y escribir archivos, ejecutar código, buscar en la web, administrar tareas y trabajar juntos como miembros reales de un equipo.",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX admite estructuras multiorganizativas. Las organizaciones se pueden administrar en \"Configuración → General\":",
    "Soul 人设指令": "Comando del personaje del alma",
    "Shift+Enter 换行，Enter 发送。": "Mayús+Intro para ajustar la línea, Intro para enviar.",
    "SQL 数据库": "base de datos SQL",
    "SSH 私钥": "clave privada SSH",
    "Thread 回复": "Respuesta del hilo",
    "TLS 加密": "Cifrado TLS",
    "Token 用量榜": "Lista de uso de tokens",
    "UPSTREAM · 上游": "ARRIBA · aguas arriba",
    "Web 设计工程师": "ingeniero de diseño web",
    "Webhook 名称，如 GitHub Push...": "Nombre del webhook, como GitHub Push...",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "El alma es el elemento de configuración más importante del Agente. Determina el posicionamiento de roles, las áreas de especialización y el comportamiento del Agente. Escribir bien Soul es la clave para que Agent sea realmente útil.",
    "Soul（人设指令）": "Alma (comando de la personalidad)",
    "Webhook URL（含 Secret）": "URL de webhook (incluido el secreto)",
    "Webhook 事件触发": "Activador de evento de webhook",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook permite que los sistemas externos activen tareas de ejecución del Agente a través de solicitudes HTTP y es adecuado para interactuar con CI/CD, monitorear alarmas, enviar formularios y otros sistemas."
  },
  "ptBR": {
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— Visualize as tarefas em segundo plano executadas pelo Agente, incluindo progresso, status e resultados.",
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— Mude para uma organização diferente com um clique, e o agente e a base de conhecimento mudarão de acordo.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— Visualize agentes e membros da sua organização, crie novos agentes ou convide novos membros.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— Definir a personalidade, experiência e comportamento do Agente. Por exemplo, você pode criar um Agente \"Revisor de Código\" para focar na qualidade do código e, em seguida, criar um Agente \"Gerente de Produto\" para torná-lo bom na análise de requisitos.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "—Dar reconhecimento ao agente para facilitar a diferenciação em cenários multiagentes.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— Diga ao Agente quem é e em que se especializa.",
    "— 个人偏好、组织管理、账号安全。": "—Preferências pessoais, gerenciamento organizacional e segurança da conta.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— Gerencie as habilidades instaladas do Agente ou instale novas habilidades do mercado.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— Qual formato, estilo e etapas devem ser seguidos ao responder.",
    "— 管理共享文档，上传和浏览 .md 文件。": "— Gerencie documentos compartilhados, carregue e navegue em arquivos .md.",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— Pode gerenciar agentes, bases de conhecimento e membros, mas não pode modificar as configurações da organização.",
    "— 接入 Zoom 会议或聊天。": "— Participe de uma reunião ou bate-papo do Zoom.",
    "— 浏览和安装技能，管理已发布的技能。": "— Procure e instale habilidades e gerencie habilidades publicadas.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— Você pode usar o Agent, participar de conversas e acessar a base de conhecimento, mas não pode realizar operações de gerenciamento.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— Dê ao agente a capacidade de criar e gerenciar tarefas agendadas.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— Permitir que o Agente defina tarefas agendadas ou periódicas, como gerar relatórios todas as manhãs.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— Permitir que Agentes liguem para outros Agentes para obter colaboração entre Agentes.",
    "— 让 Agent 能够自动生成和发布新技能。": "— Permita que os agentes gerem e publiquem automaticamente novas habilidades.",
    "— 什么该做，什么不该做。": "— O que fazer e o que não fazer.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— Permitir que os próprios Agentes criem novas habilidades e as publiquem no mercado para uso de outras instalações do Agente.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— O proprietário tem permissões totais, os administradores podem gerenciar Agentes e membros, e membros comuns podem usar Agentes e bases de conhecimento.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "—Crie um Bot através do BotFather e preencha o Bot Token para conectar.",
    "— 通过 Telegram Bot 接入。": "— Acesso via Telegram Bot.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— Acesso através do iLink para interagir com o Agente no WeChat.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— Expanda os limites de capacidade do agente instalando diferentes habilidades.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Fale com o Agente diretamente em Feishu através do robô Feishu.",
    "— 通过企业微信或 iLink 接入。": "— Acesso via Business WeChat ou iLink.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— Registros de bate-papo com agente suportam saída de streaming em tempo real.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "— Tem permissões totais para gerenciar configurações, membros e agentes da organização. Cada organização tem apenas um proprietário.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— A interface principal para comunicação com Agentes, com a lista de Agentes à esquerda e a janela de chat à direita.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— Convide membros para ingressar na organização atual por e-mail na página \"Equipe\".",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— Permitir que os Agentes liguem para outros Agentes no espaço de trabalho para implementar pipelines automatizados entre Agentes. Por exemplo, após o Agente A concluir a análise, ele transfere automaticamente os resultados para o Agente B para gerar um relatório.",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— Navegue por todas as habilidades disponíveis no \"Skill Market\" na barra de navegação e veja detalhes e instruções de instalação.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— Na aba \"Habilidades\" da interface de diálogo, instale ou desinstale as habilidades do Agente atual. Agentes diferentes podem ter conjuntos de habilidades diferentes instalados.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Crie um aplicativo na plataforma aberta Feishu, obtenha o App ID e o App Secret e acesse-o. Os membros da equipe podem conversar diretamente com o Agente no Feishu.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— O Agente pode ler e gravar arquivos e executar código no diretório do sistema de arquivos especificado. Diferentes Agentes podem operar diferentes diretórios de projetos.",
    "— 最多可创建 2 个组织。": "— Pode criar até 2 organizações.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": ", não tem fins lucrativos, não cobrará nenhuma taxa dos usuários e não realizará promoções comerciais ou vendas de qualquer forma.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": ", sem fins lucrativos, não cobrará nenhuma taxa dos usuários e não realizará promoções comerciais ou vendas de qualquer forma.",
    "、": ",",
    ".pen 文件": "arquivo .pen",
    "· 点击启用": "· Clique para ativar",
    "· 点击召唤": "· Clique para convocar",
    "· 用于 Agent 理解": "· Usado para compreensão do Agente",
    "，同时可以被邀请加入他人的组织。": "e pode ser convidado a ingressar em organizações de outras pessoas.",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": ", é usado apenas para demonstrar a viabilidade técnica da plataforma de colaboração de IA multiagente. Este produto",
    "@提及": "@menções",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": ", é usado apenas para demonstrar a viabilidade técnica da plataforma de colaboração de IA multiagente. Este produto",
    "（一次性延时任务）": "(Tarefa atrasada uma vez)",
    "（由 Soul 指令定义）": "(definido pela diretiva Soul)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst Com base nos dados acima, faça uma análise do cenário competitivo",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer Organize a análise acima em um relatório PDF",
    "← 返回": "← Retorno",
    "← 返回列表": "← Voltar à lista",
    "← 返回详情": "← Voltar aos detalhes",
    "@提及机制": "Mecanismo de @menção",
    "/ 月": "/ lua",
    "+ 记录": "+ registro",
    "+ 添加": "+ adicionar",
    "✓ 反馈已提交，感谢您的意见！": "✓ O feedback foi enviado, obrigado pela sua opinião!",
    "✓ 已连接": "✓ Conectado",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher Pesquise os dados do mercado externo de veículos de nova energia em 2024",
    "163 邮箱": "163 E-mail",
    "+ 创建新组织": "+ Criar nova organização",
    "1. 产品性质": "1. Natureza do produto",
    "2 个组织": "2 organizações",
    "1. 產品性質": "1. Natureza do produto",
    "2. 数据与隐私": "2. Dados e privacidade",
    "2. 資料與隱私": "2. Dados e privacidade",
    "30 分钟后提醒我开会": "Lembre-me de uma reunião em 30 minutos",
    "3. 第三方服务": "3. Serviços de terceiros",
    "3. 第三方服務": "3. Serviços de terceiros",
    "5. 免责声明": "5. Isenção de responsabilidade",
    "4. 服務可用性": "4. Disponibilidade do serviço",
    "5. 免責聲明": "5. Isenção de responsabilidade",
    "4. 服务可用性": "4. Disponibilidade do serviço",
    "安装方式": "Método de instalação",
    "安装给以下 Agent：": "Instalado nos seguintes Agentes:",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "Conecte o Agent à plataforma de mensagens instantâneas que sua equipe está usando e tenha conversas diretas em chats em grupo ou privados.",
    "把世界级设计标准": "Trazendo padrões de design de classe mundial",
    "把指标接回真实数据": "Conecte os indicadores aos dados reais",
    "保存对象": "salvar objeto",
    "保存失败": "Falha ao salvar",
    "保存修改": "Salvar alterações",
    "保存中...": "Salvando...",
    "保存中…": "Salvando…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "O relatório resume regularmente o uso do NovaX por toda a organização e também descobre insights de negócios dignos de atenção com base em dados subjacentes, como bancos de dados, BI, Git e caixas de correio às quais a organização está conectada.",
    "被移出了组织": "Removido da organização",
    "6. 联系方式": "6. Informações de contato",
    "安装不同的": "Instale diferentes",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "Este produto não é adequado para cenários profissionais, como aconselhamento médico, consulta jurídica e tomada de decisões financeiras.",
    "6. 聯絡方式": "6. Informações de contato",
    "本次分析提示": "Dicas para esta análise",
    "本期 SKILL": "HABILIDADE nesta questão",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "Ontologia não é outra base de conhecimento. Ele conecta os objetos, indicadores, dados e responsáveis ​​do negócio em um mapa razoável, permitindo ao Agente não apenas “encontrar informações”, mas também saber de onde vem um número, por que ele muda e qual o impacto que terá.",
    "本体加载失败": "Falha no carregamento da ontologia",
    "本体视图": "visão da ontologia",
    "本体完整度": "Integridade ontológica",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "A ontologia salva apenas a estrutura e o calibre, e as credenciais do banco de dados são gerenciadas pelo conector ou variáveis ​​de ambiente e não entram no gráfico de negócios.",
    "本月": "este mês",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "Compare os valores de observação do indicador e siga o cálculo e a linhagem dos dados para descobrir em qual camada ocorreu a mudança.",
    "必填": "Obrigatório",
    "避免把相关性误判为因果": "Evite confundir correlação com causalidade",
    "编辑": "editar",
    "编辑定义": "Editar definição",
    "编辑对象": "Editar objeto",
    "编辑了 Agent": "Agente editado",
    "编辑业务对象": "Editar objeto de negócios",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "Este produto não é adequado para cenários profissionais, como aconselhamento médico, consulta jurídica e tomada de decisões financeiras.",
    "标识（可选）": "Logotipo (opcional)",
    "标题": "título",
    "表、视图、ETL 模型": "Tabelas, visualizações, modelos ETL",
    "补充口径、边界或业务背景": "Suplemento de calibre, limite ou contexto de negócios",
    "补充驱动关系": "Relação de condução complementar",
    "补充影响关系": "Relação de influência suplementar",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "Este produto chama o serviço OpenAI Codex para lidar com a solicitação de conversa. O conteúdo das suas conversas será processado de acordo com a política de privacidade desse serviço. Recomenda-se evitar inserir informações pessoais confidenciais nas conversas.",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "Este produto chama o serviço OpenAI Codex para processar solicitações de conversa. O conteúdo das suas conversas será processado de acordo com a política de privacidade desse serviço. Recomenda-se evitar inserir informações pessoais confidenciais nas conversas.",
    "不保证": "Sem garantia",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "Escrever Alma – Este é o passo mais crucial. Soul determina como o Agente entende as tarefas e responde às perguntas. Quanto mais específico for escrito, melhor será o desempenho do Agente.",
    "不保證": "Sem garantia",
    "不会用于商业化运营": "Não será usado para operações comerciais",
    "不会主动收集": "Não coletará ativamente",
    "不會用於商業化營運": "Não será usado para operações comerciais",
    "不會主動收集": "Não coletará ativamente",
    "参会者": "Participantes",
    "参与聚合、关联和过滤的列": "Colunas envolvidas na agregação, associação e filtragem",
    "仓库地址": "Endereço do armazém",
    "仓库协作": "colaboração em armazém",
    "草稿": "rascunho",
    "策": "política",
    "查看": "Verificar",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "Ao contrário das ferramentas comuns de conversação de IA, o Agente da NovaX possui memória persistente, habilidades instaláveis, suporta colaboração entre várias pessoas e pode se conectar a plataformas de mensagens instantâneas como Feishu, Telegram e WeChat para integrar IA em seu fluxo de trabalho diário.",
    "查看全部模型 →": "Veja todos os modelos →",
    "查看它负责哪些指标、目标或业务流程。": "Veja por quais métricas, metas ou processos de negócios ele é responsável.",
    "查看完整影响路径": "Veja o caminho completo do impacto",
    "查找文件": "Encontre arquivos",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "Agentes diferentes podem ter Almas completamente diferentes. Por exemplo, uma equipe pode ter vários agentes com funções diferentes, como “pesquisador”, “escritor” e “revisor de código” ao mesmo tempo.",
    "查看每个技能的功能说明、安装量和评分。": "Veja descrições de recursos, instalações e classificações para cada habilidade.",
    "产品 PRD、技术架构文档": "Produto PRD, documentos de arquitetura técnica",
    "产品文档和技术架构": "Documentação do produto e arquitetura técnica",
    "常见问题和标准回答": "Perguntas frequentes e respostas padrão",
    "成员（Member）": "Membro",
    "抽出一位大师的思维，": "Extraia os pensamentos de um mestre,",
    "成员 / Agent": "Membro/Agente",
    "常见问题和解答模板": "Modelo de perguntas frequentes",
    "处理事件": "lidar com eventos",
    "触发次数": "Número de gatilhos",
    "创建": "criar",
    "创建 Agent": "Criar agente",
    "创建 Webhook": "Criar webhook",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "Após a criação de um webhook, sistemas externos (GitHub, Stripe, Sentry, etc.) podem ser acionados automaticamente via HTTP POST",
    "创建第一个指标": "Crie seu primeiro indicador",
    "创建核心指标": "Crie indicadores principais",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "Além da interface web, o Agente da NovaX também pode se conectar a plataformas de mensagens instantâneas:",
    "创建会议": "Criar reunião",
    "创建了 Agent": "Agente criado",
    "创建类型": "Criar tipo",
    "创建你的第一个 Agent": "Crie seu primeiro Agente",
    "创建企业自建应用，获取凭证": "Crie um aplicativo empresarial autoconstruído e obtenha credenciais",
    "创建失败": "Falha na criação",
    "创建时间": "hora de criação",
    "创建中...": "Criando...",
    "创建中…": "Criando…",
    "创建组织": "Crie uma organização",
    "成员与权限": "Membros e permissões",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "Após a criação, o sistema gera uma URL e uma chave exclusivas, que podem ser acionadas por um sistema externo enviando uma solicitação POST para a URL.",
    "创刊导读": "Introdução à fundação da publicação",
    "创作与协作": "Crie e colabore",
    "此文件类型暂不支持预览": "Este tipo de arquivo não suporta visualização no momento",
    "次": "Segunda categoria",
    "从 160+ 专业角色模板中选择": "Escolha entre mais de 160 modelos de funções profissionais",
    "从数据到行动的业务地图": "Mapeamento de negócios dos dados à ação",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "Determine a semântica exata da mesma palavra dentro da empresa a partir das definições de objeto de negócios e métricas.",
    "从业务世界的第一个对象开始": "Comece com o primeiro objeto do mundo dos negócios",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "Comece com a receita, o volume de pedidos, as taxas de conversão ou os resultados de negócios que mais lhe interessam.",
    "从预设创建": "Criar a partir da predefinição",
    "代码读取": "leitura de código",
    "待开始": "Para ser iniciado",
    "待认领": "Para ser reivindicado",
    "大": "grande",
    "持久记忆": "memória duradoura",
    "待验证": "Para ser verificado",
    "单次任务": "tarefa única",
    "单次执行": "execução única",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "Quando você solicita métricas, linhagem, atribuição ou impacto, o NovaX Agent primeiro lê o contexto da ontologia relevante. A base de conhecimento fornece “texto original e histórico”, e a ontologia fornece “estrutura de negócios determinada”, e os dois podem ser relacionados por meio de evidências.",
    "当前仅支持 .md 格式": "Atualmente apenas o formato .md é suportado",
    "当前值": "valor atual",
    "当前": "atual",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "Registre bancos de dados, tabelas de dados e campos-chave e, em seguida, use \"linhagem de dados\" ou \"dependência de cálculo\" para conectar-se aos indicadores. No futuro, quando o Agente for questionado sobre o calibre, ele poderá encontrar a verdadeira fonte através do link, em vez de adivinhar com base no documento.",
    "登记数据来源": "Registrar fontes de dados",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "Registre fontes de dados, tabelas e campos e, em seguida, conecte-se a indicadores usando relacionamentos de \"linhagem de dados\" ou \"dependência de cálculo\".",
    "登记数据资产": "Registrar ativos de dados",
    "登录账号": "Conta de login",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "Crie até 2 organizações, uma para projetos ou equipes diferentes.",
    "等待 Agent 连接...": "Aguardando a conexão do agente...",
    "等待连接成功": "Aguarde a conexão bem-sucedida",
    "等待确认": "Aguardando confirmação",
    "等待扫码...": "Aguardando digitalização...",
    "等待中": "Esperando",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "Edição 1 · Compilado pela sua equipe de agentes · Esta edição",
    "登录状态已失效，请重新登录": "O status de login expirou, faça login novamente",
    "待上线": "Estar on-line",
    "第二步：认识你的界面": "Etapa 2: Conheça sua interface",
    "的 AI 协作者。": "de colaboradores de IA.",
    "第三步：创建你的第一个 Agent": "Etapa 3: crie seu primeiro agente",
    "第一期正在准备中": "A primeira edição está sendo preparada",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "Clique em “Gerar código QR” e o sistema iniciará o processo de login na página web do WeChat.",
    "点击「生成二维码」获取微信登录码": "Clique em \"Gerar código QR\" para obter o código de login do WeChat",
    "点击连接，系统自动完成配置": "Clique em Conectar e o sistema conclui automaticamente a configuração.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "Clique no botão abaixo para acessar a plataforma aberta do Feishu e o sistema criará automaticamente um aplicativo criado por você mesmo para você.",
    "第四步：开始对话": "Etapa 4: inicie uma conversa",
    "点": "apontar",
    "钉钉": "DingTalk",
    "定时任务": "tarefas agendadas",
    "定位变化": "Mudanças de posicionamento",
    "定义第一个核心指标": "Defina o primeiro indicador principal",
    "定义核心指标": "Defina as principais métricas",
    "定义业务类型": "Defina o tipo de negócio",
    "定义这个 Agent 的性格、指令和能力...": "Defina a personalidade, os comandos e as habilidades deste Agente...",
    "定义证据": "Definir evidências",
    "定义指标口径": "Definir calibre do indicador",
    "第五步：丰富 Agent 的知识": "Passo 5: Enriquecer o conhecimento do Agente",
    "第一步：注册和登录": "Passo 1: Registre-se e faça login",
    "调整对话消息流中的文字大小": "Ajustar o tamanho do texto no fluxo da conversa",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Leia a estrutura do arquivo Figma, componentes e comentários para permitir que o Agente entenda o design da interface, as especificações do design e o feedback colaborativo.",
    "读取内容": "Leia o conteúdo",
    "读取网页": "Ler páginas da web",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "Depois de lê-lo, você pode ir direto ao diálogo e continuar a fazer perguntas sobre causas, impactos e próximos passos.",
    "端口": "porta",
    "断开连接": "Desconectar",
    "断开失败": "Falha na desconexão",
    "定时任务（MetaSchedule）": "Tarefas agendadas (MetaSchedule)",
    "独立身份、独立记忆、独立技能": "Identidade independente, memória independente, habilidades independentes",
    "对话": "diálogo",
    "对象": "objeto",
    "对象存储": "armazenamento de objetos",
    "对象类型 *": "Tipo de objeto *",
    "对象列表": "lista de objetos",
    "对象已连接": "O objeto está conectado",
    "对象已删除": "Objeto excluído",
    "对应 Agent 暂不可用": "O Agente correspondente está temporariamente indisponível",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "Vários arquivos são separados por vírgulas; se deixado em branco, será utilizado o intervalo visível do próprio Token.",
    "多媒体": "multimídia",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "A conversa é o principal método de interação da NovaX. Cada Agente mantém um histórico de conversas independente. Na interface de conversa, existem três guias na parte superior:",
    "多人": "várias pessoas",
    "多维表格": "mesa multidimensional",
    "多 Agent 接力": "Retransmissão multiagente",
    "多平台连接": "Conectividade multiplataforma",
    "对话系统": "Sistema de diálogo",
    "额度信息加载失败": "Falha ao carregar informações de cota",
    "二": "dois",
    "二维码已过期，请重新生成": "O código QR expirou, gere-o novamente",
    "发起会议": "Iniciar uma reunião",
    "发送人": "remetente",
    "发送时间": "Hora de envio",
    "翻开 →": "Abrir →",
    "反馈": "opinião",
    "反馈中心": "Centro de Feedback",
    "返回": "retornar",
    "方向": "direção",
    "方向未知": "direção desconhecida",
    "访问 Token": "Token de acesso",
    "飞书 / Lark": "Feishu/Cotovia",
    "飞书开放平台": "Plataforma aberta Feishu",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "O aplicativo Feishu foi criado. Adicione o Bot ao Grupo Feishu para começar a usá-lo.",
    "费曼思维": "Feynman pensando",
    "分析对象": "Objeto de análise",
    "分析思路": "Ideias analíticas",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "A cota é compartilhada pelos membros da organização e todo o consumo é deduzido da organização atual.",
    "额度与账单": "Limite de crédito e fatura",
    "分钟": "minuto",
    "否": "não",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "O servidor primeiro verificará a chave CLI do Pencil. A geração de design é corrigida usando Codex 5.6 sol · high e opera apenas em arquivos .pen no espaço de trabalho atual do Agente.",
    "服务器已连接，等待 Bot 上线...": "O servidor está conectado, aguardando o Bot ficar online...",
    "分析完成后：": "Após a conclusão da análise:",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "A disponibilidade contínua, estabilidade ou durabilidade dos dados do Serviço. O Serviço pode ser suspenso, alterado ou encerrado a qualquer momento sem aviso prévio. Não utilize este produto em um ambiente de produção ou para armazenar dados importantes.",
    "负向": "Negativo",
    "负责人": "responsável",
    "复制": "cópia",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "Copie o seguinte comando para o terminal e execute-o. O Agente se conectará automaticamente ao servidor NovaX.",
    "富文本卡片": "Cartão de texto rico",
    "覆盖确认": "Confirmação de cobertura",
    "刚刚": "apenas",
    "额外额度": "Crédito extra",
    "个": "individual",
    "个对象": "objetos",
    "个可用技能": "habilidades disponíveis",
    "个人存储": "armazenamento pessoal",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "DISPONIBILIDADE CONTÍNUA, ESTABILIDADE OU DURABILIDADE DE DADOS DOS SERVIÇOS. O Serviço pode ser suspenso, alterado ou encerrado a qualquer momento sem aviso prévio. Não utilize este produto em um ambiente de produção ou para armazenar dados importantes.",
    "个人文档数": "Número de documentos pessoais",
    "个人知识库日志": "Registro da base de conhecimento pessoal",
    "个属性": "atributos",
    "个已有来源": "fontes existentes",
    "个字段": "campos",
    "格式文档，上传后立即生效。": "Documento de formato, com efeito imediato após o upload.",
    "个人练手的技术演示项目（Demo）": "Projeto de demonstração técnica (Demo) para prática pessoal",
    "给任务取个名字...": "Dê um nome à tarefa...",
    "更新计划": "Plano de atualização",
    "工作区标识（可选）": "ID do espaço de trabalho (opcional)",
    "工作区名称（可选）": "Nome do espaço de trabalho (opcional)",
    "工作日": "dias úteis",
    "工作通知": "aviso de emprego",
    "公开仓库（无需凭据）": "Repositório público (sem necessidade de credenciais)",
    "公式、单位、粒度与负责人": "Fórmula, unidade, granularidade e responsável",
    "個人練手的技術展示專案（Demo）": "Projeto de demonstração de tecnologia de prática pessoal (Demo)",
    "供 Pencil 内的 Codex Agent 使用": "Para uso do Codex Agent no Pencil",
    "共同规则": "regras comuns",
    "共同记忆": "memória compartilhada",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "Atualmente não há documentos que possam ser associados à base de conhecimento compartilhada. Você pode adicionar evidências após salvar.",
    "关闭": "encerramento",
    "关闭简报": "Fechar apresentação",
    "关闭上传选择": "Fechar seleção de upload",
    "关闭使用引导": "Fechar guia de uso",
    "关闭消息导航": "Desative a navegação de mensagens",
    "关键字段": "Campos-chave",
    "关系名称": "nome do relacionamento",
    "关系说明": "Descrição do relacionamento",
    "关系有证据": "Há evidências de relacionamento",
    "关系证据": "evidência de relacionamento",
    "观测日期": "Data de observação",
    "观测值已删除": "Observação excluída",
    "观远 BI": "Guanyuan BI",
    "观远 BI 地址": "Endereço BI de Guanyuan",
    "观远 BI 密码": "Senha do BI Guanyuan",
    "管理": "gerenciar",
    "工作原理": "Princípio de funcionamento",
    "工作目录": "diretório de trabalho",
    "功能详解": "Explicação detalhada da função",
    "规划中": "Em planejamento",
    "国内平台": "Plataforma doméstica",
    "管理员（Admin）": "Administrador",
    "还没有积累私有记忆": "Nenhuma memória privada foi acumulada ainda",
    "还没有上游驱动": "Ainda não há driver upstream",
    "还没有数据血缘": "Nenhuma linhagem de dados ainda",
    "还没有下游影响": "Nenhum efeito downstream ainda",
    "还没有血缘关系。": "Ainda não há relação de sangue.",
    "还没有执行对象": "Nenhum objeto de execução ainda",
    "还没有指标": "Ainda não há indicadores",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "Você também precisa compartilhar a página de destino com esta integração no Notion.",
    "海外平台": "Plataforma internacional",
    "核心指标": "indicadores principais",
    "环比变化": "Mudança mês a mês",
    "恢复": "recuperar",
    "会话文件": "arquivo de sessão",
    "会议 ·": "Reunião ·",
    "会议集成": "Integração de conferência",
    "会议纪要": "ata da reunião",
    "会议链接或 ID": "Link ou ID da reunião",
    "会议密码:": "Senha da reunião:",
    "会议时长（分钟）": "Duração da reunião (minutos)",
    "会议主题": "Tema da conferência",
    "活跃": "ativo",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Verifique a conexão com base no GuanCLI oficial de Guanyuan. Após a conexão, podem ser lidas páginas, cartões, conjuntos de dados, ETL, indicadores e ChatBI. A criação, modificação e exclusão não são permitidas por padrão.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "Com base no protocolo WeChat iLink, o Agente pode enviar e receber mensagens privadas diretamente após escanear o código QR. Recomenda-se usar uma conta WeChat dedicada como operadora do Agente.",
    "即将推出": "em breve",
    "计算 / 映射表达式": "Expressões de cálculo/mapeamento",
    "计算、影响与责任关系": "Cálculo, Impacto e Responsabilidade",
    "计算公式": "Fórmula de cálculo",
    "计算口径": "Calcular calibre",
    "记录定义、口径或事实所在位置": "Definição de registro, calibre ou localização factual",
    "记录两个以上周期": "Grave mais de dois ciclos",
    "记录两个周期的数据后即可比较变化。": "As alterações podem ser comparadas após registrar dados de dois períodos.",
    "记录数值": "valor recorde",
    "记录中…": "Gravação…",
    "还没有产生额度消费": "Nenhuma cota de consumo foi incorrida ainda",
    "纪要": "resumo",
    "记住与你的所有历史对话（": "Lembre-se de todas as conversas históricas com você (",
    "核心内置技能": "Habilidades básicas integradas",
    "技能": "Habilidade",
    "核心概念": "conceitos centrais",
    "规定行为": "comportamento prescrito",
    "技能（Skill）— 能力扩展": "Habilidade - expansão de habilidade",
    "技能。安装后直接在对话中用自然语言描述即可：": "Habilidade. Após a instalação, basta descrevê-lo em linguagem natural na conversa:",
    "技能创作（MetaSkill）": "Criação de habilidades (MetaSkill)",
    "技能分为系统内置技能和社区发布的技能。": "As habilidades são divididas em habilidades integradas no sistema e habilidades publicadas pela comunidade.",
    "技能模块": "Módulo de habilidade",
    "技能市场": "mercado de competências",
    "技能市场分为两个维度：": "O mercado de competências está dividido em duas dimensões:",
    "加入 Zoom 会议": "Participe de uma reunião Zoom",
    "加入会议": "Participe de uma reunião",
    "加入了组织": "Entrou para a organização",
    "加载中...": "carregando...",
    "加载中…": "carregando…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "Compatível com AWS S3, MinIO e a maioria dos armazenamentos de objetos do protocolo S3",
    "简": "simples",
    "简报": "resumo",
    "简报加载失败": "Falha ao carregar o briefing",
    "简报生成失败": "Falha na geração do briefing",
    "建立关系": "construir relacionamentos",
    "建立血缘": "Estabelecer linhagem",
    "建立业务关系": "Estabelecer relações comerciais",
    "建立中…": "Prédio…",
    "建议从一个核心指标开始": "Recomenda-se começar com um indicador central",
    "建议使用数据库侧的只读账号": "Recomenda-se usar uma conta somente leitura no lado do banco de dados",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "Recomenda-se registrar primeiro uma fonte de dados, um indicador central e uma meta de negócio e depois conectá-los.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "Recomenda-se conceder apenas current_user:read, file_content:read, file_comments:read",
    "将": "Vai",
    "将 App ID 和 App Secret 填入下方": "Preencha o ID do aplicativo e o segredo do aplicativo abaixo",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "Implante este agente como um Discord Bot para interagir no canal do servidor.",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "Habilidades são módulos que ampliam as capacidades dos Agentes. Diferentes agentes podem ser instalados com diferentes conjuntos de habilidades, assim como os funcionários são equipados com diferentes ferramentas.",
    "接入飞书": "Acesse Feishu",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Acesse as páginas, conjuntos de dados, ETL e sistemas de indicadores do Guanyuan BI, permitindo que este Agente entenda e analise diretamente os dados operacionais da empresa.",
    "接入微信": "Acesse o WeChat",
    "揭开第一期": "Revelar a primeira edição",
    "结构搭好后，Agent 会自动使用": "Após a estrutura ser configurada, o Agente irá utilizá-la automaticamente",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "Os relacionamentos estruturais fornecem caminhos aos candidatos; a verdadeira atribuição ainda requer uma combinação de observações, evidências e condições de negócios.",
    "结构信息充足": "Informação estrutural suficiente",
    "解释业务": "explicar o negócio",
    "仅供": "apenas",
    "仅管理员可删除组织知识库文档": "Somente administradores podem excluir documentos da base de conhecimento organizacional",
    "角色权限": "Permissões de função",
    "技能系统": "Sistema de habilidades",
    "仅支持 .md 文件": "Suporta apenas arquivos .md",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "Habilidades são módulos funcionais que podem ser instalados nos Agentes. Cada habilidade dá ao Agente uma habilidade específica. NovaX possui algumas habilidades básicas integradas e também fornece um mercado de habilidades para você descobrir e instalar mais recursos:",
    "进 Agent 的肌肉记忆。": "Entre na memória muscular do Agente.",
    "仅所有者可购买": "Disponível apenas para compra pelo proprietário",
    "近 30 天消耗": "Consumo nos últimos 30 dias",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "Entre na página “Equipe” e clique no botão “Novo Agente”. Preencha o nome e a descrição do Agente e crie-o. Após a criação, clique no cartão Agente para entrar na página de detalhes, onde você pode:",
    "进入第一期": "Insira o primeiro período",
    "进行中": "em andamento",
    "进行中/待开": "Em andamento/a ser aberto",
    "竞": "competir",
    "竞对与行业": "Concorrência e Indústria",
    "聚合方式": "Método de agregação",
    "可留空自动生成，例如 contract": "Pode ser deixado em branco para gerar automaticamente, como contrato",
    "可能后果与下游": "Possíveis consequências e a jusante",
    "可能原因与上游": "Possíveis razões e a montante",
    "可选": "Opcional",
    "可选 · 关联共享知识库": "Opcional · Base de conhecimento compartilhada associada",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "Você pode criar equipes, agentes ou projetos e estabelecer responsabilidades com métricas e metas de negócios.",
    "可用": "Disponível",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "Entre na página “Conversa” e clique em um Agente na lista à esquerda para entrar no chat. Envie uma mensagem na caixa de entrada e o Agente transmitirá a resposta em tempo real. Suporte de conversação:",
    "可追溯证据": "evidência rastreável",
    "客户联系": "contato do cliente",
    "口径、公式、粒度和负责人": "Calibre, fórmula, granularidade e responsável",
    "口径与依赖": "Calibre e dependência",
    "跨层查看正在形成的业务语义。": "Veja a semântica de negócios emergentes em todas as camadas.",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "Entre na página “Base de Conhecimento” e carregue o documento no formato .md. Estes documentos tornam-se uma referência partilhada por todos os Agentes. Por exemplo, você pode fazer upload das especificações do código da empresa e deixar o agente de revisão de código verificar o código de acordo com essa especificação.",
    "进入左侧导航栏的「知识库」页面。": "Entre na página \"Base de Conhecimento\" na barra de navegação esquerda.",
    "来源与流转": "Fonte e circulação",
    "类": "tipo",
    "类型说明": "Descrição do tipo",
    "类型已删除": "Tipo excluído",
    "类型与字段": "Tipos e campos",
    "快速上手": "Comece rapidamente",
    "可用 Nova 点": "Pontos Nova disponíveis",
    "理解含义": "entenda o significado",
    "例：产品评审会、周例会...": "Exemplo: reunião de revisão de produto, reunião semanal...",
    "例如 研究助手": "por exemplo assistente de pesquisa",
    "例如 demo": "Por exemplo demonstração",
    "例如 NovaX 产品团队": "Por exemplo, a equipe de produto NovaX",
    "例如 product-design": "Por exemplo, design de produto",
    "例如 researcher": "Por exemplo pesquisador",
    "例如：2026-W30 / 2026-07": "Por exemplo: 2026-W30/2026-07",
    "例如：合同": "Por exemplo: contrato",
    "例如：经营看板 / SQL 查询": "Por exemplo: Consulta Business Kanban/SQL",
    "例如：库存充足时": "Por exemplo: quando o estoque é suficiente",
    "例如：渠道=自然流量，地区=华东": "Por exemplo: canal = tráfego natural, região = Leste da China",
    "例如：同日 / 7 天后": "Por exemplo: mesmo dia/7 dias depois",
    "例如：支付转化率": "Por exemplo: taxa de conversão de pagamento",
    "例如：SUM(pay_amount)": "Por exemplo: SOMA(valor_pagamento)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "Por exemplo: SUM(pay_amount) ouorders.pay_amount → receita",
    "连接": "conectar",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "Conecte-se ao AWS S3, MinIO ou a um armazenamento de objetos compatível e deixe o agente navegar no diretório e ler arquivos dentro do prefixo de autorização.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "Conecte-se a um repositório GitHub, GitLab ou Gitee e deixe este Agente ler código, analisar alterações e participar da colaboração de desenvolvimento dentro do escopo da autorização.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "Conecte-se ao PostgreSQL, MySQL, SQL Server e outros bancos de dados para consultar dados comerciais reais com permissões somente leitura.",
    "连接成功": "Conexão bem-sucedida",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "Após a conexão ser bem-sucedida, o Agente acessará automaticamente o seu WeChat e responderá às mensagens no chat designado.",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "para especificar quais agentes respondem. Mensagens sem @ não acionarão nenhum Agente.",
    "连接飞书": "Conecte-se a Feishu",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Depois de se conectar ao Feishu, os membros da equipe podem falar diretamente com o Agente no chat em grupo do Feishu. Ele oferece suporte aos recursos nativos do Feishu, como cartões de rich text, envio e recebimento de arquivos e vinculação de calendário.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "Após a conexão, os nós do arquivo e os comentários podem ser lidos, mas não é possível modificar o design, postar comentários ou gerenciar a equipe.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "Após a conexão, os objetos podem ser listados e arquivos com até 2 MB dentro do prefixo limitado podem ser lidos. Não é permitido fazer upload, substituir ou excluir.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "Após a conexão, você poderá pesquisar e ler páginas autorizadas e blocos de conteúdo, mas não terá permissão para criar, modificar ou excluir páginas.",
    "连接计算来源和业务目标": "Conecte fontes de computação e objetivos de negócios",
    "连接类型": "Tipo de conexão",
    "连接目标或流程": "Conectar alvo ou processo",
    "连接你的 AI 引擎": "Conecte seu mecanismo de IA",
    "连接上下游": "Conecte upstream e downstream",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "Conecte designs, documentos, e-mails, códigos e dados de negócios para permitir que os Agentes participem de trabalhos reais dentro de um escopo claramente autorizado.",
    "连接失败": "Falha na conexão",
    "连接数据或指标": "Conecte dados ou métricas",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "Após a conexão ser concluída, adicione o Agente ao Grupo Feishu para iniciar a conversa.",
    "连接微信": "Conecte-se ao WeChat",
    "连接验证成功": "Verificação de conexão bem-sucedida",
    "连接中...": "Conectando...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "Após dois períodos consecutivos de registro, a NovaX calcula as alterações e procura possíveis fatores a montante em uma análise de impacto.",
    "联网搜索": "Pesquisa na Internet",
    "链接": "Link",
    "列表视图": "visualização de lista",
    "临时凭据才需要": "Credenciais temporárias são necessárias apenas",
    "另有": "Também",
    "留空会继续使用已加密保存的凭据": "Deixe em branco para continuar usando credenciais salvas criptografadas",
    "六": "seis",
    "六个视图，其实是同一张图": "Seis visualizações, na verdade a mesma imagem",
    "路径样式（MinIO 常用）": "Estilo de caminho (comumente usado pelo MinIO)",
    "马斯克思维": "Almíscar pensando",
    "芒格思维": "O pensamento de Munger",
    "来扩展能力": "para expandir capacidades",
    "累计消耗": "Consumo cumulativo",
    "没有发现新增内容": "Nenhum novo conteúdo encontrado",
    "没有匹配的角色": "Nenhuma função correspondente",
    "没有匹配的消息": "Nenhuma mensagem correspondente",
    "没有匹配的指标": "Nenhuma métrica correspondente",
    "没有上游路径": "nenhum caminho ascendente",
    "没有下游路径": "nenhum caminho a jusante",
    "没有新增内容": "Nada de novo",
    "没有找到匹配的技能": "Nenhuma habilidade correspondente encontrada",
    "没有找到匹配的文件": "Nenhum arquivo correspondente encontrado",
    "每": "Todo",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "Mensagens sem @ qualquer Agente serão enviadas ao grupo, mas não acionarão respostas do Agente, o que facilita a comunicação entre os membros da equipe.",
    "每篇内容都来自": "Cada conteúdo vem de",
    "每天": "diariamente",
    "连接到飞书、Telegram、微信等": "Conecte-se a Feishu, Telegram, WeChat, etc.",
    "每小时": "por hora",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "Cada camada responde a uma pergunta diferente e, juntas, formam a ontologia sobre a qual o Agente pode raciocinar.",
    "每月": "por mês",
    "每周": "semanalmente",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "Cada Agente pode ver o contexto no chat em grupo, para que os Agentes subsequentes possam fazer referência direta à saída do Agente anterior.",
    "每个用户最多可以创建": "Cada usuário pode criar até",
    "密码": "senha",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "Senhas, tokens e chaves privadas são criptografados e armazenados apenas no lado do servidor e não serão gravados em arquivos ou conversas do Agente.",
    "每天早上 9 点给我发一份行业新闻摘要": "Envie-me um resumo das notícias do setor todas as manhãs às 9h",
    "描述": "descrever",
    "名称": "nome",
    "名称 *": "Nome *",
    "名称不能为空": "O nome não pode ficar vazio",
    "每周五下午 5 点生成本周工作总结": "Um resumo do trabalho da semana é gerado todas as sextas-feiras às 17h.",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "A cota gratuita é uma cota única para a organização e é compartilhada por todos os membros. Atualmente convertido em $ 1 = 750 Nova Points.",
    "模板消息": "mensagem modelo",
    "免费赠送": "presente grátis",
    "名称和头像": "Nome e avatar",
    "模型定义": "Definição de modelo",
    "模型": "Modelo",
    "默认邮箱目录": "Diretório de caixa de correio padrão",
    "明确角色": "esclarecer funções",
    "内部群聊": "Bate-papo em grupo interno",
    "内容读取": "Leitura de conteúdo",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "Os tipos integrados formam a semântica comum do NovaX, e os tipos personalizados descrevem seu negócio exclusivo.",
    "你": "você",
    "目录": "Índice",
    "模型和": "modelo e",
    "模板中用": "Usado em modelos",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "Você pode pensar em um Agente como um membro virtual da equipe. Pode:",
    "你可以随时在设置中注销账号，删除所有关联数据。": "Você pode sair da sua conta e excluir todos os dados associados a qualquer momento nas configurações.",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "Você pode sair da sua conta a qualquer momento nas configurações e excluir todos os dados associados.",
    "女娲 · Skill 造人术": "Técnica de Criação Humana Nuwa·Skill",
    "篇": "Capítulo",
    "频道对话": "Conversa no canal",
    "平台": "plataforma",
    "平台公告": "Anúncio da plataforma",
    "评估后果": "Avalie as consequências",
    "评论读取": "Comentários lidos",
    "凭据已加密保存，": "As credenciais são salvas criptografadas,",
    "期望方向": "direção desejada",
    "企业微信": "WeChat Empresarial",
    "企业邮箱 / 自定义 IMAP": "E-mail comercial/IMAP personalizado",
    "启用（兼容自签名证书）": "Ativado (compatível com certificados autoassinados)",
    "启用（推荐）": "Ativar (recomendado)",
    "启用并验证证书": "Habilitar e verificar certificado",
    "起点 *": "Ponto de partida *",
    "前": "avançar",
    "前往": "Vá para",
    "前往飞书开放平台 →": "Vá para a Plataforma Aberta Feishu →",
    "前缀隔离": "isolamento de prefixo",
    "乔布斯思维": "Pensamento sobre empregos",
    "切换": "trocar",
    "前提：Agent 需要安装": "Pré-requisito: o agente precisa estar instalado",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "Troque ou crie organizações, cada organização possui agentes e membros independentes.",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "O conteúdo da conversa que você insere durante o uso é usado apenas para interagir com o mecanismo de IA e não será armazenado ou usado adicionalmente para treinar o modelo.",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "O conteúdo da conversa que você insere durante o uso é usado apenas para interagir com o mecanismo de IA e não será armazenado ou usado adicionalmente para treinar o modelo.",
    "切换组织": "Mudar de organização",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "Por favor, use a conclusão do briefing para explicar melhor as razões, os possíveis impactos e as ações mais valiosas que devemos tomar a seguir.",
    "请输入您的反馈、建议或遇到的问题...": "Por favor, insira seus comentários, sugestões ou problemas...",
    "请填写 App ID 和 App Secret": "Preencha o ID do aplicativo e o segredo do aplicativo",
    "请勿填写网页登录密码": "Por favor, não preencha a senha de login da página da web",
    "请选择一个角色": "Selecione uma função",
    "区域": "área",
    "驱动行动": "impulsionar a ação",
    "取消": "Cancelar",
    "全部": "todos",
    "全部对象": "Todos os objetos",
    "全部执行对象": "Todos os objetos de execução",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "A caixa de correio é aberta no modo somente leitura IMAP; o corpo do e-mail pode ser pesquisado e lido, e os nomes dos anexos podem ser visualizados. O e-mail não será enviado, excluído, movido ou marcado.",
    "全员群": "Todos os membros",
    "权限隔离": "Isolamento de permissão",
    "确保 Codex CLI 已安装": "Certifique-se de que o Codex CLI esteja instalado",
    "确定": "Claro",
    "确定断开？已保存凭据会被删除。": "Tem certeza de que deseja desconectar? As credenciais salvas serão excluídas.",
    "切换中...": "Trocando...",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "Depois de trocar de organização, os agentes, a base de conhecimento e os membros da equipe que você vê serão alterados de acordo.",
    "确定删除这个会议？": "Tem certeza de que deseja excluir esta reunião?",
    "确定删除这条指标观测吗？": "Tem certeza de que deseja excluir esta observação do indicador?",
    "清除后所有聊天记录将被删除，无法恢复。": "Após a limpeza, todo o histórico de bate-papo será excluído e não poderá ser recuperado.",
    "确认断开": "Confirmar desconexão",
    "确认已安装。": "Confirme que está instalado.",
    "确定清除所有会话？": "Tem certeza de que deseja limpar todas as sessões?",
    "群聊": "bate-papo em grupo",
    "群聊@唤醒": "Bate-papo em grupo@wake",
    "群聊对话": "Conversa de bate-papo em grupo",
    "确定要注销账号吗？": "Tem certeza de que deseja cancelar sua conta?",
    "全局市场": "mercado global",
    "确认清除": "Confirmar claro",
    "确认注销": "Confirmar logout",
    "让组织的重要变化": "Faça mudanças importantes em sua organização",
    "人": "pessoas",
    "人格蒸馏 · 女娲造人": "Destilação de Personalidade·Nuwa cria seres humanos",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "O bate-papo em grupo é o principal cenário de colaboração da NovaX. Clique em “Todos os membros” no topo da lista de agentes para entrar. Todos os agentes e membros da equipe no chat em grupo compartilham o mesmo espaço de conversa.",
    "群聊与多 Agent 协作": "Bate-papo em grupo e colaboração multiagente",
    "认证方式": "Método de autenticação",
    "任务名称": "Nome da tarefa",
    "仍建议用实际数据验证候选原因。": "Ainda é recomendado verificar as causas candidatas com dados reais.",
    "日": "dia",
    "日历联动": "Vinculação de calendário",
    "日期": "data",
    "任务": "Tarefa",
    "群聊中需要通过": "No chat em grupo, você precisa passar",
    "人设和行为规则": "Personalidade e regras comportamentais",
    "三": "três",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "Se você tiver alguma dúvida ou preocupação, entre em contato com o desenvolvedor por meio do canal de feedback do produto.",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "Depois de escanear o código QR para fazer login no WeChat, o Agent pode servir como seu assistente do WeChat, respondendo mensagens automaticamente, gerenciando bate-papos em grupo e cuidando de assuntos diários.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "Depois de escanear o código QR para se conectar ao WeChat, este Agente acessa automaticamente as mensagens do WeChat e pode responder em chats privados ou em grupo.",
    "扫码区域": "Área de código de digitalização",
    "删除": "excluir",
    "删除观测": "Excluir observação",
    "删除后无法恢复，确定要删除这个文档吗？": "A exclusão não pode ser restaurada. Tem certeza de que deseja excluir este documento?",
    "删除会议": "Excluir reunião",
    "删除了 Agent": "Agente excluído",
    "删除失败": "Falha na exclusão",
    "删除失败或无权操作": "A exclusão falhou ou não há permissão para operar",
    "删除文档": "Excluir documento",
    "商业专业": "Especialização em negócios",
    "上传": "carregar",
    "上传到哪里？": "Onde fazer upload?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "Após o upload, ele ainda poderá ser visualizado separadamente em \"Base de Conhecimento da Organização/Minha Base de Conhecimento\".",
    "上传了": "Enviado",
    "上传录音": "Carregar gravação",
    "上传失败": "Falha no upload",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "Se você tiver alguma dúvida ou preocupação, entre em contato com o desenvolvedor por meio do canal de feedback do produto.",
    "上次：": "Última vez:",
    "上次触发": "último acionado",
    "上次执行": "executado pela última vez",
    "上下游网络": "Redes upstream e downstream",
    "上一步": "Etapa anterior",
    "上游候选": "candidato a montante",
    "尚未补充业务定义": "Nenhuma definição de negócio foi adicionada ainda",
    "尚未连接指标或业务目标。": "Nenhuma métrica ou meta de negócios foi conectada ainda.",
    "如何创建": "Como criar",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "Defina uma tarefa agendada, como \"Envie-me um relatório diário às 9h, todos os dias\"",
    "设计创作": "criação de design",
    "设计生成": "geração de design",
    "设计师包 · DESIGN": "Bolsa de design · DESIGN",
    "上传文件作为附件。": "Carregue o arquivo como anexo.",
    "三级权限体系": "Sistema de autoridade de três níveis",
    "谁来行动": "quem vai agir",
    "设置": "configurar",
    "设定边界": "definir limites",
    "什么属于这个类型，什么不属于？": "O que pertence a este gênero e o que não pertence?",
    "生成二维码": "Gerar código QR",
    "生成二维码失败": "Falha ao gerar o código QR",
    "生成纪要": "Gerar minutos",
    "生成纪要中": "Gerando minutos",
    "生成失败": "Falha na compilação",
    "生成中...": "Gerando...",
    "失败": "falhar",
    "实体与关系来源": "Fontes de entidade e relacionamento",
    "使用": "usar",
    "时间": "tempo",
    "使用工具": "Usar ferramentas",
    "使用时只记住两个动作": "Apenas lembre-se de duas ações ao usá-lo",
    "使用引导": "Utilize o guia",
    "什么是 Agent": "O que é agente",
    "设置头像，从预设中选择或上传自定义图片。": "Defina um avatar, escolha uma das predefinições ou carregue uma imagem personalizada.",
    "使用方式": "Uso",
    "视条件而定": "Sujeito a condições",
    "是": "sim",
    "是 / 否": "se",
    "示例：": "Exemplo:",
    "适用条件": "Condições aplicáveis",
    "收到 Webhook 事件: {{payload}}": "Evento de webhook recebido: {{payload}}",
    "收起": "fechar",
    "手动创建": "Criar manualmente",
    "手动记录": "Gravação manual",
    "输入清晰、唯一的业务名称": "Insira um nome comercial claro e exclusivo",
    "输入消息，@agent 名字来提问": "Digite uma mensagem, @nome do agente para fazer uma pergunta",
    "属性": "propriedade",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "Os atributos são usados ​​para unificar o significado do negócio e também se tornar o contexto estruturado do Agente.",
    "属性字段": "campo de atributo",
    "数": "número",
    "数据层：数从哪里来": "Camada de dados: de onde vêm os números?",
    "数据从哪里来，经过什么，最终形成哪个指标": "De onde vêm os dados, por onde passam e qual indicador é finalmente formado?",
    "数据分析": "análise de dados",
    "数据观察": "Observação de dados",
    "数据集": "Conjunto de dados",
    "数据库、表和关键字段": "Banco de dados, tabelas e campos-chave",
    "数据库地址": "Endereço do banco de dados",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "O acesso ao banco de dados pode complementar automaticamente o parentesco e a observação; ele pode descobrir correlações, mas não atualizará automaticamente as correlações para causalidade.",
    "数据库类型": "Tipo de banco de dados",
    "数据库密码": "Senha do banco de dados",
    "数据库名": "Nome do banco de dados",
    "数据血缘": "Linhagem de dados",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "A linhagem de dados responde \"de onde vêm os números?\"; influenciar respostas de relacionamento \"possivelmente por quê\"; apenas causa e efeito comprovados podem responder \"determinar o que causa isso\".",
    "数据血缘图": "Diagrama de linhagem de dados",
    "数据与办公": "Dados e escritório",
    "数据源": "fonte de dados",
    "数据源、表与字段": "Fontes de dados, tabelas e campos",
    "数据资产": "ativos de dados",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "Campos de dados → Indicadores principais → Objetivos de negócios → Responsável",
    "数值来源": "Fonte de valor",
    "数字": "número",
    "双人": "Dobro",
    "说明": "ilustrar",
    "说明它在业务里代表什么，以及不包含什么": "Explique o que representa no negócio e o que não inclui",
    "私聊": "bate-papo privado",
    "私聊回复": "Resposta de bate-papo privado",
    "私钥口令（可选）": "Senha da chave privada (opcional)",
    "思考中...": "Pensamento...",
    "思维框架": "estrutura de pensamento",
    "四": "Quatro",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "A quarta camada não consiste em quatro diretórios separados, mas em uma ligação entre os fatos e a ação. Você não precisa preencher tudo de uma vez, apenas crie primeiro o link mais importante.",
    "松开以上传 .md 文件": "Solte para fazer upload do arquivo .md",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "Pesquise e leia páginas do Notion e blocos de conteúdo autorizados para Integração, permitindo que o Agente utilize documentos da equipe e materiais de projeto.",
    "搜索会话内的文件": "Pesquisar arquivos em uma sessão",
    "搜索技能名称、描述或标签...": "Pesquise o nome, a descrição ou a tag de uma habilidade...",
    "搜索内容": "Pesquisar conteúdo",
    "搜索项目、团队或 Agent": "Pesquise projetos, equipes ou agentes",
    "搜索消息...": "Pesquisar mensagens...",
    "搜索预设角色...": "Pesquisar funções predefinidas...",
    "搜索知识库...": "Pesquise na base de conhecimento...",
    "搜索指标或口径": "Métricas ou calibre de pesquisa",
    "所属层 *": "Camada pertencente *",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "Use seu endereço de e-mail para registrar uma conta. O sistema enviará um código de verificação para o seu e-mail. Após a verificação, defina uma senha para concluir o cadastro. Fazer login pela primeira vez cria automaticamente uma organização padrão.",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "Também continuará a prestar atenção às informações urgentes ou importantes sobre a concorrência, bem como às grandes notícias sobre a indústria e as orientações políticas, e a impulsionar as mudanças que realmente requerem a atenção da organização aqui.",
    "使用者的個人資訊用於任何商業用途。": "As informações pessoais do usuário são utilizadas para qualquer finalidade comercial.",
    "所有者（Owner）": "Proprietário",
    "提出原因": "Dê razões",
    "提交反馈": "Enviar comentários",
    "提交分析": "Enviar análise",
    "添加关系": "Adicionar relacionamento",
    "添加字段": "Adicionar campo",
    "条关系": "relação",
    "条件性": "condicionalidade",
    "条因果关系": "relação causal",
    "跳": "Pular",
    "跳过引导": "Pular inicialização",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Crie, modifique e exporte rascunhos de design .pen por meio da CLI do Pencil Headless, e o processo de geração sempre usa o Codex.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Interaja com o Agente através do Telegram Bot, oferecendo suporte a mensagens instantâneas e processamento de arquivos em escala global.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Interaja com este agente através do Telegram Bot para oferecer suporte a mensagens instantâneas globais.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "Acesse este Agente através da API do WhatsApp Business para alcançar usuários em todo o mundo.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "Acesse este Agente por meio do aplicativo WeChat empresarial para oferecer suporte a cenários de comunicação interna e atendimento ao cliente.",
    "通过": "passar",
    "适合放入的内容": "O que colocar",
    "通信对话 (": "conversa de comunicação (",
    "通用工具 (": "Ferramentas Gerais (",
    "同名文档": "Documento com o mesmo nome",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "Pacotes e cotas já podem ser visualizados, e as compras podem ser feitas assim que o canal de pagamento for determinado.",
    "同一组织 · 同一份简报 · 持续沉淀": "A mesma organização · o mesmo resumo · acumulação contínua",
    "统计": "estatísticas",
    "统计粒度": "granularidade estatística",
    "统计周期": "período estatístico",
    "图标": "ícone",
    "图标视图": "visualização de ícones",
    "图片 / PDF 导出": "Exportação de imagem/PDF",
    "套餐之间仅额度不同，所有产品能力保持一致。": "Apenas a quantidade difere entre os pacotes e todos os recursos do produto permanecem os mesmos.",
    "团队的": "equipe",
    "团队": "equipe",
    "团队日志": "Registro da equipe",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "Convide membros para participar por e-mail e defina diferentes funções (proprietário/administrador/membro).",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "O mesmo Agente pode trabalhar em plataformas Web e de mensagens instantâneas, e as memórias e habilidades de conversação são compartilhadas em todas as plataformas.",
    "团队规范、工作流程、审批标准": "Especificações da equipe, processos de trabalho e padrões de aprovação",
    "推荐建模顺序": "Ordem de modelagem recomendada",
    "推荐": "recomendar",
    "退出登录": "Sair",
    "拖入 .md 文件，或点击上传": "Arraste o arquivo .md ou clique em Carregar",
    "外部系统 POST 到此 URL 即可触发": "O POST do sistema externo para este URL pode ser acionado",
    "团队协作（NovaX Bus）": "Colaboração em equipe (NovaX Bus)",
    "团队规范和工作流程": "Normas da equipe e processos de trabalho",
    "完成": "Terminar",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "Os indicadores completos incluem definição do negócio, calibre de cálculo, granularidade, dimensão, origem, responsável e observações históricas.",
    "网络错误": "erro de rede",
    "微信": "WeChat",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "A conexão WeChat é baseada no protocolo da versão web e uma conta WeChat precisa ser mantida online como uma operadora de agente. Recomenda-se usar uma conta WeChat dedicada.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "O WeChat está conectado e o Agente responderá automaticamente à mensagem. Ele pode ser usado após o serviço ser reiniciado.",
    "唯一标识": "identificador exclusivo",
    "维度切片": "fatia de dimensão",
    "未补充映射表达式": "Expressão de mapeamento não complementada",
    "未连接": "Não conectado",
    "未设置": "não definido",
    "未设置编码": "Nenhum conjunto de codificação",
    "未设置更新频率": "Frequência de atualização não definida",
    "未设置公式": "Nenhuma fórmula definida",
    "未设置统计粒度": "A granularidade das estatísticas não está definida",
    "未知": "desconhecido",
    "未知文档": "Documento desconhecido",
    "文本": "texto",
    "文档读取失败": "Falha na leitura do documento",
    "文档读取失败或无权访问": "Falha na leitura do documento ou sem permissão de acesso",
    "文档已覆盖": "Documento coberto",
    "文档已删除": "Documento excluído",
    "文档已上传": "Documento enviado",
    "文件处理": "Processamento de arquivos",
    "文件传输": "transferência de arquivos",
    "文件读取": "leitura de arquivo",
    "文件分享": "compartilhamento de arquivos",
    "文件过大，最大支持 2MB": "O arquivo é muito grande, o máximo suportado é 2 MB",
    "文件结构": "Estrutura de arquivo",
    "文件收发": "Envio e recebimento de arquivos",
    "我": "EU",
    "我的知识库": "Minha base de conhecimento",
    "外观": "Aparência",
    "我们": "nós",
    "我想继续讨论这篇组织简报：": "Gostaria de continuar discutindo este resumo organizacional:",
    "无单位": "Sem unidade",
    "无公式": "Nenhuma fórmula",
    "无可用 Agent": "Nenhum agente disponível",
    "无描述": "Sem descrição",
    "五": "cinco",
    "系统": "sistema",
    "系统工具": "ferramentas do sistema",
    "系统内置": "Sistema integrado",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "Força do raciocínio e execução de tarefas na área restrita de gravação do espaço de trabalho.",
    "我們": "nós",
    "下次：": "próxima vez:",
    "下次执行": "Execute na próxima vez",
    "下一步": "Próxima etapa",
    "下游影响": "efeitos a jusante",
    "下载": "download",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "Primeiro “crie um novo objeto” e depois “estabeleça um relacionamento”. O objeto pode ser campo, indicador, alvo ou agente; a relação precisa de seleccionar explicitamente cálculo, linhagem, impacto, causalidade ou atribuição, e tentar complementar fórmulas, condições, confiança e provas.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "Primeiro, crie indicadores como “vendas, volume de pedidos e taxa de conversão” que sejam realmente utilizados para a tomada de decisões e complete a definição do negócio, fórmula, granularidade estatística e responsável; em seguida, registre os valores de pelo menos dois períodos para que a NovaX possa determinar quais alterações ocorreram.",
    "先看懂四层业务地图": "Primeiro entenda o mapa de negócios de quatro camadas",
    "先验证，再保存": "Verifique primeiro e depois salve",
    "现在搭建第一条业务链路": "Agora crie o primeiro link comercial",
    "现在可以通过受限工具安全使用这个连接。": "Esta conexão agora é segura para uso com ferramentas restritas.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "Agora comece gerando o primeiro problema para sua organização. À medida que informações e conexões continuam sendo adicionadas, a NovaX continuará a divulgar conteúdo que vale a pena prestar atenção aqui.",
    "限定前缀（可选）": "prefixo de qualificação (opcional)",
    "限定文件 Key（可选）": "Chave de arquivo qualificado (opcional)",
    "相对上一期": "Em comparação com a edição anterior",
    "详细记忆文件": "arquivo de memória detalhado",
    "项操作": "operações",
    "消耗": "consumir",
    "消息导航": "Navegação de mensagens",
    "消息卡片": "cartão de mensagem",
    "消息": "Informação",
    "小时": "Hora",
    "协作 Agent": "Agente de colaboração",
    "斜杠命令": "comando de barra",
    "小": "Pequeno",
    "新建对象": "Novo objeto",
    "新建业务概念": "Novo conceito de negócio",
    "新建执行对象": "Crie um novo objeto de execução",
    "新建指标": "Novo indicador",
    "形成指标": "indicadores de formulário",
    "修改文件": "Modificar arquivos",
    "虚拟主机样式（AWS 默认）": "Estilo de host virtual (padrão AWS)",
    "需要两个周期": "São necessários dois ciclos",
    "选择 .md 文件 →": "Selecione o arquivo .md →",
    "选择要安装到的 Agent": "Selecione o agente para instalar",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "Escolha uma função predefinida para começar rapidamente ou crie um agente personalizado manualmente.",
    "选择一个执行对象": "Selecione um objeto de execução",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "Depois de selecionar uma métrica, a análise de impacto olha para cima, para a fonte de cálculo e para os direcionadores candidatos, e para baixo, para as metas, processos e pessoas responsáveis ​​pelo impacto. A relação de influência é apenas uma pista; somente a relação causal com evidência de verificação será expressa pelo Agente como causa definitiva.",
    "选择一个指标开始": "Escolha um indicador para começar",
    "选择指标或业务对象": "Selecione uma métrica ou objeto de negócios",
    "血缘与计算映射": "Linhagem e mapeamento computacional",
    "寻址方式": "Modo de endereçamento",
    "沿关系找原因，也看后果": "Acompanhe o relacionamento para encontrar a causa e também observe as consequências.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "Identifique metas, processos, projetos e proprietários afetados ao longo dos relacionamentos posteriores.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "Gere motivadores candidatos ao longo de relações causais e de impacto e rebaixe expressões com base em confiança, condições e evidências.",
    "沿用 Figma Token 可见范围": "Herdar o alcance visível do Figma Token",
    "消息字体大小": "Tamanho da fonte da mensagem",
    "外部平台": "plataforma externa",
    "颜色": "cor",
    "演示文稿制作": "Produção de apresentação",
    "验证并保存": "Verifique e salve",
    "验证并连接": "Verifique e conecte",
    "验证结果": "Resultados da verificação",
    "写 Soul 的要点": "Pontos-chave para escrever a alma",
    "系统任务": "Tarefas do sistema",
    "要点速读": "Pontos para ler rapidamente",
    "也是 Agent 们的": "Também para Agentes",
    "业务本体": "Ontologia de negócios",
    "业务层：数字说明什么": "Camada de negócios: o que dizem os números",
    "业务地图": "mapa de negócios",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "O mapa de negócios analisa o quadro geral, a rede de indicadores analisa o calibre e a montante e a jusante, a linhagem de dados analisa a fonte, a análise de impacto analisa as causas e consequências, a execução da organização analisa a pessoa responsável e o modelo define o tipo de objeto de gestão. A troca de visualizações não cria dados duplicados.",
    "业务定义": "definição de negócio",
    "业务对象": "objeto de negócios",
    "研究员输出数据后：": "Depois que o pesquisador produz os dados:",
    "业务连接": "conexão comercial",
    "业务声明": "Declaração comercial",
    "业务指标": "métricas de negócios",
    "页面分析": "Análise de página",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "Design de páginas, apresentações, geração de imagens de IA: faça com que seu agente pareça um designer profissional.",
    "页面搜索": "Pesquisa de página",
    "一": "um",
    "一只 Agent。": "Um agente.",
    "移除了": "Removido",
    "已保存，留空不修改": "Salvo, deixe em branco sem modificação",
    "已触发": "Provocado",
    "已存在，是否覆盖？": "Já existe? Substituir?",
    "已复制": "Copiado",
    "已归档": "Arquivado",
    "已过期": "Expirado",
    "已结束": "terminou",
    "已连接": "Conectado",
    "已连接 ·": "Conectado ·",
    "已取消": "Cancelado",
    "已扫码，请在手机上确认...": "O código foi escaneado, confirme no seu celular...",
    "已生成纪要": "Minuto gerado",
    "已完成": "Concluído",
    "已验证": "Verificado",
    "已验证因果": "Causa e efeito verificados",
    "已暂停": "Suspenso",
    "因果可信度阶梯": "escada de credibilidade causal",
    "业务规则、行业术语、标准话术": "Regras de negócios, terminologia do setor, vocabulário padrão",
    "邀请成员": "Convidar membros",
    "引导进度": "progresso de inicialização",
    "应用消息": "Mensagens do aplicativo",
    "应用专用密码 / 授权码": "Senha/código de autorização específico do aplicativo",
    "影响分析": "análise de impacto",
    "影响分析失败": "Falha na análise de impacto",
    "影响时滞": "Afeta o atraso de tempo",
    "影响语义": "Afetar a semântica",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "O desenvolvedor não é responsável por quaisquer perdas diretas ou indiretas decorrentes do uso deste produto.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "O desenvolvedor não é responsável por quaisquer perdas diretas ou indiretas decorrentes do uso deste produto.",
    "业务规则和约束条件": "Regras e restrições de negócios",
    "用 1 分钟看懂业务本体": "Reserve 1 minuto para entender a ontologia de negócios",
    "用法示例": "Exemplos de uso",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "Agentes com habilidades MetaSkill podem criar e publicar automaticamente novas habilidades com base nas suas necessidades.",
    "用户名": "nome de usuário",
    "用链接或 ID 进入": "Entre com link ou ID",
    "用手机微信扫描二维码，确认登录。": "Use o WeChat no seu celular para escanear o código QR e confirmar o login.",
    "用手机微信扫描二维码并确认登录": "Use o WeChat no seu celular para escanear o código QR e confirmar o login",
    "用于比较变化": "usado para comparar mudanças",
    "用于区分这个 Agent 的 Pencil 设计文件": "Arquivo de design de lápis usado para distinguir este Agente",
    "邮件搜索": "Pesquisa de correio",
    "邮箱": "Correspondência",
    "邮箱类型": "Tipo de e-mail",
    "邮箱账号": "Conta de e-mail",
    "有纪要": "Com ata",
    "语义关系": "Relações semânticas",
    "语义属性": "Propriedades semânticas",
    "用户的个人信息用于任何商业用途。": "As informações pessoais do usuário são utilizadas para qualquer finalidade comercial.",
    "拥有专属的": "Tenha exclusividade",
    "预定时间（可选，留空则立即开始）": "Horário agendado (opcional, deixe em branco para iniciar imediatamente)",
    "原始转写": "transcrição original",
    "原因与后果": "causas e consequências",
    "语音输入（需浏览器支持 Web Speech API）。": "Entrada de voz (requer que o navegador suporte Web Speech API).",
    "月度额度不足时，可由组织所有者补充。": "Se a cota mensal for insuficiente, ela poderá ser reabastecida pelo proprietário da organização.",
    "运行连接命令": "Execute o comando de conexão",
    "运行引擎": "ligar o motor",
    "运行中": "Em execução",
    "再查一次": "Verifique novamente",
    "再查一次，没有新增内容": "Verificado novamente, sem conteúdo novo",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Colabore com este agente no Microsoft Teams e integre-o aos fluxos de trabalho empresariais.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "Colabore diretamente com Agentes nos canais do Slack, adequados ao fluxo de trabalho diário de equipes no exterior.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Trabalhe diretamente com este Agente em um canal do Slack, dando suporte às respostas do Thread.",
    "永久删除你的账号和所有数据，此操作不可撤销。": "Exclua permanentemente sua conta e todos os dados. Esta ação é irreversível.",
    "用量明细加载失败": "Falha ao carregar detalhes de uso",
    "月度套餐": "pacote mensal",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "Crie-o na subaba “Webhook” da aba “Tarefa” e preencha o nome e o modelo de prompt do Word.",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "Crie uma nova organização ou troque de organização em \"Configurações → Gerenciamento de contas\".",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "Conecte este Agente a um grupo DingTalk para oferecer suporte aos recursos nativos do DingTalk, como cartões de mensagens e notificações de trabalho.",
    "在不同组织之间切换，数据完全隔离。": "Alterne entre diferentes organizações com isolamento completo de dados.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "Clique em “Novo Agente” na página “Equipe” para criá-lo. Após a criação, clique no cartão Agente para entrar na página de detalhes para configuração.",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "Gerencie os membros da organização na página \"Equipe\". Clique em “Convidar membros” e digite seu endereço de e-mail para enviar convites.",
    "在对话中让": "deixe entrar conversa",
    "在对话中让 agent \"记住\"重要信息": "Deixe o agente “lembrar” de informações importantes durante a conversa",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Confirme a autorização no backend do Feishu e o aplicativo obterá automaticamente as permissões necessárias (envio e recebimento de mensagens, gerenciamento de grupos, etc.).",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Comunique-se diretamente com este agente no bate-papo em grupo do Feishu, oferecendo suporte aos recursos nativos do Feishu, como cartões de rich text, envio e recebimento de arquivos, etc.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "Mude para a guia “Habilidades” na parte superior da interface de conversa, navegue na lista disponível e clique em Instalar.",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "Execute o NovaX Agent em seu computador para conectar com segurança seu espaço de trabalho local do Codex ao NovaX.",
    "在服务器上读写文件、执行代码": "Ler e gravar arquivos e executar código no servidor",
    "暂不关联": "Ainda não é relevante",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "Mude para a guia \"Conexão\" na parte superior da interface de diálogo para configurar. Atualmente suporta:",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "Na lista de agentes na página de conversa, você verá uma entrada “Grupo de todos os membros”. Em um bate-papo em grupo, você pode usar @AgentName para especificar um agente para responder perguntas. Isso permite que vários agentes colaborem na mesma conversa. Por exemplo, primeiro deixe o Agente “Pesquisador” procurar informações e depois deixe o Agente “Escritor” escrever um artigo com base nas informações.",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "Por enquanto, você precisa criar manualmente um aplicativo no backend do Feishu e preencher as credenciais. Um processo de criação automatizado está em desenvolvimento - bastará uma autorização com um clique para concluir a conexão.",
    "暂停": "pausa",
    "暂无 Webhook": "Ainda não há webhooks",
    "暂无定时任务": "Ainda não há tarefas agendadas",
    "暂无观测": "Ainda não há observações",
    "暂无观测值": "Ainda não há observações",
    "暂无记录": "Ainda não há registro",
    "暂无记忆": "Ainda não há memória",
    "暂无纪要 — 会议结束后自动转写": "Ainda não há ata - transcrita automaticamente após o término da reunião",
    "暂无类型说明": "Nenhuma descrição de tipo ainda",
    "暂无日志": "Ainda não há registros",
    "暂无属性字段": "Ainda não há campos de atributos",
    "暂无数据": "Ainda não há dados",
    "暂无说明": "Ainda não há descrição",
    "暂无文件": "Nenhum arquivo ainda",
    "暂无业务定义": "Ainda não há definição de negócio",
    "粘贴 Figma 访问 Token": "Cole o token de acesso Figma",
    "粘贴 Zoom 链接或输入会议 ID": "Cole o link do Zoom ou insira o ID da reunião",
    "展开查看": "Expandir para visualizar",
    "账号": "conta",
    "这份证据如何支持该关系？": "Como essas evidências apoiam o relacionamento?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "Aqui você mantém suas equipes, agentes, projetos, tarefas, documentos e habilidades originais e os conecta às métricas de negócios.",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "Na página “Mercado de habilidades” na barra de navegação esquerda, você pode navegar por todas as habilidades disponíveis.",
    "暂时无法读取额度信息": "Temporariamente incapaz de ler as informações de crédito",
    "蒸馏": "destilação",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "Destilar estruturas de tomada de decisão, princípios básicos e DNA expressivo – refinando um consultor mental que você pode recorrer a qualquer momento.",
    "整体结构": "estrutura geral",
    "正文与附件信息": "Informações de texto e anexo",
    "正向": "avançar",
    "正在编撰组织简报": "Compilando briefing organizacional",
    "正在创建微信连接...": "Criando conexão WeChat...",
    "正在读取组织最近的使用情况": "Lendo o uso recente da organização",
    "正在计算影响路径…": "Calculando caminho de impacto…",
    "正在建立业务语义地图…": "Construindo mapa semântico de negócios...",
    "正在生成二维码...": "Gerando código QR...",
    "正在验证连接…": "Verificando conexão...",
    "正在由 Agent 团队编撰第一期": "A primeira edição está sendo compilada pela equipe do Agente",
    "正在整理组织数据与知识": "Organizando dados e conhecimentos organizacionais",
    "证据等级": "Nível de evidência",
    "证据摘要": "resumo de evidências",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "Suporta GitHub, GitLab, Gitee e serviços Git internos",
    "占位，表示外部传入的数据。例如：": "Espaço reservado, representando dados recebidos externamente. Por exemplo:",
    "知识库": "base de conhecimento",
    "知识库 &middot; Knowledge Base": "Base de Conhecimento · Base de Conhecimento",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "Este é o modo de colaboração mais poderoso da NovaX. Você pode fazer com que vários agentes assumam o controle para concluir tarefas complexas na mesma conversa:",
    "正在加载组织额度…": "Carregando cota da organização...",
    "知识库（Memory）— 共享大脑": "Base de Conhecimento (Memória) - Cérebro Compartilhado",
    "支付功能正在准备中": "A função de pagamento está sendo preparada",
    "知识库为空": "A base de conhecimento está vazia",
    "知识库文档": "Documentação da base de conhecimento",
    "知识库暂无共享文档。": "Atualmente não há documentos compartilhados na base de conhecimento.",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "Uma base de conhecimento é um repositório de documentos compartilhados em nível de organização. Cada documento Markdown que você carregar se tornará de conhecimento comum de todos os Agentes da organização. Adequado para:",
    "执行层：谁根据它采取行动": "Camada executiva: quem age com base nisso",
    "执行命令": "executar comando",
    "执行频率": "Frequência de execução",
    "执行任务": "executar tarefas",
    "执行时间": "Tempo de execução",
    "执行时间：": "Tempo de execução:",
    "执行异常": "Exceção de execução",
    "执行指令": "Executar instruções",
    "执行中": "Executando",
    "只读查询": "consulta somente leitura",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "A conexão somente leitura ao Gmail, QQ, 163 ou caixa de correio IMAP empresarial que suporta código de autorização permite que o Agente pesquise e classifique e-mails reais.",
    "只读收件箱": "caixa de entrada somente leitura",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "Os documentos carregados na base de conhecimento são armazenados localmente no servidor e só podem ser lidos pelos agentes da sua organização.",
    "指": "consulte",
    "指标": "índice",
    "指标 / 维度": "Métricas/Dimensões",
    "指标不是一个数字": "Um indicador não é um número",
    "指标层：数字怎么计算": "Camada indicadora: como calcular números",
    "指标查询": "Consulta de indicador",
    "指标观测": "observação do indicador",
    "指标口径": "Calibre de índice",
    "指标目录": "Catálogo de indicadores",
    "指标网络": "rede de indicadores",
    "指标已映射": "Métricas mapeadas",
    "指标异动与影响分析": "Mudanças nos indicadores e análise de impacto",
    "指标值 *": "Valor do indicador *",
    "至少需要两个周期": "São necessários pelo menos dois ciclos",
    "置信度": "Confiança",
    "置信度 ·": "Confiança ·",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "Os documentos carregados na base de conhecimento são armazenados localmente no servidor e só podem ser lidos pelos agentes da sua organização.",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "Uma base de conhecimento é um repositório de documentos compartilhados em nível de organização. Os documentos carregados serão referenciados automaticamente por todos os Agentes no momento da resposta, o que equivale a dotar todos os Agentes de conhecimentos prévios.",
    "终点 *": "Ponto final *",
    "终端运行": "Execução do terminal",
    "种类型": "tipo",
    "重复任务": "Repetir tarefas",
    "重新尝试": "Tente novamente",
    "重新加载": "recarregar",
    "重要规则": "Regras importantes",
    "周末": "fim de semana",
    "主持人:": "hospedar:",
    "主持人：": "hospedar:",
    "主动来到你面前": "Tome a iniciativa de ir até você",
    "注入": "injeção",
    "中": "meio",
    "只有组织所有者可以购买套餐或充值额度。": "Somente o proprietário da organização pode adquirir planos ou créditos.",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "O endereço de e-mail necessário para o registro é utilizado apenas para verificação da conta e login, e não será utilizado para marketing ou transferido a terceiros.",
    "注销账号": "Cancelar conta",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "Após sair, sua conta, histórico de bate-papo e todos os dados serão excluídos permanentemente e não poderão ser recuperados.",
    "转发": "Avançar",
    "转发到": "encaminhar para",
    "转写已完成，可生成纪要": "A transcrição foi concluída e minutos podem ser gerados",
    "转写中": "Transcrever",
    "状态": "estado",
    "字段": "Campo",
    "字段名称": "Nome do campo",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "O endereço de e-mail necessário para o registro é utilizado apenas para verificação da conta e login, e não será utilizado para marketing ou transferido a terceiros.",
    "自定义类型": "Tipo personalizado",
    "自定义名称、描述和人格": "Personalize nome, descrição e personalidade",
    "自定义周期": "Ciclo personalizado",
    "自动响应指定聊天中的消息": "Responder automaticamente às mensagens em um bate-papo específico",
    "自动应答": "Resposta automática",
    "自动转写生成纪要": "Transcreva e gere minutos automaticamente",
    "自适应卡片": "cartão adaptativo",
    "组": "Grupo",
    "组件理解": "Compreensão dos componentes",
    "注销中...": "Saindo...",
    "组织编辑人数": "Número de editores na organização",
    "组织变动": "mudanças organizacionais",
    "组织": "organizar",
    "自定义界面显示偏好": "Personalize as preferências de exibição da interface",
    "组织存储": "Organize o armazenamento",
    "组织洞察": "insights organizacionais",
    "组织里的某一位 Agent": "Um agente na organização",
    "组织（Workspace）— 协作空间": "Organização (espaço de trabalho) — Espaço de colaboração",
    "组织名称": "Nome da organização",
    "组织成员和自动任务的消费都会记录在这里。": "Aqui serão registrados o consumo dos membros da organização e tarefas automáticas.",
    "组织共享额度": "Cota de compartilhamento da organização",
    "组织文档数": "Número de documentos da organização",
    "组织信号": "sinais organizacionais",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "Uma organização é um espaço de colaboração independente, semelhante ao Workspace do Slack ou à Equipe Feishu. Todos os membros de uma organização compartilham o mesmo conjunto de Agentes e base de conhecimento. você pode:",
    "组织内所有成员共享使用": "Compartilhado por todos os membros da organização",
    "组织与执行": "Organização e Execução",
    "组织知识库": "base de conhecimento organizacional",
    "组织知识库日志": "Registro da base de conhecimento da organização",
    "组织执行": "Execução organizacional",
    "最多展开 3 跳": "Expanda até 3 saltos",
    "最多追溯 3 跳": "Rastreie até 3 saltos",
    "组织与多租户": "Organização e multilocação",
    "组织所有者": "Proprietário da organização",
    "最近更新": "Últimas atualizações",
    "最近观测": "observações recentes",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "O link mínimo utilizável requer apenas quatro objetos. Comece com o indicador principal ao qual você presta atenção todos os dias e complete-o gradualmente mais tarde. Não há necessidade de projetar toda a empresa no início.",
    "最新观测": "Últimas observações",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "À esquerda estão os possíveis impulsionadores ou fontes de cálculo e à direita estão os efeitos do indicador.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "Como PEN_AGENT_API_KEY, ele é passado apenas para este processo local do Pencil.",
    "组织与团队管理": "Organização e gestão de equipes",
    "最后更新：2026 年 5 月": "Última atualização: maio de 2026",
    "作为个人练手 Demo 项目，我们": "Como um projeto de demonstração de treinamento pessoal, nós",
    "最後更新：2026 年 5 月": "Última atualização: maio de 2026",
    "Agent 会怎样使用": "Como o agente será usado",
    "最近用量": "uso recente",
    "作為個人練手 Demo 專案，我們": "Como um projeto de demonstração de prática pessoal, nós",
    "Agent — 你的 AI 团队成员": "Agente – o membro da sua equipe de IA",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "O agente não só pode ser usado na página web da NovaX, mas também pode ser conectado a plataformas externas de mensagens instantâneas. Uma vez conectados, os Agentes compartilham o mesmo conjunto de memórias, habilidades e base de conhecimento em todas as plataformas.",
    "Agent 级别": "Nível do agente",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "Depois que o Agente for iniciado, ele se conectará automaticamente. O status abaixo ficará verde e você poderá começar a usá-lo.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "Agent é a unidade principal da NovaX. Cada Agente é um assistente de IA independente com o seu próprio:",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "O agente cria tarefas cron automaticamente. Os resultados da execução aparecem na conversa como mensagens. Você pode pausar, retomar ou excluir tarefas criadas na guia Tarefas.",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "O agente pode criar tarefas em segundo plano que são executadas regularmente sem que você precise acioná-las manualmente. Mude para a guia “Tarefas” na parte superior da interface de conversa para visualizar e gerenciar.",
    "Agent 在对话中输出的文件会显示在这里": "Os arquivos gerados pelo Agente na conversa serão exibidos aqui",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agente é o conceito central da NovaX. Ao contrário dos chatbots tradicionais, cada Agente é um agente com",
    "Agent 周报": "Agente semanal",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "O Agente executa automaticamente a solicitação após recebê-la e envia o resultado para a conversa.",
    "AI 图像生成": "Geração de imagens de IA",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "O conteúdo gerado pela IA pode conter erros ou informações imprecisas. Faça seu próprio julgamento e verificação.",
    "DOWNSTREAM · 下游": "A JUSANTE · A jusante",
    "ETL 血缘": "Linhagem ETL",
    "Git 仓库": "Repositório Git",
    "Git 用户名；GitHub App 可填 x-access-token": "Nome de usuário Git; O aplicativo GitHub pode preencher x-access-token",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ e 163 geralmente precisam primeiro ativar o IMAP e criar uma senha ou código de autorização específico do aplicativo.",
    "IMAP 地址": "Endereço IMAP",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Os agentes referem-se automaticamente a esses documentos ao responder perguntas, garantindo que as respostas se ajustem às normas e ao contexto da equipe.",
    "Notion 工作区": "Espaço de trabalho de noção",
    "Codex 智能体底座": "Base de corpo inteligente Codex",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "O conteúdo gerado por IA pode conter erros ou informações imprecisas. Faça seu próprio julgamento e verificação.",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Renderização de formato Markdown, incluindo destaque de código, tabelas, listas, etc.",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "A NovaX rastreia dados e motivadores de negócios de cima para baixo e identifica metas, processos e impactos de execução de baixo para cima.",
    "Nova 点": "Ponto novo",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "A interface do NovaX consiste em uma barra de navegação à esquerda e uma área de conteúdo principal à direita. A barra de navegação oferece cinco entradas principais:",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "A NovaX adota uma arquitetura multi-tenant baseada em organizações (Workspaces). Cada organização é um espaço de colaboração completamente independente, e agentes, bases de conhecimento, habilidades, membros e dados de conversação estão todos isolados.",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "Todos os agentes da NovaX são executados uniformemente no OpenAI Codex e usam",
    "NovaX 是什么": "O que é NovaX",
    "NovaX 是一个": "NovaX é um",
    "NovaX 是一個": "NovaX é um",
    "NovaX Agent 工作区": "Espaço de trabalho do Agente NovaX",
    "PG 思维": "Pensamento do PG",
    "Prompt 模板": "Modelo de prompt",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Modelo de prompt, usando {{payload}} para representar os dados recebidos",
    "QQ 邮箱": "Caixa de correio QQ",
    "S3 兼容地址（AWS S3 可留空）": "Endereço compatível com S3 (AWS S3 pode ser deixado em branco)",
    "Schema 浏览": "Navegação no esquema",
    "secret_... 或 ntn_...": "segredo_... ou ntn_...",
    "Session Token（可选）": "Token de sessão (opcional)",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX é uma plataforma de colaboração de IA multiagente. Você pode pensar nisso como um ambiente de trabalho de equipe de IA: vários agentes de IA são criados aqui, cada um com seu próprio nome, personalidade, experiência e espaço de trabalho. Eles podem ler e gravar arquivos, executar códigos, pesquisar na web, gerenciar tarefas e trabalhar juntos como verdadeiros membros da equipe.",
    "Skill 市场": "Mercado de habilidades",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX oferece suporte a estruturas multiorganizacionais. As organizações podem ser gerenciadas em \"Configurações → Geral\":",
    "Shift+Enter 换行，Enter 发送。": "Shift + Enter para quebrar a linha, Enter para enviar.",
    "SQL 数据库": "Banco de dados SQL",
    "SSH 私钥": "Chave privada SSH",
    "Thread 回复": "Resposta do tópico",
    "TLS 加密": "Criptografia TLS",
    "Token 用量榜": "Lista de uso de token",
    "UPSTREAM · 上游": "A montante · a montante",
    "Web 设计工程师": "Engenheiro de web design",
    "Webhook 名称，如 GitHub Push...": "Nome do webhook, como GitHub Push...",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "Soul é o item de configuração mais importante do Agente. Determina o posicionamento do papel do Agente, áreas de especialização e comportamento. Escrever bem o Soul é a chave para tornar o Agent verdadeiramente útil.",
    "Soul 人设指令": "Comando de personagem de alma",
    "Webhook URL（含 Secret）": "URL do webhook (incluindo segredo)",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "O Webhook permite que sistemas externos acionem tarefas de execução de agentes por meio de solicitações HTTP e é adequado para interface com CI/CD, monitoramento de alarmes, envio de formulários e outros sistemas.",
    "Soul（人设指令）": "Alma (comando de personalidade)",
    "Webhook 事件触发": "Gatilho de evento de webhook"
  },
  "fr": {
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "— Affichez les tâches en arrière-plan effectuées par l'agent, y compris la progression, l'état et les résultats.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "— Affichez les agents et les membres de votre organisation, créez de nouveaux agents ou invitez de nouveaux membres.",
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— Basculez vers une autre organisation en un clic, et l'agent et la base de connaissances changeront en conséquence.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "— Donner la reconnaissance aux agents pour faciliter la différenciation dans les scénarios multi-agents.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— Définir la personnalité, l'expertise et le comportement de l'agent. Par exemple, vous pouvez créer un agent « Code Reviewer » pour vous concentrer sur la qualité du code, puis créer un agent « Product Manager » pour le rendre performant dans l'analyse des exigences.",
    "— 个人偏好、组织管理、账号安全。": "—Préférences personnelles, gestion organisationnelle et sécurité du compte.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— Dites à l'agent de qui il s'agit et dans quoi il se spécialise.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— Gérez les compétences installées de l'agent ou installez de nouvelles compétences du marché.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— Quel format, style et étapes doivent être suivis pour répondre.",
    "— 管理共享文档，上传和浏览 .md 文件。": "— Gérez les documents partagés, téléchargez et parcourez les fichiers .md.",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "— Peut gérer les agents, les bases de connaissances et les membres, mais ne peut pas modifier les paramètres de l'organisation.",
    "— 接入 Zoom 会议或聊天。": "— Rejoignez une réunion ou un chat Zoom.",
    "— 浏览和安装技能，管理已发布的技能。": "— Parcourez et installez les compétences, et gérez les compétences publiées.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "— Vous pouvez utiliser l'agent, participer à des conversations et accéder à la base de connaissances, mais vous ne pouvez pas effectuer d'opérations de gestion.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "— Donnez à l'agent la possibilité de créer et de gérer des tâches planifiées.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— Autorisez l'agent à définir des tâches planifiées ou périodiques, telles que la génération de rapports chaque matin.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "— Autoriser les agents à appeler d'autres agents pour réaliser une collaboration entre agents.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "— Laissez les agents créer eux-mêmes de nouvelles compétences et les publier sur le marché pour que d'autres installations d'agents puissent les utiliser.",
    "— 让 Agent 能够自动生成和发布新技能。": "— Permettez aux agents de générer et de publier automatiquement de nouvelles compétences.",
    "— 什么该做，什么不该做。": "— Que faire et ne pas faire.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— Le propriétaire dispose de toutes les autorisations, les administrateurs peuvent gérer les agents et les membres, et les membres ordinaires peuvent utiliser les agents et les bases de connaissances.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "—Créez un bot via BotFather et remplissez le jeton du bot pour vous connecter.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— Accès via iLink pour interagir avec l'agent dans WeChat.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— Élargissez les limites des capacités de l'agent en installant différentes compétences.",
    "— 通过 Telegram Bot 接入。": "— Accès via Telegram Bot.",
    "— 通过企业微信或 iLink 接入。": "— Accès via Business WeChat ou iLink.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Parlez à l'agent directement à Feishu via le robot Feishu.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "— Les enregistrements de discussion avec l'agent prennent en charge la sortie de streaming en temps réel.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "— Dispose d'autorisations complètes pour gérer les paramètres, les membres et les agents de l'organisation. Chaque organisation n'a qu'un seul propriétaire.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "— L'interface principale de communication avec les agents, avec la liste des agents à gauche et la fenêtre de discussion à droite.",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "— Autoriser les agents à appeler d'autres agents dans l'espace de travail pour implémenter des pipelines automatisés entre agents. Par exemple, une fois l'analyse terminée, l'agent A transfère automatiquement les résultats à l'agent B pour générer un rapport.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— Invitez les membres à rejoindre l'organisation actuelle par e-mail sur la page « Équipe ».",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— Parcourez toutes les compétences disponibles dans le « Marché des compétences » dans la barre de navigation et affichez les détails et les instructions d'installation.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— Dans l'onglet « Compétences » de l'interface de dialogue, installer ou désinstaller les compétences de l'Agent actuel. Différents agents peuvent avoir différents ensembles de compétences installés.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "—Créez une application sur la plate-forme ouverte Feishu, obtenez l'ID d'application et le secret d'application, puis accédez-y. Les membres de l'équipe peuvent discuter directement avec l'agent sur Feishu.",
    "— 最多可创建 2 个组织。": "— Peut créer jusqu'à 2 organisations.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— L'agent peut lire et écrire des fichiers et exécuter du code dans le répertoire du système de fichiers spécifié. Différents agents peuvent gérer différents répertoires de projets.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": ", à but non lucratif, ne facturera aucun frais aux utilisateurs et ne procédera à aucune promotion commerciale ni vente sous quelque forme que ce soit.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": ", n'a pas de but lucratif, ne facturera aucun frais aux utilisateurs et ne procédera à aucune promotion commerciale ni vente sous quelque forme que ce soit.",
    "、": ",",
    ".pen 文件": "fichier .pen",
    "· 点击启用": "· Cliquez pour activer",
    "· 点击召唤": "· Cliquez pour invoquer",
    "· 用于 Agent 理解": "· Utilisé pour la compréhension des agents",
    "，同时可以被邀请加入他人的组织。": ", et peut être invité à rejoindre les organisations d’autres personnes.",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": ", sert uniquement à démontrer la faisabilité technique de la plateforme de collaboration multi-agents IA. Ce produit",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": ", sert uniquement à démontrer la faisabilité technique de la plateforme de collaboration multi-agents IA. Ce produit",
    "@提及": "@mentions",
    "（一次性延时任务）": "(Tâche différée unique)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst Sur la base des données ci-dessus, effectuez une analyse du paysage concurrentiel",
    "（由 Soul 指令定义）": "(défini par la directive Soul)",
    "@提及机制": "Mécanisme de @mention",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer Organisez l'analyse ci-dessus dans un rapport PDF",
    "← 返回": "← Retour",
    "← 返回列表": "← Retour à la liste",
    "← 返回详情": "← Retour aux détails",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher Recherchez les données du marché étranger des véhicules à énergie nouvelle en 2024",
    "/ 月": "/ lune",
    "+ 记录": "+ enregistrement",
    "+ 添加": "+ ajouter",
    "✓ 反馈已提交，感谢您的意见！": "✓ Des commentaires ont été soumis, merci pour votre avis !",
    "✓ 已连接": "✓ Connecté",
    "+ 创建新组织": "+ Créer une nouvelle organisation",
    "163 邮箱": "163 E-mail",
    "1. 产品性质": "1. Nature du produit",
    "2 个组织": "2 organisations",
    "1. 產品性質": "1. Nature du produit",
    "2. 数据与隐私": "2. Données et confidentialité",
    "2. 資料與隱私": "2. Données et confidentialité",
    "3. 第三方服务": "3. Services tiers",
    "3. 第三方服務": "3. Services tiers",
    "30 分钟后提醒我开会": "Rappelle-moi une réunion dans 30 minutes",
    "5. 免责声明": "5. Avis de non-responsabilité",
    "4. 服務可用性": "4. Disponibilité des services",
    "4. 服务可用性": "4. Disponibilité des services",
    "5. 免責聲明": "5. Avis de non-responsabilité",
    "安装给以下 Agent：": "Installé sur les agents suivants :",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "Connectez l'agent à la plate-forme de messagerie instantanée que votre équipe utilise et discutez directement dans des discussions de groupe ou des discussions privées.",
    "把世界级设计标准": "Apporter des normes de conception de classe mondiale",
    "把指标接回真实数据": "Reliez les indicateurs aux données réelles",
    "保存对象": "enregistrer l'objet",
    "保存失败": "Échec de l'enregistrement",
    "保存修改": "Enregistrer les modifications",
    "保存中...": "Économie...",
    "保存中…": "Économie…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "Le rapport résume régulièrement l'utilisation de NovaX par l'ensemble de l'organisation et découvre également des informations commerciales dignes d'attention basées sur des données sous-jacentes telles que les bases de données, la BI, Git et les boîtes aux lettres auxquelles l'organisation s'est connectée.",
    "被移出了组织": "Supprimé de l'organisation",
    "安装方式": "Méthode d'installation",
    "6. 联系方式": "6. Coordonnées",
    "安装不同的": "Installer différent",
    "6. 聯絡方式": "6. Coordonnées",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "Ce produit ne convient pas aux scénarios professionnels tels que les conseils médicaux, les consultations juridiques et la prise de décision financière.",
    "本次分析提示": "Conseils pour cette analyse",
    "本期 SKILL": "COMPÉTENCE dans ce numéro",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "L'ontologie n'est pas une autre base de connaissances. Il relie les objets, les indicateurs, les données et les responsables de l'entreprise dans une carte raisonnable, permettant à l'Agent non seulement de « trouver des informations », mais aussi de savoir d'où vient un chiffre, pourquoi il change et quel impact il aura.",
    "本体加载失败": "Le chargement de l'ontologie a échoué",
    "本体视图": "vue ontologie",
    "本体完整度": "Intégrité ontologique",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "L'ontologie enregistre uniquement la structure et le calibre, et les informations d'identification de la base de données sont gérées par le connecteur ou les variables d'environnement et n'entrent pas dans le graphique métier.",
    "本月": "ce mois-ci",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "Comparez les valeurs d'observation de l'indicateur, puis suivez le calcul et le lignage des données pour déterminer à quelle couche le changement s'est produit.",
    "必填": "Requis",
    "避免把相关性误判为因果": "Évitez de confondre corrélation et causalité",
    "编辑": "modifier",
    "编辑定义": "Modifier la définition",
    "编辑对象": "Modifier l'objet",
    "编辑了 Agent": "Agent modifié",
    "编辑业务对象": "Modifier un objet métier",
    "标识（可选）": "Logo (facultatif)",
    "标题": "titre",
    "表、视图、ETL 模型": "Tables, vues, modèles ETL",
    "补充口径、边界或业务背景": "Compléter le calibre, la frontière ou le contexte commercial",
    "补充驱动关系": "Relation de conduite complémentaire",
    "补充影响关系": "Relation d'influence supplémentaire",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "Ce produit appelle le service OpenAI Codex pour gérer les demandes de conversation. Le contenu de vos conversations sera traité conformément à la politique de confidentialité de ce service. Il est recommandé d'éviter de saisir des informations personnelles sensibles dans les conversations.",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "Ce produit appelle le service OpenAI Codex pour gérer la demande de conversation. Le contenu de vos conversations sera traité conformément à la politique de confidentialité de ce service. Il est recommandé d'éviter de saisir des informations personnelles sensibles dans les conversations.",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "Ce produit ne convient pas aux scénarios professionnels tels que les conseils médicaux, les consultations juridiques et la prise de décision financière.",
    "不保证": "Aucune garantie",
    "不保證": "Aucune garantie",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "Writing Soul – C’est l’étape la plus cruciale. L'âme détermine la manière dont l'agent comprend les tâches et répond aux questions. Plus c’est écrit de manière spécifique, meilleures seront les performances de l’agent.",
    "不会主动收集": "Ne collectera pas activement",
    "不会用于商业化运营": "Ne sera pas utilisé pour des opérations commerciales",
    "不會用於商業化營運": "Ne sera pas utilisé pour des opérations commerciales",
    "参会者": "Participants",
    "参与聚合、关联和过滤的列": "Colonnes impliquées dans l'agrégation, l'association et le filtrage",
    "仓库地址": "Adresse de l'entrepôt",
    "仓库协作": "collaboration entre entrepôts",
    "草稿": "brouillon",
    "策": "politique",
    "查看": "Vérifier",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "Différents agents peuvent avoir des âmes complètement différentes. Par exemple, une équipe peut avoir plusieurs agents avec différents rôles tels que « chercheur », « rédacteur » et « réviseur de code » en même temps.",
    "不會主動收集": "Ne collectera pas activement",
    "查看全部模型 →": "Voir tous les modèles →",
    "查看它负责哪些指标、目标或业务流程。": "Découvrez de quelles mesures, objectifs ou processus métier il est responsable.",
    "查看完整影响路径": "Afficher le chemin d’impact complet",
    "查找文件": "Rechercher des fichiers",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "Contrairement aux outils de conversation IA ordinaires, l'agent de NovaX dispose d'une mémoire persistante, de compétences installables, prend en charge la collaboration entre plusieurs personnes et peut se connecter à des plateformes de messagerie instantanée telles que Feishu, Telegram et WeChat pour intégrer l'IA dans votre flux de travail quotidien.",
    "查看每个技能的功能说明、安装量和评分。": "Affichez les descriptions des fonctionnalités, les installations et les évaluations pour chaque compétence.",
    "产品 PRD、技术架构文档": "PRD produit, documents d'architecture technique",
    "常见问题和标准回答": "Foire aux questions et réponses standard",
    "产品文档和技术架构": "Documentation produit et architecture technique",
    "常见问题和解答模板": "Modèle de FAQ",
    "成员（Member）": "Membre",
    "抽出一位大师的思维，": "Faites ressortir les pensées d'un maître,",
    "成员与权限": "Membres et autorisations",
    "处理事件": "gérer les événements",
    "触发次数": "Nombre de déclencheurs",
    "创建": "créer",
    "创建 Agent": "Créer un agent",
    "创建 Webhook": "Créer un webhook",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "Après avoir créé un webhook, les systèmes externes (GitHub, Stripe, Sentry, etc.) peuvent se déclencher automatiquement via HTTP POST",
    "创建第一个指标": "Créez votre premier indicateur",
    "创建核心指标": "Créer des indicateurs de base",
    "成员 / Agent": "Membre/Agent",
    "创建会议": "Créer une réunion",
    "创建了 Agent": "Agent créé",
    "创建类型": "Créer un type",
    "创建你的第一个 Agent": "Créez votre premier agent",
    "创建企业自建应用，获取凭证": "Créez une application d'entreprise auto-construite et obtenez des informations d'identification",
    "创建失败": "La création a échoué",
    "创建时间": "temps de création",
    "创建中...": "Création...",
    "创建中…": "Création…",
    "创建组织": "Créer une organisation",
    "持久记忆": "souvenir durable",
    "创刊导读": "Introduction à la création de la publication",
    "创作与协作": "Créer et collaborer",
    "此文件类型暂不支持预览": "Ce type de fichier ne prend actuellement pas en charge l'aperçu",
    "次": "De second ordre",
    "从 160+ 专业角色模板中选择": "Choisissez parmi plus de 160 modèles de rôles professionnels",
    "从数据到行动的业务地图": "Cartographie d'entreprise des données à l'action",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "Déterminez la sémantique exacte du même mot au sein de l’entreprise à partir des définitions d’objets métier et de métriques.",
    "从业务世界的第一个对象开始": "Commencez par le premier objet du monde des affaires",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "Commencez par les revenus, le volume des commandes, les taux de conversion ou les résultats commerciaux qui vous intéressent le plus.",
    "从预设创建": "Créer à partir d'un préréglage",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "En plus de l'interface web, l'Agent de NovaX peut également se connecter aux plateformes de messagerie instantanée :",
    "代码读取": "lecture de code",
    "待开始": "A commencer",
    "待认领": "À réclamer",
    "大": "grand",
    "待验证": "A vérifier",
    "单次任务": "tâche unique",
    "单次执行": "exécution unique",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "Lorsque vous demandez des métriques, un lignage, une attribution ou un impact, l'agent NovaX lit d'abord le contexte de l'ontologie pertinente. La base de connaissances fournit « le texte et le contexte originaux », et l'ontologie fournit « une structure d'entreprise déterminée », et les deux peuvent être liés par des preuves.",
    "当前仅支持 .md 格式": "Actuellement, seul le format .md est pris en charge",
    "当前值": "valeur actuelle",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "Après la création, le système génère une URL et une clé uniques, qui peuvent être déclenchées par un système externe envoyant une requête POST à ​​l'URL.",
    "当前": "actuel",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "Enregistrez les bases de données, les tables de données et les champs clés, puis utilisez la « lignée des données » ou la « dépendance de calcul » pour vous connecter aux indicateurs. À l'avenir, lorsque l'agent sera interrogé sur le calibre, il pourra trouver la véritable source via le lien au lieu de deviner sur la base du document.",
    "登记数据来源": "Enregistrer les sources de données",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "Enregistrez les sources de données, les tables et les champs, puis connectez-vous aux indicateurs à l'aide de relations de « lignage des données » ou de « dépendance de calcul ».",
    "登记数据资产": "Enregistrer les actifs de données",
    "登录账号": "Compte de connexion",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "Créez jusqu'à 2 organisations, une pour différents projets ou équipes.",
    "等待 Agent 连接...": "En attente de la connexion de l'agent...",
    "等待连接成功": "Attendez une connexion réussie",
    "等待确认": "En attente de confirmation",
    "等待扫码...": "En attente de numérisation...",
    "等待中": "En attendant",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "Numéro 1 · Compilé par votre équipe d'agents · Ce numéro",
    "登录状态已失效，请重新登录": "Le statut de connexion a expiré, veuillez vous reconnecter",
    "待上线": "Être en ligne",
    "的 AI 协作者。": "de collaborateurs en IA.",
    "第四步：开始对话": "Étape 4 : Démarrer une conversation",
    "第二步：认识你的界面": "Étape 2 : Connaissez votre interface",
    "第一期正在准备中": "Le premier numéro est en préparation",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "Cliquez sur « Générer un code QR » et le système lancera le processus de connexion à la page Web WeChat.",
    "点击「生成二维码」获取微信登录码": "Cliquez sur \"Générer le code QR\" pour obtenir le code de connexion WeChat",
    "点击连接，系统自动完成配置": "Cliquez sur Connecter et le système termine automatiquement la configuration.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "Cliquez sur le bouton ci-dessous pour accéder à la plate-forme ouverte Feishu et le système créera automatiquement une application auto-construite pour vous.",
    "点": "indiquer",
    "钉钉": "DingTalk",
    "定时任务": "tâches planifiées",
    "第三步：创建你的第一个 Agent": "Étape 3 : Créez votre premier agent",
    "第五步：丰富 Agent 的知识": "Étape 5 : Enrichir les connaissances de l’agent",
    "定位变化": "Changements de positionnement",
    "定义第一个核心指标": "Définir le premier indicateur clé",
    "定义核心指标": "Définir les métriques de base",
    "定义业务类型": "Définir le type d'entreprise",
    "定义这个 Agent 的性格、指令和能力...": "Définissez la personnalité, les commandes et les capacités de cet agent...",
    "定义证据": "Définir les preuves",
    "定义指标口径": "Définir le calibre de l'indicateur",
    "第一步：注册和登录": "Étape 1 : Inscrivez-vous et connectez-vous",
    "调整对话消息流中的文字大小": "Ajuster la taille du texte dans le flux de conversation",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Lisez la structure, les composants et les commentaires du fichier Figma pour permettre à l'agent de comprendre la conception de l'interface, les spécifications de conception et les commentaires collaboratifs.",
    "读取内容": "Lire le contenu",
    "读取网页": "Lire des pages Web",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "Après l'avoir lu, vous pouvez vous lancer directement dans son dialogue et continuer à poser des questions sur les causes, les impacts et les prochaines étapes.",
    "端口": "port",
    "断开连接": "Déconnecter",
    "断开失败": "Échec de la déconnexion",
    "定时任务（MetaSchedule）": "Tâches planifiées (MetaSchedule)",
    "对话": "dialogue",
    "对象": "objet",
    "对象存储": "stockage d'objets",
    "对象类型 *": "Type d'objet *",
    "对象列表": "liste d'objets",
    "对象已连接": "L'objet est connecté",
    "对象已删除": "Objet supprimé",
    "对应 Agent 暂不可用": "L'Agent correspondant est temporairement indisponible",
    "独立身份、独立记忆、独立技能": "Identité indépendante, mémoire indépendante, compétences indépendantes",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "Plusieurs fichiers sont séparés par des virgules ; si elle est laissée vide, la plage visible du jeton lui-même sera utilisée.",
    "多媒体": "multimédia",
    "多人": "plusieurs personnes",
    "多维表格": "tableau multidimensionnel",
    "对话系统": "Système de dialogue",
    "多 Agent 接力": "Relais multi-agents",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "La conversation est la méthode d'interaction principale de NovaX. Chaque agent conserve un historique de conversation indépendant. Dans l’interface de conversation, il y a trois onglets en haut :",
    "额度信息加载失败": "Échec du chargement des informations sur le quota",
    "多平台连接": "Connectivité multiplateforme",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "Le quota est partagé par les membres de l'organisation et toute consommation est déduite de l'organisation actuelle.",
    "二": "deux",
    "二维码已过期，请重新生成": "Le code QR a expiré, veuillez le régénérer",
    "发起会议": "Démarrer une réunion",
    "发送人": "expéditeur",
    "发送时间": "Heure d'envoi",
    "翻开 →": "Ouvrir →",
    "反馈": "retour",
    "反馈中心": "Centre de commentaires",
    "返回": "retour",
    "方向": "direction",
    "方向未知": "direction inconnue",
    "访问 Token": "Jeton d'accès",
    "飞书 / Lark": "Feishu / Alouette",
    "飞书开放平台": "Plateforme ouverte Feishu",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "L'application Feishu a été créée. Ajoutez le bot au groupe Feishu pour commencer à l'utiliser.",
    "费曼思维": "Feynman pense",
    "分析对象": "Objet d'analyse",
    "分析思路": "Idées analytiques",
    "分钟": "minute",
    "否": "Non",
    "额外额度": "Crédit supplémentaire",
    "额度与账单": "Limite de crédit et facture",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "Le serveur vérifiera d’abord la clé Pencil CLI. La génération de conception est corrigée à l'aide de Codex 5.6 sol · high et ne fonctionne que sur les fichiers .pen dans l'espace de travail actuel de l'agent.",
    "服务器已连接，等待 Bot 上线...": "Le serveur est connecté, attendant que le Bot se connecte...",
    "负向": "Négatif",
    "负责人": "responsable",
    "复制": "copie",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "Copiez la commande suivante sur le terminal et exécutez-la. L'agent se connectera automatiquement au serveur NovaX.",
    "富文本卡片": "Carte de texte enrichi",
    "覆盖确认": "Confirmation de couverture",
    "刚刚": "juste",
    "分析完成后：": "Une fois l’analyse terminée :",
    "个": "individuel",
    "个对象": "objets",
    "个可用技能": "compétences disponibles",
    "个人存储": "stockage personnel",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "La disponibilité continue, la stabilité ou la durabilité des données du Service. Le Service peut être suspendu, modifié ou résilié à tout moment sans préavis. N'utilisez pas ce produit dans un environnement de production ou pour stocker des données importantes.",
    "个人文档数": "Nombre de documents personnels",
    "个人知识库日志": "Journal de la base de connaissances personnelle",
    "个属性": "attributs",
    "个已有来源": "sources existantes",
    "个字段": "champs",
    "给任务取个名字...": "Donnez un nom à la tâche...",
    "更新计划": "Plan de mise à jour",
    "格式文档，上传后立即生效。": "Format du document, en vigueur immédiatement après le téléchargement.",
    "工作区标识（可选）": "ID de l'espace de travail (facultatif)",
    "工作区名称（可选）": "Nom de l'espace de travail (facultatif)",
    "工作日": "jours ouvrables",
    "工作通知": "avis d'emploi",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "DISPONIBILITÉ CONTINUE, STABILITÉ OU DURABILITÉ DES DONNÉES DES SERVICES. Le Service peut être suspendu, modifié ou résilié à tout moment sans préavis. N'utilisez pas ce produit dans un environnement de production ou pour stocker des données importantes.",
    "公开仓库（无需凭据）": "Dépôt public (aucune information d'identification requise)",
    "公式、单位、粒度与负责人": "Formule, unité, granularité et responsable",
    "工作原理": "Principe de fonctionnement",
    "个人练手的技术演示项目（Demo）": "Projet de démonstration technique (Démo) pour la pratique personnelle",
    "供 Pencil 内的 Codex Agent 使用": "À utiliser par l'agent du Codex dans Pencil",
    "共同规则": "règles communes",
    "共同记忆": "mémoire partagée",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "Il n'existe actuellement aucun document pouvant être associé dans la base de connaissances partagée. Vous pouvez ajouter des preuves après avoir enregistré.",
    "关闭": "fermeture",
    "关闭简报": "Fermer la présentation",
    "关闭上传选择": "Fermer la sélection de téléchargement",
    "关闭使用引导": "Fermer le guide d'utilisation",
    "关闭消息导航": "Désactiver la navigation dans les messages",
    "关键字段": "Champs clés",
    "关系名称": "nom de la relation",
    "关系说明": "Description de la relation",
    "关系有证据": "Il existe des preuves de relation",
    "关系证据": "preuve de relation",
    "观测日期": "Date d'observation",
    "观测值已删除": "Observation supprimée",
    "观远 BI": "Guanyuan BI",
    "观远 BI 地址": "Adresse BI de Guanyuan",
    "观远 BI 密码": "Mot de passe Guanyuan BI",
    "管理": "gérer",
    "功能详解": "Explication détaillée des fonctions",
    "工作目录": "répertoire de travail",
    "规划中": "En cours de planification",
    "国内平台": "Plateforme nationale",
    "個人練手的技術展示專案（Demo）": "Projet de démonstration de technologie de pratique personnelle (Démo)",
    "管理员（Admin）": "Administrateur",
    "还没有积累私有记忆": "Aucune mémoire privée n'a encore été accumulée",
    "还没有上游驱动": "Il n'y a pas encore de pilote en amont",
    "还没有数据血缘": "Pas encore de traçage de données",
    "还没有下游影响": "Pas encore d’effets en aval",
    "还没有血缘关系。": "Il n'y a pas encore de lien de sang.",
    "还没有执行对象": "Aucun objet d'exécution pour l'instant",
    "还没有指标": "Pas encore d'indicateurs",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "Vous devez également partager la page cible avec cette intégration dans Notion.",
    "海外平台": "Plateforme à l'étranger",
    "还没有产生额度消费": "Aucun quota de consommation n'a encore été engagé",
    "规定行为": "comportement prescrit",
    "核心概念": "concepts de base",
    "核心指标": "indicateurs de base",
    "环比变化": "Changement d'un mois à l'autre",
    "恢复": "récupérer",
    "会话文件": "fichier de session",
    "会议 ·": "Réunion ·",
    "会议集成": "Intégration de conférence",
    "会议纪要": "procès-verbal de réunion",
    "会议链接或 ID": "Lien ou identifiant de la réunion",
    "会议密码:": "Mot de passe de la réunion :",
    "会议时长（分钟）": "Durée de la réunion (minutes)",
    "会议主题": "Thème de la conférence",
    "活跃": "actif",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Vérifiez la connexion en fonction du GuanCLI officiel de Guanyuan. Après connexion, les pages, cartes, jeux de données, ETL, indicateurs et ChatBI peuvent être lus. La création, la modification et la suppression ne sont pas autorisées par défaut.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "Basé sur le protocole WeChat iLink, l'agent peut directement envoyer et recevoir des messages privés après avoir scanné le code QR. Il est recommandé d'utiliser un compte WeChat dédié comme transporteur d'agent.",
    "即将推出": "à venir",
    "计算 / 映射表达式": "Expressions de calcul/cartographie",
    "计算、影响与责任关系": "Calcul, impact et responsabilité",
    "计算公式": "Formule de calcul",
    "计算口径": "Calculer le calibre",
    "记录定义、口径或事实所在位置": "Définition, calibre ou emplacement factuel du dossier",
    "记录两个以上周期": "Enregistrez plus de deux cycles",
    "记录两个周期的数据后即可比较变化。": "Les changements peuvent être comparés après avoir enregistré les données pendant deux périodes.",
    "记录数值": "valeur d'enregistrement",
    "记录中…": "Enregistrement…",
    "纪要": "résumé",
    "技能": "Compétence",
    "核心内置技能": "Compétences de base intégrées",
    "记住与你的所有历史对话（": "Rappelez-vous toutes les conversations historiques avec vous (",
    "技能。安装后直接在对话中用自然语言描述即可：": "Compétence. Après l'installation, décrivez-le simplement en langage naturel dans la conversation :",
    "技能（Skill）— 能力扩展": "Compétence - extension des capacités",
    "技能创作（MetaSkill）": "Création de compétences (MetaSkill)",
    "技能分为系统内置技能和社区发布的技能。": "Les compétences sont divisées en compétences intégrées au système et compétences publiées par la communauté.",
    "技能模块": "Module de compétences",
    "技能市场": "marché des compétences",
    "技能市场分为两个维度：": "Le marché des compétences se divise en deux dimensions :",
    "加入 Zoom 会议": "Rejoindre une réunion Zoom",
    "加入会议": "Rejoindre une réunion",
    "加入了组织": "A rejoint l'organisation",
    "加载中...": "chargement...",
    "加载中…": "chargement…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "Compatible avec AWS S3, MinIO et la plupart des stockages d'objets du protocole S3",
    "简": "simple",
    "简报": "briefing",
    "简报加载失败": "Le briefing n'a pas pu être chargé",
    "简报生成失败": "La génération du briefing a échoué",
    "建立关系": "établir des relations",
    "建立血缘": "Établir une lignée",
    "建立业务关系": "Établir des relations d'affaires",
    "建立中…": "Bâtiment…",
    "建议从一个核心指标开始": "Il est recommandé de commencer par un indicateur de base",
    "建议使用数据库侧的只读账号": "Il est recommandé d'utiliser un compte en lecture seule côté base de données",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "Il est recommandé d'enregistrer d'abord une source de données, un indicateur principal et un objectif commercial, puis de les connecter.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "Il est recommandé d'accorder uniquement current_user:read, file_content:read, file_comments:read",
    "将": "Volonté",
    "将 App ID 和 App Secret 填入下方": "Remplissez l'ID d'application et le secret d'application ci-dessous",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "Déployez cet agent en tant que Discord Bot pour interagir dans le canal du serveur.",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "Les compétences sont des modules fonctionnels pouvant être installés sur les Agents. Chaque compétence confère à l'Agent une capacité spécifique. NovaX possède des compétences de base intégrées et propose également un marché de compétences vous permettant de découvrir et d'installer davantage de fonctionnalités :",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "Les compétences sont des modules qui étendent les capacités des agents. Différents agents peuvent être installés avec différents ensembles de compétences, tout comme les employés sont équipés de différents outils.",
    "接入飞书": "Accéder à Feishu",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Accédez aux pages, ensembles de données, ETL et systèmes d'indicateurs de Guanyuan BI, permettant à cet agent de comprendre et d'analyser directement les données d'exploitation de l'entreprise.",
    "接入微信": "Accéder à WeChat",
    "揭开第一期": "Dévoilez le premier numéro",
    "结构搭好后，Agent 会自动使用": "Une fois la structure configurée, l'agent l'utilisera automatiquement",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "Les relations structurelles donnent des cheminements aux candidats ; la véritable attribution nécessite toujours une combinaison d’observations, de preuves et de conditions commerciales.",
    "结构信息充足": "Informations structurelles suffisantes",
    "解释业务": "expliquer les affaires",
    "仅供": "seulement",
    "仅管理员可删除组织知识库文档": "Seuls les administrateurs peuvent supprimer les documents de la base de connaissances de l'organisation",
    "仅支持 .md 文件": "Prend uniquement en charge les fichiers .md",
    "进 Agent 的肌肉记忆。": "Entrez dans la mémoire musculaire de l'agent.",
    "技能系统": "Système de compétences",
    "角色权限": "Autorisations de rôle",
    "仅所有者可购买": "Uniquement disponible à l'achat par le propriétaire",
    "近 30 天消耗": "Consommation au cours des 30 derniers jours",
    "进入第一期": "Entrez la première période",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "Accédez à la page « Conversation » et cliquez sur un agent dans la liste de gauche pour accéder au chat. Envoyez un message dans la zone de saisie et l'agent diffusera la réponse en temps réel. Prise en charge des conversations :",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "Entrez dans la page « Équipe » et cliquez sur le bouton « Nouvel agent ». Remplissez le nom et la description de l'agent et créez-le. Après la création, cliquez sur la fiche Agent pour accéder à la page de détails, où vous pourrez :",
    "进行中": "en cours",
    "进行中/待开": "En cours/à ouvrir",
    "竞": "rivaliser",
    "竞对与行业": "Concurrence et industrie",
    "聚合方式": "Méthode d'agrégation",
    "可留空自动生成，例如 contract": "Peut être laissé vide pour générer automatiquement, comme un contrat",
    "可能后果与下游": "Conséquences possibles et en aval",
    "可能原因与上游": "Raisons possibles et en amont",
    "可选": "Facultatif",
    "可选 · 关联共享知识库": "Facultatif · Base de connaissances partagée associée",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "Vous pouvez créer des équipes, des agents ou des projets et établir la responsabilité avec des mesures et des objectifs commerciaux.",
    "可用": "Disponible",
    "可追溯证据": "preuve traçable",
    "客户联系": "contact client",
    "口径、公式、粒度和负责人": "Calibre, formule, granularité et responsable",
    "口径与依赖": "Calibre et dépendance",
    "跨层查看正在形成的业务语义。": "Découvrez la sémantique métier émergente à travers les couches.",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "Accédez à la page « Base de connaissances » et téléchargez le document au format .md. Ces documents deviennent une référence partagée pour tous les Agents. Par exemple, vous pouvez télécharger les spécifications du code de l'entreprise, puis laisser l'agent de révision du code vérifier le code conformément à cette spécification.",
    "来源与流转": "Origine et diffusion",
    "进入左侧导航栏的「知识库」页面。": "Accédez à la page « Base de connaissances » dans la barre de navigation de gauche.",
    "可用 Nova 点": "Points Nova disponibles",
    "类": "gentil",
    "类型说明": "Description du type",
    "类型已删除": "Type supprimé",
    "类型与字段": "Types et champs",
    "快速上手": "Commencez rapidement",
    "理解含义": "comprendre le sens",
    "例：产品评审会、周例会...": "Exemple : Réunion de revue de produit, réunion hebdomadaire...",
    "例如 研究助手": "par ex. assistant de recherche",
    "例如 demo": "Par exemple démo",
    "例如 NovaX 产品团队": "Par exemple, l'équipe produit NovaX",
    "例如 product-design": "Par exemple, la conception de produits",
    "例如 researcher": "Par exemple chercheur",
    "例如：2026-W30 / 2026-07": "Par exemple : 2026-W30/2026-07",
    "例如：合同": "Par exemple : contrat",
    "例如：经营看板 / SQL 查询": "Par exemple : Business Kanban/Requête SQL",
    "例如：库存充足时": "Par exemple : lorsque le stock est suffisant",
    "例如：渠道=自然流量，地区=华东": "Par exemple : canal = trafic naturel, région = Chine orientale",
    "例如：同日 / 7 天后": "Par exemple : le même jour / 7 jours plus tard",
    "例如：支付转化率": "Par exemple : taux de conversion des paiements",
    "例如：SUM(pay_amount)": "Par exemple : SUM(pay_amount)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "Par exemple : SUM(pay_amount) ou commandes.pay_amount → revenue",
    "连接": "connecter",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "Connectez-vous à AWS S3, MinIO ou à un magasin d'objets compatible et laissez l'agent parcourir le répertoire et lire les fichiers dans le préfixe d'autorisation.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "Connectez-vous à un référentiel GitHub, GitLab ou Gitee et laissez cet agent lire le code, analyser les modifications et participer à la collaboration de développement dans le cadre de l'autorisation.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "Connectez-vous à PostgreSQL, MySQL, SQL Server et à d'autres bases de données pour interroger des données professionnelles réelles avec des autorisations en lecture seule.",
    "连接成功": "Connexion réussie",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "Une fois la connexion établie, l'agent accédera automatiquement à votre WeChat et répondra aux messages dans le chat désigné.",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "pour spécifier quel agent répond. Les messages sans @ ne déclencheront aucun agent.",
    "连接飞书": "Connectez-vous à Feishu",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Après s'être connectés à Feishu, les membres de l'équipe peuvent parler directement à l'agent dans le chat de groupe Feishu. Il prend en charge les fonctionnalités natives de Feishu telles que les cartes de texte enrichi, l'envoi et la réception de fichiers et la liaison de calendrier.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "Après connexion, les nœuds de fichiers et les commentaires peuvent être lus, mais il n'est pas ouvert pour modifier le design, publier des commentaires ou gérer l'équipe.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "Après la connexion, les objets peuvent être répertoriés et les fichiers ne dépassant pas 2 Mo dans le préfixe limité peuvent être lus. Le téléchargement, l'écrasement ou la suppression ne sont pas autorisés.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "Après vous être connecté, vous pouvez rechercher et lire les pages autorisées et les blocs de contenu, mais vous n'êtes pas autorisé à créer, modifier ou supprimer des pages.",
    "连接计算来源和业务目标": "Connectez les sources informatiques et les objectifs commerciaux",
    "连接类型": "Type de connexion",
    "连接目标或流程": "Connecter la cible ou le processus",
    "连接你的 AI 引擎": "Connectez votre moteur d'IA",
    "连接上下游": "Connectez-vous en amont et en aval",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "Connectez les conceptions, les documents, les e-mails, le code et les données commerciales pour permettre aux agents de participer à un travail réel dans un cadre clairement autorisé.",
    "连接失败": "La connexion a échoué",
    "连接数据或指标": "Connecter des données ou des métriques",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "Une fois la connexion terminée, ajoutez l'agent au groupe Feishu pour démarrer la conversation.",
    "连接微信": "Connectez-vous à WeChat",
    "连接验证成功": "Vérification de la connexion réussie",
    "连接中...": "De liaison...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "Après deux périodes d'enregistrement consécutives, NovaX calcule les changements et recherche en amont les éventuels facteurs déterminants dans une analyse d'impact.",
    "联网搜索": "Recherche sur Internet",
    "链接": "Lien",
    "列表视图": "vue en liste",
    "临时凭据才需要": "Des informations d'identification temporaires sont uniquement requises",
    "另有": "Aussi",
    "留空会继续使用已加密保存的凭据": "Laissez vide pour continuer à utiliser les informations d'identification enregistrées cryptées",
    "六": "six",
    "六个视图，其实是同一张图": "Six vues, en fait la même image",
    "路径样式（MinIO 常用）": "Style de chemin (couramment utilisé par MinIO)",
    "马斯克思维": "Musk réfléchit",
    "芒格思维": "La pensée de Munger",
    "累计消耗": "Consommation cumulée",
    "来扩展能力": "pour étendre les capacités",
    "没有发现新增内容": "Aucun nouveau contenu trouvé",
    "没有匹配的角色": "Aucun rôle correspondant",
    "没有匹配的消息": "Aucun message correspondant",
    "没有匹配的指标": "Aucune métrique correspondante",
    "没有上游路径": "pas de chemin en amont",
    "没有下游路径": "pas de chemin en aval",
    "没有新增内容": "Rien de nouveau",
    "没有找到匹配的技能": "Aucune compétence correspondante trouvée",
    "没有找到匹配的文件": "Aucun fichier correspondant trouvé",
    "每": "Chaque",
    "连接到飞书、Telegram、微信等": "Connectez-vous à Feishu, Telegram, WeChat, etc.",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "Les messages sans @ aucun agent seront envoyés au groupe mais ne déclencheront pas de réponses d'agent, ce qui facilite la communication entre les membres de l'équipe.",
    "每篇内容都来自": "Chaque contenu provient",
    "每天": "tous les jours",
    "每个用户最多可以创建": "Chaque utilisateur peut créer jusqu'à",
    "每小时": "par heure",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "Chaque couche répond à une question différente et, ensemble, elles forment l'ontologie sur laquelle l'agent peut raisonner.",
    "每月": "par mois",
    "每周": "hebdomadaire",
    "密码": "mot de passe",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "Les mots de passe, les jetons et les clés privées sont uniquement chiffrés et stockés côté serveur et ne seront pas écrits dans les fichiers ou les conversations de l'agent.",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "Chaque agent peut voir le contexte dans la discussion de groupe, afin que les agents suivants puissent directement référencer le résultat de l'agent précédent.",
    "每天早上 9 点给我发一份行业新闻摘要": "Envoyez-moi un résumé de l'actualité du secteur chaque matin à 9h",
    "描述": "décrire",
    "名称": "nom",
    "名称 *": "Nom *",
    "名称不能为空": "Le nom ne peut pas être vide",
    "每周五下午 5 点生成本周工作总结": "Une synthèse du travail de la semaine est générée chaque vendredi à 17h.",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "Le quota gratuit est un quota unique pour l'organisation et est partagé par tous les membres. Actuellement converti à 1 $ = 750 Nova Points.",
    "模板消息": "modèle de message",
    "免费赠送": "cadeau gratuit",
    "名称和头像": "Nom et avatar",
    "模型定义": "Définition du modèle",
    "模型": "Modèle",
    "默认邮箱目录": "Répertoire de boîte aux lettres par défaut",
    "内部群聊": "Chat de groupe interne",
    "内容读取": "Lecture de contenu",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "Les types intégrés forment la sémantique commune de NovaX, et les types personnalisés décrivent votre activité unique.",
    "你": "toi",
    "目录": "Table des matières",
    "明确角色": "clarifier les rôles",
    "模板中用": "Utilisé dans les modèles",
    "模型和": "modèle et",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "Vous pouvez considérer un agent comme un membre virtuel de l’équipe. Ça peut:",
    "你可以随时在设置中注销账号，删除所有关联数据。": "Vous pouvez vous déconnecter de votre compte et supprimer toutes les données associées à tout moment dans les paramètres.",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "Vous pouvez à tout moment vous déconnecter de votre compte dans les paramètres et supprimer toutes les données associées.",
    "女娲 · Skill 造人术": "Technique de création humaine Nuwa·Skill",
    "篇": "Chapitre",
    "频道对话": "Conversation de canal",
    "平台": "plate-forme",
    "平台公告": "Annonce de la plateforme",
    "评估后果": "Évaluer les conséquences",
    "评论读取": "Commentaires lus",
    "凭据已加密保存，": "Les informations d'identification sont enregistrées cryptées,",
    "期望方向": "direction souhaitée",
    "企业微信": "Entreprise WeChat",
    "企业邮箱 / 自定义 IMAP": "E-mail professionnel/IMAP personnalisé",
    "启用（兼容自签名证书）": "Activé (compatible avec les certificats auto-signés)",
    "启用（推荐）": "Activer (recommandé)",
    "启用并验证证书": "Activer et vérifier le certificat",
    "起点 *": "Point de départ *",
    "前": "avant",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "Le contenu de la conversation que vous saisissez lors de l'utilisation est uniquement utilisé pour interagir avec le moteur d'IA et ne sera pas stocké ni utilisé en outre pour entraîner le modèle.",
    "前往": "Aller à",
    "前往飞书开放平台 →": "Accédez à la plateforme ouverte Feishu →",
    "前缀隔离": "isolement du préfixe",
    "乔布斯思维": "Penser l'emploi",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "Le contenu de la conversation que vous saisissez lors de l'utilisation est uniquement utilisé pour interagir avec le moteur d'IA et ne sera pas stocké ni utilisé en outre pour entraîner le modèle.",
    "切换": "changer",
    "前提：Agent 需要安装": "Condition préalable : L'agent doit être installé",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "Changez ou créez des organisations, chaque organisation a des agents et des membres indépendants.",
    "切换中...": "Commutation...",
    "切换组织": "Changer d'organisation",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "Veuillez utiliser la conclusion du briefing pour expliquer davantage les raisons, les impacts possibles et les actions les plus valables que nous devrions entreprendre ensuite.",
    "请输入您的反馈、建议或遇到的问题...": "Veuillez saisir vos commentaires, suggestions ou problèmes...",
    "请填写 App ID 和 App Secret": "Veuillez remplir l'ID de l'application et le secret de l'application",
    "请勿填写网页登录密码": "Veuillez ne pas renseigner le mot de passe de connexion à la page Web",
    "请选择一个角色": "Veuillez sélectionner un rôle",
    "区域": "zone",
    "驱动行动": "conduire une action",
    "取消": "Annuler",
    "全部": "tous",
    "全部对象": "Tous les objets",
    "全部执行对象": "Tous les objets d'exécution",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "La boîte aux lettres est ouverte en mode lecture seule IMAP partout ; le corps de l'e-mail peut être recherché et lu, et les noms des pièces jointes peuvent être consultés. L'e-mail ne sera pas envoyé, supprimé, déplacé ou marqué.",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "Après avoir changé d'organisation, les agents, la base de connaissances et les membres de l'équipe que vous voyez changeront en conséquence.",
    "全员群": "Tous les membres",
    "权限隔离": "Isolement des autorisations",
    "确保 Codex CLI 已安装": "Assurez-vous que Codex CLI est installé",
    "确定": "Bien sûr",
    "确定断开？已保存凭据会被删除。": "Êtes-vous sûr de vous déconnecter ? Les informations d'identification enregistrées seront supprimées.",
    "清除后所有聊天记录将被删除，无法恢复。": "Après l'effacement, tout l'historique des discussions sera supprimé et ne pourra pas être récupéré.",
    "确定删除这个会议？": "Êtes-vous sûr de vouloir supprimer cette réunion ?",
    "确定删除这条指标观测吗？": "Etes-vous sûr de vouloir supprimer cette observation d'indicateur ?",
    "确认断开": "Confirmer la déconnexion",
    "确定清除所有会话？": "Êtes-vous sûr de vouloir effacer toutes les sessions ?",
    "确认已安装。": "Confirmez qu'il est installé.",
    "确定要注销账号吗？": "Êtes-vous sûr de vouloir annuler votre compte ?",
    "全局市场": "marché mondial",
    "群聊": "discussion de groupe",
    "群聊@唤醒": "Discussion de groupe @wake",
    "群聊对话": "Conversation de groupe",
    "确认注销": "Confirmer la déconnexion",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "La discussion de groupe est le scénario de collaboration principal de NovaX. Cliquez sur « Tous les membres » en haut de la liste des agents pour entrer. Tous les agents et membres de l'équipe participant à la discussion de groupe partagent le même espace de conversation.",
    "确认清除": "Confirmer effacer",
    "让组织的重要变化": "Apportez des changements importants à votre organisation",
    "人": "personnes",
    "人格蒸馏 · 女娲造人": "Distillation de la personnalité·Nuwa crée les êtres humains",
    "认证方式": "Méthode d'authentification",
    "任务名称": "Nom de la tâche",
    "仍建议用实际数据验证候选原因。": "Il est toujours recommandé de vérifier les causes potentielles avec des données réelles.",
    "日": "jour",
    "日历联动": "Lien avec le calendrier",
    "日期": "date",
    "任务": "Tâche",
    "群聊中需要通过": "Dans le chat de groupe, vous devez réussir",
    "群聊与多 Agent 协作": "Chat de groupe et collaboration multi-agents",
    "人设和行为规则": "Règles de personnalité et de comportement",
    "三": "trois",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "Si vous avez des questions ou des préoccupations, veuillez contacter le développeur via le canal de commentaires intégré au produit.",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "Après avoir scanné le code QR pour vous connecter à WeChat, l'agent peut vous servir d'assistant WeChat, répondant automatiquement aux messages, gérant les discussions de groupe et gérant les affaires quotidiennes.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "Après avoir scanné le code QR pour se connecter à WeChat, cet agent accède automatiquement aux messages WeChat et peut répondre dans des discussions privées ou des discussions de groupe.",
    "扫码区域": "Zone de numérisation du code",
    "删除": "supprimer",
    "删除观测": "Supprimer l'observation",
    "删除后无法恢复，确定要删除这个文档吗？": "La suppression ne peut pas être restaurée. Êtes-vous sûr de vouloir supprimer ce document ?",
    "删除会议": "Supprimer la réunion",
    "删除了 Agent": "Agent supprimé",
    "删除失败": "Échec de la suppression",
    "删除失败或无权操作": "La suppression a échoué ou aucune autorisation d'exploitation",
    "删除文档": "Supprimer le document",
    "商业专业": "Majeure en affaires",
    "上传": "télécharger",
    "上传到哪里？": "Où télécharger ?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "Après le téléchargement, il peut toujours être consulté séparément dans « Base de connaissances de l'organisation/Ma base de connaissances ».",
    "上传了": "Téléchargé",
    "上传录音": "Télécharger l'enregistrement",
    "上传失败": "Échec du téléchargement",
    "如何创建": "Comment créer",
    "上次：": "Dernière fois:",
    "上次触发": "dernier déclenchement",
    "上次执行": "dernière exécution",
    "上下游网络": "Réseaux amont et aval",
    "上一步": "Étape précédente",
    "上游候选": "candidat en amont",
    "尚未补充业务定义": "Aucune définition d'entreprise n'a encore été ajoutée",
    "尚未连接指标或业务目标。": "Aucune mesure ou objectif commercial n'a encore été connecté.",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "Si vous avez des questions ou des préoccupations, veuillez contacter le développeur via le canal de commentaires intégré au produit.",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "Définissez une tâche planifiée, telle que « Envoyez-moi un rapport quotidien à 9 h 00 tous les jours »",
    "设计创作": "création de conception",
    "设计生成": "génération de conception",
    "设计师包 · DESIGN": "Sac de créateur · DESIGN",
    "三级权限体系": "Système d'autorité à trois niveaux",
    "设置": "installation",
    "谁来行动": "qui agira",
    "什么属于这个类型，什么不属于？": "Qu’est-ce qui appartient à ce genre et qu’est-ce qui n’y appartient pas ?",
    "生成二维码": "Générer un code QR",
    "生成二维码失败": "Échec de la génération du code QR",
    "生成纪要": "Générer des minutes",
    "生成纪要中": "Générer des minutes",
    "生成失败": "Échec de la construction",
    "生成中...": "Générateur...",
    "失败": "échouer",
    "上传文件作为附件。": "Téléchargez le fichier en pièce jointe.",
    "实体与关系来源": "Sources d'entités et de relations",
    "使用": "utiliser",
    "时间": "temps",
    "设定边界": "fixer des limites",
    "使用工具": "Utiliser des outils",
    "使用时只记住两个动作": "N'oubliez pas deux actions lorsque vous l'utilisez",
    "使用引导": "Utilisez le guide",
    "什么是 Agent": "Qu'est-ce qu'Agent",
    "设置头像，从预设中选择或上传自定义图片。": "Définissez un avatar, choisissez parmi les préréglages ou téléchargez une image personnalisée.",
    "使用方式": "Usage",
    "视条件而定": "Sous conditions",
    "是": "Oui",
    "是 / 否": "si",
    "示例：": "Exemple:",
    "适用条件": "Conditions applicables",
    "收到 Webhook 事件: {{payload}}": "Événement Webhook reçu : {{payload}}",
    "收起": "fermer",
    "手动创建": "Créer manuellement",
    "手动记录": "Enregistrement manuel",
    "输入清晰、唯一的业务名称": "Saisissez un nom d'entreprise clair et unique",
    "输入消息，@agent 名字来提问": "Entrez un message, @nom de l'agent pour poser une question",
    "属性": "propriété",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "Les attributs sont utilisés pour unifier la signification commerciale et deviennent également le contexte structuré de l'agent.",
    "属性字段": "champ d'attribut",
    "数": "nombre",
    "数据层：数从哪里来": "Couche de données : d’où viennent les chiffres ?",
    "数据从哪里来，经过什么，最终形成哪个指标": "D'où viennent les données, par quoi passent-elles et quel indicateur est finalement constitué ?",
    "数据分析": "analyse des données",
    "数据观察": "Observation des données",
    "数据集": "Ensemble de données",
    "数据库、表和关键字段": "Base de données, tables et champs clés",
    "数据库地址": "Adresse de la base de données",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "L'accès à la base de données peut automatiquement compléter la parenté et l'observation ; il peut découvrir des corrélations, mais il ne transformera pas automatiquement les corrélations en causalité.",
    "数据库类型": "Type de base de données",
    "数据库密码": "Mot de passe de la base de données",
    "数据库名": "Nom de la base de données",
    "数据血缘": "Lignage des données",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "Le lignage des données répond « d’où viennent les chiffres ? » ; influencer la relation répond « peut-être pourquoi » ; seules les causes et les effets prouvés peuvent répondre « déterminer la cause ».",
    "数据血缘图": "Diagramme de lignage des données",
    "数据与办公": "Données et bureau",
    "数据源": "source de données",
    "数据源、表与字段": "Sources de données, tables et champs",
    "数据资产": "actifs de données",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "Champs de données → Indicateurs de base → Objectifs commerciaux → Responsable",
    "数值来源": "Source de valeur",
    "数字": "nombre",
    "双人": "Double",
    "说明": "illustrer",
    "说明它在业务里代表什么，以及不包含什么": "Expliquer ce que cela représente dans l'entreprise et ce que cela ne comprend pas",
    "私聊": "chat privé",
    "私聊回复": "Réponse par chat privé",
    "私钥口令（可选）": "Mot de passe de clé privée (facultatif)",
    "思考中...": "Pensée...",
    "思维框架": "cadre de réflexion",
    "四": "Quatre",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "Le quatrième niveau n’est pas constitué de quatre répertoires distincts, mais d’un lien entre les faits et l’action. Vous n’avez pas besoin de tout remplir d’un coup, créez simplement d’abord le lien le plus important.",
    "松开以上传 .md 文件": "Relâchez pour télécharger le fichier .md",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "Recherchez et lisez les pages Notion et les blocs de contenu autorisés à l'intégration, permettant à l'agent d'utiliser les documents de l'équipe et le matériel du projet.",
    "搜索会话内的文件": "Rechercher des fichiers au sein d'une session",
    "搜索技能名称、描述或标签...": "Recherchez un nom de compétence, une description ou une balise...",
    "搜索内容": "Rechercher du contenu",
    "搜索项目、团队或 Agent": "Rechercher des projets, des équipes ou des agents",
    "搜索消息...": "Rechercher des messages...",
    "搜索预设角色...": "Rechercher des rôles prédéfinis...",
    "搜索知识库...": "Rechercher dans la base de connaissances...",
    "搜索指标或口径": "Rechercher des métriques ou un calibre",
    "所属层 *": "Couche d'appartenance *",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "Elle continuera également à prêter attention aux renseignements urgents ou importants sur la concurrence, ainsi qu'aux grandes nouvelles sur l'industrie et les orientations politiques, et à promouvoir les changements qui nécessitent réellement l'attention de l'organisation dans ce domaine.",
    "使用者的個人資訊用於任何商業用途。": "Les informations personnelles de l'utilisateur sont utilisées à des fins commerciales.",
    "所有者（Owner）": "Propriétaire",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "Utilisez votre adresse e-mail pour créer un compte. Le système enverra un code de vérification à votre adresse e-mail. Après vérification, définissez un mot de passe pour terminer l'inscription. La première connexion crée automatiquement une organisation par défaut.",
    "适合放入的内容": "Que mettre dedans",
    "提出原因": "Donnez des raisons",
    "提交反馈": "Soumettre des commentaires",
    "提交分析": "Soumettre l'analyse",
    "添加关系": "Ajouter une relation",
    "添加字段": "Ajouter un champ",
    "条关系": "relation",
    "条件性": "conditionnalité",
    "条因果关系": "relation causale",
    "跳": "Saut",
    "跳过引导": "Sauter le démarrage",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Créez, modifiez et exportez des brouillons de conception .pen via Pencil Headless CLI, et le processus de génération utilise toujours le Codex.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Interagissez avec l'agent via Telegram Bot, prenant en charge la messagerie instantanée et le traitement de fichiers à l'échelle mondiale.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Interagissez avec cet agent via Telegram Bot pour prendre en charge la messagerie instantanée mondiale.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "Accédez à cet agent via l'API WhatsApp Business pour atteindre les utilisateurs du monde entier.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "Accédez à cet agent via l'application d'entreprise WeChat pour prendre en charge les scénarios de communication interne et de service client.",
    "通过": "passer",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "Les packages et les quotas peuvent déjà être consultés et les achats peuvent être effectués une fois le canal de paiement déterminé.",
    "通信对话 (": "conversation de communication (",
    "通用工具 (": "Outils généraux (",
    "同名文档": "Document du même nom",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "Invitez les membres à rejoindre par e-mail et définissez différents rôles (propriétaire/administrateur/membre).",
    "套餐之间仅额度不同，所有产品能力保持一致。": "Seul le montant diffère selon les packages et toutes les capacités du produit restent les mêmes.",
    "同一组织 · 同一份简报 · 持续沉淀": "La même organisation · le même brief · accumulation continue",
    "统计": "statistiques",
    "统计粒度": "granularité statistique",
    "统计周期": "période statistique",
    "图标": "icône",
    "图标视图": "vue par icône",
    "图片 / PDF 导出": "Exportation d'images/PDF",
    "团队的": "équipe",
    "团队": "équipe",
    "团队日志": "Journal d'équipe",
    "推荐建模顺序": "Ordre de modélisation recommandé",
    "推荐": "recommander",
    "团队规范、工作流程、审批标准": "Spécifications de l'équipe, processus de travail et normes d'approbation",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "Le même agent peut travailler sur les plateformes Web et de messagerie instantanée, et les souvenirs et compétences de conversation sont partagés sur toutes les plateformes.",
    "团队规范和工作流程": "Normes d'équipe et processus de travail",
    "退出登录": "Se déconnecter",
    "拖入 .md 文件，或点击上传": "Faites glisser le fichier .md ou cliquez sur Télécharger",
    "外部系统 POST 到此 URL 即可触发": "Le POST du système externe vers cette URL peut être déclenché",
    "完成": "Finition",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "Les indicateurs complets incluent la définition de l’entreprise, le calibre du calcul, la granularité, la dimension, la source, le responsable et les observations historiques.",
    "网络错误": "erreur réseau",
    "微信": "WeChat",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "La connexion WeChat est basée sur le protocole de la version Web et un compte WeChat doit être conservé en ligne en tant qu'opérateur agent. Il est recommandé d'utiliser un compte WeChat dédié.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat est connecté et l'agent répondra automatiquement au message. Il peut être utilisé après le redémarrage du service.",
    "唯一标识": "identifiant unique",
    "维度切片": "tranche de dimension",
    "未补充映射表达式": "Expression de mappage non complétée",
    "未连接": "Non connecté",
    "未设置": "pas réglé",
    "未设置编码": "Aucun jeu de codage",
    "未设置更新频率": "Fréquence de mise à jour non définie",
    "未设置公式": "Aucune formule définie",
    "未设置统计粒度": "La granularité des statistiques n'est pas définie",
    "未知": "inconnu",
    "未知文档": "Document inconnu",
    "文本": "texte",
    "文档读取失败": "Échec de la lecture du document",
    "文档读取失败或无权访问": "Échec de la lecture du document ou absence d'autorisation d'accès",
    "文档已覆盖": "Document couvert",
    "文档已删除": "Document supprimé",
    "文档已上传": "Document téléchargé",
    "文件处理": "Traitement des fichiers",
    "文件传输": "transfert de fichiers",
    "文件读取": "lecture de fichiers",
    "文件分享": "partage de fichiers",
    "文件过大，最大支持 2MB": "Le fichier est trop volumineux, le maximum pris en charge est de 2 Mo",
    "文件结构": "Structure du fichier",
    "文件收发": "Envoi et réception de fichiers",
    "我": "je",
    "我的知识库": "Ma base de connaissances",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "Raisonnez et exécutez des tâches dans le bac à sable d'écriture de l'espace de travail.",
    "团队协作（NovaX Bus）": "Collaboration en équipe (NovaX Bus)",
    "外观": "Apparence",
    "我们": "nous",
    "我想继续讨论这篇组织简报：": "J'aimerais continuer à discuter de ce brief organisationnel :",
    "无单位": "Sans unité",
    "无公式": "Pas de formule",
    "无可用 Agent": "Aucun agent disponible",
    "无描述": "Pas de description",
    "五": "cinq",
    "系统": "système",
    "系统工具": "outils système",
    "系统内置": "Système intégré",
    "下次：": "la prochaine fois:",
    "下次执行": "Exécuter la prochaine fois",
    "下一步": "Étape suivante",
    "下游影响": "effets en aval",
    "下载": "télécharger",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "D'abord \"créer un nouvel objet\", puis \"établir une relation\". L'objet peut être un champ, un indicateur, une cible ou un agent ; la relation doit sélectionner explicitement le calcul, la lignée, l’impact, la causalité ou l’attribution, et essayer de compléter les formules, les conditions, la confiance et les preuves.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "Créez d'abord des indicateurs tels que « ventes, volume de commandes et taux de conversion » qui sont véritablement utilisés pour la prise de décision, et complétez la définition de l'entreprise, la formule, la granularité statistique et le responsable ; enregistrez ensuite les valeurs pendant au moins deux périodes afin que NovaX puisse déterminer quels changements se sont produits.",
    "先看懂四层业务地图": "Comprenez d'abord la carte commerciale à quatre niveaux",
    "先验证，再保存": "Vérifiez d'abord, puis enregistrez",
    "现在搭建第一条业务链路": "Créez maintenant le premier lien commercial",
    "现在可以通过受限工具安全使用这个连接。": "Cette connexion peut désormais être utilisée en toute sécurité avec des outils restreints.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "Commencez maintenant par générer le premier numéro pour votre organisation. Au fur et à mesure que des informations et des connexions continuent d'être ajoutées, NovaX continuera à proposer du contenu digne d'attention ici.",
    "限定前缀（可选）": "préfixe de qualification (facultatif)",
    "限定文件 Key（可选）": "Clé de fichier qualifié (facultatif)",
    "相对上一期": "Par rapport au numéro précédent",
    "详细记忆文件": "fichier mémoire détaillé",
    "项操作": "opérations",
    "我們": "nous",
    "消耗": "consommer",
    "消息导航": "Navigation dans les messages",
    "消息卡片": "carte de message",
    "消息": "information",
    "小时": "Heure",
    "协作 Agent": "Agent de collaboration",
    "斜杠命令": "commande barre oblique",
    "小": "Petit",
    "系统任务": "Tâches système",
    "外部平台": "plateforme externe",
    "新建对象": "Nouvel objet",
    "新建业务概念": "Nouveau concept d'entreprise",
    "新建执行对象": "Créer un nouvel objet d'exécution",
    "新建指标": "Nouvel indicateur",
    "形成指标": "indicateurs de formulaire",
    "修改文件": "Modifier des fichiers",
    "虚拟主机样式（AWS 默认）": "Style d'hôte virtuel (AWS par défaut)",
    "需要两个周期": "Cela prend deux cycles",
    "选择 .md 文件 →": "Sélectionnez le fichier .md →",
    "选择要安装到的 Agent": "Sélectionnez l'agent sur lequel installer",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "Choisissez un rôle prédéfini pour démarrer rapidement ou créez manuellement un agent personnalisé.",
    "选择一个执行对象": "Sélectionnez un objet d'exécution",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "Après avoir sélectionné une mesure, l'analyse d'impact examine vers le haut la source de calcul et les facteurs candidats, et vers le bas, les objectifs, les processus et les personnes responsables de l'impact. La relation d’influence n’est qu’un indice ; seule la relation causale avec la preuve de vérification sera exprimée par l'Agent comme une cause certaine.",
    "选择一个指标开始": "Choisissez un indicateur pour commencer",
    "选择指标或业务对象": "Sélectionnez une métrique ou un objet métier",
    "血缘与计算映射": "Lignée et cartographie informatique",
    "寻址方式": "Mode d'adressage",
    "沿关系找原因，也看后果": "Suivez la relation pour trouver la cause, et examinez également les conséquences.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "Identifiez les objectifs, les processus, les projets et les propriétaires concernés tout au long des relations en aval.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "Générez des pilotes candidats en fonction des relations d'impact et de causalité, et déclassez les expressions en fonction de la confiance, des conditions et des preuves.",
    "沿用 Figma Token 可见范围": "Hériter de la plage visible du jeton Figma",
    "颜色": "couleur",
    "演示文稿制作": "Réalisation de présentations",
    "验证并保存": "Vérifier et enregistrer",
    "验证并连接": "Vérifier et se connecter",
    "验证结果": "Résultats de la vérification",
    "要点速读": "Points à lire rapidement",
    "也是 Agent 们的": "Aussi pour les agents",
    "业务本体": "Ontologie métier",
    "业务层：数字说明什么": "Couche métier : ce que disent les chiffres",
    "业务地图": "carte d'affaires",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "La carte commerciale examine l'image globale, le réseau d'indicateurs examine le calibre, l'amont et l'aval, le lignage des données examine la source, l'analyse d'impact examine les causes et les conséquences, l'exécution de l'organisation examine le responsable et le modèle définit le type d'objet de gestion. Changer de vue ne crée pas de données en double.",
    "业务定义": "définition d'entreprise",
    "业务对象": "objet métier",
    "消息字体大小": "Taille de la police des messages",
    "研究员输出数据后：": "Une fois que le chercheur a généré les données :",
    "写 Soul 的要点": "Points clés pour écrire l'âme",
    "业务连接": "relation d'affaires",
    "业务声明": "Déclaration commerciale",
    "业务指标": "mesures commerciales",
    "页面分析": "Analyse des pages",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "Conception de pages, présentations, génération d’images IA : donnez à votre agent l’apparence d’un concepteur professionnel.",
    "页面搜索": "Recherche de pages",
    "一": "un",
    "一只 Agent。": "Un agent.",
    "移除了": "Supprimé",
    "已保存，留空不修改": "Enregistré, laisser vide sans modification",
    "已触发": "Déclenché",
    "已存在，是否覆盖？": "Existe déjà ? Écraser?",
    "已复制": "Copié",
    "已归档": "Archivé",
    "已过期": "Expiré",
    "已结束": "terminé",
    "已连接": "Connecté",
    "已连接 ·": "Connecté ·",
    "已取消": "Annulé",
    "已扫码，请在手机上确认...": "Le code a été scanné, merci de confirmer sur votre téléphone portable...",
    "已生成纪要": "Minute générée",
    "已完成": "Complété",
    "已验证": "Vérifié",
    "已验证因果": "Cause et effet vérifiés",
    "已暂停": "Suspendu",
    "因果可信度阶梯": "échelle de crédibilité causale",
    "业务规则、行业术语、标准话术": "Règles métier, terminologie industrielle, vocabulaire standard",
    "邀请成员": "Inviter des membres",
    "引导进度": "progression du démarrage",
    "应用消息": "Messages d'application",
    "应用专用密码 / 授权码": "Mot de passe/code d'autorisation spécifique à l'application",
    "影响分析": "analyse d'impact",
    "影响分析失败": "L'analyse d'impact a échoué",
    "影响时滞": "Affecte le décalage temporel",
    "影响语义": "Affecter la sémantique",
    "业务规则和约束条件": "Règles et contraintes métier",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "Le développeur n'est pas responsable des pertes directes ou indirectes résultant de l'utilisation de ce produit.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "Le développeur n'est pas responsable des pertes directes ou indirectes résultant de l'utilisation de ce produit.",
    "拥有专属的": "Avoir une exclusivité",
    "用 1 分钟看懂业务本体": "Prenez 1 minute pour comprendre l'ontologie métier",
    "用法示例": "Exemples d'utilisation",
    "用户名": "nom d'utilisateur",
    "用链接或 ID 进入": "Entrez avec un lien ou un identifiant",
    "用户的个人信息用于任何商业用途。": "Les informations personnelles de l'utilisateur sont utilisées à des fins commerciales.",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "Les agents possédant des compétences MetaSkill peuvent créer et publier automatiquement de nouvelles compétences en fonction de vos besoins.",
    "用手机微信扫描二维码，确认登录。": "Utilisez WeChat sur votre téléphone mobile pour scanner le code QR afin de confirmer la connexion.",
    "用手机微信扫描二维码并确认登录": "Utilisez WeChat sur votre téléphone mobile pour scanner le code QR et confirmer la connexion",
    "用于比较变化": "utilisé pour comparer les changements",
    "用于区分这个 Agent 的 Pencil 设计文件": "Fichier de conception de crayon utilisé pour distinguer cet agent",
    "邮件搜索": "Recherche de courrier",
    "邮箱": "Mail",
    "邮箱类型": "Type d'e-mail",
    "邮箱账号": "Compte de messagerie",
    "有纪要": "Avec compte rendu",
    "语义关系": "Relations sémantiques",
    "语义属性": "Propriétés sémantiques",
    "永久删除你的账号和所有数据，此操作不可撤销。": "Supprimez définitivement votre compte et toutes vos données. Cette action est irréversible.",
    "预定时间（可选，留空则立即开始）": "Heure programmée (facultatif, laissez vide pour commencer immédiatement)",
    "原始转写": "transcription originale",
    "原因与后果": "causes et conséquences",
    "语音输入（需浏览器支持 Web Speech API）。": "Saisie vocale (nécessite un navigateur pour prendre en charge l'API Web Speech).",
    "运行连接命令": "Exécuter la commande de connexion",
    "运行引擎": "faire tourner le moteur",
    "运行中": "En cours d'exécution",
    "再查一次": "Revérifier",
    "再查一次，没有新增内容": "Vérifié à nouveau, pas de nouveau contenu",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Collaborez avec cet agent dans Microsoft Teams et intégrez-le aux flux de travail de l'entreprise.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "Collaborez directement avec les agents dans les canaux Slack, adaptés au flux de travail quotidien des équipes étrangères.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Travaillez directement avec cet agent dans un canal Slack, prenant en charge les réponses Thread.",
    "用量明细加载失败": "Échec du chargement des détails d'utilisation",
    "月度套餐": "forfait mensuel",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "Créez-le dans le sous-onglet \"Webhook\" de l'onglet \"Tâche\" et remplissez le nom et le modèle de mot d'invite.",
    "月度额度不足时，可由组织所有者补充。": "Si le quota mensuel est insuffisant, il peut être reconstitué par le propriétaire de l'organisation.",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "Créez une nouvelle organisation ou changez d'organisation dans \"Paramètres → Gestion de compte\".",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "Connectez cet agent à un groupe DingTalk pour prendre en charge les fonctionnalités natives de DingTalk telles que les cartes de message et les notifications professionnelles.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "Cliquez sur \"Nouvel agent\" sur la page \"Équipe\" pour le créer. Après la création, cliquez sur la carte Agent pour accéder à la page de détails de configuration.",
    "在不同组织之间切换，数据完全隔离。": "Basculez entre différentes organisations avec une isolation complète des données.",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "Gérez les membres de l'organisation sur la page « Équipe ». Cliquez sur « Inviter des membres » et entrez votre adresse e-mail pour envoyer des invitations.",
    "在对话中让": "laisser entrer la conversation",
    "在对话中让 agent \"记住\"重要信息": "Laissez l'agent \"se souvenir\" des informations importantes pendant la conversation",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Confirmez l'autorisation dans le backend Feishu et l'application obtiendra automatiquement les autorisations nécessaires (envoi et réception de messages, gestion de groupe, etc.).",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Communiquez directement avec cet agent dans le chat de groupe Feishu, en prenant en charge les fonctionnalités natives de Feishu telles que les cartes de texte enrichi, l'envoi et la réception de fichiers, etc.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "Basculez vers l'onglet « Compétences » en haut de l'interface de conversation, parcourez la liste disponible et cliquez sur Installer.",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "Exécutez NovaX Agent sur votre ordinateur pour connecter en toute sécurité votre espace de travail Codex local à NovaX.",
    "在服务器上读写文件、执行代码": "Lire et écrire des fichiers et exécuter du code sur le serveur",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "Basculez vers l'onglet \"Connexion\" en haut de l'interface de dialogue pour configurer. Prend actuellement en charge :",
    "暂不关联": "Pas encore pertinent",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "Pour le moment, vous devez créer manuellement une application dans le backend Feishu et remplir les informations d'identification. Un processus de création automatisé est en cours de développement : une autorisation en un clic suffira pour finaliser la connexion.",
    "暂停": "pause",
    "暂无 Webhook": "Pas encore de Webhooks",
    "暂无定时任务": "Aucune tâche planifiée pour l'instant",
    "暂无观测": "Aucune observation pour l'instant",
    "暂无观测值": "Aucune observation pour l'instant",
    "暂无记录": "Pas encore d'enregistrement",
    "暂无记忆": "Pas encore de mémoire",
    "暂无纪要 — 会议结束后自动转写": "Pas encore de procès-verbal - transcrit automatiquement après la fin de la réunion",
    "暂无类型说明": "Pas encore de description du type",
    "暂无日志": "Aucun journal pour l'instant",
    "暂无属性字段": "Aucun champ d'attribut pour l'instant",
    "暂无数据": "Aucune donnée pour l'instant",
    "暂无说明": "Pas encore de description",
    "暂无文件": "Aucun fichier pour l'instant",
    "暂无业务定义": "Pas encore de définition d'entreprise",
    "粘贴 Figma 访问 Token": "Coller le jeton d'accès Figma",
    "粘贴 Zoom 链接或输入会议 ID": "Collez le lien Zoom ou entrez l'ID de la réunion",
    "展开查看": "Agrandir pour voir",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "Dans la liste des agents sur la page de conversation, vous verrez une entrée « Tous les membres du groupe ». Dans une discussion de groupe, vous pouvez utiliser @AgentName pour spécifier un agent chargé de répondre aux questions. Cela permet à plusieurs agents de collaborer dans la même conversation. Par exemple, laissez d'abord l'agent « Chercheur » rechercher des informations, puis laissez l'agent « Écrivain » rédiger un article basé sur les informations.",
    "账号": "compte",
    "这份证据如何支持该关系？": "Comment ces preuves soutiennent-elles la relation ?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "Ici, vous conservez vos équipes, agents, projets, tâches, documents et compétences d'origine et les connectez aux indicateurs commerciaux.",
    "暂时无法读取额度信息": "Temporairement incapable de lire les informations de crédit",
    "蒸馏": "distillation",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "Distiller les cadres décisionnels, les premiers principes et l'ADN expressif pour affiner un conseiller mental auquel vous pouvez faire appel à tout moment.",
    "整体结构": "structure globale",
    "正文与附件信息": "Informations sur le texte et les pièces jointes",
    "正向": "avant",
    "正在编撰组织简报": "Compilation du briefing organisationnel",
    "正在创建微信连接...": "Création d'une connexion WeChat...",
    "正在读取组织最近的使用情况": "Lire l'utilisation récente de l'organisation",
    "正在计算影响路径…": "Calcul du chemin d’impact…",
    "占位，表示外部传入的数据。例如：": "Espace réservé, représentant les données entrantes en externe. Par exemple:",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "Sur la page « Marché des compétences » dans la barre de navigation de gauche, vous pouvez parcourir toutes les compétences disponibles.",
    "正在建立业务语义地图…": "Construire une carte sémantique d'entreprise...",
    "正在生成二维码...": "Génération de code QR...",
    "正在验证连接…": "Vérification de la connexion...",
    "正在由 Agent 团队编撰第一期": "Le premier numéro est en cours de compilation par l'équipe Agent",
    "正在整理组织数据与知识": "Organiser les données et les connaissances organisationnelles",
    "证据等级": "Niveau de preuve",
    "证据摘要": "résumé des preuves",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "Prend en charge GitHub, GitLab, Gitee et les services Git internes",
    "正在加载组织额度…": "Chargement du quota de l'organisation...",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "Il s’agit du mode de collaboration le plus puissant de NovaX. Vous pouvez demander à plusieurs agents de prendre le relais pour effectuer des tâches complexes dans la même conversation :",
    "知识库": "base de connaissances",
    "知识库 &middot; Knowledge Base": "Base de connaissances · Base de connaissances",
    "支付功能正在准备中": "La fonction de paiement est en cours de préparation",
    "知识库为空": "La base de connaissances est vide",
    "知识库文档": "Documentation de la base de connaissances",
    "知识库暂无共享文档。": "Il n'y a actuellement aucun document partagé dans la base de connaissances.",
    "知识库（Memory）— 共享大脑": "Base de connaissances (Mémoire) - Cerveau partagé",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "Une base de connaissances est un référentiel de documents partagé au niveau de l'organisation. Chaque document Markdown que vous téléchargez deviendra la connaissance commune de tous les agents de l'organisation. Convient pour :",
    "执行层：谁根据它采取行动": "Niveau exécutif : qui prend des mesures en fonction de celui-ci",
    "执行命令": "exécuter la commande",
    "执行频率": "Fréquence d'exécution",
    "执行任务": "effectuer des tâches",
    "执行时间": "Temps d'exécution",
    "执行时间：": "Temps d'exécution :",
    "执行异常": "Exception d'exécution",
    "执行指令": "Exécuter les instructions",
    "执行中": "Exécution",
    "只读查询": "requête en lecture seule",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "La connexion en lecture seule à la boîte aux lettres Gmail, QQ, 163 ou IMAP d'entreprise prenant en charge le code d'autorisation permet à l'agent de rechercher et de trier de vrais e-mails.",
    "只读收件箱": "boîte de réception en lecture seule",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "Les documents téléchargés dans la base de connaissances sont stockés localement sur le serveur et ne peuvent être lus que par les agents de votre organisation.",
    "指": "se référer à",
    "指标": "indice",
    "指标 / 维度": "Métriques/Dimensions",
    "指标不是一个数字": "Un indicateur n'est pas un nombre",
    "指标层：数字怎么计算": "Couche d'indicateurs : comment calculer les nombres",
    "指标查询": "Requête d'indicateur",
    "指标观测": "observation de l'indicateur",
    "指标口径": "Calibre d'index",
    "指标目录": "Catalogue d'indicateurs",
    "指标网络": "réseau d'indicateurs",
    "指标已映射": "Métriques cartographiées",
    "指标异动与影响分析": "Modifications des indicateurs et analyse d’impact",
    "指标值 *": "Valeur de l'indicateur *",
    "至少需要两个周期": "Au moins deux cycles sont nécessaires",
    "置信度": "Confiance",
    "置信度 ·": "Confiance ·",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "Une base de connaissances est un référentiel de documents partagé au niveau de l'organisation. Les documents téléchargés seront automatiquement référencés par tous les agents lors de leur réponse, ce qui équivaut à doter tous les agents de connaissances de base.",
    "终点 *": "Point final *",
    "终端运行": "Exécution du terminal",
    "种类型": "taper",
    "重复任务": "Répéter les tâches",
    "重新尝试": "Essayer à nouveau",
    "重新加载": "recharger",
    "重要规则": "Règles importantes",
    "周末": "fin de semaine",
    "主持人:": "hôte:",
    "主持人：": "hôte:",
    "主动来到你面前": "Prenez l'initiative de venir vers vous",
    "注入": "injection",
    "中": "milieu",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "Les documents téléchargés dans la base de connaissances sont stockés localement sur le serveur et ne peuvent être lus que par les agents de votre organisation.",
    "只有组织所有者可以购买套餐或充值额度。": "Seul le propriétaire de l'organisation peut acheter des forfaits ou des crédits.",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "Après vous être déconnecté, votre compte, votre historique de discussion et toutes les données seront définitivement supprimés et ne pourront pas être récupérés.",
    "转发": "Avant",
    "转发到": "avec impatience",
    "转写已完成，可生成纪要": "La transcription est terminée et les minutes peuvent être générées",
    "转写中": "Transcription",
    "状态": "État",
    "字段": "Champ",
    "字段名称": "Nom du champ",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "L'adresse e-mail requise pour l'inscription est uniquement utilisée pour la vérification du compte et la connexion, et ne sera pas utilisée à des fins de marketing ni transférée à des tiers.",
    "自定义类型": "Type personnalisé",
    "自定义名称、描述和人格": "Personnalisez le nom, la description et la personnalité",
    "自定义周期": "Cycle personnalisé",
    "自动响应指定聊天中的消息": "Répondre automatiquement aux messages dans un chat spécifié",
    "自动应答": "Réponse automatique",
    "自动转写生成纪要": "Transcrivez et générez automatiquement des minutes",
    "自适应卡片": "carte adaptative",
    "组": "Groupe",
    "组件理解": "Compréhension des composants",
    "注销中...": "Déconnexion...",
    "注销账号": "Annuler le compte",
    "自定义界面显示偏好": "Personnaliser les préférences d'affichage de l'interface",
    "组织编辑人数": "Nombre d'éditeurs dans l'organisation",
    "组织变动": "changements organisationnels",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "L'adresse e-mail requise pour l'inscription est uniquement utilisée pour la vérification du compte et la connexion, et ne sera pas utilisée à des fins de marketing ni transférée à des tiers.",
    "组织存储": "Organiser le stockage",
    "组织洞察": "perspectives organisationnelles",
    "组织": "organiser",
    "组织里的某一位 Agent": "Un agent dans l'organisation",
    "组织成员和自动任务的消费都会记录在这里。": "La consommation des membres de l'organisation et les tâches automatiques seront enregistrées ici.",
    "组织（Workspace）— 协作空间": "Organisation (Espace de travail) — Espace de collaboration",
    "组织名称": "Nom de l'organisation",
    "组织共享额度": "Quota de partage d'organisation",
    "组织内所有成员共享使用": "Partagé par tous les membres de l'organisation",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "Une organisation est un espace de collaboration indépendant, similaire à l'espace de travail de Slack ou à l'équipe de Feishu. Tous les membres d'une organisation partagent le même ensemble d'agents et la même base de connaissances. tu peux:",
    "组织文档数": "Nombre de documents d'organisation",
    "组织信号": "signaux organisationnels",
    "组织所有者": "Propriétaire de l'organisation",
    "组织与执行": "Organisation et exécution",
    "组织知识库": "base de connaissances organisationnelles",
    "组织知识库日志": "Journal de la base de connaissances de l'organisation",
    "组织执行": "Exécution organisationnelle",
    "最多展开 3 跳": "Développez jusqu'à 3 sauts",
    "最多追溯 3 跳": "Remontez jusqu'à 3 sauts",
    "组织与多租户": "Organisation et multilocation",
    "最近更新": "Dernières mises à jour",
    "最近观测": "observations récentes",
    "最后更新：2026 年 5 月": "Dernière mise à jour : mai 2026",
    "最後更新：2026 年 5 月": "Dernière mise à jour : mai 2026",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "Le lien minimum utilisable ne nécessite que quatre objets. Commencez par l’indicateur de base auquel vous prêtez attention chaque jour, puis complétez-le progressivement plus tard. Il n’est pas nécessaire de concevoir l’ensemble de l’entreprise au départ.",
    "最新观测": "Dernières observations",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "À gauche se trouvent les facteurs ou sources de calcul possibles, et à droite ce que l'indicateur affecte.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "En tant que PEN_AGENT_API_KEY, il est uniquement transmis à ce processus Pencil local.",
    "组织与团队管理": "Organisation et gestion d'équipe",
    "作为个人练手 Demo 项目，我们": "En tant que projet de démonstration de formation personnelle, nous",
    "作為個人練手 Demo 專案，我們": "En tant que projet de démonstration de pratique personnelle, nous",
    "最近用量": "utilisation récente",
    "Agent 会怎样使用": "Comment l'agent sera utilisé",
    "Agent — 你的 AI 团队成员": "Agent - membre de votre équipe IA",
    "Agent 级别": "Niveau d'agent",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "L'agent peut non seulement être utilisé sur la page Web NovaX, mais peut également être connecté à des plateformes de messagerie instantanée externes. Une fois connectés, les agents partagent le même ensemble de souvenirs, de compétences et de connaissances sur toutes les plateformes.",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "Une fois l'agent démarré, il se connectera automatiquement. Le statut ci-dessous deviendra vert et vous pourrez commencer à l'utiliser.",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "L'agent peut créer des tâches en arrière-plan qui sont exécutées régulièrement sans que vous ayez à les déclencher manuellement. Basculez vers l'onglet « Tâches » en haut de l'interface de conversation pour afficher et gérer.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "L'agent est l'unité centrale de NovaX. Chaque Agent est un assistant IA indépendant doté de ses propres :",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "L'agent crée automatiquement des tâches périodiques. Les résultats de l'exécution apparaissent dans la conversation sous forme de messages. Vous pouvez suspendre, reprendre ou supprimer les tâches créées dans l'onglet Tâches.",
    "Agent 在对话中输出的文件会显示在这里": "Les fichiers générés par l'agent dans la conversation seront affichés ici",
    "Agent 周报": "Agent hebdomadaire",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "L'agent est le concept central de NovaX. Contrairement aux chatbots traditionnels, chaque Agent est un agent avec",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "L'agent exécute automatiquement la demande après l'avoir reçue et envoie le résultat à la conversation.",
    "AI 图像生成": "Génération d'images IA",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Les agents référencent automatiquement ces documents lorsqu'ils répondent aux questions, garantissant ainsi que les réponses correspondent aux normes et au contexte de l'équipe.",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "Le contenu généré par l'IA peut contenir des erreurs ou des informations inexactes, veuillez faire votre propre jugement et vérification.",
    "DOWNSTREAM · 下游": "AVAL · Aval",
    "ETL 血缘": "Lignée ETL",
    "Git 仓库": "Dépôt Git",
    "Git 用户名；GitHub App 可填 x-access-token": "Nom d'utilisateur Git ; L'application GitHub peut remplir le jeton d'accès x",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ et 163 doivent généralement d'abord activer IMAP et créer un mot de passe ou un code d'autorisation spécifique à l'application.",
    "IMAP 地址": "Adresse IMAP",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "Le contenu généré par l'IA peut contenir des erreurs ou des informations inexactes, veuillez faire votre propre jugement et vérification.",
    "Notion 工作区": "Espace de travail de notion",
    "Codex 智能体底座": "Base de corps intelligente Codex",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Rendu au format Markdown, y compris mise en évidence du code, tableaux, listes, etc.",
    "Nova 点": "Point Nova",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX adopte une architecture multi-tenant basée sur les organisations (Workspaces). Chaque organisation est un espace de collaboration totalement indépendant, et les agents, les bases de connaissances, les compétences, les membres et les données de conversation sont tous isolés.",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX suit les données et les moteurs commerciaux vers le haut et identifie les objectifs, les processus et les impacts d'exécution vers le bas.",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "Tous les agents de NovaX s'exécutent uniformément sur OpenAI Codex et utilisent",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "L'interface de NovaX se compose d'une barre de navigation à gauche et d'une zone de contenu principale à droite. La barre de navigation propose cinq entrées principales :",
    "NovaX 是一个": "NovaX est un",
    "NovaX 是什么": "Qu'est-ce que NovaX",
    "NovaX 是一個": "NovaX est un",
    "NovaX Agent 工作区": "Espace de travail de l'agent NovaX",
    "PG 思维": "Pensée PG",
    "Prompt 模板": "Modèle d'invite",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Modèle d'invite, utilisant {{payload}} pour représenter les données reçues",
    "QQ 邮箱": "boîte aux lettres QQ",
    "S3 兼容地址（AWS S3 可留空）": "Adresse compatible S3 (AWS S3 peut être laissé vide)",
    "Schema 浏览": "Parcourir le schéma",
    "secret_... 或 ntn_...": "secret_... ou ntn_...",
    "Session Token（可选）": "Jeton de session (facultatif)",
    "Skill 市场": "Marché des compétences",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX est une plateforme de collaboration d'IA multi-agents. Vous pouvez le considérer comme un atelier d'équipe IA : plusieurs agents IA sont créés ici, chacun avec son propre nom, sa propre personnalité, son expertise et son espace de travail. Ils peuvent lire et écrire des fichiers, exécuter du code, effectuer des recherches sur le Web, gérer des tâches et travailler ensemble comme de vrais membres d'une équipe.",
    "Shift+Enter 换行，Enter 发送。": "Maj+Entrée pour envelopper la ligne, Entrée pour envoyer.",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX prend en charge les structures multi-organisationnelles. Les organisations peuvent être gérées dans « Paramètres → Général » :",
    "SQL 数据库": "Base de données SQL",
    "SSH 私钥": "Clé privée SSH",
    "Thread 回复": "Réponse au sujet",
    "TLS 加密": "Chiffrement TLS",
    "Token 用量榜": "Liste d'utilisation des jetons",
    "UPSTREAM · 上游": "AMONT · amont",
    "Web 设计工程师": "Ingénieur conception web",
    "Webhook 名称，如 GitHub Push...": "Nom du webhook, tel que GitHub Push...",
    "Soul 人设指令": "Commande du personnage de l'âme",
    "Webhook URL（含 Secret）": "URL du webhook (y compris secret)",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "L'âme est l'élément de configuration le plus important de l'Agent. Il détermine le positionnement du rôle de l'Agent, ses domaines d'expertise et son comportement. Bien écrire Soul est la clé pour rendre Agent vraiment utile.",
    "Soul（人设指令）": "Âme (commande de personnalité)",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook permet aux systèmes externes de déclencher des tâches d'exécution d'agent via des requêtes HTTP et convient à l'interface avec CI/CD, à la surveillance des alarmes, à la soumission de formulaires et à d'autres systèmes.",
    "Webhook 事件触发": "Déclencheur d'événement Webhook"
  },
  "de": {
    "— 点击即可切换到不同的组织，Agent 和知识库会随之改变。": "— Wechseln Sie mit einem Klick zu einer anderen Organisation und der Agent und die Wissensdatenbank ändern sich entsprechend.",
    "— 查看 Agent 正在执行的后台任务，包括进度、状态和结果。": "– Sehen Sie sich die vom Agenten ausgeführten Hintergrundaufgaben an, einschließlich Fortschritt, Status und Ergebnissen.",
    "— 查看组织内的 Agent 和成员，创建新 Agent 或邀请新成员。": "– Zeigen Sie Agenten und Mitglieder in Ihrer Organisation an, erstellen Sie neue Agenten oder laden Sie neue Mitglieder ein.",
    "— 赋予 Agent 辨识度，方便在多 Agent 场景下区分。": "– Geben Sie Agentenerkennung, um die Differenzierung in Multi-Agenten-Szenarien zu erleichtern.",
    "— 定义 Agent 的性格、专长和行为方式。比如你可以创建一个「代码审查员」Agent，让它专注于代码质量；再创建一个「产品经理」Agent，让它擅长需求分析。": "— Definieren Sie die Persönlichkeit, das Fachwissen und das Verhalten des Agenten. Sie können beispielsweise einen „Code Reviewer“-Agenten erstellen, um sich auf die Codequalität zu konzentrieren, und dann einen „Product Manager“-Agenten erstellen, um ihn bei der Anforderungsanalyse zu unterstützen.",
    "— 告诉 Agent 它是谁，擅长什么领域。": "— Sagen Sie dem Agenten, wer es ist und worauf er spezialisiert ist.",
    "— 个人偏好、组织管理、账号安全。": "– Persönliche Vorlieben, Organisationsverwaltung und Kontosicherheit.",
    "— 管理该 Agent 已安装的技能，或从市场安装新技能。": "— Verwalten Sie die installierten Fähigkeiten des Agenten oder installieren Sie neue Fähigkeiten vom Markt.",
    "— 管理共享文档，上传和浏览 .md 文件。": "– Verwalten Sie freigegebene Dokumente, laden Sie .md-Dateien hoch und durchsuchen Sie sie.",
    "— 回答时应该遵循什么格式、风格、步骤。": "— Welches Format, welchen Stil und welche Schritte sollten bei der Beantwortung befolgt werden?",
    "— 可以管理 Agent、知识库和成员，不能修改组织设置。": "– Kann Agenten, Wissensdatenbanken und Mitglieder verwalten, aber keine Organisationseinstellungen ändern.",
    "— 接入 Zoom 会议或聊天。": "— Nehmen Sie an einem Zoom-Meeting oder Chat teil.",
    "— 可以使用 Agent、参与对话、访问知识库，不能进行管理操作。": "– Sie können den Agenten verwenden, an Gesprächen teilnehmen und auf die Wissensdatenbank zugreifen, aber keine Verwaltungsvorgänge ausführen.",
    "— 浏览和安装技能，管理已发布的技能。": "— Durchsuchen und installieren Sie Fertigkeiten und verwalten Sie veröffentlichte Fertigkeiten.",
    "— 让 Agent 能够调用其他 Agent，实现跨 Agent 协作。": "– Erlauben Sie Agenten, andere Agenten anzurufen, um eine agentenübergreifende Zusammenarbeit zu erreichen.",
    "— 让 Agent 具备创建和管理定时任务的能力。": "– Geben Sie dem Agenten die Möglichkeit, geplante Aufgaben zu erstellen und zu verwalten.",
    "— 让 Agent 能够设定定时或周期性任务，比如每天早上生成报告。": "— Ermöglichen Sie dem Agenten, geplante oder periodische Aufgaben festzulegen, z. B. jeden Morgen Berichte zu erstellen.",
    "— 让 Agent 自己创作新技能并发布到市场，供其他 Agent 安装使用。": "– Lassen Sie Agenten selbst neue Fähigkeiten erstellen und diese auf dem Markt veröffentlichen, damit andere Agenteninstallationen sie verwenden können.",
    "— 让 Agent 能够自动生成和发布新技能。": "— Ermöglichen Sie Agenten, automatisch neue Fähigkeiten zu generieren und zu veröffentlichen.",
    "— 什么该做，什么不该做。": "– Was zu tun ist und was nicht.",
    "— 通过 iLink 接入，实现在微信中与 Agent 交互。": "— Zugriff über iLink zur Interaktion mit dem Agenten in WeChat.",
    "— 所有者拥有全部权限，管理员可管理 Agent 和成员，普通成员可以使用 Agent 和知识库。": "— Der Eigentümer verfügt über vollständige Berechtigungen, Administratoren können Agenten und Mitglieder verwalten und normale Mitglieder können Agenten und Wissensdatenbanken verwenden.",
    "— 通过 Telegram Bot 接入。": "— Zugriff über Telegram Bot.",
    "— 通过飞书机器人直接在飞书中与 Agent 对话。": "— Sprechen Sie über den Feishu-Roboter direkt mit dem Agenten in Feishu.",
    "— 通过 BotFather 创建 Bot，填入 Bot Token 即可连接。": "– Erstellen Sie einen Bot über BotFather und geben Sie das Bot-Token ein, um eine Verbindung herzustellen.",
    "— 通过安装不同的技能扩展 Agent 的能力边界。": "— Erweitern Sie die Leistungsgrenzen des Agenten durch die Installation verschiedener Fähigkeiten.",
    "— 通过企业微信或 iLink 接入。": "— Zugriff über Business WeChat oder iLink.",
    "— 与 Agent 的聊天记录，支持实时流式输出。": "– Chat-Aufzeichnungen mit Agent unterstützen Echtzeit-Streaming-Ausgabe.",
    "— 拥有全部权限，管理组织设置、成员、Agent。每个组织只有一个所有者。": "– Verfügt über vollständige Berechtigungen zum Verwalten von Organisationseinstellungen, Mitgliedern und Agenten. Jede Organisation hat nur einen Eigentümer.",
    "— 与 Agent 交流的主界面，左侧是 Agent 列表，右侧是聊天窗口。": "– Die Hauptoberfläche für die Kommunikation mit Agenten, mit der Agentenliste auf der linken Seite und dem Chat-Fenster auf der rechten Seite.",
    "— 允许 Agent 调用工作区内的其他 Agent，实现跨 Agent 的自动化流水线。例如 Agent A 完成分析后自动将结果转交给 Agent B 生成报告。": "– Erlauben Sie Agenten, andere Agenten im Arbeitsbereich anzurufen, um agentenübergreifende automatisierte Pipelines zu implementieren. Nachdem beispielsweise Agent A die Analyse abgeschlossen hat, überträgt er die Ergebnisse automatisch an Agent B, um einen Bericht zu erstellen.",
    "— 在导航栏的「Skill 市场」中浏览所有可用技能，查看详情和安装说明。": "— Durchsuchen Sie alle verfügbaren Fertigkeiten im „Fertigkeitsmarkt“ in der Navigationsleiste und sehen Sie sich Details und Installationsanweisungen an.",
    "— 在「团队」页面通过邮箱邀请成员加入当前组织。": "— Laden Sie Mitglieder per E-Mail auf der Seite „Team“ zum Beitritt zur aktuellen Organisation ein.",
    "— 在对话界面的「技能」标签中，为当前 Agent 安装或卸载技能。不同 Agent 可以安装不同的技能组合。": "— Installieren oder deinstallieren Sie auf der Registerkarte „Skills“ der Dialogoberfläche Skills für den aktuellen Agenten. Auf verschiedenen Agenten können unterschiedliche Fähigkeiten installiert sein.",
    "— 最多可创建 2 个组织。": "— Kann bis zu 2 Organisationen erstellen.",
    "— 在飞书开放平台创建应用，获取 App ID 和 App Secret 后接入。团队成员可在飞书中直接与 Agent 对话。": "– Erstellen Sie eine Anwendung auf der offenen Feishu-Plattform, rufen Sie die App-ID und das App-Geheimnis ab und greifen Sie dann darauf zu. Teammitglieder können direkt mit dem Agenten auf Feishu chatten.",
    "— Agent 可以在指定的文件系统目录中读写文件，执行代码。不同 Agent 可以操作不同的项目目录。": "— Der Agent kann Dateien lesen und schreiben und Code im angegebenen Dateisystemverzeichnis ausführen. Verschiedene Agenten können unterschiedliche Projektverzeichnisse verwalten.",
    "，不以盈利为目的，不会向用户收取任何费用，也不会以任何形式进行商业推广或销售。": "ist nicht gewinnorientiert, erhebt keine Gebühren von den Benutzern und führt keine kommerzielle Werbung oder Verkäufe in irgendeiner Form durch.",
    "，不以營利為目的，不會向使用者收取任何費用，也不會以任何形式進行商業推廣或銷售。": "ist nicht gewinnorientiert, erhebt keine Gebühren von den Benutzern und führt keine kommerzielle Werbung oder Verkäufe in irgendeiner Form durch.",
    "，仅用于展示多 Agent AI 协作平台的技术可行性。本产品": ", wird nur verwendet, um die technische Machbarkeit der Multi-Agent-KI-Kollaborationsplattform zu demonstrieren. Dieses Produkt",
    "、": ",",
    ".pen 文件": ".pen-Datei",
    "· 点击启用": "· Klicken Sie zum Aktivieren",
    "· 点击召唤": "· Zum Beschwören klicken",
    "· 用于 Agent 理解": "· Wird zum Verständnis des Agenten verwendet",
    "，僅用於展示多 Agent AI 協作平台的技術可行性。本產品": ", wird nur verwendet, um die technische Machbarkeit der Multi-Agent-KI-Kollaborationsplattform zu demonstrieren. Dieses Produkt",
    "，同时可以被邀请加入他人的组织。": ", und kann eingeladen werden, den Organisationen anderer Personen beizutreten.",
    "@提及": "@Erwähnungen",
    "（一次性延时任务）": "(Einmalige verzögerte Aufgabe)",
    "（由 Soul 指令定义）": "(definiert durch die Soul-Anweisung)",
    "@分析师 基于上面的数据，做一份竞争格局分析": "@Analyst Führen Sie auf der Grundlage der oben genannten Daten eine Analyse der Wettbewerbslandschaft durch",
    "@提及机制": "@mention-Mechanismus",
    "← 返回": "← Zurück",
    "← 返回列表": "← Zurück zur Liste",
    "← 返回详情": "← Zurück zu den Details",
    "@研究员 搜索一下 2024 年新能源汽车出海市场数据": "@Researcher Durchsuchen Sie die ausländischen Marktdaten von Fahrzeugen mit neuer Energie im Jahr 2024",
    "@写手 把以上分析整理成一份 PDF 报告": "@writer Organisieren Sie die obige Analyse in einem PDF-Bericht",
    "+ 记录": "+ Aufnahme",
    "+ 添加": "+ hinzufügen",
    "✓ 反馈已提交，感谢您的意见！": "✓ Feedback wurde übermittelt, vielen Dank für Ihre Meinung!",
    "✓ 已连接": "✓ Verbunden",
    "/ 月": "/ Mond",
    "163 邮箱": "163 E-Mail",
    "1. 产品性质": "1. Produktbeschaffenheit",
    "+ 创建新组织": "+ Neue Organisation erstellen",
    "1. 產品性質": "1. Produktbeschaffenheit",
    "2 个组织": "2 Organisationen",
    "3. 第三方服务": "3. Dienste Dritter",
    "2. 数据与隐私": "2. Daten und Datenschutz",
    "3. 第三方服務": "3. Dienste Dritter",
    "2. 資料與隱私": "2. Daten und Datenschutz",
    "30 分钟后提醒我开会": "Erinnern Sie mich in 30 Minuten an ein Meeting",
    "4. 服务可用性": "4. Serviceverfügbarkeit",
    "4. 服務可用性": "4. Serviceverfügbarkeit",
    "5. 免責聲明": "5. Haftungsausschluss",
    "5. 免责声明": "5. Haftungsausschluss",
    "6. 联系方式": "6. Kontaktinformationen",
    "6. 聯絡方式": "6. Kontaktinformationen",
    "安装给以下 Agent：": "Installiert auf den folgenden Agenten:",
    "把 Agent 接入团队正在使用的即时通讯平台，在群聊或私聊中直接对话。": "Verbinden Sie Agent mit der Instant-Messaging-Plattform, die Ihr Team verwendet, und führen Sie direkte Gespräche in Gruppenchats oder privaten Chats.",
    "把世界级设计标准": "Wir bringen erstklassige Designstandards",
    "把指标接回真实数据": "Verbinden Sie Indikatoren wieder mit realen Daten",
    "保存对象": "Objekt speichern",
    "保存失败": "Speichern fehlgeschlagen",
    "保存修改": "Änderungen speichern",
    "保存中...": "Sparen...",
    "保存中…": "Sparen…",
    "报会定期汇总整个组织在 NovaX 中的使用情况，也会根据组织已经连接的数据库、BI、Git、邮箱等底层数据，发现值得关注的业务感知。": "Der Bericht fasst regelmäßig die NovaX-Nutzung des gesamten Unternehmens zusammen und deckt auch wichtige geschäftliche Erkenntnisse auf, die auf zugrunde liegenden Daten wie Datenbanken, BI, Git und Postfächern basieren, mit denen das Unternehmen verbunden ist.",
    "被移出了组织": "Aus der Organisation entfernt",
    "安装方式": "Installationsmethode",
    "本产品不适用于医疗建议、法律咨询、金融决策等专业场景。": "Dieses Produkt ist nicht für professionelle Szenarien wie medizinische Beratung, Rechtsberatung und finanzielle Entscheidungsfindung geeignet.",
    "本产品调用 OpenAI Codex 服务处理对话请求。你的对话内容会按照该服务的隐私政策进行处理。建议避免在对话中输入敏感个人信息。": "Dieses Produkt ruft den OpenAI Codex-Dienst auf, um Konversationsanfragen zu verarbeiten. Der Inhalt Ihrer Gespräche wird in Übereinstimmung mit der Datenschutzrichtlinie dieses Dienstes verarbeitet. Es wird empfohlen, die Eingabe sensibler persönlicher Daten in Gesprächen zu vermeiden.",
    "安装不同的": "Anders installieren",
    "本產品不適用於醫療建議、法律諮詢、金融決策等專業場景。": "Dieses Produkt ist nicht für professionelle Szenarien wie medizinische Beratung, Rechtsberatung und finanzielle Entscheidungsfindung geeignet.",
    "本次分析提示": "Tipps für diese Analyse",
    "本期 SKILL": "SKILL in dieser Ausgabe",
    "本体不是另一套知识库。它把业务里的对象、指标、数据和负责人连接成一张可推理的地图，让 Agent 不只“查到资料”，还知道一个数字怎么来、为什么变、会影响什么。": "Ontologie ist keine weitere Wissensbasis. Es verbindet die Objekte, Indikatoren, Daten und Verantwortlichen im Unternehmen zu einer sinnvollen Karte, sodass der Agent nicht nur „Informationen finden“ kann, sondern auch wissen kann, woher eine Zahl kommt, warum sie sich ändert und welche Auswirkungen sie haben wird.",
    "本体加载失败": "Das Laden der Ontologie ist fehlgeschlagen",
    "本体视图": "Ontologie-Sicht",
    "本体完整度": "Ontologische Integrität",
    "本体只保存结构与口径，数据库凭证由连接器或环境变量管理，不进入业务图谱。": "Die Ontologie speichert nur die Struktur und das Kaliber, und die Datenbankanmeldeinformationen werden vom Connector oder von Umgebungsvariablen verwaltet und gelangen nicht in den Geschäftsgraphen.",
    "本月": "diesen Monat",
    "比较指标观测值，再沿计算与数据血缘找到变化发生在哪一层。": "Vergleichen Sie die Beobachtungswerte des Indikators und folgen Sie dann der Berechnung und der Datenherkunft, um herauszufinden, auf welcher Ebene die Änderung aufgetreten ist.",
    "必填": "Erforderlich",
    "避免把相关性误判为因果": "Vermeiden Sie es, Korrelation mit Kausalität zu verwechseln",
    "编辑": "bearbeiten",
    "编辑定义": "Definition bearbeiten",
    "编辑对象": "Objekt bearbeiten",
    "编辑了 Agent": "Bearbeiteter Agent",
    "编辑业务对象": "Geschäftsobjekt bearbeiten",
    "标识（可选）": "Logo (optional)",
    "标题": "Titel",
    "表、视图、ETL 模型": "Tabellen, Ansichten, ETL-Modelle",
    "补充口径、边界或业务背景": "Ergänzen Sie Kaliber, Grenze oder Geschäftskontext",
    "补充驱动关系": "Ergänzende Fahrbeziehung",
    "补充影响关系": "Ergänzende Einflussbeziehung",
    "本產品呼叫 OpenAI Codex 服務處理對話請求。你的對話內容會按照該服務的隱私政策進行處理。建議避免在對話中輸入敏感個人資訊。": "Dieses Produkt ruft den OpenAI Codex-Dienst auf, um die Konversationsanfrage zu verarbeiten. Der Inhalt Ihrer Gespräche wird in Übereinstimmung mit der Datenschutzrichtlinie dieses Dienstes verarbeitet. Es wird empfohlen, die Eingabe sensibler persönlicher Daten in Gesprächen zu vermeiden.",
    "编写 Soul —— 这是最关键的一步。Soul 决定了 Agent 如何理解任务和回答问题。写得越具体，Agent 的表现越好。": "Soul schreiben – Dies ist der wichtigste Schritt. Soul bestimmt, wie der Agent Aufgaben versteht und Fragen beantwortet. Je spezifischer es geschrieben ist, desto besser ist die Leistung des Agenten.",
    "不会用于商业化运营": "Wird nicht für kommerzielle Zwecke verwendet",
    "不保證": "Keine Garantie",
    "不保证": "Keine Garantie",
    "不會用於商業化營運": "Wird nicht für kommerzielle Zwecke verwendet",
    "不会主动收集": "Wird nicht aktiv gesammelt",
    "不會主動收集": "Wird nicht aktiv gesammelt",
    "参会者": "Teilnehmer",
    "参与聚合、关联和过滤的列": "Spalten, die an der Aggregation, Zuordnung und Filterung beteiligt sind",
    "仓库地址": "Lageradresse",
    "仓库协作": "Zusammenarbeit im Lager",
    "草稿": "Entwurf",
    "策": "Politik",
    "查看": "Überprüfen",
    "查看全部模型 →": "Alle Modelle anzeigen →",
    "查看它负责哪些指标、目标或业务流程。": "Sehen Sie, für welche Kennzahlen, Ziele oder Geschäftsprozesse es verantwortlich ist.",
    "查看完整影响路径": "Vollständigen Aufprallweg anzeigen",
    "查找文件": "Dateien finden",
    "不同于普通的 AI 对话工具，NovaX 的 Agent 具备持久记忆、可安装技能、支持多人协作，并且可以连接飞书、Telegram、微信等即时通讯平台，让 AI 融入你的日常工作流。": "Im Gegensatz zu gewöhnlichen KI-Konversationstools verfügt der Agent von NovaX über einen dauerhaften Speicher, installierbare Fähigkeiten, unterstützt die Zusammenarbeit mehrerer Personen und kann eine Verbindung zu Instant-Messaging-Plattformen wie Feishu, Telegram und WeChat herstellen, um KI in Ihren täglichen Arbeitsablauf zu integrieren.",
    "查看每个技能的功能说明、安装量和评分。": "Sehen Sie sich Funktionsbeschreibungen, Installationen und Bewertungen für jeden Skill an.",
    "不同的 Agent 可以有完全不同的 Soul。例如一个团队可以同时拥有「研究员」、「写手」、「代码审查员」等多个角色各异的 Agent。": "Verschiedene Agenten können völlig unterschiedliche Seelen haben. Ein Team kann beispielsweise mehrere Agenten mit unterschiedlichen Rollen gleichzeitig haben, z. B. „Forscher“, „Autor“ und „Codeprüfer“.",
    "产品文档和技术架构": "Produktdokumentation und technische Architektur",
    "产品 PRD、技术架构文档": "Produkt-PRD, technische Architekturdokumente",
    "常见问题和解答模板": "FAQ-Vorlage",
    "成员（Member）": "Mitglied",
    "常见问题和标准回答": "Häufig gestellte Fragen und Standardantworten",
    "抽出一位大师的思维，": "Zeichnen Sie die Gedanken eines Meisters aus,",
    "处理事件": "Ereignisse verarbeiten",
    "触发次数": "Anzahl der Trigger",
    "创建": "erstellen",
    "创建 Agent": "Agent erstellen",
    "创建 Webhook": "Webhook erstellen",
    "创建 Webhook 后，外部系统（GitHub、Stripe、Sentry 等）可以通过 HTTP POST 自动触发": "Nach dem Erstellen eines Webhooks können externe Systeme (GitHub, Stripe, Sentry usw.) automatisch per HTTP POST auslösen",
    "创建第一个指标": "Erstellen Sie Ihren ersten Indikator",
    "创建核心指标": "Erstellen Sie Kernindikatoren",
    "除了 Web 界面，NovaX 的 Agent 还可以连接到即时通讯平台：": "Zusätzlich zur Weboberfläche kann der Agent von NovaX auch eine Verbindung zu Instant-Messaging-Plattformen herstellen:",
    "创建会议": "Treffen erstellen",
    "创建了 Agent": "Agent erstellt",
    "创建类型": "Typ erstellen",
    "创建你的第一个 Agent": "Erstellen Sie Ihren ersten Agenten",
    "创建企业自建应用，获取凭证": "Erstellen Sie eine selbst erstellte Unternehmensanwendung und erhalten Sie Anmeldeinformationen",
    "创建失败": "Die Erstellung ist fehlgeschlagen",
    "创建时间": "Schöpfungszeit",
    "创建中...": "Erstellen...",
    "创建中…": "Erstellen…",
    "成员 / Agent": "Mitglied/Agent",
    "成员与权限": "Mitglieder und Berechtigungen",
    "创建组织": "Erstellen Sie eine Organisation",
    "持久记忆": "bleibende Erinnerung",
    "创建后系统生成唯一 URL 和密钥，外部系统向该 URL 发送 POST 请求即可触发。": "Nach der Erstellung generiert das System eine eindeutige URL und einen eindeutigen Schlüssel, der durch das Senden einer POST-Anfrage an die URL durch ein externes System ausgelöst werden kann.",
    "创刊导读": "Einführung in die Gründung der Publikation",
    "创作与协作": "Erstellen und zusammenarbeiten",
    "此文件类型暂不支持预览": "Dieser Dateityp unterstützt derzeit keine Vorschau",
    "次": "Zweitklassig",
    "从 160+ 专业角色模板中选择": "Wählen Sie aus über 160 professionellen Rollenvorlagen",
    "从数据到行动的业务地图": "Geschäftsabbildung von Daten zu Maßnahmen",
    "从业务对象和指标定义确定同一个词在公司里的准确语义。": "Bestimmen Sie die genaue Semantik desselben Wortes innerhalb des Unternehmens anhand von Geschäftsobjekt- und Metrikdefinitionen.",
    "从业务世界的第一个对象开始": "Beginnen Sie mit dem ersten Objekt der Geschäftswelt",
    "从营收、订单量、转化率或你最关心的业务结果开始。": "Beginnen Sie mit Umsatz, Bestellvolumen, Konversionsraten oder den Geschäftsergebnissen, die Ihnen am wichtigsten sind.",
    "从预设创建": "Aus Voreinstellung erstellen",
    "代码读取": "Code lesen",
    "待开始": "Zu beginnen",
    "待认领": "Zu beanspruchen",
    "待验证": "Zu verifizieren",
    "单次任务": "Einzelaufgabe",
    "单次执行": "Einzelausführung",
    "当你询问指标、血缘、归因或影响时，NovaX Agent 会先读取相关本体上下文。知识库提供“原文与背景”，本体提供“确定的业务结构”，两者可以通过证据关联起来。": "Wenn Sie nach Metriken, Abstammung, Zuordnung oder Auswirkung fragen, liest NovaX Agent zunächst den relevanten Ontologiekontext. Die Wissensbasis stellt „Originaltext und Hintergrund“ bereit, und die Ontologie stellt „bestimmte Geschäftsstrukturen“ bereit, und die beiden können durch Beweise in Beziehung gesetzt werden.",
    "大": "groß",
    "当前仅支持 .md 格式": "Derzeit wird nur das .md-Format unterstützt",
    "当前值": "aktueller Wert",
    "创建最多 2 个组织，分别用于不同的项目或团队。": "Erstellen Sie bis zu zwei Organisationen, eine für verschiedene Projekte oder Teams.",
    "当前": "aktuell",
    "登记数据库、数据表和关键字段，再用“数据血缘”或“计算依赖”连接到指标。以后 Agent 被问到口径时，就能沿链路找到真实来源，而不是根据文档猜测。": "Registrieren Sie Datenbanken, Datentabellen und Schlüsselfelder und verwenden Sie dann „Datenherkunft“ oder „Berechnungsabhängigkeit“, um eine Verbindung zu Indikatoren herzustellen. Wenn der Agent künftig nach dem Kaliber gefragt wird, kann er die wahre Quelle über den Link finden, anstatt anhand von Dokumenten zu raten.",
    "登记数据来源": "Registrieren Sie Datenquellen",
    "登记数据源、表和字段，再用“数据血缘”或“计算依赖”关系连接到指标。": "Registrieren Sie Datenquellen, Tabellen und Felder und stellen Sie dann mithilfe von „Datenherkunfts“- oder „Berechnungsabhängigkeits“-Beziehungen eine Verbindung zu Indikatoren her.",
    "登记数据资产": "Registrieren Sie Datenbestände",
    "登录账号": "Login-Konto",
    "等待 Agent 连接...": "Warten auf die Verbindung des Agenten...",
    "等待连接成功": "Warten Sie auf eine erfolgreiche Verbindung",
    "等待确认": "Warten auf Bestätigung",
    "等待扫码...": "Warten auf den Scan...",
    "等待中": "Warten",
    "第 1 期 · 由你的 Agent 团队编撰 · 本期": "Ausgabe 1 · Zusammengestellt von Ihrem Agententeam · Diese Ausgabe",
    "登录状态已失效，请重新登录": "Der Anmeldestatus ist abgelaufen. Bitte melden Sie sich erneut an",
    "待上线": "Online sein",
    "的 AI 协作者。": "von KI-Mitarbeitern.",
    "第二步：认识你的界面": "Schritt 2: Kennen Sie Ihre Schnittstelle",
    "第四步：开始对话": "Schritt 4: Beginnen Sie ein Gespräch",
    "第三步：创建你的第一个 Agent": "Schritt 3: Erstellen Sie Ihren ersten Agenten",
    "第一期正在准备中": "Die erste Ausgabe ist in Vorbereitung",
    "点击「生成二维码」，系统会启动微信网页登录流程。": "Klicken Sie auf „QR-Code generieren“ und das System startet den Anmeldevorgang für die WeChat-Webseite.",
    "点击「生成二维码」获取微信登录码": "Klicken Sie auf „QR-Code generieren“, um den WeChat-Anmeldecode zu erhalten",
    "点击连接，系统自动完成配置": "Klicken Sie auf „Verbinden“ und das System schließt die Konfiguration automatisch ab.",
    "点击下方按钮，跳转到飞书开放平台，系统将自动为你创建一个企业自建应用。": "Klicken Sie auf die Schaltfläche unten, um zur offenen Feishu-Plattform zu springen. Das System erstellt automatisch eine selbst erstellte Anwendung für Sie.",
    "点": "Punkt",
    "钉钉": "DingTalk",
    "定时任务": "geplante Aufgaben",
    "第一步：注册和登录": "Schritt 1: Registrieren und anmelden",
    "定位变化": "Positionierungsänderungen",
    "定义第一个核心指标": "Definieren Sie den ersten Kernindikator",
    "定义核心指标": "Definieren Sie Kernmetriken",
    "定义业务类型": "Geschäftstyp definieren",
    "定义这个 Agent 的性格、指令和能力...": "Definieren Sie die Persönlichkeit, Befehle und Fähigkeiten dieses Agenten ...",
    "定义证据": "Beweise definieren",
    "定义指标口径": "Anzeigekaliber definieren",
    "第五步：丰富 Agent 的知识": "Schritt 5: Erweitern Sie das Wissen des Agenten",
    "读取 Figma 文件结构、组件和评论，让 Agent 理解界面设计、设计规范与协作反馈。": "Lesen Sie die Struktur, Komponenten und Kommentare der Figma-Datei, damit der Agent das Schnittstellendesign, die Designspezifikationen und das kollaborative Feedback versteht.",
    "读取内容": "Inhalt lesen",
    "读取网页": "Lesen Sie Webseiten",
    "读完后可以直接进入它的对话，继续追问原因、影响和下一步行动。": "Nachdem Sie es gelesen haben, können Sie direkt in den Dialog einsteigen und weiterhin Fragen zu Ursachen, Auswirkungen und nächsten Schritten stellen.",
    "端口": "Hafen",
    "断开连接": "Trennen",
    "断开失败": "Verbindungstrennung fehlgeschlagen",
    "对话": "Dialog",
    "独立身份、独立记忆、独立技能": "Unabhängige Identität, unabhängiges Gedächtnis, unabhängige Fähigkeiten",
    "调整对话消息流中的文字大小": "Passen Sie die Textgröße im Konversationsstream an",
    "对象": "Objekt",
    "对象存储": "Objektspeicher",
    "对象类型 *": "Objekttyp *",
    "对象列表": "Objektliste",
    "对象已连接": "Objekt ist verbunden",
    "对象已删除": "Objekt gelöscht",
    "对应 Agent 暂不可用": "Der entsprechende Agent ist vorübergehend nicht verfügbar",
    "多个文件用逗号分隔；留空时沿用 Token 自身可见范围": "Mehrere Dateien werden durch Kommas getrennt; Wenn das Feld leer bleibt, wird der sichtbare Bereich des Tokens selbst verwendet.",
    "多媒体": "Multimedia",
    "对话是 NovaX 的核心交互方式。每个 Agent 维护独立的对话历史。在对话界面中，顶部有三个标签页：": "Konversation ist die zentrale Interaktionsmethode von NovaX. Jeder Agent verwaltet einen unabhängigen Gesprächsverlauf. In der Konversationsoberfläche gibt es oben drei Registerkarten:",
    "定时任务（MetaSchedule）": "Geplante Aufgaben (MetaSchedule)",
    "对话系统": "Dialogsystem",
    "多人": "mehrere Personen",
    "多维表格": "mehrdimensionale Tabelle",
    "多 Agent 接力": "Multi-Agent-Relay",
    "额度信息加载失败": "Kontingentinformationen konnten nicht geladen werden",
    "多平台连接": "Multiplattform-Konnektivität",
    "二": "zwei",
    "二维码已过期，请重新生成": "Der QR-Code ist abgelaufen. Bitte generieren Sie ihn neu",
    "发起会议": "Starten Sie ein Meeting",
    "发送人": "Absender",
    "发送时间": "Zeit senden",
    "翻开 →": "Öffnen →",
    "反馈": "Rückmeldung",
    "反馈中心": "Feedback-Center",
    "返回": "zurückkehren",
    "方向": "Richtung",
    "方向未知": "Richtung unbekannt",
    "访问 Token": "Zugriffstoken",
    "飞书 / Lark": "Feishu / Lerche",
    "飞书开放平台": "Feishu offene Plattform",
    "飞书应用已创建，将 Bot 添加到飞书群即可开始使用。": "Die Feishu-App wurde erstellt. Fügen Sie den Bot zur Feishu-Gruppe hinzu, um ihn zu verwenden.",
    "费曼思维": "Feynman-Denken",
    "分析对象": "Analyseobjekt",
    "分析思路": "Analytische Ideen",
    "额度由组织成员共享，所有消费统一从当前组织扣除。": "Das Kontingent wird unter den Organisationsmitgliedern aufgeteilt und der gesamte Verbrauch wird von der aktuellen Organisation abgezogen.",
    "分钟": "Minute",
    "否": "NEIN",
    "额度与账单": "Kreditlimit und Rechnung",
    "服务器会先验证 Pencil CLI Key。设计生成固定使用 Codex 5.6 sol · high，并只操作当前 Agent 工作区内的 .pen 文件。": "Der Server überprüft zunächst den Pencil-CLI-Schlüssel. Die Designgenerierung ist mit Codex 5.6 sol · high behoben und funktioniert nur mit .pen-Dateien im aktuellen Agent-Arbeitsbereich.",
    "服务器已连接，等待 Bot 上线...": "Der Server ist verbunden und wartet darauf, dass der Bot online geht ...",
    "负向": "Negativ",
    "负责人": "verantwortliche Person",
    "复制": "Kopie",
    "复制以下命令到终端运行，Agent 会自动连接到 NovaX 服务器。": "Kopieren Sie den folgenden Befehl auf das Terminal und führen Sie ihn aus. Der Agent stellt automatisch eine Verbindung zum NovaX-Server her.",
    "富文本卡片": "Rich-Text-Karte",
    "覆盖确认": "Deckungsbestätigung",
    "刚刚": "Nur",
    "额外额度": "Zusätzliches Guthaben",
    "分析完成后：": "Nach Abschluss der Analyse:",
    "个": "individuell",
    "个对象": "Objekte",
    "个可用技能": "verfügbaren Fähigkeiten",
    "个人存储": "Persönlicher Speicher",
    "服務的持續可用性、穩定性或資料持久性。服務可能隨時暫停、變更或終止，恕不另行通知。請勿將本產品用於生產環境或存放重要資料。": "KONTINUIERLICHE VERFÜGBARKEIT, STABILITÄT ODER DATENHALTBARKEIT DER DIENSTE. Der Dienst kann jederzeit ohne Vorankündigung ausgesetzt, geändert oder beendet werden. Verwenden Sie dieses Produkt nicht in einer Produktionsumgebung oder zum Speichern wichtiger Daten.",
    "个人文档数": "Anzahl persönlicher Dokumente",
    "个人知识库日志": "Persönliches Wissensdatenbankprotokoll",
    "个属性": "Attribute",
    "个已有来源": "vorhandene Quellen",
    "个字段": "Felder",
    "格式文档，上传后立即生效。": "Dokument formatieren, sofort nach dem Hochladen wirksam.",
    "服务的持续可用性、稳定性或数据持久性。服务可能随时暂停、变更或终止，恕不另行通知。请勿将本产品用于生产环境或存放重要数据。": "Die kontinuierliche Verfügbarkeit, Stabilität oder Datenbeständigkeit des Dienstes. Der Dienst kann jederzeit ohne Vorankündigung ausgesetzt, geändert oder beendet werden. Verwenden Sie dieses Produkt nicht in einer Produktionsumgebung oder zum Speichern wichtiger Daten.",
    "给任务取个名字...": "Geben Sie der Aufgabe einen Namen...",
    "更新计划": "Plan aktualisieren",
    "个人练手的技术演示项目（Demo）": "Technisches Demonstrationsprojekt (Demo) für die persönliche Praxis",
    "工作区标识（可选）": "Arbeitsbereichs-ID (optional)",
    "工作区名称（可选）": "Arbeitsbereichsname (optional)",
    "工作日": "Arbeitstage",
    "工作通知": "Stellenausschreibung",
    "個人練手的技術展示專案（Demo）": "Demonstrationsprojekt für persönliche Übungstechnologie (Demo)",
    "公开仓库（无需凭据）": "Öffentliches Repository (keine Anmeldeinformationen erforderlich)",
    "公式、单位、粒度与负责人": "Formel, Einheit, Granularität und Verantwortlicher",
    "工作原理": "Funktionsprinzip",
    "供 Pencil 内的 Codex Agent 使用": "Zur Verwendung durch Codex Agent in Pencil",
    "共同规则": "gemeinsame Regeln",
    "共同记忆": "gemeinsames Gedächtnis",
    "共享知识库暂时没有可关联文档，保存后也可以再补证据。": "Derzeit gibt es keine Dokumente, die der gemeinsamen Wissensdatenbank zugeordnet werden können. Nach dem Speichern können Sie Beweise hinzufügen.",
    "关闭": "Schließung",
    "关闭简报": "Präsentation schließen",
    "关闭上传选择": "Upload-Auswahl schließen",
    "关闭使用引导": "Schließen Sie die Gebrauchsanweisung",
    "关闭消息导航": "Schalten Sie die Nachrichtennavigation aus",
    "关键字段": "Schlüsselfelder",
    "关系名称": "Beziehungsname",
    "关系说明": "Beziehungsbeschreibung",
    "关系有证据": "Es gibt Hinweise auf eine Verwandtschaft",
    "关系证据": "Beweis einer Verwandtschaft",
    "观测日期": "Beobachtungsdatum",
    "观测值已删除": "Beobachtung gelöscht",
    "观远 BI": "Guanyuan BI",
    "观远 BI 地址": "Guanyuan BI-Adresse",
    "观远 BI 密码": "Guanyuan BI-Passwort",
    "管理": "verwalten",
    "管理员（Admin）": "Admin",
    "规划中": "In Planung",
    "国内平台": "Inländische Plattform",
    "工作目录": "Arbeitsverzeichnis",
    "还没有积累私有记忆": "Es wurde noch kein privater Speicher angesammelt",
    "还没有上游驱动": "Es gibt noch keinen Upstream-Treiber",
    "还没有数据血缘": "Noch keine Datenherkunft",
    "还没有下游影响": "Noch keine nachgelagerten Auswirkungen",
    "还没有血缘关系。": "Es besteht noch keine Blutsverwandtschaft.",
    "还没有执行对象": "Noch kein Ausführungsobjekt",
    "还没有指标": "Noch keine Indikatoren",
    "还需要在 Notion 中把目标页面分享给这个 Integration": "Sie müssen auch die Zielseite mit dieser Integration in Notion teilen.",
    "海外平台": "Übersee-Plattform",
    "功能详解": "Ausführliche Funktionserklärung",
    "核心指标": "Kernindikatoren",
    "环比变化": "Monatliche Veränderung",
    "恢复": "genesen",
    "会话文件": "Sitzungsdatei",
    "会议 ·": "Treffen ·",
    "会议集成": "Konferenzintegration",
    "会议纪要": "Sitzungsprotokolle",
    "会议链接或 ID": "Meeting-Link oder ID",
    "会议密码:": "Meeting-Passwort:",
    "会议时长（分钟）": "Sitzungsdauer (Minuten)",
    "会议主题": "Konferenzthema",
    "活跃": "aktiv",
    "基于观远官方 GuanCLI 验证连接。连接后可读取页面、卡片、数据集、ETL、指标与 ChatBI，默认不开放创建、修改和删除。": "Überprüfen Sie die Verbindung anhand der offiziellen GuanCLI von Guanyuan. Nach der Verbindung können Seiten, Karten, Datensätze, ETL, Indikatoren und ChatBI gelesen werden. Das Erstellen, Ändern und Löschen ist standardmäßig nicht zulässig.",
    "基于微信 iLink 协议，扫码后 Agent 可直接收发私聊消息。建议使用专用微信号作为 Agent 载体。": "Basierend auf dem WeChat iLink-Protokoll kann der Agent nach dem Scannen des QR-Codes direkt private Nachrichten senden und empfangen. Es wird empfohlen, ein dediziertes WeChat-Konto als Agententräger zu verwenden.",
    "即将推出": "kommt bald",
    "计算 / 映射表达式": "Berechnungs-/Zuordnungsausdrücke",
    "计算、影响与责任关系": "Kalkulation, Wirkung und Verantwortung",
    "计算公式": "Berechnungsformel",
    "计算口径": "Kaliber berechnen",
    "记录定义、口径或事实所在位置": "Datensatzdefinition, Kaliber oder tatsächlicher Standort",
    "记录两个以上周期": "Zeichnen Sie mehr als zwei Zyklen auf",
    "记录两个周期的数据后即可比较变化。": "Änderungen können nach der Datenaufzeichnung über zwei Zeiträume verglichen werden.",
    "记录数值": "Rekordwert",
    "记录中…": "Aufnahme…",
    "核心概念": "Kernkonzepte",
    "规定行为": "vorgeschriebenes Verhalten",
    "纪要": "Zusammenfassung",
    "还没有产生额度消费": "Es ist noch keine Verbrauchsquote angefallen",
    "技能": "Fähigkeit",
    "核心内置技能": "Integrierte Kernkompetenzen",
    "技能（Skill）— 能力扩展": "Fertigkeit – Fähigkeitserweiterung",
    "记住与你的所有历史对话（": "Erinnern Sie sich an alle historischen Gespräche mit Ihnen (",
    "技能。安装后直接在对话中用自然语言描述即可：": "Fähigkeit. Beschreiben Sie es nach der Installation einfach in natürlicher Sprache im Gespräch:",
    "技能模块": "Fähigkeitsmodul",
    "技能创作（MetaSkill）": "Skill-Erstellung (MetaSkill)",
    "技能分为系统内置技能和社区发布的技能。": "Die Fertigkeiten werden in systemintegrierte Fertigkeiten und in der Community veröffentlichte Fertigkeiten unterteilt.",
    "技能市场分为两个维度：": "Der Kompetenzmarkt gliedert sich in zwei Dimensionen:",
    "技能市场": "Kompetenzmarkt",
    "加入 Zoom 会议": "Nehmen Sie an einem Zoom-Meeting teil",
    "加入会议": "Nehmen Sie an einer Besprechung teil",
    "加入了组织": "Der Organisation beigetreten",
    "加载中...": "Laden...",
    "加载中…": "Laden…",
    "兼容 AWS S3、MinIO 及大多数 S3 协议对象存储": "Kompatibel mit AWS S3, MinIO und den meisten S3-Protokoll-Objektspeichern",
    "简": "einfach",
    "简报": "Einweisung",
    "简报加载失败": "Briefing konnte nicht geladen werden",
    "简报生成失败": "Die Erstellung des Briefings ist fehlgeschlagen",
    "建立关系": "Beziehungen aufbauen",
    "建立血缘": "Blutlinie etablieren",
    "建立业务关系": "Bauen Sie Geschäftsbeziehungen auf",
    "建立中…": "Gebäude…",
    "建议从一个核心指标开始": "Es wird empfohlen, mit einem Kernindikator zu beginnen",
    "建议使用数据库侧的只读账号": "Es wird empfohlen, auf der Datenbankseite ein schreibgeschütztes Konto zu verwenden",
    "建议先登记一个数据源、一个核心指标和一个业务目标，然后把它们连起来。": "Es wird empfohlen, zunächst eine Datenquelle, einen Kernindikator und ein Geschäftsziel zu registrieren und diese dann zu verbinden.",
    "建议只授予 current_user:read、file_content:read、file_comments:read": "Es wird empfohlen, nur current_user:read, file_content:read, file_comments:read zu gewähren",
    "将": "Wille",
    "将 App ID 和 App Secret 填入下方": "Geben Sie unten die App-ID und das App-Geheimnis ein",
    "将此 Agent 部署为 Discord Bot，在服务器频道中交互。": "Stellen Sie diesen Agenten als Discord-Bot bereit, um im Serverkanal zu interagieren.",
    "技能是给 Agent 扩展能力的模块。不同 Agent 可以安装不同的技能组合，就像给员工配备不同的工具一样。": "Fähigkeiten sind Module, die die Fähigkeiten von Agenten erweitern. Es können unterschiedliche Agenten mit unterschiedlichen Fähigkeiten installiert werden, genauso wie Mitarbeiter mit unterschiedlichen Tools ausgestattet sind.",
    "接入飞书": "Greifen Sie auf Feishu zu",
    "接入观远 BI 的页面、数据集、ETL 与指标体系，让此 Agent 直接理解并分析企业经营数据。": "Greifen Sie auf die Seiten, Datensätze, ETL- und Indikatorsysteme von Guanyuan BI zu, sodass dieser Agent die Betriebsdaten des Unternehmens direkt verstehen und analysieren kann.",
    "接入微信": "Greifen Sie auf WeChat zu",
    "揭开第一期": "Enthüllen Sie die erste Ausgabe",
    "结构搭好后，Agent 会自动使用": "Nachdem die Struktur eingerichtet ist, wird sie vom Agenten automatisch verwendet",
    "结构关系给出候选路径；真实归因仍要结合观测值、证据和业务条件。": "Strukturelle Beziehungen geben Kandidaten Wege vor; Eine wahre Zuschreibung erfordert immer noch eine Kombination aus Beobachtungen, Beweisen und Geschäftsbedingungen.",
    "结构信息充足": "Ausreichende Strukturinformationen",
    "解释业务": "Geschäft erklären",
    "仅供": "nur",
    "仅管理员可删除组织知识库文档": "Nur Administratoren können organisatorische Wissensdatenbankdokumente löschen",
    "技能系统": "Fähigkeitssystem",
    "角色权限": "Rollenberechtigungen",
    "仅支持 .md 文件": "Unterstützt nur MD-Dateien",
    "技能是可以安装到 Agent 上的功能模块。每个技能赋予 Agent 一项特定能力。NovaX 内置了一些核心技能，同时提供技能市场让你发现和安装更多功能：": "Skills sind Funktionsmodule, die auf Agenten installiert werden können. Jede Fertigkeit verleiht dem Agenten eine bestimmte Fähigkeit. NovaX verfügt über einige integrierte Kernkompetenzen und bietet außerdem einen Kompetenzmarkt, auf dem Sie weitere Funktionen entdecken und installieren können:",
    "进 Agent 的肌肉记忆。": "Betreten Sie das Muskelgedächtnis des Agenten.",
    "近 30 天消耗": "Verbrauch in den letzten 30 Tagen",
    "仅所有者可购买": "Nur vom Eigentümer käuflich zu erwerben",
    "进入第一期": "Geben Sie den ersten Zeitraum ein",
    "进入「对话」页面，在左侧列表中点击一个 Agent 进入聊天。在输入框中发送消息，Agent 会实时流式返回回答。对话支持：": "Rufen Sie die Seite „Konversation“ auf und klicken Sie in der Liste links auf einen Agenten, um am Chat teilzunehmen. Senden Sie eine Nachricht in das Eingabefeld und der Agent sendet die Antwort in Echtzeit zurück. Gesprächsunterstützung:",
    "进入「团队」页面，点击「新建 Agent」按钮。填写 Agent 的名称和描述后创建。创建完成后，点击 Agent 卡片可以进入详情页，在这里你可以：": "Rufen Sie die Seite „Team“ auf und klicken Sie auf die Schaltfläche „Neuer Agent“. Geben Sie den Namen und die Beschreibung des Agenten ein und erstellen Sie ihn. Klicken Sie nach der Erstellung auf die Agentenkarte, um die Detailseite aufzurufen, auf der Sie Folgendes tun können:",
    "进行中": "im Gange",
    "进行中/待开": "In Bearbeitung/zu öffnen",
    "竞": "wetteifern",
    "竞对与行业": "Wettbewerb und Industrie",
    "聚合方式": "Aggregationsmethode",
    "可留空自动生成，例如 contract": "Kann zur automatischen Generierung leer gelassen werden, z. B. ein Vertrag",
    "可能后果与下游": "Mögliche Folgen und nachgelagert",
    "可能原因与上游": "Mögliche Gründe und Upstream",
    "可选": "Optional",
    "可选 · 关联共享知识库": "Optional · Zugehörige gemeinsame Wissensdatenbank",
    "可以创建团队、Agent 或项目，再与指标和业务目标建立责任关系。": "Sie können Teams, Agenten oder Projekte erstellen und Verantwortlichkeiten anhand von Kennzahlen und Geschäftszielen festlegen.",
    "可用": "Verfügbar",
    "可追溯证据": "nachvollziehbare Beweise",
    "客户联系": "Kundenkontakt",
    "口径、公式、粒度和负责人": "Kaliber, Formel, Granularität und Verantwortlicher",
    "口径与依赖": "Kaliber und Abhängigkeit",
    "跨层查看正在形成的业务语义。": "Sehen Sie sich neue Geschäftssemantiken über Ebenen hinweg an.",
    "进入左侧导航栏的「知识库」页面。": "Rufen Sie die Seite „Wissensdatenbank“ in der linken Navigationsleiste auf.",
    "进入「知识库」页面，上传 .md 格式的文档。这些文档会成为所有 Agent 的共享参考资料。比如你可以上传公司的代码规范，之后让代码审查 Agent 按照这个规范来检查代码。": "Rufen Sie die Seite „Knowledge Base“ auf und laden Sie das Dokument im .md-Format hoch. Diese Dokumente werden zu einer gemeinsamen Referenz für alle Agenten. Sie können beispielsweise die Codespezifikationen des Unternehmens hochladen und dann den Codeüberprüfungsagenten den Code gemäß dieser Spezifikation überprüfen lassen.",
    "快速上手": "Legen Sie schnell los",
    "来源与流转": "Quelle und Verbreitung",
    "可用 Nova 点": "Verfügbare Nova-Punkte",
    "类": "Art",
    "类型说明": "Typbeschreibung",
    "类型已删除": "Typ gelöscht",
    "类型与字段": "Typen und Felder",
    "理解含义": "die Bedeutung verstehen",
    "例：产品评审会、周例会...": "Beispiel: Produktbewertungstreffen, wöchentliches Treffen ...",
    "例如 研究助手": "z.B. wissenschaftlicher Mitarbeiter",
    "例如 demo": "Zum Beispiel Demo",
    "例如 NovaX 产品团队": "Zum Beispiel das NovaX-Produktteam",
    "例如 product-design": "Zum Beispiel Produktdesign",
    "例如 researcher": "Zum Beispiel Forscher",
    "例如：2026-W30 / 2026-07": "Zum Beispiel: 2026-W30/2026-07",
    "例如：合同": "Zum Beispiel: Vertrag",
    "例如：经营看板 / SQL 查询": "Beispiel: Business Kanban/SQL-Abfrage",
    "例如：库存充足时": "Zum Beispiel: wenn der Vorrat ausreichend ist",
    "例如：渠道=自然流量，地区=华东": "Beispiel: Kanal = natürlicher Verkehr, Region = Ostchina",
    "例如：同日 / 7 天后": "Zum Beispiel: am selben Tag / 7 Tage später",
    "例如：支付转化率": "Beispiel: Zahlungsumrechnungskurs",
    "例如：SUM(pay_amount)": "Zum Beispiel: SUM(pay_amount)",
    "例如：SUM(pay_amount) 或 orders.pay_amount → revenue": "Zum Beispiel: SUM(pay_amount) oderorders.pay_amount → Umsatz",
    "连接": "verbinden",
    "连接 AWS S3、MinIO 或兼容对象存储，让 Agent 浏览目录并读取授权前缀内的文件。": "Stellen Sie eine Verbindung zu AWS S3, MinIO oder einem kompatiblen Objektspeicher her und lassen Sie den Agenten das Verzeichnis durchsuchen und Dateien innerhalb des Autorisierungspräfixes lesen.",
    "连接 GitHub、GitLab 或 Gitee 仓库，让此 Agent 在授权范围内读取代码、分析变更并参与开发协作。": "Stellen Sie eine Verbindung zu einem GitHub-, GitLab- oder Gitee-Repository her und lassen Sie diesen Agenten Code lesen, Änderungen analysieren und im Rahmen der Autorisierung an der Entwicklungszusammenarbeit teilnehmen.",
    "连接 PostgreSQL、MySQL、SQL Server 等数据库，通过只读权限查询真实业务数据。": "Stellen Sie eine Verbindung zu PostgreSQL, MySQL, SQL Server und anderen Datenbanken her, um echte Geschäftsdaten mit schreibgeschützten Berechtigungen abzufragen.",
    "连接成功": "Verbindung erfolgreich",
    "连接成功后，Agent 会自动接入你的微信，在指定聊天中响应消息。": "Nachdem die Verbindung erfolgreich hergestellt wurde, greift der Agent automatisch auf Ihren WeChat zu und antwortet auf Nachrichten im angegebenen Chat.",
    "累计消耗": "Kumulierter Verbrauch",
    "连接飞书": "Verbinde dich mit Feishu",
    "连接飞书后，团队成员可以直接在飞书群聊中与 Agent 对话。支持富文本卡片、文件收发、日历联动等飞书原生能力。": "Nach der Verbindung mit Feishu können Teammitglieder im Feishu-Gruppenchat direkt mit dem Agenten sprechen. Es unterstützt die nativen Funktionen von Feishu wie Rich-Text-Karten, das Senden und Empfangen von Dateien sowie die Kalenderverknüpfung.",
    "连接后可读取文件节点和评论，不开放修改设计、发表评论或管理团队。": "Nach der Verbindung können Dateiknoten und Kommentare gelesen werden, es ist jedoch nicht möglich, das Design zu ändern, Kommentare zu posten oder das Team zu verwalten.",
    "连接后可列出对象并读取限定前缀内不超过 2MB 的文件，不开放上传、覆盖或删除。": "Nach der Verbindung können Objekte aufgelistet und Dateien mit einer Größe von maximal 2 MB innerhalb des begrenzten Präfixes gelesen werden. Das Hochladen, Überschreiben oder Löschen ist nicht gestattet.",
    "连接后可搜索并读取已授权页面和内容块，不开放创建、修改或删除页面。": "Nach der Verbindung können Sie autorisierte Seiten und Inhaltsblöcke durchsuchen und lesen, es ist Ihnen jedoch nicht gestattet, Seiten zu erstellen, zu ändern oder zu löschen.",
    "连接计算来源和业务目标": "Verbinden Sie Rechenquellen und Geschäftsziele",
    "连接类型": "Verbindungstyp",
    "连接目标或流程": "Ziel oder Prozess verbinden",
    "连接你的 AI 引擎": "Verbinden Sie Ihre KI-Engine",
    "连接上下游": "Upstream und Downstream verbinden",
    "连接设计、文档、邮箱、代码与业务数据，让 Agent 在明确授权范围内参与真实工作。": "Verbinden Sie Designs, Dokumente, E-Mails, Code und Geschäftsdaten, um Agenten die Teilnahme an echten Arbeiten innerhalb eines klar autorisierten Rahmens zu ermöglichen.",
    "连接失败": "Verbindung fehlgeschlagen",
    "连接数据或指标": "Verbinden Sie Daten oder Metriken",
    "连接完成后，将 Agent 添加到飞书群即可开始对话。": "Nachdem die Verbindung hergestellt wurde, fügen Sie den Agenten zur Feishu-Gruppe hinzu, um das Gespräch zu beginnen.",
    "连接微信": "Stellen Sie eine Verbindung zu WeChat her",
    "连接验证成功": "Verbindungsüberprüfung erfolgreich",
    "连接中...": "Verbinden...",
    "连续记录两个周期后，NovaX 会计算变化并在影响分析中沿上游寻找可能驱动。": "Nach zwei aufeinanderfolgenden Aufzeichnungszeiträumen berechnet NovaX die Veränderungen und sucht im Vorfeld in einer Wirkungsanalyse nach möglichen Treibern.",
    "联网搜索": "Internetsuche",
    "链接": "Link",
    "列表视图": "Listenansicht",
    "临时凭据才需要": "Es sind lediglich temporäre Ausweise erforderlich",
    "另有": "Auch",
    "留空会继续使用已加密保存的凭据": "Lassen Sie das Feld leer, um weiterhin verschlüsselte gespeicherte Anmeldeinformationen zu verwenden",
    "六": "sechs",
    "六个视图，其实是同一张图": "Sechs Ansichten, eigentlich das gleiche Bild",
    "路径样式（MinIO 常用）": "Pfadstil (häufig von MinIO verwendet)",
    "马斯克思维": "Musk-Denken",
    "芒格思维": "Mungers Gedanken",
    "来扩展能力": "Fähigkeiten zu erweitern",
    "没有发现新增内容": "Keine neuen Inhalte gefunden",
    "没有匹配的角色": "Keine passende Rolle",
    "没有匹配的消息": "Keine passenden Nachrichten",
    "没有匹配的指标": "Keine passenden Messwerte",
    "没有上游路径": "kein Upstream-Pfad",
    "没有下游路径": "kein Downstream-Pfad",
    "没有新增内容": "Nichts Neues",
    "没有找到匹配的技能": "Keine passenden Fähigkeiten gefunden",
    "没有找到匹配的文件": "Keine passende Datei gefunden",
    "每": "Jeder",
    "连接到飞书、Telegram、微信等": "Stellen Sie eine Verbindung zu Feishu, Telegram, WeChat usw. her.",
    "来指定哪个 Agent 回复。不带 @ 的消息不会触发任何 Agent。": "um anzugeben, welcher Agent antwortet. Nachrichten ohne @ lösen keinen Agenten aus.",
    "没有 @ 任何 Agent 的消息会发送到群里但不会触发 Agent 回复，方便团队成员之间交流。": "Nachrichten ohne @any Agent werden an die Gruppe gesendet, lösen jedoch keine Agentenantworten aus, was die Kommunikation zwischen Teammitgliedern erleichtert.",
    "每篇内容都来自": "Jeder Inhalt stammt von",
    "每天": "täglich",
    "每小时": "pro Stunde",
    "每一层回答一个不同问题，连起来才是 Agent 能推理的本体。": "Jede Schicht beantwortet eine andere Frage und zusammen bilden sie die Ontologie, über die der Agent nachdenken kann.",
    "每月": "pro Monat",
    "每周": "wöchentlich",
    "每个 Agent 都能看到群聊中的上下文，所以后续 Agent 可以直接引用前面 Agent 的输出。": "Jeder Agent kann den Kontext im Gruppenchat sehen, sodass nachfolgende Agenten direkt auf die Ausgabe des vorherigen Agenten verweisen können.",
    "每个用户最多可以创建": "Jeder Benutzer kann bis zu erstellen",
    "密码": "Passwort",
    "密码、Token 和私钥只在服务端加密存储，不会写入 Agent 文件或对话。": "Passwörter, Token und private Schlüssel werden nur verschlüsselt und auf der Serverseite gespeichert und nicht in Agentendateien oder Konversationen geschrieben.",
    "每周五下午 5 点生成本周工作总结": "Jeden Freitag um 17 Uhr wird eine Zusammenfassung der Wochenarbeit erstellt.",
    "每天早上 9 点给我发一份行业新闻摘要": "Schicken Sie mir jeden Morgen um 9 Uhr eine Zusammenfassung der Branchennachrichten",
    "描述": "beschreiben",
    "名称": "Name",
    "名称 *": "Name *",
    "名称不能为空": "Der Name darf nicht leer sein",
    "免费额度为组织一次性额度，所有成员共同使用。当前按 $1 = 750 Nova 点折算。": "Das kostenlose Kontingent ist ein einmaliges Kontingent für die Organisation und wird von allen Mitgliedern geteilt. Derzeit umgerechnet bei 1 $ = 750 Nova Points.",
    "模板消息": "Vorlagenachricht",
    "免费赠送": "kostenloses Geschenk",
    "模型定义": "Modelldefinition",
    "模型": "Modell",
    "明确角色": "Rollen klären",
    "默认邮箱目录": "Standard-Postfachverzeichnis",
    "名称和头像": "Name und Avatar",
    "模板中用": "Wird in Vorlagen verwendet",
    "内部群聊": "Interner Gruppenchat",
    "内容读取": "Lesen von Inhalten",
    "内置类型构成 NovaX 的共同语义，自定义类型描述你的独特业务。": "Integrierte Typen bilden die gemeinsame Semantik von NovaX und benutzerdefinierte Typen beschreiben Ihr einzigartiges Unternehmen.",
    "你": "Du",
    "目录": "Inhaltsverzeichnis",
    "你可以随时在设置中注销账号，删除所有关联数据。": "Sie können sich jederzeit in den Einstellungen von Ihrem Konto abmelden und alle damit verbundenen Daten löschen.",
    "模型和": "Modell und",
    "你可以隨時在設定中登出帳號，刪除所有關聯資料。": "Sie können sich jederzeit in den Einstellungen von Ihrem Konto abmelden und alle damit verbundenen Daten löschen.",
    "你可以把 Agent 理解为团队中的一个虚拟成员。它可以：": "Sie können sich einen Agenten als virtuelles Mitglied des Teams vorstellen. Es kann:",
    "女娲 · Skill 造人术": "Nuwa·Skill-Technik zur menschlichen Schöpfung",
    "篇": "Kapitel",
    "频道对话": "Kanalgespräch",
    "平台": "Plattform",
    "平台公告": "Ankündigung der Plattform",
    "评估后果": "Bewerten Sie die Konsequenzen",
    "评论读取": "Kommentare gelesen",
    "凭据已加密保存，": "Anmeldedaten werden verschlüsselt gespeichert,",
    "期望方向": "gewünschte Richtung",
    "企业微信": "Unternehmens-WeChat",
    "企业邮箱 / 自定义 IMAP": "Geschäfts-E-Mail/benutzerdefiniertes IMAP",
    "启用（兼容自签名证书）": "Aktiviert (kompatibel mit selbstsignierten Zertifikaten)",
    "启用（推荐）": "Aktivieren (empfohlen)",
    "启用并验证证书": "Zertifikat aktivieren und überprüfen",
    "起点 *": "Ausgangspunkt *",
    "前": "nach vorne",
    "前往": "Gehe zu",
    "前往飞书开放平台 →": "Gehen Sie zur Feishu Open Platform →",
    "前缀隔离": "Präfixisolation",
    "乔布斯思维": "Jobs-Denken",
    "你在使用过程中输入的对话内容仅用于与 AI 引擎交互，不会被额外存储或用于训练模型。": "Die von Ihnen während der Nutzung eingegebenen Gesprächsinhalte werden nur zur Interaktion mit der KI-Engine verwendet und nicht zusätzlich gespeichert oder zum Trainieren des Modells verwendet.",
    "你在使用過程中輸入的對話內容僅用於與 AI 引擎互動，不會被額外儲存或用於訓練模型。": "Die von Ihnen während der Nutzung eingegebenen Gesprächsinhalte werden nur zur Interaktion mit der KI-Engine verwendet und nicht zusätzlich gespeichert oder zum Trainieren des Modells verwendet.",
    "切换": "schalten",
    "前提：Agent 需要安装": "Voraussetzung: Agent muss installiert sein",
    "切换组织": "Organisation wechseln",
    "切换或创建组织，每个组织有独立的 Agent 和成员。": "Wechseln Sie oder gründen Sie Organisationen. Jede Organisation hat unabhängige Agenten und Mitglieder.",
    "请结合简报结论，进一步说明原因、可能影响，以及我们接下来最值得采取的行动。": "Bitte nutzen Sie den Abschluss des Briefings, um die Gründe, möglichen Auswirkungen und die sinnvollsten Maßnahmen, die wir als Nächstes ergreifen sollten, näher zu erläutern.",
    "请输入您的反馈、建议或遇到的问题...": "Bitte geben Sie Ihr Feedback, Ihre Vorschläge oder Probleme ein ...",
    "请填写 App ID 和 App Secret": "Bitte geben Sie App-ID und App-Geheimnis ein",
    "请勿填写网页登录密码": "Bitte geben Sie nicht das Login-Passwort für die Webseite ein",
    "请选择一个角色": "Bitte wählen Sie eine Rolle aus",
    "区域": "Bereich",
    "驱动行动": "Aktion antreiben",
    "取消": "Stornieren",
    "全部": "alle",
    "全部对象": "Alle Objekte",
    "全部执行对象": "Alle Ausführungsobjekte",
    "全程以 IMAP 只读模式打开邮箱；可搜索和读取邮件正文、查看附件名称，不会发送、删除、移动或标记邮件。": "Das Postfach wird durchgehend im schreibgeschützten IMAP-Modus geöffnet; Der E-Mail-Text kann durchsucht und gelesen werden, und die Namen der Anhänge können angezeigt werden. Die E-Mail wird nicht gesendet, gelöscht, verschoben oder markiert.",
    "切换中...": "Wechsel...",
    "切换组织后，你看到的 Agent、知识库、团队成员都会随之改变。": "Nach dem Wechsel der Organisation ändern sich die angezeigten Agenten, Wissensdatenbanken und Teammitglieder entsprechend.",
    "清除后所有聊天记录将被删除，无法恢复。": "Nach dem Löschen wird der gesamte Chatverlauf gelöscht und kann nicht wiederhergestellt werden.",
    "全员群": "Alle Mitglieder",
    "权限隔离": "Berechtigungsisolierung",
    "确保 Codex CLI 已安装": "Stellen Sie sicher, dass Codex CLI installiert ist",
    "确定": "Sicher",
    "确定断开？已保存凭据会被删除。": "Möchten Sie die Verbindung wirklich trennen? Gespeicherte Zugangsdaten werden gelöscht.",
    "确定删除这个会议？": "Sind Sie sicher, dass Sie diese Besprechung löschen möchten?",
    "确定删除这条指标观测吗？": "Sind Sie sicher, dass Sie diese Indikatorbeobachtung löschen möchten?",
    "确认断开": "Bestätigen Sie die Trennung",
    "确认已安装。": "Bestätigen Sie, dass es installiert ist.",
    "全局市场": "globalen Markt",
    "群聊": "Gruppenchat",
    "群聊@唤醒": "Gruppenchat@wake",
    "群聊对话": "Gruppenchat-Gespräch",
    "确定要注销账号吗？": "Sind Sie sicher, dass Sie Ihr Konto kündigen möchten?",
    "确定清除所有会话？": "Sind Sie sicher, dass Sie alle Sitzungen löschen möchten?",
    "确认清除": "Bestätigen Sie das Löschen",
    "让组织的重要变化": "Nehmen Sie wichtige Veränderungen in Ihrer Organisation vor",
    "人": "Menschen",
    "人格蒸馏 · 女娲造人": "Persönlichkeitsdestillation: Nuwa erschafft Menschen",
    "群聊与多 Agent 协作": "Gruppenchat und Zusammenarbeit mit mehreren Agenten",
    "确认注销": "Bestätigen Sie die Abmeldung",
    "群聊是 NovaX 的核心协作场景。在 Agent 列表顶部点击「全员群」即可进入。群聊中所有 Agent 和团队成员共处一个对话空间。": "Gruppenchat ist das zentrale Kollaborationsszenario von NovaX. Klicken Sie oben in der Agentenliste auf „Alle Mitglieder“, um teilzunehmen. In einem Gruppenchat teilen sich alle Agenten und Teammitglieder denselben Gesprächsbereich.",
    "认证方式": "Authentifizierungsmethode",
    "任务名称": "Aufgabenname",
    "仍建议用实际数据验证候选原因。": "Es wird dennoch empfohlen, mögliche Ursachen anhand tatsächlicher Daten zu überprüfen.",
    "日": "Tag",
    "日历联动": "Kalenderverknüpfung",
    "日期": "Datum",
    "任务": "Aufgabe",
    "人设和行为规则": "Persönlichkeits- und Verhaltensregeln",
    "群聊中需要通过": "Im Gruppenchat müssen Sie bestehen",
    "三": "drei",
    "如何创建": "So erstellen Sie",
    "扫码登录微信后，Agent 可作为你的微信助手，自动回复消息、管理群聊、处理日常事务。": "Nachdem Sie den QR-Code gescannt haben, um sich bei WeChat anzumelden, kann der Agent als Ihr WeChat-Assistent fungieren, automatisch auf Nachrichten antworten, Gruppenchats verwalten und alltägliche Angelegenheiten erledigen.",
    "扫码连接微信后，此 Agent 自动接入微信消息，可在私聊或群聊中响应。": "Nach dem Scannen des QR-Codes zur Verbindung mit WeChat greift dieser Agent automatisch auf WeChat-Nachrichten zu und kann in privaten Chats oder Gruppenchats antworten.",
    "扫码区域": "Codebereich scannen",
    "删除": "löschen",
    "删除观测": "Beobachtung löschen",
    "删除后无法恢复，确定要删除这个文档吗？": "Die Löschung kann nicht wiederhergestellt werden. Möchten Sie dieses Dokument wirklich löschen?",
    "删除会议": "Besprechung löschen",
    "删除了 Agent": "Agent gelöscht",
    "删除失败": "Das Löschen ist fehlgeschlagen",
    "删除失败或无权操作": "Der Löschvorgang ist fehlgeschlagen oder es liegt keine Betriebsberechtigung vor",
    "删除文档": "Dokument löschen",
    "商业专业": "Wirtschaftsmajor",
    "上传": "hochladen",
    "上传到哪里？": "Wo hochladen?",
    "上传后仍可在“组织知识库 / 我的知识库”中分别查看。": "Nach dem Hochladen kann es weiterhin separat in „Wissensdatenbank der Organisation/Meine Wissensdatenbank“ angezeigt werden.",
    "上传了": "Hochgeladen",
    "上传录音": "Aufnahme hochladen",
    "上传失败": "Der Upload ist fehlgeschlagen",
    "上次：": "Letztes Mal:",
    "上次触发": "zuletzt ausgelöst",
    "上次执行": "zuletzt ausgeführt",
    "上下游网络": "Upstream- und Downstream-Netzwerke",
    "上一步": "Vorheriger Schritt",
    "上游候选": "Upstream-Kandidat",
    "尚未补充业务定义": "Es wurde noch keine Geschäftsdefinition hinzugefügt",
    "尚未连接指标或业务目标。": "Es wurden noch keine Kennzahlen oder Geschäftsziele verknüpft.",
    "如有任何問題或疑慮，請透過產品內的回饋管道聯絡開發者。": "Wenn Sie Fragen oder Bedenken haben, wenden Sie sich bitte über den Feedback-Kanal innerhalb des Produkts an den Entwickler.",
    "如有任何问题或疑虑，请通过产品内的反馈渠道联系开发者。": "Wenn Sie Fragen oder Bedenken haben, wenden Sie sich bitte über den Feedback-Kanal im Produkt an den Entwickler.",
    "设定定时任务，例如\"每天早上9点给我发日报\"": "Legen Sie eine geplante Aufgabe fest, z. B. „Senden Sie mir jeden Tag um 9 Uhr einen täglichen Bericht.“",
    "设计创作": "Designerstellung",
    "设计生成": "Design-Generierung",
    "设计师包 · DESIGN": "Designertasche · DESIGN",
    "上传文件作为附件。": "Laden Sie die Datei als Anhang hoch.",
    "三级权限体系": "Dreistufiges Autoritätssystem",
    "设置": "aufstellen",
    "谁来行动": "wer wird handeln",
    "什么属于这个类型，什么不属于？": "Was gehört zu diesem Genre und was nicht?",
    "生成二维码": "QR-Code generieren",
    "生成二维码失败": "QR-Code konnte nicht generiert werden",
    "生成纪要": "Minuten generieren",
    "生成纪要中": "Minuten generieren",
    "生成失败": "Build fehlgeschlagen",
    "生成中...": "Generieren...",
    "失败": "scheitern",
    "设定边界": "Grenzen setzen",
    "实体与关系来源": "Entitäts- und Beziehungsquellen",
    "使用": "verwenden",
    "时间": "Zeit",
    "设置头像，从预设中选择或上传自定义图片。": "Legen Sie einen Avatar fest, wählen Sie aus Voreinstellungen oder laden Sie ein benutzerdefiniertes Bild hoch.",
    "使用工具": "Verwenden Sie Werkzeuge",
    "使用时只记住两个动作": "Denken Sie bei der Verwendung einfach an zwei Aktionen",
    "使用引导": "Nutzen Sie den Leitfaden",
    "什么是 Agent": "Was ist Agent?",
    "使用方式": "Verwendung",
    "视条件而定": "Vorbehaltlich der Bedingungen",
    "是": "Ja",
    "是 / 否": "ob",
    "适用条件": "Anwendbare Bedingungen",
    "收到 Webhook 事件: {{payload}}": "Webhook-Ereignis empfangen: {{payload}}",
    "收起": "schließen",
    "手动创建": "Manuell erstellen",
    "手动记录": "Manuelle Aufnahme",
    "输入清晰、唯一的业务名称": "Geben Sie einen klaren, eindeutigen Firmennamen ein",
    "输入消息，@agent 名字来提问": "Geben Sie eine Nachricht und den Namen des @agenten ein, um eine Frage zu stellen",
    "属性": "Eigentum",
    "属性用于统一业务含义，也会成为 Agent 的结构化上下文。": "Attribute werden verwendet, um die Geschäftsbedeutung zu vereinheitlichen und auch zum strukturierten Kontext des Agenten zu werden.",
    "属性字段": "Attributfeld",
    "数": "Nummer",
    "数据层：数从哪里来": "Datenschicht: Woher kommen die Zahlen?",
    "数据从哪里来，经过什么，最终形成哪个指标": "Woher kommen die Daten, was durchlaufen sie und welcher Indikator wird letztendlich gebildet?",
    "数据分析": "Datenanalyse",
    "数据观察": "Datenbeobachtung",
    "数据集": "Datensatz",
    "数据库、表和关键字段": "Datenbank, Tabellen und Schlüsselfelder",
    "数据库地址": "Datenbankadresse",
    "数据库接入能自动补充血缘和观测；它可以发现相关性，但不会自动把相关性升级成因果。": "Der Datenbankzugriff kann Verwandtschaft und Beobachtung automatisch ergänzen; Es kann Korrelationen entdecken, aber Korrelationen werden nicht automatisch auf Kausalität hochgestuft.",
    "数据库类型": "Datenbanktyp",
    "数据库密码": "Datenbankpasswort",
    "数据库名": "Datenbankname",
    "数据血缘": "Datenherkunft",
    "数据血缘回答“数从哪里来”；影响关系回答“可能为什么”；只有已验证因果才能回答“确定是什么导致”。": "Datenherkunft antwortet: „Woher kommen Zahlen?“; Einfluss Beziehung antwortet „eventuell warum“; Nur nachgewiesene Ursache und Wirkung können die Frage beantworten: „Bestimmen Sie, was sie verursacht.“",
    "数据血缘图": "Datenherkunftsdiagramm",
    "数据与办公": "Daten und Büro",
    "数据源": "Datenquelle",
    "数据源、表与字段": "Datenquellen, Tabellen und Felder",
    "数据资产": "Datenbestände",
    "数据字段 → 核心指标 → 业务目标 → 负责人": "Datenfelder → Kernindikatoren → Geschäftsziele → Verantwortlicher",
    "数值来源": "Wertquelle",
    "数字": "Nummer",
    "双人": "Doppelt",
    "说明": "veranschaulichen",
    "说明它在业务里代表什么，以及不包含什么": "Erklären Sie, was es im Unternehmen darstellt und was nicht",
    "私聊": "privater Chat",
    "私聊回复": "Private Chat-Antwort",
    "私钥口令（可选）": "Passwort für den privaten Schlüssel (optional)",
    "思考中...": "Denken...",
    "思维框架": "Denkrahmen",
    "四": "Vier",
    "四层不是四个独立目录，而是一条从事实到行动的链路。你不需要一次填满，先搭出一条最重要的链路即可。": "Die vierte Ebene besteht nicht aus vier separaten Verzeichnissen, sondern aus einer Verbindung von Fakten zu Maßnahmen. Sie müssen nicht alles auf einmal ausfüllen, sondern erstellen Sie einfach zuerst den wichtigsten Link.",
    "松开以上传 .md 文件": "Lassen Sie los, um die .md-Datei hochzuladen",
    "搜索并读取授权给 Integration 的 Notion 页面与内容块，让 Agent 使用团队文档和项目资料。": "Durchsuchen und lesen Sie Notion-Seiten und Inhaltsblöcke, die für die Integration autorisiert sind, sodass der Agent Teamdokumente und Projektmaterialien verwenden kann.",
    "搜索会话内的文件": "Durchsuchen Sie Dateien innerhalb einer Sitzung",
    "搜索技能名称、描述或标签...": "Suchen Sie nach einem Fertigkeitsnamen, einer Beschreibung oder einem Tag ...",
    "搜索内容": "Inhalte durchsuchen",
    "搜索项目、团队或 Agent": "Suchen Sie nach Projekten, Teams oder Agenten",
    "搜索消息...": "Nachrichten durchsuchen...",
    "搜索预设角色...": "Nach voreingestellten Rollen suchen...",
    "搜索知识库...": "Durchsuchen Sie die Wissensdatenbank...",
    "搜索指标或口径": "Suchmetriken oder Kaliber",
    "所属层 *": "Zugehörige Schicht *",
    "示例：": "Beispiel:",
    "使用者的個人資訊用於任何商業用途。": "Die persönlichen Daten des Benutzers werden für kommerzielle Zwecke verwendet.",
    "使用邮箱注册账号。系统会发送验证码到你的邮箱，验证后设置密码即可完成注册。首次登录会自动创建一个默认组织。": "Verwenden Sie Ihre E-Mail-Adresse, um ein Konto zu registrieren. Das System sendet einen Bestätigungscode an Ihre E-Mail. Legen Sie nach der Überprüfung ein Passwort fest, um die Registrierung abzuschließen. Wenn Sie sich zum ersten Mal anmelden, wird automatisch eine Standardorganisation erstellt.",
    "它还会持续关注竞对的紧急或重要情报，以及行业和政策方向的大新闻，把真正需要组织关注的变化集中推送到这里。": "Darüber hinaus wird es weiterhin auf dringende oder wichtige Informationen zum Wettbewerb sowie auf wichtige Branchen- und Politiknachrichten achten und die Veränderungen vorantreiben, die hier wirklich die Aufmerksamkeit der Organisation erfordern.",
    "所有者（Owner）": "Eigentümer",
    "提出原因": "Geben Sie Gründe an",
    "提交反馈": "Feedback abgeben",
    "提交分析": "Analyse einreichen",
    "添加关系": "Beziehung hinzufügen",
    "添加字段": "Feld hinzufügen",
    "条关系": "Beziehung",
    "条件性": "Konditionalität",
    "条因果关系": "Kausalzusammenhang",
    "跳": "Springen",
    "跳过引导": "Boot überspringen",
    "适合放入的内容": "Was einzugeben ist",
    "通过 Pencil Headless CLI 创建、修改和导出 .pen 设计稿，生成过程固定使用 Codex。": "Erstellen, ändern und exportieren Sie .pen-Designentwürfe über die Pencil Headless CLI, und der Generierungsprozess verwendet immer Codex.",
    "通过 Telegram Bot 与 Agent 交互，支持全球范围内的即时通讯和文件处理。": "Interagieren Sie mit dem Agenten über Telegram Bot und unterstützen Sie so Instant Messaging und Dateiverarbeitung auf globaler Ebene.",
    "通过 Telegram Bot 与此 Agent 交互，支持全球即时通讯。": "Interagieren Sie mit diesem Agenten über Telegram Bot, um globales Instant Messaging zu unterstützen.",
    "通过 WhatsApp Business API 接入此 Agent，覆盖全球用户。": "Greifen Sie über die WhatsApp Business API auf diesen Agenten zu, um Benutzer auf der ganzen Welt zu erreichen.",
    "通过企业微信应用接入此 Agent，支持内部沟通与客户服务场景。": "Greifen Sie über die WeChat-Unternehmensanwendung auf diesen Agenten zu, um interne Kommunikations- und Kundendienstszenarien zu unterstützen.",
    "通过": "passieren",
    "通信对话 (": "Kommunikationsgespräch (",
    "通用工具 (": "Allgemeine Werkzeuge (",
    "同名文档": "Dokument mit demselben Namen",
    "套餐与额度已经可以查看，支付渠道确定后即可开放购买。": "Pakete und Kontingente sind bereits einsehbar und nach Festlegung des Zahlungskanals können Einkäufe getätigt werden.",
    "同一组织 · 同一份简报 · 持续沉淀": "Die gleiche Organisation · derselbe Auftrag · kontinuierliche Akkumulation",
    "统计": "Statistiken",
    "统计粒度": "statistische Granularität",
    "统计周期": "statistischer Zeitraum",
    "图标": "Symbol",
    "图标视图": "Symbolansicht",
    "图片 / PDF 导出": "Bild-/PDF-Export",
    "通过邮箱邀请成员加入，设置不同的角色（所有者 / 管理员 / 成员）。": "Laden Sie Mitglieder per E-Mail zum Beitritt ein und legen Sie verschiedene Rollen fest (Eigentümer/Administrator/Mitglied).",
    "套餐之间仅额度不同，所有产品能力保持一致。": "Lediglich die Menge unterscheidet sich zwischen den Paketen und alle Produktfunktionen bleiben gleich.",
    "团队的": "Team",
    "团队": "Team",
    "同一个 Agent 可以同时在 Web 和 IM 平台上工作，对话记忆和技能在所有平台间共享。": "Derselbe Agent kann sowohl auf Web- als auch auf IM-Plattformen arbeiten, und Gesprächserinnerungen und Fähigkeiten werden auf allen Plattformen geteilt.",
    "团队日志": "Teamprotokoll",
    "团队规范、工作流程、审批标准": "Teamvorgaben, Arbeitsprozesse und Genehmigungsstandards",
    "团队规范和工作流程": "Teamnormen und Arbeitsabläufe",
    "推荐建模顺序": "Empfohlene Modellierungsreihenfolge",
    "推荐": "empfehlen",
    "退出登录": "Abmelden",
    "拖入 .md 文件，或点击上传": "Ziehen Sie die .md-Datei hinein oder klicken Sie auf Hochladen",
    "团队协作（NovaX Bus）": "Teamzusammenarbeit (NovaX Bus)",
    "外部系统 POST 到此 URL 即可触发": "Ein externer System-POST an diese URL kann ausgelöst werden",
    "完成": "Beenden",
    "完整指标包含业务定义、计算口径、粒度、维度、来源、负责人和历史观测。": "Zu den vollständigen Indikatoren gehören Geschäftsdefinition, Berechnungskaliber, Granularität, Dimension, Quelle, verantwortliche Person und historische Beobachtungen.",
    "网络错误": "Netzwerkfehler",
    "微信": "WeChat",
    "微信连接基于网页版协议，需要保持一个微信号在线作为 Agent 载体。建议使用专用微信号。": "Die WeChat-Verbindung basiert auf dem Webversionsprotokoll und ein WeChat-Konto muss als Agent-Träger online gehalten werden. Es wird empfohlen, ein dediziertes WeChat-Konto zu verwenden.",
    "微信已连接，Agent 将自动响应消息。服务重启后即可使用。": "WeChat ist verbunden und der Agent antwortet automatisch auf die Nachricht. Es kann nach dem Neustart des Dienstes verwendet werden.",
    "唯一标识": "eindeutige Kennung",
    "维度切片": "Dimensionsscheibe",
    "未补充映射表达式": "Mapping-Ausdruck nicht ergänzt",
    "未连接": "Nicht verbunden",
    "未设置": "nicht eingestellt",
    "未设置编码": "Keine Kodierung festgelegt",
    "未设置更新频率": "Aktualisierungshäufigkeit nicht festgelegt",
    "未设置公式": "Keine Formel festgelegt",
    "未设置统计粒度": "Die Granularität der Statistiken ist nicht festgelegt",
    "未知": "unbekannt",
    "未知文档": "Unbekanntes Dokument",
    "文本": "Text",
    "文档读取失败": "Das Lesen des Dokuments ist fehlgeschlagen",
    "文档读取失败或无权访问": "Das Lesen des Dokuments ist fehlgeschlagen oder es liegt keine Zugriffsberechtigung vor",
    "文档已覆盖": "Dokument abgedeckt",
    "文档已删除": "Dokument gelöscht",
    "文档已上传": "Dokument hochgeladen",
    "文件处理": "Dateiverarbeitung",
    "文件传输": "Dateiübertragung",
    "文件读取": "Datei lesen",
    "文件分享": "Dateifreigabe",
    "文件过大，最大支持 2MB": "Die Datei ist zu groß. Die maximal unterstützte Größe beträgt 2 MB",
    "文件结构": "Dateistruktur",
    "文件收发": "Senden und Empfangen von Dateien",
    "我": "ICH",
    "我的知识库": "Meine Wissensdatenbank",
    "外观": "Aussehen",
    "推理强度，并在 workspace-write 沙箱内执行任务。": "Begründen Sie Stärke und führen Sie Aufgaben innerhalb der Workspace-Write-Sandbox aus.",
    "我想继续讨论这篇组织简报：": "Ich möchte diesen Organisationsauftrag gerne weiter besprechen:",
    "无单位": "Ohne Einheit",
    "无公式": "Keine Formel",
    "无可用 Agent": "Kein Agent verfügbar",
    "无描述": "Keine Beschreibung",
    "五": "fünf",
    "系统": "System",
    "系统工具": "Systemwerkzeuge",
    "系统内置": "System integriert",
    "我们": "uns",
    "下次：": "nächstes Mal:",
    "下次执行": "Nächstes Mal ausführen",
    "下一步": "Nächster Schritt",
    "下游影响": "nachgelagerte Effekte",
    "下载": "herunterladen",
    "先“新建对象”，再“建立关系”。对象可以是字段、指标、目标或 Agent；关系需要明确选择计算、血缘、影响、因果或归属，并尽量补充公式、条件、置信度和证据。": "Zuerst „ein neues Objekt erstellen“ und dann „eine Beziehung herstellen“. Das Objekt kann ein Feld, ein Indikator, ein Ziel oder ein Agent sein; Die Beziehung muss explizit Berechnung, Abstammung, Auswirkung, Kausalität oder Zuschreibung auswählen und versuchen, Formeln, Bedingungen, Vertrauen und Beweise zu ergänzen.",
    "先创建“销售额、订单量、转化率”这类真正用于决策的指标，补齐业务定义、公式、统计粒度和负责人；再记录至少两个周期的数值，NovaX 才能判断它发生了什么变化。": "Erstellen Sie zunächst Indikatoren wie „Umsatz, Bestellvolumen und Conversion-Rate“, die wirklich zur Entscheidungsfindung verwendet werden, und vervollständigen Sie die Geschäftsdefinition, Formel, statistische Granularität und die verantwortliche Person. Zeichnen Sie dann die Werte für mindestens zwei Zeiträume auf, damit NovaX feststellen kann, welche Änderungen aufgetreten sind.",
    "先看懂四层业务地图": "Verstehen Sie zunächst die vierschichtige Geschäftskarte",
    "先验证，再保存": "Zuerst überprüfen, dann speichern",
    "现在搭建第一条业务链路": "Bauen Sie nun den ersten Geschäftslink auf",
    "现在可以通过受限工具安全使用这个连接。": "Diese Verbindung kann jetzt sicher mit eingeschränkten Werkzeugen verwendet werden.",
    "现在先为你的组织生成第一期。后续随着信息和连接不断补充，NovaX 会继续在这里为你推送值得关注的内容。": "Beginnen Sie nun damit, das erste Problem für Ihre Organisation zu generieren. Da weiterhin Informationen und Verbindungen hinzugefügt werden, wird NovaX weiterhin Inhalte vorantreiben, die es wert sind, hier beachtet zu werden.",
    "限定前缀（可选）": "Qualifizierendes Präfix (optional)",
    "限定文件 Key（可选）": "Qualifizierter Dateischlüssel (optional)",
    "相对上一期": "Im Vergleich zur vorherigen Ausgabe",
    "详细记忆文件": "detaillierte Speicherdatei",
    "项操作": "Operationen",
    "我們": "Wir",
    "消耗": "verbrauchen",
    "消息导航": "Nachrichtennavigation",
    "消息卡片": "Nachrichtenkarte",
    "消息": "Information",
    "外部平台": "externe Plattform",
    "小时": "Stunde",
    "协作 Agent": "Kollaborationsagent",
    "斜杠命令": "Slash-Befehl",
    "系统任务": "Systemaufgaben",
    "小": "Klein",
    "新建对象": "Neues Objekt",
    "新建业务概念": "Neues Geschäftskonzept",
    "新建执行对象": "Erstellen Sie ein neues Ausführungsobjekt",
    "新建指标": "Neuer Indikator",
    "形成指标": "Formindikatoren",
    "修改文件": "Dateien ändern",
    "虚拟主机样式（AWS 默认）": "Virtueller Host-Stil (AWS-Standard)",
    "需要两个周期": "Es dauert zwei Zyklen",
    "选择 .md 文件 →": "Wählen Sie die .md-Datei →",
    "选择要安装到的 Agent": "Wählen Sie den Agenten aus, auf dem installiert werden soll",
    "选择一个预设角色快速开始，或手动创建一个自定义 Agent。": "Wählen Sie eine voreingestellte Rolle, um schnell loszulegen, oder erstellen Sie manuell einen benutzerdefinierten Agenten.",
    "选择一个执行对象": "Wählen Sie ein Ausführungsobjekt aus",
    "选择一个指标后，影响分析会向上查找计算来源和候选驱动，向下查找会受影响的目标、流程与负责人。影响关系只是线索；只有带有验证证据的因果关系，Agent 才会作为确定原因表达。": "Nach der Auswahl einer Metrik blickt die Wirkungsanalyse nach oben auf die Berechnungsquelle und mögliche Treiber und nach unten auf die Ziele, Prozesse und Personen, die für die Wirkung verantwortlich sind. Die Einflussbeziehung ist nur ein Hinweis; Nur der Kausalzusammenhang mit Verifizierungsnachweisen wird vom Agenten als eindeutige Ursache angegeben.",
    "选择一个指标开始": "Wählen Sie einen Indikator, um zu beginnen",
    "选择指标或业务对象": "Wählen Sie eine Metrik oder ein Geschäftsobjekt aus",
    "血缘与计算映射": "Blutlinien- und Computerkartierung",
    "寻址方式": "Adressierungsmodus",
    "沿关系找原因，也看后果": "Verfolgen Sie die Beziehung, um die Ursache zu finden, und schauen Sie sich auch die Konsequenzen an.",
    "沿下游关系识别会受影响的目标、流程、项目和负责人。": "Identifizieren Sie betroffene Ziele, Prozesse, Projekte und Eigentümer entlang nachgelagerter Beziehungen.",
    "沿影响与因果关系生成候选驱动，并根据置信度、条件和证据降级表达。": "Generieren Sie mögliche Treiber anhand von Auswirkungs- und Kausalbeziehungen und stufen Sie Ausdrücke basierend auf Vertrauen, Bedingungen und Beweisen herab.",
    "沿用 Figma Token 可见范围": "Erben Sie den sichtbaren Bereich von Figma Token",
    "颜色": "Farbe",
    "演示文稿制作": "Präsentationsproduktion",
    "验证并保存": "Überprüfen und speichern",
    "验证并连接": "Überprüfen und verbinden",
    "验证结果": "Verifizierungsergebnisse",
    "要点速读": "Punkte zum schnellen Lesen",
    "也是 Agent 们的": "Auch für Agenten",
    "业务本体": "Geschäftsontologie",
    "业务层：数字说明什么": "Business-Schicht: Was die Zahlen sagen",
    "业务地图": "Geschäftskarte",
    "业务地图看全貌，指标网络看口径与上下游，数据血缘看来源，影响分析看原因和后果，组织执行看负责人，模型定义管理对象类型。切换视图不会产生重复数据。": "Die Geschäftslandkarte betrachtet das Gesamtbild, das Indikatornetzwerk betrachtet das Kaliber sowie Upstream und Downstream, die Datenherkunft betrachtet die Quelle, die Wirkungsanalyse betrachtet die Ursachen und Konsequenzen, die Organisationsausführung betrachtet die verantwortliche Person und das Modell definiert den Managementobjekttyp. Beim Wechseln der Ansichten entstehen keine doppelten Daten.",
    "业务定义": "Geschäftsdefinition",
    "业务对象": "Geschäftsobjekt",
    "消息字体大小": "Schriftgröße der Nachricht",
    "研究员输出数据后：": "Nachdem der Forscher die Daten ausgegeben hat:",
    "写 Soul 的要点": "Wichtige Punkte zum Schreiben von Soul",
    "业务连接": "Geschäftsverbindung",
    "业务声明": "Geschäftserklärung",
    "业务指标": "Geschäftskennzahlen",
    "页面分析": "Seitenanalyse",
    "页面设计、演示文稿、AI 图像生成 — 让你的 Agent 拥有专业设计师水准。": "Seitendesign, Präsentationen, KI-Bildgenerierung – lassen Sie Ihren Agenten wie einen professionellen Designer aussehen.",
    "页面搜索": "Seitensuche",
    "一": "eins",
    "一只 Agent。": "Ein Agent.",
    "移除了": "ENTFERNT",
    "已保存，留空不修改": "Gespeichert, ohne Änderung leer lassen",
    "已触发": "Ausgelöst",
    "已存在，是否覆盖？": "Existiert bereits? Überschreiben?",
    "已复制": "Kopiert",
    "已归档": "Archiviert",
    "已过期": "Abgelaufen",
    "已结束": "beendet",
    "已连接": "Verbunden",
    "已连接 ·": "Verbunden ·",
    "已取消": "Abgesagt",
    "已扫码，请在手机上确认...": "Der Code wurde gescannt, bitte bestätigen Sie auf Ihrem Mobiltelefon...",
    "已生成纪要": "Minute generiert",
    "已完成": "Vollendet",
    "已验证": "Verifiziert",
    "已验证因果": "Ursache und Wirkung überprüft",
    "已暂停": "Ausgesetzt",
    "因果可信度阶梯": "kausale Glaubwürdigkeitsleiter",
    "业务规则、行业术语、标准话术": "Geschäftsregeln, Branchenterminologie, Standardvokabular",
    "邀请成员": "Mitglieder einladen",
    "引导进度": "Boot-Fortschritt",
    "应用消息": "Bewerbungsnachrichten",
    "应用专用密码 / 授权码": "Anwendungsspezifisches Passwort/Autorisierungscode",
    "影响分析": "Wirkungsanalyse",
    "影响分析失败": "Die Wirkungsanalyse ist fehlgeschlagen",
    "影响时滞": "Beeinflussen Sie die Zeitverzögerung",
    "影响语义": "Beeinflussen Sie die Semantik",
    "业务规则和约束条件": "Geschäftsregeln und -beschränkungen",
    "因使用本产品产生的任何直接或间接损失，开发者不承担责任。": "Der Entwickler ist nicht verantwortlich für direkte oder indirekte Verluste, die durch die Verwendung dieses Produkts entstehen.",
    "因使用本產品產生的任何直接或間接損失，開發者不承擔責任。": "Der Entwickler ist nicht verantwortlich für direkte oder indirekte Verluste, die durch die Verwendung dieses Produkts entstehen.",
    "拥有 MetaSkill 技能的 Agent 可以根据你的需求自动创作新技能并发布。": "Agenten mit MetaSkill-Fähigkeiten können basierend auf Ihren Anforderungen automatisch neue Fertigkeiten erstellen und veröffentlichen.",
    "用 1 分钟看懂业务本体": "Nehmen Sie sich 1 Minute Zeit, um die Geschäftsontologie zu verstehen",
    "用法示例": "Anwendungsbeispiele",
    "用户名": "Benutzername",
    "用链接或 ID 进入": "Mit Link oder ID eingeben",
    "用户的个人信息用于任何商业用途。": "Die persönlichen Daten des Benutzers werden für kommerzielle Zwecke verwendet.",
    "拥有专属的": "Exklusiv haben",
    "用手机微信扫描二维码，确认登录。": "Verwenden Sie WeChat auf Ihrem Mobiltelefon, um den QR-Code zu scannen und die Anmeldung zu bestätigen.",
    "用手机微信扫描二维码并确认登录": "Verwenden Sie WeChat auf Ihrem Mobiltelefon, um den QR-Code zu scannen und die Anmeldung zu bestätigen",
    "用于比较变化": "Wird zum Vergleichen von Änderungen verwendet",
    "用于区分这个 Agent 的 Pencil 设计文件": "Bleistift-Designdatei, die zur Unterscheidung dieses Agenten verwendet wird",
    "邮件搜索": "Mailsuche",
    "邮箱": "Post",
    "邮箱类型": "E-Mail-Typ",
    "邮箱账号": "E-Mail-Konto",
    "有纪要": "Mit Protokoll",
    "语义关系": "Semantische Beziehungen",
    "语义属性": "Semantische Eigenschaften",
    "永久删除你的账号和所有数据，此操作不可撤销。": "Löschen Sie Ihr Konto und alle Daten dauerhaft. Diese Aktion ist irreversibel.",
    "预定时间（可选，留空则立即开始）": "Geplante Zeit (optional, leer lassen, um sofort zu beginnen)",
    "原始转写": "Originaltranskription",
    "原因与后果": "Ursachen und Folgen",
    "用量明细加载失败": "Nutzungsdetails konnten nicht geladen werden",
    "语音输入（需浏览器支持 Web Speech API）。": "Spracheingabe (erfordert Browser zur Unterstützung der Web Speech API).",
    "运行连接命令": "Verbindungsbefehl ausführen",
    "运行引擎": "Motor laufen lassen",
    "运行中": "Läuft",
    "再查一次": "Überprüfen Sie es noch einmal",
    "再查一次，没有新增内容": "Nochmals überprüft, kein neuer Inhalt",
    "在 Microsoft Teams 中与此 Agent 协作，融入企业办公流程。": "Arbeiten Sie mit diesem Agenten in Microsoft Teams zusammen und integrieren Sie ihn in Unternehmensabläufe.",
    "在 Slack 频道中直接与 Agent 协作，适合海外团队的日常工作流。": "Arbeiten Sie direkt mit Agenten in Slack-Kanälen zusammen, die für den täglichen Arbeitsablauf ausländischer Teams geeignet sind.",
    "在 Slack 频道中直接与此 Agent 协作，支持 Thread 回复。": "Arbeiten Sie direkt mit diesem Agenten in einem Slack-Kanal und unterstützen Sie Thread-Antworten.",
    "月度套餐": "Monatspaket",
    "月度额度不足时，可由组织所有者补充。": "Sollte das monatliche Kontingent nicht ausreichen, kann es vom Organisationsinhaber wieder aufgefüllt werden.",
    "在「任务」标签页的「Webhook」子标签中创建，填写名称和提示词模板。": "Erstellen Sie es auf der Unterregisterkarte „Webhook“ der Registerkarte „Aufgabe“ und geben Sie den Namen und die Eingabeaufforderungswortvorlage ein.",
    "在「设置 → 账号管理」中创建新组织或切换组织。": "Erstellen Sie eine neue Organisation oder wechseln Sie die Organisation unter „Einstellungen → Kontoverwaltung“.",
    "在钉钉群组中接入此 Agent，支持消息卡片、工作通知等钉钉原生能力。": "Verbinden Sie diesen Agenten mit einer DingTalk-Gruppe, um die nativen Funktionen von DingTalk wie Nachrichtenkarten und Arbeitsbenachrichtigungen zu unterstützen.",
    "在「团队」页面管理组织成员。点击「邀请成员」输入邮箱即可发送邀请。": "Verwalten Sie Organisationsmitglieder auf der Seite „Team“. Klicken Sie auf „Mitglieder einladen“ und geben Sie Ihre E-Mail-Adresse ein, um Einladungen zu versenden.",
    "在「团队」页面中点击「新建 Agent」即可创建，创建后点击 Agent 卡片进入详情页进行配置。": "Klicken Sie auf der Seite „Team“ auf „Neuer Agent“, um ihn zu erstellen. Klicken Sie nach der Erstellung auf die Agentenkarte, um die Detailseite für die Konfiguration aufzurufen.",
    "在不同组织之间切换，数据完全隔离。": "Wechseln Sie zwischen verschiedenen Organisationen mit vollständiger Datenisolierung.",
    "在对话界面顶部切换到「技能」标签页，浏览可用列表并点击安装。": "Wechseln Sie zur Registerkarte „Skills“ oben in der Konversationsoberfläche, durchsuchen Sie die verfügbare Liste und klicken Sie auf „Installieren“.",
    "在对话中让": "ins Gespräch kommen lassen",
    "在对话中让 agent \"记住\"重要信息": "Lassen Sie den Agenten während des Gesprächs wichtige Informationen „merken“.",
    "在飞书后台确认授权，应用会自动获取必要的权限（消息收发、群管理等）。": "Bestätigen Sie die Autorisierung im Feishu-Backend und die Anwendung erhält automatisch die erforderlichen Berechtigungen (Senden und Empfangen von Nachrichten, Gruppenverwaltung usw.).",
    "在飞书群聊中直接与此 Agent 对话，支持富文本卡片、文件收发等飞书原生能力。": "Kommunizieren Sie direkt mit diesem Agenten im Feishu-Gruppenchat und unterstützen Sie dabei die nativen Funktionen von Feishu wie Rich-Text-Karten, Senden und Empfangen von Dateien usw.",
    "在你的电脑上运行 NovaX Agent，将本地 Codex 工作区安全地连接到 NovaX。": "Führen Sie NovaX Agent auf Ihrem Computer aus, um Ihren lokalen Codex-Arbeitsbereich sicher mit NovaX zu verbinden.",
    "在对话界面顶部切换到「连接」标签页进行配置。目前支持：": "Wechseln Sie zum Konfigurieren auf die Registerkarte „Verbindung“ oben in der Dialogoberfläche. Unterstützt derzeit:",
    "暂不关联": "Noch nicht relevant",
    "在对话页面的 Agent 列表中，你会看到一个「全员群」入口。在群聊中，你可以用 @AgentName 的方式指定某个 Agent 来回答问题。这使得多个 Agent 可以在同一个对话中协作，比如先让「研究员」Agent 搜索资料，再让「写手」Agent 根据资料撰写文章。": "In der Agentenliste auf der Konversationsseite sehen Sie den Eintrag „Gruppe aller Mitglieder“. In einem Gruppenchat können Sie mit @AgentName einen Agenten angeben, der Fragen beantwortet. Dadurch können mehrere Agenten im selben Gespräch zusammenarbeiten. Lassen Sie beispielsweise zuerst den Agenten „Rechercheur“ nach Informationen suchen und lassen Sie dann den Agenten „Autor“ einen Artikel basierend auf den Informationen schreiben.",
    "暂时需要手动在飞书后台创建应用并填入凭证。自动化创建流程正在开发中 — 届时只需一键授权即可完成连接。": "Vorerst müssen Sie manuell eine Anwendung im Feishu-Backend erstellen und die Anmeldeinformationen eingeben. Ein automatisierter Erstellungsprozess ist in der Entwicklung – eine Ein-Klick-Autorisierung genügt, um die Verbindung herzustellen.",
    "暂停": "Pause",
    "暂无 Webhook": "Noch keine Webhooks",
    "暂无定时任务": "Noch keine geplanten Aufgaben",
    "暂无观测": "Noch keine Beobachtungen",
    "暂无观测值": "Noch keine Beobachtungen",
    "暂无记录": "Noch keine Aufzeichnung",
    "暂无记忆": "Noch keine Erinnerung",
    "暂无纪要 — 会议结束后自动转写": "Noch kein Protokoll – wird nach Ende der Besprechung automatisch transkribiert",
    "暂无类型说明": "Noch keine Typbeschreibung",
    "暂无日志": "Noch keine Protokolle",
    "暂无属性字段": "Noch keine Attributfelder",
    "暂无数据": "Noch keine Daten",
    "暂无说明": "Noch keine Beschreibung",
    "暂无文件": "Noch keine Dateien",
    "暂无业务定义": "Noch keine Geschäftsdefinition",
    "粘贴 Figma 访问 Token": "Figma-Zugriffstoken einfügen",
    "粘贴 Zoom 链接或输入会议 ID": "Fügen Sie den Zoom-Link ein oder geben Sie die Meeting-ID ein",
    "展开查看": "Zur Ansicht erweitern",
    "在左侧导航栏的「Skill 市场」页面，可以浏览所有可用技能。": "Auf der Seite „Fertigkeitsmarkt“ in der linken Navigationsleiste können Sie alle verfügbaren Fertigkeiten durchsuchen.",
    "账号": "Konto",
    "这份证据如何支持该关系？": "Wie stützen diese Beweise die Beziehung?",
    "这里保留原来的团队、Agent、项目、任务、文档和 Skill，并把它们连接到业务指标。": "Hier behalten Sie Ihre ursprünglichen Teams, Agenten, Projekte, Aufgaben, Dokumente und Fähigkeiten bei und verknüpfen sie mit Geschäftskennzahlen.",
    "在服务器上读写文件、执行代码": "Lesen und schreiben Sie Dateien und führen Sie Code auf dem Server aus",
    "蒸馏": "Destillation",
    "蒸馏决策框架、第一性原理与表达 DNA — 炼制一位可随时召唤的思维顾问。": "Destillieren Sie Entscheidungsrahmen, Grundprinzipien und ausdrucksstarke DNA – und verfeinern Sie so einen Mentalberater, an den Sie sich jederzeit wenden können.",
    "整体结构": "Gesamtstruktur",
    "正文与附件信息": "Text- und Anhangsinformationen",
    "正向": "nach vorne",
    "正在编撰组织简报": "Erstellen eines Organisationsbriefings",
    "正在创建微信连接...": "WeChat-Verbindung wird erstellt...",
    "正在读取组织最近的使用情况": "Lesen der aktuellen Nutzung durch die Organisation",
    "正在计算影响路径…": "Wirkweg berechnen…",
    "占位，表示外部传入的数据。例如：": "Platzhalter, der extern eingehende Daten darstellt. Zum Beispiel:",
    "暂时无法读取额度信息": "Die Kreditinformationen können vorübergehend nicht gelesen werden",
    "正在建立业务语义地图…": "Erstellen einer semantischen Geschäftskarte...",
    "正在生成二维码...": "QR-Code wird generiert...",
    "正在验证连接…": "Verbindung wird überprüft...",
    "正在由 Agent 团队编撰第一期": "Die erste Ausgabe wird vom Agententeam zusammengestellt",
    "正在整理组织数据与知识": "Organisationsdaten und Wissen organisieren",
    "证据等级": "Evidenzgrad",
    "证据摘要": "Zusammenfassung der Beweise",
    "支持 GitHub、GitLab、Gitee 和企业内部 Git 服务": "Unterstützt GitHub, GitLab, Gitee und interne Git-Dienste",
    "知识库": "Wissensbasis",
    "知识库 &middot; Knowledge Base": "Wissensdatenbank · Wissensdatenbank",
    "正在加载组织额度…": "Organisationskontingent wird geladen...",
    "这是 NovaX 最强大的协作模式。你可以让多个 Agent 在同一个对话中接力完成复杂任务：": "Dies ist der leistungsstärkste Kollaborationsmodus von NovaX. Sie können mehrere Agenten beauftragen, komplexe Aufgaben im selben Gespräch zu erledigen:",
    "支付功能正在准备中": "Zahlungsfunktion ist in Vorbereitung",
    "知识库为空": "Die Wissensdatenbank ist leer",
    "知识库文档": "Dokumentation der Wissensdatenbank",
    "知识库暂无共享文档。": "Derzeit sind in der Wissensdatenbank keine freigegebenen Dokumente vorhanden.",
    "知识库（Memory）— 共享大脑": "Wissensdatenbank (Speicher) – Shared Brain",
    "知识库是组织级别的共享文档库。你上传的每一篇 Markdown 文档，都会成为该组织下所有 Agent 的共同知识。适合放入：": "Eine Wissensdatenbank ist ein gemeinsam genutztes Dokumenten-Repository auf Organisationsebene. Jedes von Ihnen hochgeladene Markdown-Dokument wird zum allgemeinen Wissen aller Agenten in der Organisation. Geeignet für:",
    "执行层：谁根据它采取行动": "Führungsebene: Wer ergreift darauf basierende Maßnahmen?",
    "执行命令": "Befehl ausführen",
    "执行频率": "Ausführungshäufigkeit",
    "执行任务": "Aufgaben ausführen",
    "执行时间": "Ausführungszeit",
    "执行时间：": "Ausführungszeit:",
    "执行异常": "Ausführungsausnahme",
    "执行指令": "Anweisungen ausführen",
    "执行中": "Ausführen",
    "只读查询": "schreibgeschützte Abfrage",
    "只读连接 Gmail、QQ、163 或支持授权码的企业 IMAP 邮箱，让 Agent 搜索和整理真实邮件。": "Eine schreibgeschützte Verbindung zu Gmail, QQ, 163 oder einem Unternehmens-IMAP-Postfach, das Autorisierungscode unterstützt, ermöglicht es dem Agenten, echte E-Mails zu suchen und zu sortieren.",
    "只读收件箱": "schreibgeschützter Posteingang",
    "指": "beziehen sich auf",
    "指标": "Index",
    "指标 / 维度": "Metriken/Dimensionen",
    "指标不是一个数字": "Ein Indikator ist keine Zahl",
    "指标层：数字怎么计算": "Indikatorschicht: So berechnen Sie Zahlen",
    "指标查询": "Indikatorabfrage",
    "指标观测": "Indikatorbeobachtung",
    "指标口径": "Indexkaliber",
    "指标目录": "Indikatorenkatalog",
    "指标网络": "Indikatornetzwerk",
    "指标已映射": "Zugeordnete Metriken",
    "指标异动与影响分析": "Indikatoränderungen und Auswirkungsanalyse",
    "指标值 *": "Indikatorwert *",
    "至少需要两个周期": "Es sind mindestens zwei Zyklen erforderlich",
    "置信度": "Vertrauen",
    "置信度 ·": "Vertrauen ·",
    "知识库中上传的文档存储在服务器本地，仅供你所在组织的 Agent 读取。": "In die Wissensdatenbank hochgeladene Dokumente werden lokal auf dem Server gespeichert und können nur von Agenten in Ihrer Organisation gelesen werden.",
    "终点 *": "Endpunkt *",
    "终端运行": "Terminallauf",
    "种类型": "Typ",
    "重复任务": "Aufgaben wiederholen",
    "重新尝试": "Versuchen Sie es erneut",
    "重新加载": "neu laden",
    "重要规则": "Wichtige Regeln",
    "周末": "Wochenende",
    "主持人:": "Gastgeber:",
    "主持人：": "Gastgeber:",
    "主动来到你面前": "Ergreifen Sie die Initiative und kommen Sie zu Ihnen",
    "知识库是组织级别的共享文档库。上传的文档会被所有 Agent 在回答时自动参考，相当于给所有 Agent 统一配备了背景知识。": "Eine Wissensdatenbank ist ein gemeinsam genutztes Dokumenten-Repository auf Organisationsebene. Die hochgeladenen Dokumente werden von allen Agenten bei der Beantwortung automatisch referenziert, was gleichbedeutend damit ist, dass alle Agenten mit Hintergrundwissen ausgestattet werden.",
    "注入": "Injektion",
    "知識庫中上傳的文件儲存在伺服器本地，僅供你所在組織的 Agent 讀取。": "In die Wissensdatenbank hochgeladene Dokumente werden lokal auf dem Server gespeichert und können nur von Agenten in Ihrer Organisation gelesen werden.",
    "中": "Mitte",
    "只有组织所有者可以购买套餐或充值额度。": "Nur der Eigentümer der Organisation kann Pläne oder Credits erwerben.",
    "注销后你的账号、聊天记录和所有数据将被永久删除，无法恢复。": "Nach dem Abmelden werden Ihr Konto, Ihr Chatverlauf und alle Daten dauerhaft gelöscht und können nicht wiederhergestellt werden.",
    "注册所需的邮箱仅用于账号验证和登录，不会用于营销或转让给第三方。": "Die für die Registrierung erforderliche E-Mail-Adresse wird nur zur Kontoverifizierung und Anmeldung verwendet und nicht für Marketingzwecke verwendet oder an Dritte weitergegeben.",
    "注销中...": "Abmelden...",
    "转发": "Nach vorne",
    "转发到": "weiterleiten an",
    "转写已完成，可生成纪要": "Die Transkription ist abgeschlossen und es kann ein Protokoll erstellt werden",
    "转写中": "Transkribieren",
    "状态": "Zustand",
    "字段": "Feld",
    "字段名称": "Feldname",
    "自定义类型": "Benutzerdefinierter Typ",
    "自定义名称、描述和人格": "Passen Sie Name, Beschreibung und Persönlichkeit an",
    "自定义周期": "Benutzerdefinierter Zyklus",
    "自动响应指定聊天中的消息": "Antworten Sie automatisch auf Nachrichten in einem bestimmten Chat",
    "自动应答": "Automatische Antwort",
    "自动转写生成纪要": "Automatische Transkription und Generierung von Protokollen",
    "自适应卡片": "adaptive Karte",
    "组": "Gruppe",
    "组件理解": "Komponentenverständnis",
    "注销账号": "Konto kündigen",
    "组织编辑人数": "Anzahl der Redakteure in der Organisation",
    "组织变动": "organisatorische Veränderungen",
    "註冊所需的信箱僅用於帳號驗證和登入，不會用於行銷或轉讓給第三方。": "Die für die Registrierung erforderliche E-Mail-Adresse wird nur zur Kontoverifizierung und Anmeldung verwendet und nicht für Marketingzwecke verwendet oder an Dritte weitergegeben.",
    "组织": "organisieren",
    "组织存储": "Lager organisieren",
    "组织洞察": "organisatorische Erkenntnisse",
    "组织（Workspace）— 协作空间": "Organisation (Arbeitsbereich) – Raum für Zusammenarbeit",
    "自定义界面显示偏好": "Passen Sie die Anzeigeeinstellungen der Benutzeroberfläche an",
    "组织成员和自动任务的消费都会记录在这里。": "Der Verbrauch von Organisationsmitgliedern und automatischen Aufgaben wird hier erfasst.",
    "组织里的某一位 Agent": "Ein Agent in der Organisation",
    "组织名称": "Name der Organisation",
    "组织共享额度": "Freigabekontingent der Organisation",
    "组织内所有成员共享使用": "Von allen Mitgliedern der Organisation geteilt",
    "组织文档数": "Anzahl der Organisationsdokumente",
    "组织信号": "organisatorische Signale",
    "组织所有者": "Eigentümer der Organisation",
    "组织是一个独立的协作空间，类似于 Slack 的 Workspace 或飞书的团队。一个组织内的所有成员共享同一组 Agent 和知识库。你可以：": "Eine Organisation ist ein unabhängiger Kollaborationsraum, ähnlich dem Workspace von Slack oder dem Team von Feishu. Alle Mitglieder einer Organisation nutzen dieselben Agenten und dieselbe Wissensdatenbank. du kannst:",
    "组织与执行": "Organisation und Durchführung",
    "组织知识库": "organisatorische Wissensbasis",
    "组织知识库日志": "Protokoll der Wissensdatenbank der Organisation",
    "组织执行": "Organisatorische Durchführung",
    "最多展开 3 跳": "Erweitern Sie bis zu 3 Sprünge",
    "最多追溯 3 跳": "Bis zu 3 Hops zurückverfolgen",
    "组织与团队管理": "Organisation und Teammanagement",
    "最近更新": "Neueste Updates",
    "最近观测": "Aktuelle Beobachtungen",
    "组织与多租户": "Organisation und Mandantenfähigkeit",
    "最小可用链路只需要四个对象。先从你每天都会关注的那个核心指标开始，后面再逐步补全，不需要一开始设计整个公司。": "Der minimal nutzbare Link erfordert nur vier Objekte. Beginnen Sie mit dem Kernindikator, auf den Sie jeden Tag achten, und vervollständigen Sie ihn später schrittweise. Es ist nicht erforderlich, zu Beginn das gesamte Unternehmen zu entwerfen.",
    "最新观测": "Neueste Beobachtungen",
    "左侧是可能驱动或计算来源，右侧是该指标会影响的对象。": "Auf der linken Seite sind mögliche Treiber oder Berechnungsquellen aufgeführt, auf der rechten Seite die Auswirkungen des Indikators.",
    "作为 PEN_AGENT_API_KEY 仅传给本次本地 Pencil 进程": "Als PEN_AGENT_API_KEY wird es nur an diesen lokalen Pencil-Prozess übergeben.",
    "最後更新：2026 年 5 月": "Letzte Aktualisierung: Mai 2026",
    "最近用量": "aktuelle Nutzung",
    "最后更新：2026 年 5 月": "Letzte Aktualisierung: Mai 2026",
    "作为个人练手 Demo 项目，我们": "Als persönliches Trainings-Demoprojekt haben wir",
    "作為個人練手 Demo 專案，我們": "Als persönliches Praxis-Demo-Projekt haben wir",
    "Agent 会怎样使用": "Wie der Agent verwendet wird",
    "Agent — 你的 AI 团队成员": "Agent – ​​Ihr KI-Teammitglied",
    "Agent 不仅可以在 NovaX 网页端使用，还可以连接到外部即时通讯平台。连接后 Agent 在所有平台共享同一套记忆、技能和知识库。": "Der Agent kann nicht nur auf der NovaX-Webseite verwendet werden, sondern kann auch mit externen Instant-Messaging-Plattformen verbunden werden. Sobald die Agenten verbunden sind, nutzen sie auf allen Plattformen dieselben Erinnerungen, Fähigkeiten und Wissensdatenbanken.",
    "Agent 级别": "Agentenebene",
    "Agent 启动后会自动连接，下方状态变绿即可开始使用。": "Nachdem der Agent gestartet wurde, stellt er automatisch eine Verbindung her. Der Status unten wird grün und Sie können mit der Verwendung beginnen.",
    "Agent 可以创建定时执行的后台任务，无需你手动触发。在对话界面顶部切换到「任务」标签页查看和管理。": "Der Agent kann Hintergrundaufgaben erstellen, die regelmäßig ausgeführt werden, ohne dass Sie sie manuell auslösen müssen. Wechseln Sie zur Registerkarte „Aufgaben“ oben in der Konversationsoberfläche, um sie anzuzeigen und zu verwalten.",
    "Agent 会自动创建 cron 任务。执行结果以消息形式出现在对话中。你可以在「任务」标签页中暂停、恢复或删除已创建的任务。": "Der Agent erstellt automatisch Cron-Tasks. Die Ausführungsergebnisse werden in der Konversation als Nachrichten angezeigt. Auf der Registerkarte „Aufgaben“ können Sie erstellte Aufgaben anhalten, fortsetzen oder löschen.",
    "Agent 是 NovaX 的核心单元。每个 Agent 是一个独立的 AI 助手，拥有自己的：": "Agent ist die Kerneinheit von NovaX. Jeder Agent ist ein unabhängiger KI-Assistent mit seinen eigenen:",
    "Agent 在对话中输出的文件会显示在这里": "Hier werden die vom Agenten im Gespräch ausgegebenen Dateien angezeigt",
    "Agent 周报": "Agent Weekly",
    "Agent 是 NovaX 的核心概念。不同于传统的聊天机器人，每个 Agent 是一个拥有": "Agent ist das Kernkonzept von NovaX. Im Gegensatz zu herkömmlichen Chatbots ist jeder Agent ein Agent mit",
    "Agent 在回答问题时会自动参考这些文档，确保回答符合团队的规范和上下文。": "Agenten beziehen sich bei der Beantwortung von Fragen automatisch auf diese Dokumente und stellen so sicher, dass die Antworten den Normen und dem Kontext des Teams entsprechen.",
    "Agent 收到请求后自动执行，并将结果发送到对话中。": "Der Agent führt die Anfrage nach Erhalt automatisch aus und sendet das Ergebnis an die Konversation.",
    "AI 图像生成": "KI-Bilderzeugung",
    "AI 產生的內容可能包含錯誤或不準確資訊，請自行判斷和驗證。": "Die von KI generierten Inhalte können Fehler oder ungenaue Informationen enthalten. Bitte treffen Sie Ihre eigene Beurteilung und Überprüfung.",
    "DOWNSTREAM · 下游": "stromabwärts · flussabwärts",
    "ETL 血缘": "ETL-Abstammung",
    "Git 仓库": "Git-Repository",
    "Git 用户名；GitHub App 可填 x-access-token": "Git-Benutzername; Die GitHub-App kann x-access-token ausfüllen",
    "Gmail、QQ、163 通常需要先开启 IMAP 并创建应用专用密码或授权码": "Gmail, QQ und 163 müssen normalerweise zuerst IMAP aktivieren und ein anwendungsspezifisches Passwort oder einen Autorisierungscode erstellen.",
    "IMAP 地址": "IMAP-Adresse",
    "Notion 工作区": "Notion-Arbeitsbereich",
    "AI 生成的内容可能包含错误或不准确信息，请自行判断和验证。": "KI-generierte Inhalte können Fehler oder ungenaue Informationen enthalten. Bitte treffen Sie Ihre eigene Beurteilung und Überprüfung.",
    "Markdown 格式渲染，包括代码高亮、表格、列表等。": "Rendering im Markdown-Format, einschließlich Code-Hervorhebung, Tabellen, Listen usw.",
    "Codex 智能体底座": "Codex Smart Body Base",
    "NovaX 会向上追溯数据与业务驱动，向下识别目标、流程和执行影响。": "NovaX verfolgt Daten und Geschäftstreiber nach oben und identifiziert Ziele, Prozesse und Auswirkungen auf die Ausführung nach unten.",
    "Nova 点": "Nova-Punkt",
    "NovaX 采用组织（Workspace）为单位的多租户架构。每个组织是一个完全独立的协作空间，Agent、知识库、技能、成员、对话数据全部隔离。": "NovaX übernimmt eine mandantenfähige Architektur, die auf Organisationen (Workspaces) basiert. Jede Organisation ist ein völlig unabhängiger Raum für die Zusammenarbeit, und Agenten, Wissensdatenbanken, Fähigkeiten, Mitglieder und Konversationsdaten sind alle isoliert.",
    "NovaX 的界面由左侧导航栏和右侧主内容区组成。导航栏提供五个主要入口：": "Die Oberfläche von NovaX besteht aus einer Navigationsleiste auf der linken Seite und einem Hauptinhaltsbereich auf der rechten Seite. Die Navigationsleiste bietet fünf Haupteingänge:",
    "NovaX 的所有 Agent 统一运行在 OpenAI Codex 上，默认使用": "Alle Agenten von NovaX laufen einheitlich auf OpenAI Codex und nutzen",
    "NovaX 是什么": "Was ist NovaX?",
    "NovaX 是一个": "NovaX ist ein",
    "NovaX 是一個": "NovaX ist ein",
    "NovaX Agent 工作区": "Arbeitsbereich des NovaX-Agenten",
    "PG 思维": "PG-Denken",
    "Prompt 模板": "Prompt-Vorlage",
    "Prompt 模板，用 {{payload}} 表示收到的数据": "Eingabeaufforderungsvorlage, die {{payload}} zur Darstellung der empfangenen Daten verwendet",
    "QQ 邮箱": "QQ-Postfach",
    "S3 兼容地址（AWS S3 可留空）": "S3-kompatible Adresse (AWS S3 kann leer bleiben)",
    "Schema 浏览": "Schema-Durchsuchen",
    "secret_... 或 ntn_...": "Secret_... oder ntn_...",
    "Session Token（可选）": "Sitzungstoken (optional)",
    "NovaX 是一个多 Agent AI 协作平台。你可以把它想象成一个 AI 团队工作台：在这里创建多个 AI Agent，每个 Agent 有自己的名字、人设、专长和工作空间。它们能读写文件、执行代码、搜索网络、管理任务，像真正的团队成员一样协同工作。": "NovaX ist eine Multi-Agent-KI-Kollaborationsplattform. Sie können es sich wie eine KI-Team-Werkbank vorstellen: Hier werden mehrere KI-Agenten erstellt, jeder mit seinem eigenen Namen, seiner eigenen Persönlichkeit, seinem eigenen Fachwissen und seinem eigenen Arbeitsbereich. Sie können Dateien lesen und schreiben, Code ausführen, im Internet suchen, Aufgaben verwalten und wie echte Teammitglieder zusammenarbeiten.",
    "Skill 市场": "Kompetenzmarkt",
    "Shift+Enter 换行，Enter 发送。": "Umschalt+Eingabetaste zum Zeilenumbruch, Eingabetaste zum Senden.",
    "NovaX 支持多组织架构。在「设置 → 通用」中可以管理组织：": "NovaX unterstützt organisationsübergreifende Strukturen. Organisationen können unter „Einstellungen → Allgemein“ verwaltet werden:",
    "SQL 数据库": "SQL-Datenbank",
    "SSH 私钥": "Privater SSH-Schlüssel",
    "Thread 回复": "Thread-Antwort",
    "TLS 加密": "TLS-Verschlüsselung",
    "Token 用量榜": "Liste der Token-Nutzung",
    "UPSTREAM · 上游": "STROMAUFWÄRTS · stromaufwärts",
    "Web 设计工程师": "Webdesign-Ingenieur",
    "Webhook 名称，如 GitHub Push...": "Webhook-Name, z. B. GitHub Push...",
    "Soul 人设指令": "Seelencharakterbefehl",
    "Webhook URL（含 Secret）": "Webhook-URL (einschließlich Secret)",
    "Soul 是 Agent 最重要的配置项，它决定了 Agent 的角色定位、专长领域和行为方式。写好 Soul 是让 Agent 真正好用的关键。": "Die Seele ist das wichtigste Konfigurationselement des Agenten. Es bestimmt die Rollenpositionierung, Fachgebiete und das Verhalten des Agenten. Das gute Schreiben von Soul ist der Schlüssel, um Agent wirklich nützlich zu machen.",
    "Webhook 让外部系统通过 HTTP 请求触发 Agent 执行任务，适合与 CI/CD、监控告警、表单提交等系统对接。": "Webhook ermöglicht externen Systemen das Auslösen von Agent-Ausführungsaufgaben über HTTP-Anfragen und eignet sich für die Schnittstelle mit CI/CD, die Überwachung von Alarmen, die Formularübermittlung und andere Systeme.",
    "Soul（人设指令）": "Seele (Persönlichkeitsbefehl)",
    "Webhook 事件触发": "Webhook-Ereignisauslöser"
  }
};
